/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Api Root */
        get: operations["api_root_api__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Health Check */
        get: operations["health_check_api_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Reports
         * @description List all reports for the current user's organization (requires claims:view permission).
         *
         *     Hides reports with status starting with "orphan_" (e.g. the
         *     "orphan_2026-04-25" tag set by the duplicate-cleanup script). The
         *     orphan filter is the LIST default — single-record GET /{report_id}
         *     still returns orphan records so audit trails are reachable.
         *
         *     Pass ?include_orphans=true to override (e.g. for forensic UI).
         */
        get: operations["list_reports_api_v1_reports_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report
         * @description Get a specific report by ID (requires claims:view permission)
         */
        get: operations["get_report_api_v1_reports__report_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Report
         * @description Delete a report (requires claims:delete permission - Owner/Admin only)
         */
        delete: operations["delete_report_api_v1_reports__report_id__delete"];
        options?: never;
        head?: never;
        /**
         * Patch Report
         * @description Partially update a report with specific fields
         *     Used for updating FEMA declaration number, event details, etc.
         *     Requires claims:edit_any (Owner/Admin) or claims:edit_own (Analyst for own claims)
         */
        patch: operations["patch_report_api_v1_reports__report_id__patch"];
        trace?: never;
    };
    "/api/v1/reports/compare/{report_id1}/{report_id2}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Compare Reports
         * @description Compare two reports side-by-side showing all input values and calculation results.
         *     Useful for debugging calculation discrepancies between different data entry methods.
         */
        get: operations["compare_reports_api_v1_reports_compare__report_id1___report_id2__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Report
         * @description Generate a new BI report with payroll reconciliation (requires claims:create permission).
         *
         *     Thin wrapper as of 2026-05-03 — calculation logic lives in
         *     `app.services.report_generation_service._run_generation_pipeline`. The
         *     same pipeline is invoked by the auto-progression hook in
         *     `queue_assignment_service.recompute_and_persist_queue` so that data
         *     flowing in via the client portal also produces a report without a
         *     manual wizard Step-6 click. See docs/plans/2026-05-03-auto-progression-fix.md.
         */
        post: operations["generate_report_api_v1_reports_generate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate Report Data
         * @description Validate report data and run BI calculation (dry run without saving)
         */
        post: operations["validate_report_data_api_v1_reports_validate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Report
         * @description Update an existing report with new data (for Edit/Resume functionality)
         *     Requires claims:edit_any (Owner/Admin) or claims:edit_own (Analyst for own claims)
         */
        put: operations["update_report_api_v1_reports__report_id__update_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/recalculate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Recalculate Report
         * @description Recalculate existing report with edited financial data
         *     OMEGA Feature: User edits 48 months → recalculate claim
         *     Requires claims:calculate permission
         */
        post: operations["recalculate_report_api_v1_reports__report_id__recalculate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Duplicate Claim
         * @description Duplicate an existing claim as a template
         *     Copies all data except dates and results
         *     Creates a new draft ready for editing
         */
        post: operations["duplicate_claim_api_v1_reports__report_id__duplicate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Case Files
         * @description List all S3 files associated with a case/report.
         *
         *     Checks both hierarchical storage (org_id/case_id/) and legacy format (uploads/claim_id/).
         *     Returns pre-signed download URLs for each file.
         */
        get: operations["list_case_files_api_v1_reports__report_id__files_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/files/{s3_key}/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Case File
         * @description Get a pre-signed download URL for a specific file.
         *
         *     The URL is valid for 1 hour and forces browser download.
         */
        get: operations["download_case_file_api_v1_reports__report_id__files__s3_key__download_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/drafts/save": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Draft
         * @description Auto-save wizard progress as draft
         *     Called every 30 seconds from frontend
         *
         *     PHASE 1a: Triggers orchestrator on case creation or step advancement
         *     - New draft created → trigger on_case_created
         *     - Draft advances to step 2+ → trigger on_step_reached (if not already triggered)
         */
        post: operations["save_draft_api_v1_reports_drafts_save_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/drafts/latest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Latest Draft
         * @description Get the most recent draft for current user.
         *     Used to restore wizard state on page load (spawn-fix guard #2 from PR #194).
         *
         *     Coerces draft documents written by either path:
         *       - POST /drafts/save (older path) — writes last_modified + ISO strings
         *       - ClaimService.create_claim (modern wizard entry) — writes neither
         *         last_modified nor ISO created_at (datetime object)
         */
        get: operations["get_latest_draft_api_v1_reports_drafts_latest_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/drafts/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Drafts
         * @description Get all drafts for current user with enhanced metadata
         *     Used to show saved work in dashboard with status indicators
         */
        get: operations["list_drafts_api_v1_reports_drafts_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/drafts/{draft_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update Draft Status
         * @description Update workflow status, priority, or notes for a draft
         *     Allows manual override of auto-calculated status
         */
        patch: operations["update_draft_status_api_v1_reports_drafts__draft_id__status_patch"];
        trace?: never;
    };
    "/api/v1/reports/drafts/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Draft
         * @description Get a specific draft by ID with full data
         */
        get: operations["get_draft_api_v1_reports_drafts__draft_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Draft
         * @description Delete a draft (called after successful claim submission)
         *
         *     Also performs cascade delete of related clarification records to prevent orphans.
         */
        delete: operations["delete_draft_api_v1_reports_drafts__draft_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/sensitivity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Sensitivity Analysis Endpoint
         * @description Run sensitivity analysis on a report
         *
         *     Tests how the claim amount changes when a key parameter varies ±X%
         *
         *     Args:
         *         report_id: Report ID
         *         parameter: 'payroll', 'revenue', or 'variable_expenses'
         *         min_pct: Minimum percentage (default 80)
         *         max_pct: Maximum percentage (default 120)
         *         step_pct: Step size (default 5)
         *
         *     Returns:
         *         {
         *             base_claim: float,
         *             parameter: str,
         *             results: [{pct: int, claim: float, change_pct: float}],
         *             range: {min: float, max: float, spread: float}
         *         }
         */
        post: operations["run_sensitivity_analysis_endpoint_api_v1_reports__report_id__sensitivity_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/monte-carlo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Monte Carlo Endpoint
         * @description Run Monte Carlo simulation on a report
         *
         *     MUST DO:
         *     - ✅ 1,000 iterations minimum
         *     - ✅ ±15% Gaussian noise
         *     - ✅ 95% CI (2.5th-97.5th percentile)
         *     - ✅ <10 second performance
         *     - ✅ NumPy vectorization
         *     - ✅ Random seed for reproducibility
         *     - ✅ Wrap bi_engine (no modifications)
         *
         *     Args:
         *         report_id: Report ID
         *         iterations: Number of Monte Carlo runs (minimum 1,000)
         *         noise_pct: Gaussian noise std dev (default 0.15 for ±15%)
         *         seed: Random seed for reproducibility
         *
         *     Returns:
         *         {
         *             base_claim: float,
         *             iterations: int,
         *             results: {
         *                 mean: float,
         *                 median: float,
         *                 std_dev: float,
         *                 ci_95_low: float,
         *                 ci_95_high: float,
         *                 min: float,
         *                 max: float
         *             },
         *             distribution_sample: list[float]
         *         }
         */
        post: operations["run_monte_carlo_endpoint_api_v1_reports__report_id__monte_carlo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/detect-loss-period": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Loss Period Endpoint
         * @description Auto-detect the loss/event period from uploaded financial data.
         *
         *     Analyzes revenue patterns to identify:
         *     - Which year shows significant decline (coverage year)
         *     - Which months are affected (loss period)
         *     - Suggested event start/end dates
         *
         *     This helps users who don't know the exact event dates for their BI claim.
         */
        post: operations["detect_loss_period_endpoint_api_v1_reports_detect_loss_period_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/validate-event-date": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate Event Date Endpoint
         * @description Validate that the provided event date aligns with revenue decline patterns.
         *
         *     This helps identify issues where:
         *     - Event date is in a year with no financial data
         *     - Event date doesn't match when revenue actually declined
         *     - The causation test might fail due to date mismatch
         *
         *     Returns validation status, warnings, and suggested corrections.
         */
        post: operations["validate_event_date_endpoint_api_v1_reports_validate_event_date_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/org": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Organization
         * @description Get current user's organization details
         */
        get: operations["get_organization_api_v1_org_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bulk/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Bulk Health
         * @description Health check for bulk upload endpoint
         */
        get: operations["bulk_health_api_v1_bulk_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/events/event-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Event Types
         * @description Get all available event types for causation testing
         *
         *     Returns:
         *     - List of event configurations with thresholds and descriptions
         */
        get: operations["get_event_types_api_v1_events_event_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/events/event-types/{event_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Event Type Details
         * @description Get detailed configuration for a specific event type
         *
         *     Parameters:
         *     - event_type: Event type identifier (e.g., 'hurricane', 'flood')
         *
         *     Returns:
         *     - Detailed event configuration including thresholds, data sources, qualifiers
         */
        get: operations["get_event_type_details_api_v1_events_event_types__event_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/regenerate-sample-pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Regenerate Sample Pdf
         * @description Regenerate the sample PDF with correct page numbering.
         *     Requires authentication (admin function).
         */
        get: operations["regenerate_sample_pdf_api_v1_download_regenerate_sample_pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/sample-pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Sample Pdf
         * @description Download the 11-page sample PDF report
         *     No authentication required - public demo
         */
        get: operations["get_sample_pdf_api_v1_download_sample_pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/sample-pdf-download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Sample Pdf
         * @description Download the sample PDF report (forces download)
         *     No authentication required - public demo
         */
        get: operations["download_sample_pdf_api_v1_download_sample_pdf_download_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/narrative/{filename}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Narrative Pdf
         * @description Download generated AI narrative PDF. Requires authentication.
         */
        get: operations["download_narrative_pdf_api_v1_download_narrative__filename__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/report-pdf/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Generate And Download Report Pdf
         * @description Generate and download the 11-page BI report PDF on demand.
         *     This is a synchronous endpoint that generates the PDF immediately.
         *     Requires authentication.
         */
        get: operations["generate_and_download_report_pdf_api_v1_download_report_pdf__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/court-ready-bundle/{report_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Court Bundle Cache Status
         * @description Check if a cached PDF bundle exists for this report.
         *     Returns cache status and metadata.
         */
        get: operations["get_court_bundle_cache_status_api_v1_download_court_ready_bundle__report_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/court-ready-bundle/{report_id}/cached": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Cached Bundle
         * @description Download a previously cached PDF bundle.
         *     Returns 404 if no cached version exists.
         */
        get: operations["download_cached_bundle_api_v1_download_court_ready_bundle__report_id__cached_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/court-ready-bundle/{report_id}/cache": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Clear Bundle Cache
         * @description Clear cached PDF bundle for a report.
         */
        delete: operations["clear_bundle_cache_api_v1_download_court_ready_bundle__report_id__cache_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/court-ready-bundle/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Court Ready Bundle
         * @description Generate a comprehensive court-ready PDF bundle.
         *
         *     Documents available:
         *     - court_report: Main calculation summary with methodology
         *     - attorney_brief: Confidential case strategy (attorney's eyes only)
         *     - forensic_report: Expert witness technical analysis
         *     - exhibits: Charts, tables, and supporting data
         *     - completed_pl: Reconstructed P&L statement
         *     - evidence_bundle: Index of all source documents
         *     - future_closure: Future forced closure analysis (7-8 pages)
         *
         *     Watermark options: DRAFT, WORK_IN_PROGRESS, NOT_CERTIFIED
         *
         *     Features:
         *     - Auto-caches generated PDFs for quick re-download
         *     - Module-level selection within each document type
         *     - Force regenerate option to bypass cache
         *
         *     Returns: ZIP file with all selected documents, or single PDF if only one selected.
         */
        post: operations["generate_court_ready_bundle_api_v1_download_court_ready_bundle__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/download/court-ready-bundle/{report_id}/preview/{document_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Preview Court Document
         * @description Preview a single court-ready document.
         *
         *     Document types: court_report, attorney_brief, forensic_report, exhibits, completed_pl, evidence_bundle
         */
        get: operations["preview_court_document_api_v1_download_court_ready_bundle__report_id__preview__document_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/extract-pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Pdf
         * @description Extract financial data from PDF using Claude Vision
         *
         *     - Upload PDF (max 10MB)
         *     - Returns structured financial data
         *     - Logs to audit trail
         */
        post: operations["extract_pdf_api_v1_ai_extract_pdf_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/suggest-categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Suggest Categories
         * @description Suggest BI expense categories for transactions
         *
         *     - Input: Array of transactions with descriptions
         *     - Returns: Categorized with confidence scores
         *     - Logs to audit trail
         */
        post: operations["suggest_categories_api_v1_ai_suggest_categories_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/detect-anomalies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Anomalies
         * @description Detect anomalies in financial data
         *
         *     - Revenue drops, payroll spikes, duplicates, outliers
         *     - Returns: List of anomalies with severity
         *     - Logs to audit trail
         */
        post: operations["detect_anomalies_api_v1_ai_detect_anomalies_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/explain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Explain Calculation
         * @description Explain BI calculation in plain English
         *
         *     - Input: Calculation results + user question
         *     - Returns: Plain English explanation
         *     - SAFETY: Read-only, never calculates
         *     - Logs to audit trail
         */
        post: operations["explain_calculation_api_v1_ai_explain_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/approve-suggestion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve Suggestion
         * @description Mark AI suggestion as approved/rejected by user
         *
         *     - Required for audit compliance
         *     - User must review all AI suggestions
         */
        post: operations["approve_suggestion_api_v1_ai_approve_suggestion_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/audit-trail/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Audit Trail
         * @description Get AI audit trail for a claim (for PDF appendix)
         *
         *     - Returns all AI interactions for this claim
         *     - Used in report generation
         */
        get: operations["get_audit_trail_api_v1_ai_audit_trail__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Ai Stats
         * @description Get AI usage statistics for current user
         *
         *     - Total calls, approval rate, etc.
         *     - For dashboard analytics
         */
        get: operations["get_ai_stats_api_v1_ai_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Ai Health
         * @description Health check for AI endpoints
         */
        get: operations["ai_health_api_v1_ai_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/generate-narrative-pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Narrative Pdf
         * @description Generate downloadable 14-page PDF from AI narrative
         *
         *     Premium Feature: $150/report
         *
         *     - Takes AI-generated narrative text
         *     - Merges with court-ready PDF template
         *     - Includes Sensitivity Analysis and Monte Carlo results
         *     - Returns downloadable PDF URL
         *     - Includes in audit trail
         */
        post: operations["generate_narrative_pdf_api_v1_narrator_generate_narrative_pdf_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/generate-narrative": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Narrative
         * @description Generate AI-powered legal narrative for claim report
         *
         *     Premium Feature: $150/report add-on
         *
         *     - Generates 14-page court-ready narrative
         *     - Based on BI calculation results
         *     - Includes Sensitivity Analysis and Monte Carlo results if available
         *     - Professional legal tone
         *     - Auto-saves to report database
         *     - Requires user review before finalization
         */
        post: operations["generate_narrative_api_v1_narrator_generate_narrative_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/generate-narrative-accountant/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Narrative For Accountant
         * @description Generate court-ready expert report with ACCOUNTANT'S credentials
         *
         *     This endpoint is called from the accountant collaboration portal.
         *     It uses the logged-in accountant's profile/credentials.
         *
         *     SECURITY (audit C-3 follow-up, 2026-04-19): previously had no auth at
         *     all — a TODO said "get accountant info from auth token" but the code
         *     just fetched any report by id. Now requires a valid accountant JWT
         *     AND an active share entry for that accountant → report pair. Rejects
         *     403 if the accountant doesn't have edit/sign access to this report.
         *
         *     Flow:
         *     1. Verify accountant has access to this report (403 otherwise)
         *     2. Fetch accountant's profile (credentials)
         *     3. Fetch report data
         *     4. Generate narrative with accountant's real credentials
         *     5. Save to report and return
         */
        post: operations["generate_narrative_for_accountant_api_v1_narrator_generate_narrative_accountant__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/save-narrative": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Narrative
         * @description Save edited narrative sections to the report database
         *
         *     Call this after editing sections to persist changes before PDF export
         */
        post: operations["save_narrative_api_v1_narrator_save_narrative_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/refine-section": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Refine Section
         * @description Refine a specific section based on user feedback
         *
         *     - Allows iterative editing with AI assistance
         *     - Maintains professional tone
         *     - Auto-saves refined section to database
         *     - Logs all revisions to audit trail
         */
        post: operations["refine_section_api_v1_narrator_refine_section_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/narrative/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Saved Narrative
         * @description Get saved narrative for a claim (from report database)
         *
         *     Returns the narrative saved to the report, allowing users to view/edit/export
         *     without regenerating the entire narrative.
         */
        get: operations["get_saved_narrative_api_v1_narrator_narrative__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/narrative-preview/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Narrative Preview
         * @description DEPRECATED: Use /narrative/{claim_id} instead
         *
         *     Get previously generated narrative for a claim from audit trail
         */
        get: operations["get_narrative_preview_api_v1_narrator_narrative_preview__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/narrator/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Narrator Health
         * @description Health check for narrator endpoints
         */
        get: operations["narrator_health_api_v1_narrator_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/tax/parse-1065": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse 1065
         * @description Parse IRS Form 1065 using Claude Vision
         *
         *     **Phase 2 Feature**
         *
         *     - Extracts Schedule K Line 1 (Ordinary Income)
         *     - Extracts Schedule K Line 13d (Other Deductions)
         *     - Returns structured financial data
         *     - Logs to audit trail
         *
         *     **Use Case:** User uploads 1065 during Step 3 data entry
         */
        post: operations["parse_1065_api_v1_tax_parse_1065_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/tax/parse-1065-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse 1065 Demo
         * @description Parse IRS Form 1065 - DEMO VERSION (No Auth Required)
         *
         *     **Phase 2 Feature - Demo Mode**
         *
         *     - Works without authentication
         *     - Same functionality as authenticated version
         *     - For testing and demo purposes
         *
         *     **Use Case:** Demo wizard tax upload
         */
        post: operations["parse_1065_demo_api_v1_tax_parse_1065_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/tax/reconcile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reconcile Tax Pl
         * @description Reconcile tax return data with P&L data
         *
         *     **Phase 2 Feature**
         *
         *     - Compares tax return amounts with P&L entries
         *     - Identifies discrepancies
         *     - Suggests adjustment entries
         *     - Returns reconciliation report
         *
         *     **Use Case:** After parsing 1065, reconcile with existing P&L data
         */
        post: operations["reconcile_tax_pl_api_v1_tax_reconcile_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/tax/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Tax Parser Health
         * @description Health check for tax parser endpoints
         */
        get: operations["tax_parser_health_api_v1_tax_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/last-claim": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Last Claim
         * @description Get user's most recent claim
         *
         *     **Day 4-6 Feature**
         *
         *     - Fetches last claim from MongoDB
         *     - Returns claim data for preview
         *     - Used by "Use Last Claim" button
         *
         *     **Use Case:** User clicks "Use Last Claim" to see their previous submission
         */
        get: operations["get_last_claim_api_v1_predictive_last_claim_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/predict": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Predictions
         * @description Generate predictions based on user's claim history
         *
         *     **Day 4-6 Feature**
         *
         *     - Analyzes previous claims
         *     - Predicts revenue, expenses, payroll
         *     - Applies seasonal adjustments
         *     - Returns confidence scores
         *
         *     **Use Case:** User clicks "Apply" in preview modal to auto-fill form
         */
        post: operations["generate_predictions_api_v1_predictive_predict_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim History
         * @description Get user's claim history
         *
         *     **Day 4-6 Feature**
         *
         *     - Returns last N claims
         *     - Shows pattern over time
         *     - Used for analytics and confidence calculation
         *
         *     **Use Case:** Display claim history in dashboard
         */
        get: operations["get_claim_history_api_v1_predictive_history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/apply": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Predictions
         * @description Apply predictions to current form data
         *
         *     **Day 4-6 Feature**
         *
         *     - Merges predictions with existing data
         *     - Respects manual entries (unless override enabled)
         *     - Returns merged data ready for form
         *
         *     **Use Case:** After user approves predictions in modal
         */
        post: operations["apply_predictions_api_v1_predictive_apply_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Predictive Health
         * @description Health check for predictive endpoints
         */
        get: operations["predictive_health_api_v1_predictive_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/last-claim-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Last Claim Demo
         * @description Demo endpoint - Get last claim without authentication
         *     Uses hardcoded demo-user-123 for testing
         */
        get: operations["get_last_claim_demo_api_v1_predictive_last_claim_demo_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/predictive/predict-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Predictions Demo
         * @description Demo endpoint - Generate predictions without authentication
         *     Uses hardcoded demo-user-123 for testing
         */
        post: operations["generate_predictions_demo_api_v1_predictive_predict_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bundle/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Bundle
         * @description Create complete bundle PDF (25 pages)
         *
         *     **Premium Feature - $200**
         *
         *     - Merges Standard BI Report (11 pages)
         *     - Merges AI Narrative Report (14 pages)
         *     - Adds professional cover page
         *     - Adds table of contents
         *     - Returns 25-page bundle
         *
         *     **Use Case:** User purchases Complete Bundle on report detail page
         */
        post: operations["create_bundle_api_v1_bundle_create_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bundle/download/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Bundle
         * @description Download existing bundle PDF
         *
         *     **Premium Feature - $200**
         *
         *     - Returns bundle PDF file
         *     - Requires previous bundle creation
         *     - Requires authentication
         *
         *     **Use Case:** User downloads purchased bundle from dashboard
         */
        get: operations["download_bundle_api_v1_bundle_download__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bundle/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview Bundle
         * @description Preview bundle contents without creating full PDF
         *
         *     **Premium Feature - $200**
         *
         *     - Shows what will be included
         *     - Displays page count breakdown
         *     - Shows pricing
         *     - No charge for preview
         *     - Returns real data from existing bundle record if available
         *
         *     **Use Case:** User previews bundle before purchasing
         */
        post: operations["preview_bundle_api_v1_bundle_preview_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bundle/pricing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Bundle Pricing
         * @description Get bundle pricing information
         *
         *     **Public Endpoint**
         *
         *     - No authentication required
         *     - Shows pricing tiers
         *     - Shows bundle savings
         *
         *     **Use Case:** Display pricing on landing page or pricing page
         */
        get: operations["get_bundle_pricing_api_v1_bundle_pricing_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bundle/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Bundle Health
         * @description Health check for bundle PDF endpoints
         */
        get: operations["bundle_health_api_v1_bundle_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check for financial documents API
         */
        get: operations["health_check_api_v1_financial_docs_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-1065": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Form 1065
         * @description Parse IRS Form 1065 (Partnership/S-Corp Tax Return)
         *     Protected endpoint - requires authentication
         */
        post: operations["parse_form_1065_api_v1_financial_docs_parse_1065_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-bank-statement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Bank Statement
         * @description Parse Bank Statement
         *     Protected endpoint - requires authentication
         */
        post: operations["parse_bank_statement_api_v1_financial_docs_parse_bank_statement_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-profit-loss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Profit Loss
         * @description Parse P&L (Profit & Loss) Statement
         *     Supports: PDF, Excel (.xlsx, .xls), CSV, QuickBooks (.iif, .qbo)
         *     Protected endpoint - requires authentication
         */
        post: operations["parse_profit_loss_api_v1_financial_docs_parse_profit_loss_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/three-way-reconciliation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Three Way Reconciliation
         * @description Perform 3-way reconciliation across all three documents
         *     Protected endpoint - requires authentication
         *
         *     Uploads:
         *     - form_1065_file: IRS Form 1065 PDF
         *     - bank_statement_file: Bank Statement PDF
         *     - pl_statement_file: P&L Statement PDF
         *
         *     Returns:
         *     - Parsed data from all three documents
         *     - Reconciliation analysis
         *     - Discrepancies identified
         *     - Suggested adjustments
         *     - Claim impact estimation
         */
        post: operations["three_way_reconciliation_api_v1_financial_docs_three_way_reconciliation_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-1065-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Form 1065 Demo
         * @description Demo endpoint for Form 1065 parsing
         */
        post: operations["parse_form_1065_demo_api_v1_financial_docs_parse_1065_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-bank-statement-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Bank Statement Demo
         * @description Demo endpoint for bank statement parsing
         */
        post: operations["parse_bank_statement_demo_api_v1_financial_docs_parse_bank_statement_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-profit-loss-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Profit Loss Demo
         * @description Demo endpoint for P&L parsing
         */
        post: operations["parse_profit_loss_demo_api_v1_financial_docs_parse_profit_loss_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/three-way-reconciliation-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Three Way Reconciliation Demo
         * @description Demo endpoint for 3-way reconciliation
         */
        post: operations["three_way_reconciliation_demo_api_v1_financial_docs_three_way_reconciliation_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/financial-docs/parse-excel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Excel Spreadsheet
         * @description Parse Excel/CSV spreadsheet for financial data import.
         *     Fast parser first, AI fallback if needed.
         *
         *     Supports:
         *     - .xlsx, .xls (Excel)
         *     - .csv (Comma Separated Values)
         */
        post: operations["parse_excel_spreadsheet_api_v1_financial_docs_parse_excel_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check for edge case detection API
         */
        get: operations["health_check_api_v1_edge_cases_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Edge Cases
         * @description Analyze claim data for edge cases and provide AI suggestions
         *
         *     Returns:
         *     - All detected issues
         *     - AI explanations
         *     - Suggested corrections
         *     - User action options
         */
        post: operations["analyze_edge_cases_api_v1_edge_cases_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/detect-negative-revenue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Negative Revenue
         * @description Detect negative revenue entries
         */
        post: operations["detect_negative_revenue_api_v1_edge_cases_detect_negative_revenue_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/detect-zero-payroll": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Zero Payroll
         * @description Detect zero payroll entries
         */
        post: operations["detect_zero_payroll_api_v1_edge_cases_detect_zero_payroll_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/detect-missing-months": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Missing Months
         * @description Detect missing months and provide predictions
         */
        post: operations["detect_missing_months_api_v1_edge_cases_detect_missing_months_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/detect-outliers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Outliers
         * @description Detect outliers in financial data
         */
        post: operations["detect_outliers_api_v1_edge_cases_detect_outliers_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/log-user-decision": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Log User Decision
         * @description Log user's decision on an edge case
         *     Creates audit trail for all user choices
         */
        post: operations["log_user_decision_api_v1_edge_cases_log_user_decision_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/edge-cases/analyze-demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Edge Cases Demo
         * @description Demo endpoint for edge case analysis
         */
        post: operations["analyze_edge_cases_demo_api_v1_edge_cases_analyze_demo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check for audit trail API
         */
        get: operations["health_check_api_v1_audit_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim Audit Trail
         * @description Get complete audit trail for a claim
         *
         *     Optional filters:
         *     - category: 'user_action', 'field_change', 'calculation', 'ai_decision', 'system_event'
         *     - start_date: ISO timestamp
         *     - end_date: ISO timestamp
         */
        get: operations["get_claim_audit_trail_api_v1_audit_claim__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Audit Summary
         * @description Get audit trail summary statistics
         *
         *     Returns overview of all activity on a claim
         */
        get: operations["get_audit_summary_api_v1_audit_claim__claim_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Audit Trail
         * @description Export complete audit trail as JSON file
         *
         *     For forensic accountants to download and verify
         */
        get: operations["export_audit_trail_api_v1_audit_claim__claim_id__export_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/field-changes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Field Changes
         * @description Get all field changes for forensic review
         *
         *     Shows original → final values for every field
         */
        get: operations["get_field_changes_api_v1_audit_claim__claim_id__field_changes_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/ai-decisions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Ai Decisions
         * @description Get all AI decisions and user responses
         *
         *     Shows AI transparency for forensic review
         */
        get: operations["get_ai_decisions_api_v1_audit_claim__claim_id__ai_decisions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/calculations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Calculations
         * @description Get all calculations performed
         *
         *     Shows methodology and formulas used
         */
        get: operations["get_calculations_api_v1_audit_claim__claim_id__calculations_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/demo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim Audit Trail Demo
         * @description Demo endpoint for audit trail
         */
        get: operations["get_claim_audit_trail_demo_api_v1_audit_claim__claim_id__demo_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/export-excel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Forensic Excel
         * @description Export complete forensic Excel workbook (8 sheets)
         *
         *     For forensic accountants to download and verify all calculations
         *
         *     Sheets:
         *     1. Data Input (48 months)
         *     2. Variable Profit calculations
         *     3. Causation Tests
         *     4. Benchmark Selection (156 candidates)
         *     5. Step 1 & Step 2 calculations
         *     6. Final Claim Summary
         *     7. Audit Trail
         *     8. AI Decisions
         */
        get: operations["export_forensic_excel_api_v1_audit_claim__claim_id__export_excel_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/claim/{claim_id}/explain-pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Ai Explanation Pdf
         * @description Export AI Explanation PDF (2-page plain English summary)
         *
         *     For clients and non-technical stakeholders to understand the claim
         *
         *     Features:
         *     - Executive summary
         *     - Calculation breakdown in plain English
         *     - AI decisions explained
         *     - Methodology overview
         *     - Non-technical language
         */
        get: operations["export_ai_explanation_pdf_api_v1_audit_claim__claim_id__explain_pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Human Override Log
         * @description Log human overrides of AI-automated values.
         *
         *     Called when:
         *     - Human modifies AI-populated values in wizard steps
         *     - Manual corrections are made to calculations
         *     - Values are adjusted during accountant review
         *
         *     This creates a court-defensible audit trail showing:
         *     - What AI originally populated
         *     - What human changed it to
         *     - When and who made the change
         */
        post: operations["create_human_override_log_api_v1_audit_log_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/overrides/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Human Overrides
         * @description Get all human override audit entries for a case.
         *
         *     Shows chronological history of all human modifications to AI values.
         */
        get: operations["get_human_overrides_api_v1_audit_overrides__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit/overrides/{case_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Override Summary
         * @description Get summary of human override activity for a case.
         *
         *     Shows:
         *     - Total overrides
         *     - Most frequently changed fields
         *     - AI vs human ratio
         */
        get: operations["get_override_summary_api_v1_audit_overrides__case_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/documents/bulk-upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Upload Documents
         * @description Upload multiple documents for OCR extraction and classification
         *
         *     Supported formats: PDF, XLSX, XLS, CSV
         *     Document types detected: K1, 1065, P&L, Bank Statement
         *
         *     Uses FREE open-source OCR (no AI cost for extraction)
         *     AI only used as fallback for uncertain classifications
         */
        post: operations["bulk_upload_documents_api_v1_documents_bulk_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/documents/process-single": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Process Single Document
         * @description Process a single document for testing/debugging
         *     Returns detailed extraction results
         */
        post: operations["process_single_document_api_v1_documents_process_single_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/documents/upload-zip": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload Zip Batch
         * @description 🚀 MAGICAL ZIP BATCH UPLOAD
         *
         *     Drop one ZIP file → Auto-extract, categorize, and process all documents
         *
         *     Features:
         *     - Extracts up to 50 files from ZIP
         *     - Concurrent processing (5 at a time)
         *     - Auto-categorizes: K1, 1065, P&L, Bank statements
         *     - Returns organized data ready for wizard
         *     - Processing time: ~1-2 seconds per file
         *
         *     Example: Upload tax_docs_2022.zip containing 30 PDFs → Get organized data in <60 seconds
         */
        post: operations["upload_zip_batch_api_v1_documents_upload_zip_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/documents/supported-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Supported Document Types
         * @description Get list of supported document types and their detection keywords
         */
        get: operations["get_supported_document_types_api_v1_documents_supported_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/health-score/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Health Assessment
         * @description Get traffic light health assessment for a specific report.
         *
         *     SECURITY (audit H-2, 2026-04-18): requires auth AND enforces
         *     org-level isolation — a user from org A cannot read a report
         *     owned by org B, even if they guess the report_id.
         */
        get: operations["get_health_assessment_api_v1_claims_health_score__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/health-scores/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Health Assessments Summary
         * @description Get traffic light health summary for all reports (for dashboard display).
         *
         *     SECURITY (audit H-2, 2026-04-18): query is always scoped to the caller's
         *     org_id. The `org_id` query parameter was removed — callers cannot choose
         *     which org's reports to list. `user_id` filter is retained but scoped.
         */
        get: operations["get_health_assessments_summary_api_v1_claims_health_scores_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/expenses/categorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Categorize Single Expense
         * @description Categorize a single expense description
         *
         *     Args:
         *         input: Expense description and optional threshold
         *
         *     Returns:
         *         Categorization result with category, canonical name, confidence
         */
        post: operations["categorize_single_expense_api_v1_expenses_categorize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/expenses/categorize/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Categorize Multiple Expenses
         * @description Categorize multiple expense descriptions at once
         *
         *     Args:
         *         input: List of expense descriptions and optional threshold
         *
         *     Returns:
         *         List of categorization results
         */
        post: operations["categorize_multiple_expenses_api_v1_expenses_categorize_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/expenses/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Expense Categories
         * @description Get all available expense categories with their metadata
         *
         *     Returns:
         *         Dictionary of categories with canonical names and classifications
         */
        get: operations["list_expense_categories_api_v1_expenses_categories_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/expenses/suggest-classification/{category}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Classification Suggestion
         * @description Get suggested continuing/variable classification for a category
         *
         *     Args:
         *         category: The expense category
         *
         *     Returns:
         *         Suggested classification with confidence level
         */
        get: operations["get_classification_suggestion_api_v1_expenses_suggest_classification__category__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/fema/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Declarations
         * @description Search FEMA disaster declarations database
         *
         *     Returns list of matching disaster declarations with details.
         *     No authentication required - uses public FEMA OpenFEMA API.
         */
        get: operations["search_declarations_api_v1_fema_search_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/fema/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate Declaration
         * @description Validate a FEMA declaration number
         *
         *     Checks if the provided FEMA number exists in the database
         *     and optionally validates against claim state/dates.
         */
        post: operations["validate_declaration_api_v1_fema_validate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/fema/suggest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Suggest Declarations
         * @description Suggest FEMA declarations based on claim details
         *
         *     Uses state, event dates, and type to find matching declarations.
         *     Returns scored suggestions with match confidence.
         */
        post: operations["suggest_declarations_api_v1_fema_suggest_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/fema/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Recent Declarations
         * @description Get most recent FEMA disaster declarations
         *
         *     Useful for showing users recent disasters and their declaration numbers.
         */
        get: operations["get_recent_declarations_api_v1_fema_recent_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/analysis/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comparative Analysis
         * @description 📊 Get comparative analysis for a completed report
         */
        get: operations["get_comparative_analysis_api_v1_benchmarks_analysis__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/benchmark/{event_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Event Benchmarks
         * @description Get industry benchmarks for a specific event type
         */
        get: operations["get_event_benchmarks_api_v1_benchmarks_benchmark__event_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/industry/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Industry Benchmarks
         * @description Get list of available industries with benchmark data.
         *
         *     Returns all NAICS codes that have industry benchmark data available
         *     for financial ratio comparisons.
         */
        get: operations["get_available_industry_benchmarks_api_v1_benchmarks_industry_available_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/industry/{naics_code}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Industry Benchmark By Naics
         * @description Get benchmark data for a specific NAICS code.
         *
         *     Returns industry benchmark ratios including:
         *     - COGS ratio
         *     - Payroll ratio
         *     - Rent ratio
         *     - Utilities ratio
         *     - Gross margin
         *     - Operating margin
         *     - Net margin
         */
        get: operations["get_industry_benchmark_by_naics_api_v1_benchmarks_industry__naics_code__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/industry/compare": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare To Industry Benchmark Endpoint
         * @description Compare business financials against industry benchmarks.
         *
         *     Compares key financial ratios against BLS/Census industry data:
         *     - COGS ratio (Cost of Goods Sold / Revenue)
         *     - Payroll ratio (Payroll & Benefits / Revenue)
         *     - Rent ratio (Rent & Occupancy / Revenue)
         *     - Utilities ratio (Utilities / Revenue)
         *     - Gross margin ((Revenue - COGS) / Revenue)
         *     - Net margin (Net Profit / Revenue)
         *
         *     Deviation levels:
         *     - CRITICAL: >50% deviation
         *     - HIGH: 30-50% deviation
         *     - MODERATE: 15-30% deviation
         *     - NORMAL: <15% deviation
         *     - FAVORABLE: Better than benchmark
         *
         *     Returns forensic implications for claim review.
         */
        post: operations["compare_to_industry_benchmark_endpoint_api_v1_benchmarks_industry_compare_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/industry/compare/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Report To Industry
         * @description Compare a report's financials against industry benchmarks.
         *
         *     Automatically extracts financial data from the report and
         *     determines the appropriate industry based on business type.
         */
        post: operations["compare_report_to_industry_api_v1_benchmarks_industry_compare_report__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/industry/naics-lookup/{business_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Lookup Naics Code
         * @description Look up NAICS code from business type description.
         *
         *     Maps common business types to their NAICS codes for benchmarking.
         */
        get: operations["lookup_naics_code_api_v1_benchmarks_industry_naics_lookup__business_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/benchmarks/ratios/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extended Ratios
         * @description Get extended financial ratios for a report's P&L data.
         *
         *     Computes four categories of ratios from the parsed P&L statement:
         *     - **Profitability**: Net profit margin, EBITDA margin, Return on revenue
         *     - **Expense**: Operating expense ratio, professional services, depreciation, debt service, marketing
         *     - **Efficiency**: Revenue per employee, payroll efficiency, fixed cost ratio, variable cost ratio
         *     - **BI-Specific**: Continuing expense ratio, saved expense ratio, break-even revenue
         *
         *     Each ratio includes a value, label, category, interpretation, and unit.
         *     Division by zero is handled gracefully (value=None with explanatory note).
         */
        get: operations["get_extended_ratios_api_v1_benchmarks_ratios__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster-qa/adjuster-qa/ask": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Ask Question
         * @description Ask a question about the adjuster analysis.
         *
         *     Requires:
         *     - report_id: The report to ask about
         *     - question: The question to ask
         *     - conversation_history: Optional previous messages
         *
         *     Returns AI-generated answer with confidence and sources.
         */
        post: operations["ask_question_api_v1_adjuster_qa_adjuster_qa_ask_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster-qa/adjuster-qa/history/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Conversation History
         * @description Get conversation history for a report.
         */
        get: operations["get_conversation_history_api_v1_adjuster_qa_adjuster_qa_history__report_id__get"];
        put?: never;
        post?: never;
        /**
         * Clear Conversation History
         * @description Clear conversation history for a report.
         */
        delete: operations["clear_conversation_history_api_v1_adjuster_qa_adjuster_qa_history__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster-qa/adjuster-qa/suggested-questions/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Suggested Questions
         * @description Get suggested questions based on the analysis.
         */
        get: operations["get_suggested_questions_api_v1_adjuster_qa_adjuster_qa_suggested_questions__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/scenarios/calculate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Scenario
         * @description 🎲 Calculate loss projection scenario with adjusted parameters
         *
         *     Allows adjusters to test "what-if" scenarios:
         *     - Change indemnity period
         *     - Adjust revenue drop percentage
         *     - Modify expense reductions
         *     - Set custom daily gross profit
         *
         *     Returns instant recalculation + comparison + "but-for" projection
         */
        post: operations["calculate_scenario_api_v1_scenarios_calculate__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/scenarios/saved/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Saved Scenarios
         * @description Get all saved scenarios for a report
         */
        get: operations["get_saved_scenarios_api_v1_scenarios_saved__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/scenarios/save/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Scenario
         * @description Save a scenario for future comparison
         */
        post: operations["save_scenario_api_v1_scenarios_save__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/scenarios/saved/{report_id}/{scenario_index}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Scenario
         * @description Delete a saved scenario
         */
        delete: operations["delete_scenario_api_v1_scenarios_saved__report_id___scenario_index__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/subrogation/analyze/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Subrogation
         * @description 🔍 Analyze claim for subrogation opportunities
         *
         *     Scans claim text for 42 high-confidence trigger patterns.
         *     Returns top 5 opportunities sorted by priority score.
         *
         *     Factors analyzed:
         *     - Third-party liability indicators
         *     - State-specific recovery rates
         *     - Comparative fault considerations
         *     - Statute of limitations countdown
         *     - Projected recovery amounts
         */
        post: operations["analyze_subrogation_api_v1_subrogation_analyze__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/subrogation/generate-letter/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Demand Letter
         * @description 📄 Generate professional demand letter for subrogation opportunity
         *
         *     Creates a formatted demand letter with:
         *     - Legal basis for recovery
         *     - Evidence summary
         *     - Damage calculation
         *     - Payment demand with deadline
         */
        post: operations["generate_demand_letter_api_v1_subrogation_generate_letter__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/register": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Register Accountant
         * @description Register a new forensic accountant — INVITE-GATED.
         *
         *     SECURITY (audit C-5, 2026-04-18): this endpoint was previously open to the
         *     public. Anyone on the internet could mint an `active` forensic-accountant
         *     record and receive a JWT. Now the caller MUST supply an `invite_token`
         *     that was issued by `/collaboration/shares` for their exact email address.
         *
         *     Flow:
         *       1. Look up a pending share by invite_token.
         *       2. Verify the share is still active and matches the caller's email.
         *       3. Create the accountant record.
         *       4. Bind the new accountant_id to the share and mark it accepted.
         *       5. Return an access token.
         *
         *     Rejection cases → the response bodies are deliberately generic (not
         *     leaking whether a token exists) except for the "email already registered"
         *     response, which is unavoidable on a signup form.
         */
        post: operations["register_accountant_api_v1_collaboration_register_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Login Accountant
         * @description Login for forensic accountants
         */
        post: operations["login_accountant_api_v1_collaboration_login_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Profile
         * @description Get current accountant's profile
         */
        get: operations["get_accountant_profile_api_v1_collaboration_profile_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invites": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Invites
         * @description List invites/shares
         *     - For users: shows invites they've sent
         *     - For accountants: shows invites they've received
         */
        get: operations["list_invites_api_v1_collaboration_invites_get"];
        put?: never;
        /**
         * Invite Accountant
         * @description Invite a forensic accountant to collaborate on a report
         *     Only report owners (users) can send invites
         */
        post: operations["invite_accountant_api_v1_collaboration_invites_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invites/accept": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Accept Invite
         * @description Accept an invite to collaborate on a report
         *     Accountant must be logged in
         */
        post: operations["accept_invite_api_v1_collaboration_invites_accept_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invites/accept-by-report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Accept Invite By Report
         * @description Accept a pending invite for a specific report (simpler than token-based)
         *     Used from dashboard pending invites list
         */
        post: operations["accept_invite_by_report_api_v1_collaboration_invites_accept_by_report__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/shares/my-reports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List All My Shares
         * @description List all collaboration shares across all reports owned by the current user.
         *     Used for dashboard to show collaboration status on each report card.
         */
        get: operations["list_all_my_shares_api_v1_collaboration_shares_my_reports_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/shares": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Report Shares
         * @description List all accountants who have access to a specific report
         */
        get: operations["list_report_shares_api_v1_collaboration_reports__report_id__shares_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/shares/{share_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Revoke Share
         * @description Revoke an accountant's access to a report
         *     Only report owner can revoke
         */
        delete: operations["revoke_share_api_v1_collaboration_shares__share_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invites/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Pending Invites
         * @description List all pending invites for the current accountant
         */
        get: operations["list_pending_invites_api_v1_collaboration_invites_pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/shared": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Shared Reports
         * @description List all reports shared with the current accountant
         */
        get: operations["list_shared_reports_api_v1_collaboration_reports_shared_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comments
         * @description Get all comments for a report
         */
        get: operations["get_comments_api_v1_collaboration_reports__report_id__comments_get"];
        put?: never;
        /**
         * Create Comment
         * @description Create a comment on a report (accountant only)
         */
        post: operations["create_comment_api_v1_collaboration_reports__report_id__comments_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/view": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report For Accountant
         * @description Get full report details for an accountant
         *     Verifies accountant has access before returning data
         */
        get: operations["get_report_for_accountant_api_v1_collaboration_reports__report_id__view_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/comparative-analysis": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comparative Analysis For Accountant
         * @description Get AI-powered comparative analysis for forensic accountant review
         *     Shows how claim compares to industry benchmarks
         */
        get: operations["get_comparative_analysis_for_accountant_api_v1_collaboration_reports__report_id__comparative_analysis_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/review-insights": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Review Insights For Accountant
         * @description Get AI-generated review insights and key questions for forensic accountant
         *     Analyzes the report and generates relevant Q&A based on the specific claim
         */
        get: operations["get_review_insights_for_accountant_api_v1_collaboration_reports__report_id__review_insights_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/documents/download-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download All Documents
         * @description Download all report documents as a ZIP file
         */
        get: operations["download_all_documents_api_v1_collaboration_reports__report_id__documents_download_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/documents/{file_type}/{file_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Report Document
         * @description Download a specific document from a report (tax file, P&L, or other)
         *     Converts structured data to CSV format for download
         */
        get: operations["download_report_document_api_v1_collaboration_reports__report_id__documents__file_type___file_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/versions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Versions
         * @description Get all versions for a report
         */
        get: operations["get_versions_api_v1_collaboration_reports__report_id__versions_get"];
        put?: never;
        /**
         * Create Version
         * @description Create a version snapshot of the report
         */
        post: operations["create_version_api_v1_collaboration_reports__report_id__versions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/versions/{version_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Version Detail
         * @description Get detailed version including snapshot data
         */
        get: operations["get_version_detail_api_v1_collaboration_reports__report_id__versions__version_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/signatures": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Signatures
         * @description Get all signatures for a report
         */
        get: operations["get_signatures_api_v1_collaboration_reports__report_id__signatures_get"];
        put?: never;
        /**
         * Create Signature
         * @description Create an e-signature for the report
         */
        post: operations["create_signature_api_v1_collaboration_reports__report_id__signatures_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/accountant/dashboard-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Dashboard Stats
         * @description Get firm-wide dashboard statistics for multi-client view
         *     Returns aggregated stats across all shared reports
         */
        get: operations["get_accountant_dashboard_stats_api_v1_collaboration_accountant_dashboard_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/accountant/clients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Clients
         * @description Get list of unique clients for filtering
         *     Returns client names with claim counts and total values
         */
        get: operations["get_accountant_clients_api_v1_collaboration_accountant_clients_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/accountant/claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Claims
         * @description Get all claims across clients with filtering options
         *     Enhanced view for multi-client management
         */
        get: operations["get_accountant_claims_api_v1_collaboration_accountant_claims_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/accountant/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant All Comments
         * @description Get all comments across all shared reports
         *     For the Comments page in accountant portal
         */
        get: operations["get_accountant_all_comments_api_v1_collaboration_accountant_comments_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/public-share": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Public Share
         * @description Create a public shareable link for read-only report access.
         *     No authentication required to view - perfect for opposing counsel/adjusters.
         */
        post: operations["create_public_share_api_v1_collaboration_reports__report_id__public_share_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/public/{share_token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Public Share
         * @description View a shared report - NO AUTHENTICATION REQUIRED.
         *     Returns report data for read-only display.
         */
        get: operations["get_public_share_api_v1_collaboration_public__share_token__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/public/{share_token}/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Public Share Pdf
         * @description Download watermarked PDF for a shared report - NO AUTHENTICATION REQUIRED.
         */
        get: operations["get_public_share_pdf_api_v1_collaboration_public__share_token__pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/reports/{report_id}/public-shares": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Public Shares
         * @description List all public shares for a report (for the owner)
         */
        get: operations["list_public_shares_api_v1_collaboration_reports__report_id__public_shares_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/public-shares/{share_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Revoke Public Share
         * @description Revoke a public share link
         */
        delete: operations["revoke_public_share_api_v1_collaboration_public_shares__share_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Invite User To Case
         * @description Invite a user to collaborate on a case.
         *     Only case owners can send invitations.
         *     Stores the invite in the ``collaboration_invites`` collection.
         */
        post: operations["invite_user_to_case_api_v1_collaboration_invite_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/cases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Collaboration Cases
         * @description List all cases that have been shared with the current user
         *     via the collaboration portal.
         */
        get: operations["list_collaboration_cases_api_v1_collaboration_cases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/cases/{case_id}/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Comments
         * @description Get all comments for a shared case.
         *     The caller must be the case owner OR hold an accepted invite.
         */
        get: operations["get_case_comments_api_v1_collaboration_cases__case_id__comments_get"];
        put?: never;
        /**
         * Add Case Comment
         * @description Add a comment to a shared case.
         *     The caller must be the case owner OR hold an accepted invite.
         */
        post: operations["add_case_comment_api_v1_collaboration_cases__case_id__comments_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/invite/{invite_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Revoke Collaboration Invite
         * @description Revoke (cancel) a collaboration invitation.
         *     Only the inviter (case owner) can revoke.
         */
        delete: operations["revoke_collaboration_invite_api_v1_collaboration_invite__invite_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/collaboration/cases/{case_id}/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Activity
         * @description Get the activity feed for a shared case.
         *     The caller must be the case owner OR hold an accepted invite.
         */
        get: operations["get_case_activity_api_v1_collaboration_cases__case_id__activity_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/accountant-profile/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Or Update Profile
         * @description Create or update accountant profile with credentials
         *     This allows accountants to input their credentials once, which will be
         *     automatically inserted into all reports they generate
         */
        post: operations["create_or_update_profile_api_v1_accountant_profile_create_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/accountant-profile/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get My Profile
         * @description Get the authenticated accountant's profile
         */
        get: operations["get_my_profile_api_v1_accountant_profile_me_get"];
        put?: never;
        post?: never;
        /**
         * Delete My Profile
         * @description Delete accountant profile (for testing or if they leave)
         */
        delete: operations["delete_my_profile_api_v1_accountant_profile_me_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/accountant-profile/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check Profile Status
         * @description Quick check if accountant has completed their profile
         *     Used to prompt profile completion if needed
         */
        get: operations["check_profile_status_api_v1_accountant_profile_check_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comments/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Comment
         * @description Create a new comment on a report section
         */
        post: operations["create_comment_api_v1_comments__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comments/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comments
         * @description Get all comments for a report, optionally filtered by section
         */
        get: operations["get_comments_api_v1_comments__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comments/{comment_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Comment
         * @description Update an existing comment
         */
        put: operations["update_comment_api_v1_comments__comment_id__put"];
        post?: never;
        /**
         * Delete Comment
         * @description Delete a comment
         */
        delete: operations["delete_comment_api_v1_comments__comment_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comments/{comment_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Toggle Comment Resolution
         * @description Toggle the resolved status of a comment thread
         */
        post: operations["toggle_comment_resolution_api_v1_comments__comment_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comments/{report_id}/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comment Count
         * @description Get comment count by section for a report
         */
        get: operations["get_comment_count_api_v1_comments__report_id__count_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activity/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Log Activity
         * @description Log a user activity for audit trail
         */
        post: operations["log_activity_api_v1_activity_log_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activity/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Activity
         * @description Get activity log for a specific report
         */
        get: operations["get_report_activity_api_v1_activity__report_id__get"];
        put?: never;
        post?: never;
        /**
         * Clear Report Activity
         * @description Clear activity log for a report (admin only)
         */
        delete: operations["clear_report_activity_api_v1_activity__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activity/user/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get My Activity
         * @description Get activity log for the current user across all reports
         */
        get: operations["get_my_activity_api_v1_activity_user_me_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activity/reports/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Activity Summary
         * @description Get activity summary statistics
         */
        get: operations["get_activity_summary_api_v1_activity_reports_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activity/admin/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Activities
         * @description Get all activities across all reports (admin/owner only)
         *     Supports filtering by user, action type, date range, and search
         */
        get: operations["get_all_activities_api_v1_activity_admin_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/signatures/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Signature
         * @description Create a digital signature on a report
         */
        post: operations["create_signature_api_v1_signatures__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/signatures/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Signature
         * @description Get the signature for a report
         */
        get: operations["get_signature_api_v1_signatures__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/signatures/{report_id}/image": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Signature Image
         * @description Get the signature image data for a report
         */
        get: operations["get_signature_image_api_v1_signatures__report_id__image_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/signatures/{signature_id}/revoke": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Revoke Signature
         * @description Revoke a signature (admin or signer only)
         */
        post: operations["revoke_signature_api_v1_signatures__signature_id__revoke_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/signatures/{report_id}/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Verify Signature
         * @description Verify the authenticity and validity of a signature
         */
        get: operations["verify_signature_api_v1_signatures__report_id__verify_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/tags/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add Tags To Report
         * @description Add tags to a report
         */
        post: operations["add_tags_to_report_api_v1_dashboard_tags_add_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/tags/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Remove Tag From Report
         * @description Remove a tag from a report
         */
        post: operations["remove_tag_from_report_api_v1_dashboard_tags_remove_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/tags/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Tags
         * @description Get all unique tags used by the user
         */
        get: operations["get_all_tags_api_v1_dashboard_tags_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/views": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Saved Views
         * @description Get all saved views for the current user
         */
        get: operations["get_saved_views_api_v1_dashboard_views_get"];
        put?: never;
        /**
         * Create Saved View
         * @description Create a saved view (filter/sort combination)
         */
        post: operations["create_saved_view_api_v1_dashboard_views_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/views/{view_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Saved View
         * @description Update a saved view
         */
        put: operations["update_saved_view_api_v1_dashboard_views__view_id__put"];
        post?: never;
        /**
         * Delete Saved View
         * @description Delete a saved view
         */
        delete: operations["delete_saved_view_api_v1_dashboard_views__view_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Templates
         * @description Get all report templates for the current user
         */
        get: operations["get_report_templates_api_v1_dashboard_templates_get"];
        put?: never;
        /**
         * Create Report Template
         * @description Create a report template
         */
        post: operations["create_report_template_api_v1_dashboard_templates_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/templates/{template_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Template
         * @description Get a specific report template
         */
        get: operations["get_report_template_api_v1_dashboard_templates__template_id__get"];
        /**
         * Update Report Template
         * @description Update a report template
         */
        put: operations["update_report_template_api_v1_dashboard_templates__template_id__put"];
        post?: never;
        /**
         * Delete Report Template
         * @description Delete a report template
         */
        delete: operations["delete_report_template_api_v1_dashboard_templates__template_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/templates/categories/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Template Categories
         * @description Get all template categories
         */
        get: operations["get_template_categories_api_v1_dashboard_templates_categories_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/extract-from-document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract From Document
         * @description Extract structured data from document text using AI
         */
        post: operations["extract_from_document_api_v1_ai_automation_extract_from_document_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/auto-categorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Auto Categorize Report
         * @description Automatically categorize and tag a report
         */
        post: operations["auto_categorize_report_api_v1_ai_automation_auto_categorize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/suggest-fields": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Suggest Missing Fields
         * @description Suggest values for missing fields based on partial data
         */
        post: operations["suggest_missing_fields_api_v1_ai_automation_suggest_fields_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/generate-tags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Smart Tags
         * @description Generate smart tags from text content
         */
        post: operations["generate_smart_tags_api_v1_ai_automation_generate_tags_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/predict-duration": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Predict Event Duration
         * @description Predict typical event duration and recovery period
         */
        post: operations["predict_event_duration_api_v1_ai_automation_predict_duration_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/analyze-document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Document Relevance
         * @description Analyze document relevance to claim
         */
        post: operations["analyze_document_relevance_api_v1_ai_automation_analyze_document_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-automation/auto-tag-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Auto Tag Report
         * @description Automatically tag an existing report based on its content
         */
        post: operations["auto_tag_report_api_v1_ai_automation_auto_tag_report_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Config
         * @description Get current global configuration for future closure calculations.
         *
         *     Returns default multipliers, continuation ranges, etc.
         */
        get: operations["get_config_api_v1_future_closure_config_get"];
        /**
         * Update Config
         * @description Update global configuration for organization.
         *
         *     Admin-only endpoint to modify defaults.
         */
        put: operations["update_config_api_v1_future_closure_config_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Future Closure
         * @description Calculate future forced closure demand for a specific report.
         *
         *     Parameters:
         *         - aggression: 0-100 slider value
         *         - use_best_base: true/false
         *         - base_months: 12-96
         *         - custom_continuations: optional overrides
         *         - custom_one_time_costs: optional overrides
         *         - closure_duration_months: default 36
         *
         *     This saves the calculation to the database and returns results.
         */
        post: operations["calculate_future_closure_api_v1_future_closure_calculate__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculations/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Calculations
         * @description Get all future closure calculations for a report.
         *
         *     Returns history of calculations with different parameters.
         */
        get: operations["get_calculations_api_v1_future_closure_calculations__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculation/{calculation_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Calculation
         * @description Get a specific calculation by ID.
         */
        get: operations["get_calculation_api_v1_future_closure_calculation__calculation_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/project-post-loss/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Project Post Loss Revenue
         * @description Generate "But-For" projections for the post-loss period.
         *
         *     This endpoint answers: "What would revenue have been if the event hadn't occurred?"
         *
         *     Uses:
         *     - Historical revenue data to establish baseline
         *     - Prophet forecasting (if available) or statistical methods
         *     - BLS industry data for market-adjusted projections
         *     - Confidence intervals for court-defensible ranges
         *
         *     Parameters (optional in body):
         *     - interruption_days: Override the interruption period length
         *     - naics_code: Industry code for BLS data integration
         *     - confidence_level: 0.80, 0.95, or 0.99 (default: 0.95)
         *     - actual_revenue_during_loss: Actual revenue earned during loss period (for comparison)
         *
         *     Returns:
         *     - Projected revenue (what it SHOULD have been)
         *     - Confidence intervals
         *     - Comparison with actual revenue (if provided)
         *     - Lost revenue calculation
         *     - Monthly/daily breakdowns
         *     - Methodology documentation
         */
        post: operations["project_post_loss_revenue_api_v1_future_closure_project_post_loss__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/projections/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Projections History
         * @description Get all but-for projections for a report.
         */
        get: operations["get_projections_history_api_v1_future_closure_projections__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/sensitivity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Sensitivity Analysis
         * @description Run sensitivity analysis for future closure demand.
         *
         *     Varies key drivers +/-10% to show impact on total demand.
         *     Returns data for tornado chart visualization.
         *
         *     Parameters:
         *         - aggression: Base aggression level
         *         - use_best_base: Base period selection
         *         - base_months: Historical period length
         *         - variation_pct: Percentage to vary (default: 0.10)
         */
        post: operations["calculate_sensitivity_analysis_api_v1_future_closure_calculate__report_id__sensitivity_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/monte-carlo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Monte Carlo
         * @description Run Monte Carlo simulation for future closure demand.
         *
         *     Parameters:
         *         - aggression: Base aggression level
         *         - iterations: Number of simulations (default: 50000)
         *         - noise_pct: Noise percentage (default: 0.15)
         */
        post: operations["calculate_monte_carlo_api_v1_future_closure_calculate__report_id__monte_carlo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/analyze-edge-cases/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Edge Cases
         * @description Analyze edge cases for future closure calculation.
         *
         *     Detects and flags:
         *     - Revenue spikes (>25% YoY)
         *     - Data gaps (missing months)
         *     - Entity-specific adjustments
         *
         *     Returns flags, dual projections, and processed data info.
         */
        post: operations["analyze_edge_cases_api_v1_future_closure_analyze_edge_cases__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/generate-explanation/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Edge Case Explanation
         * @description Generate AI-powered explanation of edge case overrides.
         *
         *     Takes the analysis_flags, edge_case_config, and optional Monte Carlo results
         *     and generates a professional, defensible narrative explanation suitable for:
         *     - Report documentation
         *     - Opposing counsel explanations
         *     - Litigation support
         *
         *     Returns:
         *         {
         *             "explanation_text": str,  # Full narrative
         *             "sections": dict,         # Parsed sections
         *             "summary": str,           # One-paragraph summary
         *             "word_count": int
         *         }
         */
        post: operations["generate_edge_case_explanation_api_v1_future_closure_generate_explanation__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/export/{report_id}/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Future Closure Pdf Endpoint
         * @description Generate and download PDF report for Future Forced Closure analysis.
         *
         *     This creates a comprehensive, court-ready PDF including:
         *     - Executive Summary with total demand
         *     - Pro Forma projection table (36 months)
         *     - Assumptions & Configuration Log
         *     - One-Time Costs breakdown
         *     - Methodology & Defensibility notes
         *
         *     Parameters:
         *         - calculation_id: Optional specific calculation to export (default: latest)
         *
         *     Returns:
         *         PDF file as streaming response
         */
        get: operations["export_future_closure_pdf_endpoint_api_v1_future_closure_export__report_id__pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/export/{report_id}/docx": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Future Closure Docx
         * @description Generate and download editable Word document expert report.
         *
         *     Creates a professional Word document for attorneys including:
         *     - Executive Summary with total demand
         *     - Methodology documentation
         *     - Financial analysis
         *     - Calculation Audit Trail (Appendix B)
         *
         *     Word format allows attorneys to edit and customize before filing.
         */
        get: operations["export_future_closure_docx_api_v1_future_closure_export__report_id__docx_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/case-config/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Config
         * @description Get case-specific configuration overrides for a report.
         *
         *     Returns saved configuration for this specific case, if any.
         */
        get: operations["get_case_config_api_v1_future_closure_case_config__report_id__get"];
        /**
         * Save Case Config
         * @description Save case-specific configuration overrides for a report.
         *
         *     Allows attorneys to save custom settings that override global defaults
         *     for this specific case.
         *
         *     Config structure:
         *     {
         *         "aggression": 65,
         *         "use_best_base": true,
         *         "base_months": 36,
         *         "closure_duration_months": 36,
         *         "custom_continuations": {
         *             "officer_salary": 100,
         *             "employee_wages": 100,
         *             "rent": 100,
         *             "utilities": 30,
         *             "insurance": 90,
         *             "other_expenses": 35
         *         },
         *         "custom_one_time_costs": null,
         *         "notes": "Custom settings for Smith v. ChemCorp litigation"
         *     }
         */
        put: operations["save_case_config_api_v1_future_closure_case_config__report_id__put"];
        post?: never;
        /**
         * Delete Case Config
         * @description Delete case-specific configuration, reverting to global defaults.
         */
        delete: operations["delete_case_config_api_v1_future_closure_case_config__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/validate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Validate Report Data
         * @description Validate report data for Future Closure calculations.
         *
         *     Returns warnings and errors about data quality, completeness,
         *     and suitability for projections.
         */
        get: operations["validate_report_data_api_v1_future_closure_validate__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/audit-trail/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Audit Trail
         * @description Get the full calculation audit trail for a report.
         *
         *     Returns all logged parameter changes for legal defensibility review.
         */
        get: operations["get_audit_trail_api_v1_future_closure_audit_trail__report_id__get"];
        put?: never;
        /**
         * Add Audit Trail Entry
         * @description Add an entry to the calculation audit trail for legal defensibility.
         *
         *     Logs parameter changes with timestamps for court documentation.
         */
        post: operations["add_audit_trail_entry_api_v1_future_closure_audit_trail__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/scenarios/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Saved Scenarios
         * @description Get all saved future closure scenarios for a report.
         */
        get: operations["get_saved_scenarios_api_v1_future_closure_scenarios__report_id__get"];
        put?: never;
        /**
         * Save Scenario
         * @description Save a future closure calculation as a named scenario.
         *     Body: { name: str, calculation_id: str, notes?: str }
         */
        post: operations["save_scenario_api_v1_future_closure_scenarios__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/scenarios/{report_id}/{scenario_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Scenario
         * @description Delete a saved scenario.
         */
        delete: operations["delete_scenario_api_v1_future_closure_scenarios__report_id___scenario_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/scenarios/{report_id}/compare": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Scenarios
         * @description Compare multiple saved scenarios side-by-side.
         *     Body: { scenario_ids: [str, str, ...] }
         *     Returns normalized comparison data for all requested scenarios.
         */
        post: operations["compare_scenarios_api_v1_future_closure_scenarios__report_id__compare_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/pv-discount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Pv Discount
         * @description Apply present-value discounting to the FC demand.
         *
         *     Parameters (in body):
         *         method: "treasury" | "wacc" | "custom"
         *         rate: custom annual rate (required if method="custom")
         *         compounding: "discrete" | "continuous" (default: "discrete")
         *         projection_months: number of months to discount (default: 36)
         *         For WACC:
         *             cost_of_equity: annual cost of equity
         *             cost_of_debt: annual cost of debt
         *             equity_weight: weight of equity (0-1)
         *             tax_rate: corporate tax rate
         */
        post: operations["calculate_pv_discount_api_v1_future_closure_calculate__report_id__pv_discount_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/policy-deductions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Policy Deductions
         * @description Apply the full policy-deductions waterfall to the FC demand.
         *
         *     Parameters (in body):
         *         waiting_period_hours: 0, 24, 48, 72
         *         waiting_period_retroactive: bool
         *         adv_deductible_days: int
         *         dollar_deductible: number
         *         coinsurance_pct: 80, 90, 100
         *         actual_coverage_limit: number
         *         annual_bi_value: number (defaults to gross loss)
         *         policy_limit: number
         */
        post: operations["calculate_policy_deductions_api_v1_future_closure_calculate__report_id__policy_deductions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/bottom-up": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Bottom Up
         * @description Run the ISO CP 00 30 bottom-up BI calculation and reconcile with top-down.
         *
         *     Parameters (in body):
         *         expense_classifications: dict mapping expense name -> classification
         *             ("fixed_continuing", "variable", "semi_variable")
         *         loss_period_start_year: int (year)
         *         loss_period_start_month: int (1-12)
         *         loss_period_months: int (default 12)
         *         tolerance_pct: float (default 10, variance tolerance for reconciliation)
         */
        post: operations["calculate_bottom_up_api_v1_future_closure_calculate__report_id__bottom_up_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/future-closure/calculate/{report_id}/epi": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Epi
         * @description Calculate Extended Period of Indemnity (post-restoration ramp-up losses).
         *
         *     Parameters (in body):
         *         epi_duration_days: 30-720 (default 180)
         *         restoration_date: "YYYY-MM-DD" (required)
         *         ramp_up_curve: "linear" | "exponential" | "s_curve" | "custom"
         *         but_for_monthly_revenue: list of monthly but-for revenue amounts
         *         actual_monthly_revenue: list of monthly actual revenue amounts
         *         saved_costs: list of monthly saved costs (optional, defaults to 0)
         */
        post: operations["calculate_epi_api_v1_future_closure_calculate__report_id__epi_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/check-messiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Check Document Messiness
         * @description Universal messiness check for ALL file types.
         *
         *     Analyzes uploaded documents to detect data quality issues:
         *     - PDF: Scanned detection, OCR confidence, text structure
         *     - CSV: Headers, column consistency, duplicates, encoding
         *     - Excel: Multiple sheets, merged cells, hidden content, formulas
         *
         *     Returns issues with severity levels (red=blocking, amber=warning)
         *     and recommendations for handling messy data.
         */
        post: operations["check_document_messiness_api_v1_cleanup_check_messiness_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload Cleanup Documents
         * @description Upload documents for BI financial cleanup
         *
         *     Supported formats: PDF, XLSX, XLS, CSV
         *     Max files: 50 per upload
         *     Max file size: 50MB each
         *
         *     Triggers async processing pipeline:
         *     1. Store files in GridFS
         *     2. Intelligent OCR (pdfplumber → Textract fallback)
         *     3. Transaction extraction
         *     4. AI classification with confidence scoring
         *     5. Route to validation queue
         */
        post: operations["upload_cleanup_documents_api_v1_cleanup_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/by-report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Job By Report Id
         * @description Find the most recent cleanup job associated with a report/draft ID.
         *     This is used when navigating from the work queue to transaction validation.
         */
        get: operations["get_job_by_report_id_api_v1_cleanup_jobs_by_report__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Job Status
         * @description Get cleanup job status and statistics
         */
        get: operations["get_job_status_api_v1_cleanup_jobs__job_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Cleanup Job
         * @description Delete a single cleanup job and all its associated data
         */
        delete: operations["delete_cleanup_job_api_v1_cleanup_jobs__job_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Job Transactions
         * @description Get transactions for a cleanup job with pagination.
         *
         *     If transaction_id is provided, returns the page containing that transaction.
         */
        get: operations["get_job_transactions_api_v1_cleanup_jobs__job_id__transactions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Review Transaction
         * @description Review and approve/modify a single transaction
         */
        post: operations["review_transaction_api_v1_cleanup_jobs__job_id__review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/bulk-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Review Transactions
         * @description Bulk review multiple transactions with same action
         */
        post: operations["bulk_review_transactions_api_v1_cleanup_jobs__job_id__bulk_review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/re-auto-approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Rerun Auto Approval
         * @description Re-run auto-approval on pending transactions with improved logic
         *
         *     This applies smart auto-approval to transactions that:
         *     - Have high confidence (>=90%) in clear-cut categories
         *     - Have medium-high confidence (>=85%) in unambiguous categories
         *
         *     Useful when approval thresholds have been updated.
         */
        post: operations["rerun_auto_approval_api_v1_cleanup_jobs__job_id__re_auto_approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/re-classify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reclassify Transactions
         * @description Re-classify all transactions with the latest classification rules
         *
         *     This is useful when:
         *     - Vendor database has been updated
         *     - Classification rules have been improved
         *     - Need to apply latest AI models to existing data
         */
        post: operations["reclassify_transactions_api_v1_cleanup_jobs__job_id__re_classify_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mark Job Complete
         * @description Mark a cleanup job as complete
         */
        post: operations["mark_job_complete_api_v1_cleanup_jobs__job_id__complete_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/save-for-later": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Job For Later
         * @description Save a cleanup job for later continuation.
         *     This marks the job as saved and records progress for easy resumption.
         *     Optionally accepts a business_name to identify the job.
         */
        post: operations["save_job_for_later_api_v1_cleanup_jobs__job_id__save_for_later_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Cleanup Jobs
         * @description List all cleanup jobs for the organization
         */
        get: operations["list_cleanup_jobs_api_v1_cleanup_jobs_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/bulk-delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Delete Cleanup Jobs
         * @description Delete multiple cleanup jobs at once
         */
        post: operations["bulk_delete_cleanup_jobs_api_v1_cleanup_jobs_bulk_delete_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/stuck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stuck Jobs
         * @description Get all jobs that appear to be stuck (in processing state for >30 minutes)
         */
        get: operations["get_stuck_jobs_api_v1_cleanup_jobs_stuck_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/mark-stuck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mark Job As Stuck
         * @description Manually mark a job as stuck/failed
         */
        post: operations["mark_job_as_stuck_api_v1_cleanup_jobs__job_id__mark_stuck_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry Stuck Job
         * @description Attempt to retry a stuck job by re-processing its files
         */
        post: operations["retry_stuck_job_api_v1_cleanup_jobs__job_id__retry_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Clean Csv
         * @description Export clean financial data as CSV or JSON
         */
        get: operations["export_clean_csv_api_v1_cleanup_jobs__job_id__export_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/wizard-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Wizard Financial Data
         * @description Convert cleanup job transactions to wizard financial_data format.
         *     This endpoint transforms approved transactions into the format expected
         *     by the report wizard (Step 3 financial data entry).
         *
         *     Returns:
         *     - financial_data: { data_2021: [...], data_2022: [...], ... }
         *     - summary: Monthly totals by category
         *     - metadata: Job info and transaction counts
         */
        get: operations["get_wizard_financial_data_api_v1_cleanup_jobs__job_id__wizard_data_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/jobs/{job_id}/link-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Link Cleanup To Report
         * @description Link a cleanup job to an existing report
         */
        post: operations["link_cleanup_to_report_api_v1_cleanup_jobs__job_id__link_report_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/test/generate-sample": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Sample Job
         * @description Generate a sample cleanup job with realistic test transactions
         *
         *     Args:
         *         request: GenerateSampleRequest with num_transactions and review_percentage
         *
         *     Returns:
         *         Job ID and statistics
         */
        post: operations["generate_sample_job_api_v1_cleanup_test_generate_sample_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/test/ocr-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Check Ocr Providers
         * @description Check status of OCR providers
         */
        post: operations["check_ocr_providers_api_v1_cleanup_test_ocr_check_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/test/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Categories
         * @description List all valid expense categories (anti-hallucination reference)
         */
        get: operations["list_categories_api_v1_cleanup_test_categories_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/test/cleanup-test-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Cleanup Test Data
         * @description Delete all test-generated cleanup jobs and transactions
         */
        delete: operations["cleanup_test_data_api_v1_cleanup_test_cleanup_test_data_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Overall Metrics
         * @description Get overall model monitoring metrics
         *
         *     Calculates:
         *     - Auto-approval rate (high confidence transactions)
         *     - Human review rate (medium + low confidence)
         *     - Override rate (human changed AI classification)
         *     - Average confidence score
         *     - Accuracy score (AI vs human agreement)
         */
        get: operations["get_overall_metrics_api_v1_cleanup_monitoring_metrics_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/approval-rate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Approval Rate Over Time
         * @description Get auto-approval rate over time
         *
         *     Returns time series of approval rates for trend analysis
         */
        get: operations["get_approval_rate_over_time_api_v1_cleanup_monitoring_approval_rate_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/override-rate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Override Rate By Category
         * @description Get override rate by category
         *
         *     Shows which categories have the highest rate of human corrections
         */
        get: operations["get_override_rate_by_category_api_v1_cleanup_monitoring_override_rate_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/accuracy-drift": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accuracy Drift
         * @description Get accuracy drift over time
         *
         *     Compares AI classification accuracy vs human final decision
         *     Useful for detecting model degradation
         */
        get: operations["get_accuracy_drift_api_v1_cleanup_monitoring_accuracy_drift_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/top-overrides": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Top Overrides
         * @description Get top category overrides (AI category → Human correction)
         *
         *     Shows most common AI mistakes for model improvement
         */
        get: operations["get_top_overrides_api_v1_cleanup_monitoring_top_overrides_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/monitoring/category-performance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Category Performance
         * @description Get AI performance breakdown by category
         *
         *     Shows accuracy, confidence, and volume for each category
         */
        get: operations["get_category_performance_api_v1_cleanup_monitoring_category_performance_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stats
         * @description Get overall correction statistics
         *
         *     Returns:
         *     - Total number of corrections stored
         *     - Corrections by category
         *     - Most common correction patterns (from → to)
         */
        get: operations["get_stats_api_v1_cleanup_corrections_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/vendor/{vendor}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Vendor Corrections
         * @description Get correction history for a specific vendor
         *
         *     Useful for understanding how a vendor has been categorized in the past
         */
        get: operations["get_vendor_corrections_api_v1_cleanup_corrections_vendor__vendor__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/similar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Find Similar
         * @description Find similar historical corrections
         *
         *     Uses vector similarity search to find transactions with similar
         *     vendor/description patterns that have been corrected by humans.
         */
        post: operations["find_similar_api_v1_cleanup_corrections_similar_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/boost": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Boost
         * @description Get boosted classification based on historical corrections
         *
         *     Checks if similar transactions have been corrected before and
         *     returns a potentially modified classification with boosted confidence.
         */
        post: operations["get_boost_api_v1_cleanup_corrections_boost_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add Correction
         * @description Manually add a correction record
         *
         *     Useful for seeding the correction database with known patterns
         *     or importing historical corrections.
         */
        post: operations["add_correction_api_v1_cleanup_corrections_add_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Recent Corrections
         * @description Get recent corrections for review
         *
         *     Returns the most recent human corrections for monitoring
         */
        get: operations["get_recent_corrections_api_v1_cleanup_corrections_recent_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/corrections/clear-test-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Clear Test Corrections
         * @description Clear test correction data (development only)
         *
         *     WARNING: This deletes all corrections. Use only for testing.
         */
        delete: operations["clear_test_corrections_api_v1_cleanup_corrections_clear_test_data_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/anomalies/{job_id}/detect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Anomalies
         * @description Run anomaly detection for a cleanup job
         *
         *     Analyzes all transactions in the job and detects:
         *     - Revenue spikes/drops (>25% change)
         *     - Missing months/gaps
         *     - Large one-off transactions (>$10k)
         *     - Utility payment gaps
         *     - COGS exceeding revenue
         *     - Potential duplicates
         *     - Suspicious round numbers
         *     - Category imbalances
         */
        post: operations["detect_anomalies_api_v1_cleanup_anomalies__job_id__detect_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/anomalies/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Anomalies
         * @description Get all anomalies for a cleanup job
         *
         *     Supports filtering by severity, type, and resolution status
         */
        get: operations["get_anomalies_api_v1_cleanup_anomalies__job_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/anomalies/{job_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Summary
         * @description Get anomaly summary for a cleanup job
         *
         *     Returns counts by severity and type
         */
        get: operations["get_summary_api_v1_cleanup_anomalies__job_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/anomalies/{anomaly_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve
         * @description Mark an anomaly as resolved
         *
         *     Requires a resolution note explaining how the issue was addressed
         */
        post: operations["resolve_api_v1_cleanup_anomalies__anomaly_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/anomalies/types/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Anomaly Types
         * @description Get list of all anomaly types with descriptions
         */
        get: operations["get_anomaly_types_api_v1_cleanup_anomalies_types_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Notifications
         * @description Get notifications for the current user
         *
         *     Supports pagination and filtering by read status
         */
        get: operations["list_notifications_api_v1_cleanup_notifications_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications/unread-count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Unread
         * @description Get count of unread notifications
         *
         *     Use this endpoint for polling (every 30s recommended)
         */
        get: operations["get_unread_api_v1_cleanup_notifications_unread_count_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications/{notification_id}/read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Read Notification
         * @description Mark a notification as read
         */
        post: operations["read_notification_api_v1_cleanup_notifications__notification_id__read_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications/mark-all-read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Read All Notifications
         * @description Mark all notifications as read
         */
        post: operations["read_all_notifications_api_v1_cleanup_notifications_mark_all_read_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications/{notification_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove Notification
         * @description Delete a notification
         */
        delete: operations["remove_notification_api_v1_cleanup_notifications__notification_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/notifications/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Test Notification
         * @description Create a test notification (development only)
         *
         *     Useful for testing the notification UI
         */
        post: operations["create_test_notification_api_v1_cleanup_notifications_test_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/quickbooks/connect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Initiate Quickbooks Connect
         * @description Step 1: Initiate QuickBooks OAuth flow
         *     Returns the authorization URL to redirect user to QuickBooks login
         */
        get: operations["initiate_quickbooks_connect_api_v1_auth_quickbooks_connect_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/quickbooks/callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Quickbooks Oauth Callback
         * @description Step 2: Handle QuickBooks OAuth callback
         *     Exchange authorization code for access tokens
         */
        get: operations["quickbooks_oauth_callback_api_v1_auth_quickbooks_callback_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/quickbooks/status/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Quickbooks Status
         * @description Check if user has an active QuickBooks connection
         */
        get: operations["get_quickbooks_status_api_v1_auth_quickbooks_status__user_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/quickbooks/import/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Import Quickbooks Data
         * @description Import financial data from QuickBooks
         *     Returns transactions and P&L data formatted for the wizard
         */
        post: operations["import_quickbooks_data_api_v1_auth_quickbooks_import__user_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/auth/quickbooks/disconnect/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Disconnect Quickbooks
         * @description Disconnect QuickBooks account
         */
        delete: operations["disconnect_quickbooks_api_v1_auth_quickbooks_disconnect__user_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/learnings/record": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record Correction
         * @description Record a user's category correction for future learning.
         *     This helps improve AI categorization accuracy over time.
         */
        post: operations["record_correction_api_v1_cleanup_learnings_record_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/learnings/suggest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Category Suggestion
         * @description Get a category suggestion based on previous learnings.
         *     Returns the learned category if a matching pattern is found.
         */
        get: operations["get_category_suggestion_api_v1_cleanup_learnings_suggest_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/learnings/suggest-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Batch Suggestions
         * @description Get category suggestions for multiple transactions at once.
         *     More efficient than calling suggest endpoint multiple times.
         */
        get: operations["get_batch_suggestions_api_v1_cleanup_learnings_suggest_batch_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/learnings/stats/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Learning Stats
         * @description Get statistics about the learning system for a user.
         */
        get: operations["get_learning_stats_api_v1_cleanup_learnings_stats__user_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cleanup/learnings/reset/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Reset User Learnings
         * @description Reset all learnings for a specific user.
         *     Use with caution!
         */
        delete: operations["reset_user_learnings_api_v1_cleanup_learnings_reset__user_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Templates
         * @description Get list of all available report templates.
         *     Returns summary info for each template.
         */
        get: operations["list_templates_api_v1_templates_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/calculate-estimates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Calculate Estimates
         * @description Calculate expense estimates based on template and revenue.
         */
        get: operations["calculate_estimates_api_v1_templates_calculate_estimates_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/{template_id}/future-closure-defaults": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Future Closure Defaults
         * @description Get Future Closure expense defaults for a template.
         *
         *     Returns BLS median-based expense percentages and calculated monthly amounts
         *     for use in the Quick Expense Entry Panel.
         *
         *     These defaults are conservative (BLS median) and defensible for
         *     settlement negotiations.
         */
        get: operations["get_future_closure_defaults_api_v1_templates__template_id__future_closure_defaults_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/apply": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Template To Pl
         * @description Apply a template's expense ratios to generate a complete P&L structure.
         *     Supports both single-year (legacy) and multi-year revenue inputs.
         *     Returns monthly estimates that can be used to populate the wizard.
         */
        post: operations["apply_template_to_pl_api_v1_templates_apply_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/apply-multi-year": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Template Multi Year
         * @description Apply a template's expense ratios for multi-year revenue inputs.
         *     Returns monthly estimates for all provided years.
         */
        post: operations["apply_template_multi_year_api_v1_templates_apply_multi_year_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Templates
         * @description Search templates by name, description, or business type.
         */
        get: operations["search_templates_api_v1_templates_search_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/by-business-type/{business_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Template By Business Type
         * @description Find the best matching template for a business type.
         */
        get: operations["get_template_by_business_type_api_v1_templates_by_business_type__business_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/templates/{template_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Template
         * @description Get a specific template by ID with all details.
         */
        get: operations["get_template_api_v1_templates__template_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Annotations
         * @description Get annotations for a report.
         *     Supports filtering by section, type, and resolved status.
         */
        get: operations["get_annotations_api_v1_annotations__report_id__get"];
        put?: never;
        /**
         * Create Annotation
         * @description Create an annotation on a shared report.
         *     Works for report owners, accountants, and viewers with share tokens.
         */
        post: operations["create_annotation_api_v1_annotations__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Annotation Summary
         * @description Get summary statistics for annotations on a report
         */
        get: operations["get_annotation_summary_api_v1_annotations__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}/{annotation_id}/replies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Annotation Replies
         * @description Get all replies to a specific annotation
         */
        get: operations["get_annotation_replies_api_v1_annotations__report_id___annotation_id__replies_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}/{annotation_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Annotation
         * @description Update an annotation (only by original author)
         */
        put: operations["update_annotation_api_v1_annotations__report_id___annotation_id__put"];
        post?: never;
        /**
         * Delete Annotation
         * @description Soft delete an annotation (only by author or report owner)
         */
        delete: operations["delete_annotation_api_v1_annotations__report_id___annotation_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}/{annotation_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve Annotation
         * @description Mark an annotation as resolved (by report owner or accountant with edit permission)
         */
        post: operations["resolve_annotation_api_v1_annotations__report_id___annotation_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/annotations/{report_id}/{annotation_id}/unresolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Unresolve Annotation
         * @description Mark an annotation as unresolved (reopen)
         */
        post: operations["unresolve_annotation_api_v1_annotations__report_id___annotation_id__unresolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pdf/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Pdf Job
         * @description Start async PDF generation.
         *     Returns immediately with job ID for progress tracking.
         */
        post: operations["create_pdf_job_api_v1_pdf_generate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pdf/jobs/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pdf Job
         * @description Get PDF job status and progress.
         *     Poll this endpoint for progress updates.
         */
        get: operations["get_pdf_job_api_v1_pdf_jobs__job_id__get"];
        put?: never;
        post?: never;
        /**
         * Cancel Pdf Job
         * @description Cancel a pending or processing PDF job
         */
        delete: operations["cancel_pdf_job_api_v1_pdf_jobs__job_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pdf/jobs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Pdf Jobs
         * @description List PDF generation jobs
         */
        get: operations["list_pdf_jobs_api_v1_pdf_jobs_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pdf/download/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Pdf
         * @description Download PDF file for a completed job (local storage fallback)
         */
        get: operations["download_pdf_api_v1_pdf_download__job_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cache/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stats
         * @description Get cache statistics
         */
        get: operations["get_stats_api_v1_cache_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cache/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Clear Cache
         * @description Clear cache (optionally by namespace)
         */
        post: operations["clear_cache_api_v1_cache_clear_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/cache/warmup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Warmup
         * @description Trigger cache warmup
         */
        post: operations["trigger_warmup_api_v1_cache_warmup_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stats
         * @description Get error statistics
         */
        get: operations["get_stats_api_v1_errors_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/circuit-breakers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Circuit Breakers
         * @description Get circuit breaker status
         */
        get: operations["get_circuit_breakers_api_v1_errors_circuit_breakers_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/circuit-breakers/{name}/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset Circuit Breaker
         * @description Reset a circuit breaker
         */
        post: operations["reset_circuit_breaker_api_v1_errors_circuit_breakers__name__reset_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Report Frontend Error
         * @description Receive error reports from frontend
         */
        post: operations["report_frontend_error_api_v1_errors_report_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comparison/compare": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Reports
         * @description Compare multiple reports side-by-side.
         *     Returns metrics, summary statistics, and chart data.
         */
        post: operations["compare_reports_api_v1_comparison_compare_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comparison/compare/{comparison_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Comparison
         * @description Get a saved comparison by ID
         */
        get: operations["get_comparison_api_v1_comparison_compare__comparison_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Comparison
         * @description Delete a saved comparison
         */
        delete: operations["delete_comparison_api_v1_comparison_compare__comparison_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comparison/user/{user_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get User Claims Summary
         * @description Get summary of all claims for a user.
         *     Useful for dashboard overview.
         */
        get: operations["get_user_claims_summary_api_v1_comparison_user__user_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/comparison/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Recent Comparisons
         * @description Get recent comparisons
         */
        get: operations["get_recent_comparisons_api_v1_comparison_recent_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlements/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Settlements
         * @description List settlements with optional filtering
         */
        get: operations["list_settlements_api_v1_settlements__get"];
        put?: never;
        /**
         * Create Settlement
         * @description Initialize settlement tracking for a report.
         *     Creates timeline with initial demand event.
         */
        post: operations["create_settlement_api_v1_settlements__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlements/{settlement_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Settlement
         * @description Get settlement details by ID
         */
        get: operations["get_settlement_api_v1_settlements__settlement_id__get"];
        /**
         * Update Settlement
         * @description Update settlement details
         */
        put: operations["update_settlement_api_v1_settlements__settlement_id__put"];
        post?: never;
        /**
         * Delete Settlement
         * @description Delete a settlement record
         */
        delete: operations["delete_settlement_api_v1_settlements__settlement_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlements/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Settlement By Report
         * @description Get settlement details by report ID
         */
        get: operations["get_settlement_by_report_api_v1_settlements_report__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlements/{settlement_id}/events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add Event
         * @description Add an event to the settlement timeline.
         *     Automatically updates status and amounts based on event type.
         */
        post: operations["add_event_api_v1_settlements__settlement_id__events_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlements/stats/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Settlement Stats
         * @description Get aggregate settlement statistics
         */
        get: operations["get_settlement_stats_api_v1_settlements_stats_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Brandings
         * @description List all branding configurations
         */
        get: operations["list_brandings_api_v1_branding__get"];
        put?: never;
        /**
         * Create Branding
         * @description Create branding configuration for an organization.
         *     Only one active branding per org allowed.
         */
        post: operations["create_branding_api_v1_branding__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Branding
         * @description Get branding configuration for an organization
         */
        get: operations["get_branding_api_v1_branding__org_id__get"];
        /**
         * Update Branding
         * @description Update branding configuration
         */
        put: operations["update_branding_api_v1_branding__org_id__put"];
        post?: never;
        /**
         * Delete Branding
         * @description Delete/deactivate branding for an organization
         */
        delete: operations["delete_branding_api_v1_branding__org_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}/css": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Branding Css
         * @description Get CSS variables for branding
         */
        get: operations["get_branding_css_api_v1_branding__org_id__css_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}/tailwind": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Branding Tailwind
         * @description Get Tailwind-compatible color config
         */
        get: operations["get_branding_tailwind_api_v1_branding__org_id__tailwind_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}/pdf-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pdf Branding
         * @description Get PDF-specific branding configuration
         */
        get: operations["get_pdf_branding_api_v1_branding__org_id__pdf_config_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview Branding
         * @description Preview branding without saving.
         *     Returns CSS and config for testing.
         */
        post: operations["preview_branding_api_v1_branding__org_id__preview_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/themes/presets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Preset Themes
         * @description Get available preset color themes
         */
        get: operations["get_preset_themes_api_v1_branding_themes_presets_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/branding/{org_id}/apply-theme/{theme_name}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Preset Theme
         * @description Apply a preset theme to organization's branding
         */
        post: operations["apply_preset_theme_api_v1_branding__org_id__apply_theme__theme_name__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/keys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Api Keys
         * @description List API keys for an organization
         */
        get: operations["list_api_keys_api_v1_external_keys_get"];
        put?: never;
        /**
         * Create Api Key
         * @description Create a new API key.
         *     ⚠️ The full API key is only shown once - save it securely!
         */
        post: operations["create_api_key_api_v1_external_keys_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/keys/{key_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Revoke Api Key
         * @description Revoke an API key
         */
        delete: operations["revoke_api_key_api_v1_external_keys__key_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/webhooks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Webhooks
         * @description List webhooks for the organization
         */
        get: operations["list_webhooks_api_v1_external_webhooks_get"];
        put?: never;
        /**
         * Create Webhook
         * @description Create a webhook subscription
         */
        post: operations["create_webhook_api_v1_external_webhooks_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/webhooks/{webhook_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Webhook
         * @description Delete a webhook
         */
        delete: operations["delete_webhook_api_v1_external_webhooks__webhook_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/webhooks/{webhook_id}/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Webhook
         * @description Send a test event to a webhook
         */
        post: operations["test_webhook_api_v1_external_webhooks__webhook_id__test_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Claims
         * @description List claims for the organization
         */
        get: operations["list_claims_api_v1_external_claims_get"];
        put?: never;
        /**
         * Create Claim
         * @description Create a new claim via API
         */
        post: operations["create_claim_api_v1_external_claims_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/claims/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim
         * @description Get a specific claim
         */
        get: operations["get_claim_api_v1_external_claims__claim_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Claim
         * @description Delete a claim
         */
        delete: operations["delete_claim_api_v1_external_claims__claim_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/usage": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Api Usage
         * @description Get API usage statistics
         */
        get: operations["get_api_usage_api_v1_external_usage_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external/openapi.json": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Openapi Schema
         * @description Get OpenAPI schema for this API
         */
        get: operations["get_openapi_schema_api_v1_external_openapi_json_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Analytics Summary
         * @description Get comprehensive analytics summary for the user's claims
         */
        get: operations["get_analytics_summary_api_v1_analytics_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Analytics Csv
         * @description Export all claims data as CSV-ready format
         */
        get: operations["export_analytics_csv_api_v1_analytics_export_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/data-health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Data Health Metrics
         * @description Get data health metrics for the Data Health Dashboard widget.
         *
         *     Returns:
         *     - % auto-categorized vs manual transactions
         *     - Average AI confidence score
         *     - Average client response time
         *     - % claims with pending clarifications >7 days
         *     - Top anomaly types
         */
        get: operations["get_data_health_metrics_api_v1_analytics_data_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/email-engagement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Engagement Analytics
         * @description 📧 EMAIL ENGAGEMENT ANALYTICS
         *
         *     Get aggregated email engagement metrics across all evidence requests.
         *
         *     Returns:
         *     - Summary metrics (total sent, open rate, click rate)
         *     - Daily trend data for charting
         *     - Recent email activity list
         */
        get: operations["get_email_engagement_analytics_api_v1_analytics_email_engagement_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/ab-test-results": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Ab Test Results
         * @description 🧪 A/B TEST RESULTS
         *
         *     Get performance results for email A/B tests.
         *     Compares open rates and click rates across variants.
         *
         *     Returns:
         *     - Per-variant metrics (sent, opened, clicked, rates)
         *     - Winner determination (variant with highest relevant rate)
         */
        get: operations["get_ab_test_results_api_v1_analytics_ab_test_results_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/ab-test/apply-winner": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Ab Test Winner
         * @description 🏆 APPLY A/B TEST WINNER
         *
         *     Lock a winning variant for all future emails.
         *     Stops A/B testing for that element and uses the winner consistently.
         */
        post: operations["apply_ab_test_winner_api_v1_analytics_ab_test_apply_winner_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/ab-test/clear-winner": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Clear Ab Test Winner
         * @description 🔄 CLEAR A/B TEST WINNER
         *
         *     Resume A/B testing for an element by clearing the locked winner.
         */
        post: operations["clear_ab_test_winner_api_v1_analytics_ab_test_clear_winner_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/ab-test/locked-winners": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Locked Winners
         * @description 🔒 GET LOCKED WINNERS
         *
         *     Get currently locked (applied) winners for an email type.
         */
        get: operations["get_locked_winners_api_v1_analytics_ab_test_locked_winners_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/email-retry/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Retry Stats
         * @description 📊 GET EMAIL RETRY STATISTICS
         *
         *     Returns retry queue metrics:
         *     - Jobs by status (pending, delivered, failed)
         *     - Jobs due for immediate retry
         *     - Recent failures (24h)
         *     - Success rate (7 day average)
         */
        get: operations["get_email_retry_stats_api_v1_analytics_email_retry_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/email-retry/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Retry History
         * @description 📋 GET EMAIL RETRY HISTORY
         *
         *     Returns list of retry jobs with their current status.
         *     Optionally filter by report_id.
         */
        get: operations["get_email_retry_history_api_v1_analytics_email_retry_history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/email-retry/{job_id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel Email Retry
         * @description ❌ CANCEL PENDING RETRY
         *
         *     Cancel a pending retry job. Only works for jobs with status=PENDING.
         */
        post: operations["cancel_email_retry_api_v1_analytics_email_retry__job_id__cancel_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analytics/email-retry/process-pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Retry Processing
         * @description ⚡ MANUALLY TRIGGER RETRY PROCESSING
         *
         *     Process all pending retries that are due now.
         *     Normally handled by Celery beat, but can be triggered manually.
         */
        post: operations["trigger_retry_processing_api_v1_analytics_email_retry_process_pending_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Test Email
         * @description Send a test email to verify email service is working
         */
        post: operations["send_test_email_api_v1_notifications_test_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/claim-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Claim Status Email
         * @description Send claim status update notification (runs in background)
         */
        post: operations["send_claim_status_email_api_v1_notifications_claim_status_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/share": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Share Email
         * @description Send share notification when a report is shared
         */
        post: operations["send_share_email_api_v1_notifications_share_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/report-complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Report Complete Email
         * @description Send notification when report generation is complete
         */
        post: operations["send_report_complete_email_api_v1_notifications_report_complete_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/preferences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Preferences
         * @description Get user's email notification preferences
         */
        get: operations["get_email_preferences_api_v1_notifications_preferences_get"];
        /**
         * Update Email Preferences
         * @description Update user's email notification preferences
         */
        put: operations["update_email_preferences_api_v1_notifications_preferences_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/export/csv": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Claims Csv
         * @description Export all claims as CSV file (requires reports:export permission)
         *     Optional filters: status, event_type
         */
        get: operations["export_claims_csv_api_v1_export_csv_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/export/excel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Claims Excel
         * @description Export all claims as Excel file (requires reports:export permission)
         *     Optional filters: status, event_type
         */
        get: operations["export_claims_excel_api_v1_export_excel_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/export/report/{report_id}/excel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Single Report Excel
         * @description Export comprehensive forensic accountant Excel workbook.
         *
         *     Includes:
         *     - Executive Summary
         *     - Monthly Financial Data
         *     - BI Calculation Breakdown
         *     - Statistical Validation (Sensitivity & Monte Carlo)
         *     - Causation Analysis
         *     - Assumptions & Methodology
         *     - Document Index
         */
        get: operations["export_single_report_excel_api_v1_export_report__report_id__excel_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Team Members
         * @description List all team members in the organization
         *     Supports search and filtering for large teams
         */
        get: operations["list_team_members_api_v1_team_members_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Team Stats
         * @description Get team statistics
         */
        get: operations["get_team_stats_api_v1_team_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/invite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Invite Member
         * @description Send an email invitation to join the team
         */
        post: operations["invite_member_api_v1_team_invite_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/add-direct": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add Member Directly
         * @description Directly add a team member (creates account for them)
         */
        post: operations["add_member_directly_api_v1_team_add_direct_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/members/{member_id}/role": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Member Role
         * @description Change a team member's role
         */
        put: operations["update_member_role_api_v1_team_members__member_id__role_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/members/{member_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove Member
         * @description Remove a team member
         */
        delete: operations["remove_member_api_v1_team_members__member_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/members/{member_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Member Status
         * @description Enable or disable a team member (suspend without deleting)
         */
        put: operations["update_member_status_api_v1_team_members__member_id__status_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/transfer-ownership": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Transfer Ownership
         * @description Transfer ownership to another team member (Owner only)
         */
        post: operations["transfer_ownership_api_v1_team_transfer_ownership_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/invites/{invite_id}/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend Invite
         * @description Resend an invitation email
         */
        post: operations["resend_invite_api_v1_team_invites__invite_id__resend_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/roles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Roles
         * @description Get list of roles the current user can assign
         */
        get: operations["get_available_roles_api_v1_team_roles_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/team/my-permissions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get My Permissions
         * @description Get current user's role and permissions
         */
        get: operations["get_my_permissions_api_v1_team_my_permissions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/transaction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Classify Single Transaction
         * @description Classify a single transaction
         *
         *     Uses 3-tier system:
         *     - Tier 1: Rule-based + Vendor DB (FREE, instant)
         *     - Tier 2: HuggingFace ML (FREE, ~100ms)
         *     - Tier 3: Dual-AI (Claude + GPT, paid)
         */
        post: operations["classify_single_transaction_api_v1_classify_transaction_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Classify Batch Transactions
         * @description Classify multiple transactions efficiently
         *
         *     Returns classification results with statistics on:
         *     - Auto-approval rate
         *     - Tier usage breakdown
         *     - Category distribution
         *     - Estimated cost savings
         */
        post: operations["classify_batch_transactions_api_v1_classify_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/learn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Learn From Correction
         * @description Learn from a human correction
         *
         *     Updates the vendor database so similar transactions
         *     will be classified correctly in the future.
         */
        post: operations["learn_from_correction_api_v1_classify_learn_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Classification Statistics
         * @description Get cumulative classification statistics
         *
         *     Shows:
         *     - Total transactions classified
         *     - Breakdown by tier
         *     - API calls saved
         *     - Cost savings estimate
         */
        get: operations["get_classification_statistics_api_v1_classify_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/models": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Models
         * @description Get status of available ML models
         *
         *     Shows which classification tiers are available
         */
        get: operations["get_available_models_api_v1_classify_models_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Valid Categories
         * @description Get list of valid expense categories
         *
         *     These are the categories the classifier will assign transactions to.
         */
        get: operations["get_valid_categories_api_v1_classify_categories_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/provide-payee": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Provide Payee Info
         * @description Provide payee/vendor info for an unclassified transaction
         *
         *     This is used when:
         *     - A check has only a check number (e.g., "CHECK #7202")
         *     - An ACH transaction has only a reference code
         *
         *     The system will:
         *     1. Classify the transaction with the new info
         *     2. Learn the mapping for future similar transactions
         */
        post: operations["provide_payee_info_api_v1_classify_provide_payee_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/classify/provide-payee/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Provide Payee Info Batch
         * @description Provide payee info for multiple transactions at once
         *
         *     Used when reviewing a batch of unclassified transactions
         */
        post: operations["provide_payee_info_batch_api_v1_classify_provide_payee_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/claim-documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload Claim Documents
         * @description Unified upload endpoint - The Wizard Killer.
         *     Requires authentication.
         *
         *     Accepts multiple files and claim metadata, processes everything in parallel,
         *     merges results into a single CanonicalData, and returns comprehensive stats.
         *
         *     **Supported file types:**
         *     - PDF (bank statements) - with caching
         *     - CSV (transaction exports)
         *     - Excel (.xlsx, .xls)
         *
         *     **Metadata JSON:**
         *     ```json
         *     {
         *         "company_name": "Acme Corp",
         *         "business_type": "restaurant",
         *         "interruption_type": "hurricane",
         *         "interruption_start": "2024-09-01",
         *         "interruption_end": "2024-10-15",
         *         "claimed_period_start": "2024-09-01",
         *         "claimed_period_end": "2024-12-31"
         *     }
         *     ```
         */
        post: operations["upload_claim_documents_api_v1_upload_claim_documents_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/supported-formats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Supported Formats
         * @description Get list of supported file formats.
         */
        get: operations["get_supported_formats_api_v1_upload_supported_formats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Unified Upload
         * @description Unified Upload Endpoint - Save First Architecture
         *
         *     This endpoint:
         *     1. Saves file to S3 immediately (with hierarchical folder structure)
         *     2. Returns success to user
         *     3. Processes file in background
         *
         *     S3 Folder Structure:
         *         {org_id}/{case_id}/{doc_type}/{year}/{quarter}/{auto_named_file}
         *
         *     Auto-naming:
         *         {CLIENT_SHORT}_{doc_type}_{date}_{id_short}.{ext}
         *         Example: CRESTVIEW_bankstmt_20240110_a3f8c2.pdf
         *
         *     Both Magic Link Portal and Wizard Step 3 use this endpoint.
         */
        post: operations["unified_upload_api_v1_upload_savefirst_unified_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Unified Batch Upload
         * @description Batch Upload Endpoint - Handle multiple files (up to 100)
         *
         *     Saves all files to S3 immediately with hierarchical folder structure,
         *     then processes in background. Each file gets its own upload_id for tracking.
         *
         *     S3 Folder Structure:
         *         {org_id}/{case_id}/{doc_type}/{year}/{quarter}/{auto_named_file}
         *
         *     For 100 files with 39+ pages each:
         *     - S3 upload: ~1-2 seconds per file
         *     - Background processing: Claude handles pages in batches of 8
         *     - Status can be polled individually per upload_id
         */
        post: operations["unified_batch_upload_api_v1_upload_savefirst_unified_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified/batch/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Batch Status
         * @description Get status of multiple uploads at once.
         *
         *     Args:
         *         upload_ids: Comma-separated list of upload IDs
         *
         *     Returns:
         *         List of status objects for each upload
         */
        get: operations["get_batch_status_api_v1_upload_savefirst_unified_batch_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified/{upload_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Status
         * @description Check processing status of an upload.
         *
         *     Returns full extraction audit and parsed data when complete.
         */
        get: operations["get_upload_status_api_v1_upload_savefirst_unified__upload_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified/{upload_id}/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Result
         * @description Get full parsed result for an upload.
         *
         *     Used by specialists to retrieve extracted data.
         */
        get: operations["get_upload_result_api_v1_upload_savefirst_unified__upload_id__result_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/unified/{upload_id}/evidence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Evidence
         * @description Get evidence analysis for a specific uploaded document.
         *
         *     Returns structured facts extracted by the EvidenceAnalyzer at upload time:
         *     dates, parties, amounts, case impact assessment, and auto-populate suggestions.
         */
        get: operations["get_upload_evidence_api_v1_upload_savefirst_unified__upload_id__evidence_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/claims/{claim_id}/evidence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Evidence
         * @description Get all evidence analyses for a case.
         *
         *     Aggregates evidence from every uploaded document that has been analyzed,
         *     including auto-populated field summary for audit trail.
         */
        get: operations["get_case_evidence_api_v1_upload_savefirst_claims__claim_id__evidence_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess Files
         * @description Reprocess existing S3 files through the updated extraction pipeline.
         *
         *     Use this to:
         *     - Test new extractors (PaddleOCR, OFX Parser) on existing files
         *     - Compare extraction results before/after pipeline changes
         *     - Batch re-extract files that failed previously
         *
         *     Examples:
         *     - Reprocess all OFX files: {"file_types": ["ofx", "qfx"]}
         *     - Reprocess specific uploads: {"upload_ids": ["abc123", "def456"]}
         *     - Reprocess PDFs with PaddleOCR: {"file_types": ["pdf"], "force_method": "paddleocr"}
         */
        post: operations["reprocess_files_api_v1_upload_savefirst_reprocess_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/failed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess Failed Files
         * @description Convenience endpoint to reprocess all failed uploads.
         *
         *     This is useful after fixing bugs in the extraction pipeline.
         *
         *     Args:
         *         claim_id: Optional - only reprocess failed files for a specific case
         *         file_types: Optional - only reprocess specific file types (e.g., ["pdf"])
         *         limit: Max files to reprocess (default 100)
         *
         *     Example:
         *         POST /api/v1/upload-savefirst/reprocess/failed
         *         POST /api/v1/upload-savefirst/reprocess/failed?claim_id=abc123&limit=50
         */
        post: operations["reprocess_failed_files_api_v1_upload_savefirst_reprocess_failed_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/evidence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess Evidence Analysis
         * @description Run AI evidence analysis on supporting documents that haven't been analyzed.
         *
         *     Downloads each file from S3, OCRs PDFs, runs EvidenceAnalyzer, stores results,
         *     and triggers Event Intelligence reconciliation with extracted event dates.
         *
         *     Args:
         *         claim_id: The claim/draft ID to reprocess
         *         force: If True, re-analyze even if evidence_analysis already exists
         *         limit: Max files to process (default 20)
         *
         *     Returns:
         *         Summary of processed files with extracted event dates and EI result
         */
        post: operations["reprocess_evidence_analysis_api_v1_upload_savefirst_reprocess_evidence_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/zero-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess Zero Transaction Files
         * @description Find and reprocess files that show '0 transactions' due to the serialization bug.
         *
         *     This identifies files that were processed but have no transactions stored
         *     (typically caused by the Pydantic model serialization error that was fixed).
         *
         *     Args:
         *         claim_id: Optional - only check files for a specific claim
         *         draft_id: Optional - only check files linked to a specific draft
         *         limit: Max files to reprocess (default 50)
         *         dry_run: If True, only identify affected files without reprocessing
         *
         *     Returns:
         *         List of affected files and reprocessing results
         */
        post: operations["reprocess_zero_transaction_files_api_v1_upload_savefirst_reprocess_zero_transactions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/zero-transactions/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Count Zero Transaction Files
         * @description Get count of files with 0 transactions that may need reprocessing.
         */
        get: operations["count_zero_transaction_files_api_v1_upload_savefirst_reprocess_zero_transactions_count_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/failed/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Count Failed Files
         * @description Get count of failed uploads that can be reprocessed.
         */
        get: operations["count_failed_files_api_v1_upload_savefirst_reprocess_failed_count_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Available Files
         * @description List files available for reprocessing.
         *
         *     Use this to see what files exist in S3 before reprocessing.
         *     Filter by claim_id or draft_id to see files for a specific case.
         */
        get: operations["list_available_files_api_v1_upload_savefirst_reprocess_available_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess/compare/{upload_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Extraction
         * @description Reprocess a single file and compare old vs new results.
         *
         *     Returns side-by-side comparison without updating the database.
         *     Useful for testing changes before committing.
         */
        post: operations["compare_extraction_api_v1_upload_savefirst_reprocess_compare__upload_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/recalculate-aggregates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Recalculate Aggregates
         * @description Recalculate transaction aggregates (gross_revenue, employee_wages, etc.)
         *     for an existing draft using the backend's classification logic.
         *
         *     This fixes drafts where transactions exist but Period-level aggregates are $0
         *     (data processed before the recalculate_from_transactions fix was deployed).
         */
        post: operations["recalculate_aggregates_api_v1_upload_savefirst_recalculate_aggregates_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/recalculate-aggregates/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Recalculate Aggregates
         * @description Batch recalculate transaction aggregates for all drafts with zero revenue.
         *
         *     This fixes drafts where transactions exist but Period-level aggregates are $0
         *     (data processed before the recalculate_from_transactions fix was deployed).
         *
         *     Args:
         *         dry_run: If True, only report what would be fixed without making changes
         *         limit: Maximum number of drafts to process
         *
         *     Returns:
         *         Summary of drafts found and fixed
         */
        post: operations["batch_recalculate_aggregates_api_v1_upload_savefirst_recalculate_aggregates_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reclassify-uncategorized": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reclassify Uncategorized Transactions
         * @description Reclassify all uncategorized transactions in a draft using the 3-tier system.
         *
         *     This fixes drafts where transactions were extracted but classification was skipped
         *     (e.g., processed via dynamic_bank_parser before classification was added).
         *
         *     Args:
         *         draft_id: The draft to process
         *         max_tier: Maximum classification tier to use (1=rules, 2=ML, 3=AI)
         *         batch_size: Process transactions in batches
         *
         *     Returns:
         *         Summary of reclassified transactions
         */
        post: operations["reclassify_uncategorized_transactions_api_v1_upload_savefirst_reclassify_uncategorized_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/diagnostics/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Diagnose Data Issues
         * @description Diagnose data issues in a draft's financial data.
         *
         *     Identifies:
         *     - Periods with transactions but $0 revenue (potential misclassification)
         *     - Periods with $0 COGS but expense transactions (potential COGS misclassification)
         *     - High ratio of uncategorized transactions
         *     - Periods with no transactions
         *     - Data aggregation mismatches
         *
         *     Returns:
         *         Diagnostic report with issues and recommendations
         */
        get: operations["diagnose_data_issues_api_v1_upload_savefirst_diagnostics__draft_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/fix-issues/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Fix Data Issues
         * @description Automatically fix identified data issues in a draft.
         *
         *     Fix types:
         *     - aggregation: Recalculate period aggregates from transactions
         *     - cogs: Re-categorize potential COGS transactions
         *     - uncategorized: Attempt to classify uncategorized transactions
         *
         *     Returns:
         *         Summary of fixes applied
         */
        post: operations["fix_data_issues_api_v1_upload_savefirst_fix_issues__draft_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reprocess-tax-documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess Tax Documents
         * @description Reprocess tax documents (1065/K-1) in a draft to extract financial data.
         *
         *     This fixes tax documents where:
         *     - Classification worked but extraction failed
         *     - The data object is empty ({})
         *     - Values are all zeros
         *
         *     Args:
         *         draft_id: The draft to process
         *         force_reprocess: If True, reprocess even if some data exists
         *
         *     Returns:
         *         Summary of reprocessed tax documents with extracted values
         */
        post: operations["reprocess_tax_documents_api_v1_upload_savefirst_reprocess_tax_documents_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/rebuild-variance-explanations/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Rebuild Variance Explanations
         * @description Force a canonical-cache rebuild so variance_explanations regenerates
         *     with the current build_variance_explanations() code.
         *
         *     Context: variance_explanations is computed inside rebuild_canonical_cache
         *     and stored on the claim doc. Since the cache-version hash is based on
         *     file fingerprints (not code), deploying new variance-factor logic
         *     doesn't automatically invalidate the cache. This endpoint provides a
         *     manual trigger — useful after deploys that change factor output.
         *
         *     Returns a summary of the new variance_explanations blocks per year so
         *     you can verify the new factors appear.
         */
        post: operations["rebuild_variance_explanations_api_v1_upload_savefirst_rebuild_variance_explanations__claim_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reconcile-revenue-sources/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reconcile Revenue Sources
         * @description Trigger merchant statement reconciliation for a claim.
         *
         *     Reads all `data.revenue_source_statements[]` from the draft, pulls
         *     1065 gross receipts + bank deposit history from canonical_data,
         *     runs `merchant_reconciliation_service.reconcile_claim()`, persists
         *     the summary to `data.revenue_source_reconciliation`, and flips each
         *     envelope's `reconciled` flag to true.
         *
         *     Then triggers a variance-explanations rebuild so the investigation
         *     card's "missing delivery app" warning is replaced with the concrete
         *     reconciliation narrative (if applicable).
         *
         *     Returns the summary for the UI to display.
         */
        post: operations["reconcile_revenue_sources_api_v1_upload_savefirst_reconcile_revenue_sources__claim_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/sync-draft-to-claims/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sync Draft To Claims
         * @description Diagnostic: show current tax1065Files K-1 data in the drafts collection
         *     and verify it's correct. ClaimService.claims = db.drafts, so both APIs
         *     read from the same collection.
         */
        post: operations["sync_draft_to_claims_api_v1_upload_savefirst_sync_draft_to_claims__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/scan-s3-missing/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Scan S3 Missing
         * @description Scan S3 for files that exist but aren't in uploaded_files collection.
         *     Registers them and optionally triggers extraction.
         */
        post: operations["scan_s3_missing_api_v1_upload_savefirst_scan_s3_missing__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/restore-draft/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Restore Draft
         * @description Restore a draft by searching reports, claims, and uploaded_files collections.
         *     Does NOT delete anything. Creates draft if missing, or returns existing.
         */
        post: operations["restore_draft_api_v1_upload_savefirst_restore_draft__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/dedup-tax-files/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dedup Tax Files
         * @description Deduplicate tax1065Files in a draft: remove duplicates by filename,
         *     keeping the entry with the most data (non-empty fields).
         *     Then reprocess K-1s to fix noise values ($1/$4).
         */
        post: operations["dedup_tax_files_api_v1_upload_savefirst_dedup_tax_files__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/dedup-uploads/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dedup Uploads
         * @description Deduplicate uploaded_files for a claim: remove duplicates by original_filename,
         *     keeping the record with the most processed data (parsed_data, evidence_analysis, etc.).
         *     Also rebuilds canonical_data after removing duplicates.
         *
         *     Pass dry_run=false to actually delete.
         */
        post: operations["dedup_uploads_api_v1_upload_savefirst_dedup_uploads__claim_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reanalyze-anomalies/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reanalyze Anomalies
         * @description Clear cached anomaly analysis, remove ghost periods (future dates with no
         *     real data), and re-run anomaly detection with the latest code.
         */
        post: operations["reanalyze_anomalies_api_v1_upload_savefirst_reanalyze_anomalies__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/analytics/extraction-costs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Cost Analytics
         * @description Get extraction cost analytics for the dashboard.
         *
         *     Shows:
         *     - Total cost by tier (pdfplumber, tesseract, claude, textract)
         *     - Cost over time (daily breakdown)
         *     - Free vs paid tier usage percentages
         *
         *     Only accessible to owners/admins (not viewers).
         */
        get: operations["get_extraction_cost_analytics_api_v1_upload_savefirst_analytics_extraction_costs_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/analytics/extraction-by-case": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction By Case
         * @description Get extraction analytics aggregated by case/claim.
         *
         *     Shows which cases have problematic files that need attention.
         */
        get: operations["get_extraction_by_case_api_v1_upload_savefirst_analytics_extraction_by_case_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/sync-status/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Sync Status
         * @description Get the sync status for a draft - shows if data from uploaded_files
         *     has been synced to the draft's data field.
         *
         *     Args:
         *         report_id: The draft/report ID to check
         *
         *     Returns:
         *         Sync status including file counts and transaction totals
         */
        get: operations["get_sync_status_api_v1_upload_savefirst_sync_status__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/reaggregate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reaggregate Financial Data
         * @description Re-aggregate financial_data from existing canonical_data periods.
         *
         *     This re-runs the transaction → P&L aggregation logic with improved
         *     payroll vendor matching (ADP, Paychex, etc.) without needing to
         *     re-upload or re-extract any files.
         *
         *     Use when:
         *     - Payroll classification fix was deployed but data wasn't reprocessed
         *     - Category aggregation logic was improved
         *     - financial_data needs rebuilding from canonical transactions
         */
        post: operations["reaggregate_financial_data_api_v1_upload_savefirst_reaggregate__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/debug-draft-k1/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Draft K1
         * @description Debug endpoint: Show what the draft's tax1065Files K-1 data looks like.
         *     This is what the frontend actually reads.
         */
        get: operations["debug_draft_k1_api_v1_upload_savefirst_debug_draft_k1__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload-savefirst/debug-k1-extraction/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug K1 Extraction
         * @description Debug endpoint: Download K-1 PDFs from S3, extract text, and show what the regex finds.
         *     This helps diagnose why K-1 extraction returns None.
         */
        get: operations["debug_k1_extraction_api_v1_upload_savefirst_debug_k1_extraction__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/detect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Anomalies
         * @description Analyze transactions for anomalies using rule-based detection + Claude AI.
         *
         *     Returns flagged transactions with:
         *     - anomaly_type: Type of anomaly detected
         *     - severity: low, medium, high
         *     - reason: Explanation of why it was flagged
         *     - recommendation: What to check
         */
        post: operations["detect_anomalies_api_v1_anomalies_detect_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Anomaly Types
         * @description Get list of anomaly types that can be detected.
         */
        get: operations["get_anomaly_types_api_v1_anomalies_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/detect-canonical": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Canonical Anomalies
         * @description Detect anomalies in canonical_data format from UnifiedUploader.
         *     Used by Step 3 of the wizard to show anomaly warnings.
         *
         *     Checks:
         *     - Revenue spikes/drops (>25% MoM)
         *     - Missing months in date range
         *     - Large transactions (>$10k)
         *     - Utility gaps
         *     - COGS exceeding revenue
         *     - Potential duplicates
         *     - Round number patterns
         *     - Category imbalances
         *
         *     Features:
         *     - Adaptive thresholds: Learns from resolved anomalies to reduce false positives
         *     - AI Analysis: Optional Claude-powered insights for high-severity items
         */
        post: operations["detect_canonical_anomalies_api_v1_anomalies_detect_canonical_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/ai-analysis/{job_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Ai Analysis Status
         * @description Check the status of a background AI analysis job.
         *     Returns progress and results when complete.
         */
        get: operations["get_ai_analysis_status_api_v1_anomalies_ai_analysis__job_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/analyze-single": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Single Anomaly
         * @description Get AI analysis for a single anomaly on-demand.
         *     Use this when user clicks "Get AI Insight" on an anomaly that wasn't auto-analyzed.
         */
        post: operations["analyze_single_anomaly_api_v1_anomalies_analyze_single_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/forensic-analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Forensic Analyze Anomaly
         * @description Get forensic accountant AI analysis for an anomaly.
         *
         *     Uses the senior forensic accountant persona to provide:
         *     - Professional assessment of the anomaly
         *     - Claim impact analysis (helps/hurts claim)
         *     - Specific recommendations for resolution
         *     - Supporting evidence from the transaction data
         */
        post: operations["forensic_analyze_anomaly_api_v1_anomalies_forensic_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/batch-forensic-analyze/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Forensic Analyze
         * @description Batch analyze anomalies with forensic AI and cache results to database.
         *     This auto-triggers on anomaly view to avoid per-click AI calls.
         */
        post: operations["batch_forensic_analyze_api_v1_anomalies_batch_forensic_analyze__draft_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/save-anomaly-resolution/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Anomaly Resolution
         * @description Save anomaly resolution to database for report generation.
         */
        post: operations["save_anomaly_resolution_api_v1_anomalies_save_anomaly_resolution__draft_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/consensus/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Consensus Anomalies
         * @description Retrieve stored ensemble anomaly results for a case.
         *
         *     Returns previously computed PyOD ensemble results from MongoDB.
         */
        get: operations["get_consensus_anomalies_api_v1_anomalies_consensus__case_id__get"];
        put?: never;
        /**
         * Detect Consensus Anomalies
         * @description Detect anomalies using PyOD multi-algorithm ensemble.
         *
         *     Uses 5 complementary algorithms:
         *     - Isolation Forest: Tree-based isolation
         *     - LOF: Local Outlier Factor (density-based)
         *     - ECOD: Empirical CDF-based
         *     - KNN: K-Nearest Neighbors distance
         *     - COPOD: Copula-based
         *
         *     Consensus voting determines final anomaly status:
         *     - VERY_HIGH confidence: 4-5 algorithms agree
         *     - HIGH confidence: 3 algorithms agree
         *     - MEDIUM confidence: 2 algorithms agree
         *     - LOW confidence: 1 algorithm flags
         *
         *     Returns anomalies with algorithm breakdown for transparency.
         */
        post: operations["detect_consensus_anomalies_api_v1_anomalies_consensus__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/explain-shap": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Explain Anomalies With Shap
         * @description Generate SHAP explanations for detected anomalies.
         *
         *     SHAP (SHapley Additive exPlanations) breaks down why each transaction
         *     was flagged as anomalous, showing feature contributions.
         *
         *     Returns:
         *     - narrative: Human-readable explanation
         *     - top_contributors: Top 5 features driving the anomaly score
         *     - waterfall_data: Data for visualization
         *
         *     Example response for an anomaly:
         *     ```json
         *     {
         *       "shap_explanation": {
         *         "narrative": "This transaction was flagged as anomalous (score: 0.72).
         *                      The main factors are: 1. Transaction amount of $50,000 is
         *                      unusually high (contributes 45%)...",
         *         "top_contributors": [
         *           {"feature": "amount", "contribution_percent": 45, "direction": "positive"},
         *           {"feature": "day_of_week", "contribution_percent": 15, "direction": "positive"}
         *         ]
         *       }
         *     }
         *     ```
         */
        post: operations["explain_anomalies_with_shap_api_v1_anomalies_explain_shap_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/explain-single-shap": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Explain Single Anomaly Shap
         * @description Get SHAP explanation for a single anomaly.
         *
         *     Note: Model must be trained first via /explain-shap endpoint
         *     with transaction data. This endpoint retrieves explanation from
         *     an already-trained model.
         */
        post: operations["explain_single_anomaly_shap_api_v1_anomalies_explain_single_shap_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/explain/{case_id}/{anomaly_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stored Explanation
         * @description Retrieve a stored SHAP explanation from MongoDB.
         *
         *     Used to fetch previously generated explanations without
         *     recomputing them.
         */
        get: operations["get_stored_explanation_api_v1_anomalies_explain__case_id___anomaly_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/explanations/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Explanations
         * @description Get all SHAP explanations for a case.
         *
         *     Returns all stored explanations for the given case ID,
         *     sorted by most recent first.
         */
        get: operations["get_case_explanations_api_v1_anomalies_explanations__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/shap-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Shap Status
         * @description Get status of the SHAP explainability service.
         *
         *     Returns whether SHAP is available, model training status,
         *     and configuration parameters.
         */
        get: operations["get_shap_status_api_v1_anomalies_shap_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/feature-importance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Feature Importance
         * @description Get global feature importance from the trained SHAP model.
         *
         *     Returns which features are most important overall for
         *     detecting anomalies, based on mean absolute SHAP values.
         *
         *     Requires model to be trained via /explain-shap first.
         */
        get: operations["get_feature_importance_api_v1_anomalies_feature_importance_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/canonical/with-cache": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Anomalies Canonical Cached
         * @description Detect anomalies with AI analysis caching.
         *     - First checks if cached AI analysis exists for this data hash
         *     - If cache hit and data unchanged, returns cached results
         *     - If cache miss or data changed, runs detection and queues AI analysis
         */
        post: operations["detect_anomalies_canonical_cached_api_v1_anomalies_canonical_with_cache_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/anomalies/cache/{cache_hash}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Invalidate Cache
         * @description Invalidate cached anomaly analysis when data changes
         */
        delete: operations["invalidate_cache_api_v1_anomalies_cache__cache_hash__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/stream": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start Streaming Upload
         * @description Unified Upload Endpoint - S3-First + Celery Architecture
         *
         *     1. Uploads files to S3 immediately (never lose a file)
         *     2. Creates tracking records in `uploaded_files` collection
         *     3. Queues Celery task for background processing
         *     4. Returns job_id for progress tracking
         *
         *     Progress can be tracked via:
         *     - SSE: GET /api/v1/upload/stream/{job_id}/progress
         *     - REST: GET /api/v1/upload/stream/{job_id}/status
         *     - Result: GET /api/v1/upload/stream/{job_id}/result
         */
        post: operations["start_streaming_upload_api_v1_upload_stream_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/stream/{job_id}/progress": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Stream Job Progress
         * @description Stream job progress via Server-Sent Events (SSE).
         *
         *     Usage:
         *     ```javascript
         *     const events = new EventSource('/api/v1/upload/stream/{job_id}/progress');
         *     events.onmessage = (e) => {
         *         const progress = JSON.parse(e.data);
         *         console.log(progress.percent + '%', progress.message);
         *     };
         *     ```
         */
        get: operations["stream_job_progress_api_v1_upload_stream__job_id__progress_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/stream/{job_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Job Status
         * @description Get current status of a processing job (REST alternative to SSE)
         */
        get: operations["get_job_status_api_v1_upload_stream__job_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/stream/{job_id}/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Job Result
         * @description Get final result of a completed job
         */
        get: operations["get_job_result_api_v1_upload_stream__job_id__result_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/dedup/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dedup Uploads
         * @description One-time dedup: remove duplicate upload records for a claim, keeping best per filename.
         */
        post: operations["dedup_uploads_api_v1_upload_dedup__claim_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/upload/adopt-orphans/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Adopt Orphan Uploads
         * @description Find uploaded_files records with no claim_id that match filenames
         *     already processed for this claim (via job_id linkage), and adopt them.
         *     Also finds records with claim_id=None or empty string.
         */
        post: operations["adopt_orphan_uploads_api_v1_upload_adopt_orphans__claim_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Bi Categories
         * @description Get all 48 BI expense categories.
         *
         *     Returns the definitive list of categories used for carrier reports.
         */
        get: operations["get_bi_categories_api_v1_bi_categories_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/categories/variable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Variable Categories
         * @description Get all variable expense categories
         */
        get: operations["get_variable_categories_api_v1_bi_categories_variable_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/categories/fixed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Fixed Categories
         * @description Get all fixed expense categories
         */
        get: operations["get_fixed_categories_api_v1_bi_categories_fixed_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/map": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Map Categories
         * @description Map a list of raw expense categories to BI 48 categories.
         *
         *     Use this to preview how expenses will be categorized before export.
         */
        post: operations["map_categories_api_v1_bi_map_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/map/{category}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Map Single Category
         * @description Map a single expense category to BI system.
         *
         *     Useful for testing individual category mappings.
         */
        get: operations["map_single_category_api_v1_bi_map__category__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/export/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export For Carrier
         * @description Export claim data mapped to BI 48 categories for carrier submission.
         *
         *     This generates a carrier-ready report with:
         *     - All transactions mapped to BI categories
         *     - Variable vs Fixed classification
         *     - Summary totals by category
         *     - Monthly breakdowns
         *
         *     Formats:
         *     - xlsx: Excel workbook with multiple sheets
         *     - csv: CSV file with all data
         *     - json: JSON structure for API integration
         */
        get: operations["export_for_carrier_api_v1_bi_export__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi/export/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Summary
         * @description Get a summary of BI-mapped expenses for a report.
         *
         *     Returns aggregated totals by category without full transaction details.
         */
        get: operations["export_summary_api_v1_bi_export__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/law-firms": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Law Firms
         * @description List all law firms with case counts
         */
        get: operations["list_law_firms_api_v1_law_firms_get"];
        put?: never;
        /**
         * Create Law Firm
         * @description Create a new law firm
         */
        post: operations["create_law_firm_api_v1_law_firms_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/law-firms/{law_firm_id}/bulk-import": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Import Clients
         * @description Bulk import clients for a law firm.
         *     Creates draft cases for each client with the law firm pre-assigned.
         *     Supports up to 1000 clients per import.
         */
        post: operations["bulk_import_clients_api_v1_law_firms__law_firm_id__bulk_import_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/law-firms/{law_firm_id}/clients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Law Firm Clients
         * @description Get all clients (drafts and reports) associated with a law firm.
         *     Returns a combined list from both report_drafts and reports collections.
         */
        get: operations["get_law_firm_clients_api_v1_law_firms__law_firm_id__clients_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/law-firms/{law_firm_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Law Firm
         * @description Get a single law firm by ID
         */
        get: operations["get_law_firm_api_v1_law_firms__law_firm_id__get"];
        /**
         * Update Law Firm
         * @description Update an existing law firm
         */
        put: operations["update_law_firm_api_v1_law_firms__law_firm_id__put"];
        post?: never;
        /**
         * Delete Law Firm
         * @description Delete a law firm (only if no associated cases)
         */
        delete: operations["delete_law_firm_api_v1_law_firms__law_firm_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/law-firms/search/{query}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Law Firms
         * @description Search law firms by name (for autocomplete)
         */
        get: operations["search_law_firms_api_v1_law_firms_search__query__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/analyze/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Report
         * @description Perform comprehensive forensic analysis on a BI claim.
         *     Requires authentication.
         *
         *     This endpoint:
         *     1. Retrieves the report from database
         *     2. Runs rule-based forensic checks
         *     3. Uses Claude AI for deep analysis
         *     4. Caches results for subsequent requests
         *
         *     Used by the Accountant Dashboard for professional review.
         */
        post: operations["analyze_report_api_v1_forensic_analyze__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/cache/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Clear Analysis Cache
         * @description Clear cached forensic analysis for a report. Requires authentication.
         */
        delete: operations["clear_analysis_cache_api_v1_forensic_cache__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/fraud-graph/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Fraud Graph Results
         * @description Retrieve stored fraud graph analysis results for a case.
         *
         *     Returns previously computed NetworkX fraud graph results from MongoDB.
         */
        get: operations["get_fraud_graph_results_api_v1_forensic_fraud_graph__case_id__get"];
        put?: never;
        /**
         * Analyze Fraud Graph Endpoint
         * @description Analyze transactions for fraud patterns using NetworkX graph analysis.
         *
         *     Detects:
         *     1. **Circular Payments** - Money flowing in circles (A→B→C→A)
         *        - May indicate kickbacks, self-dealing, or money laundering
         *
         *     2. **Shell Company Indicators** - Entities with suspicious patterns
         *        - Single large transactions to unknown entities
         *        - One-way money flow (only receives OR only sends)
         *        - Round number concentration
         *
         *     3. **Anomalous Clusters** - Tightly connected entity groups
         *        - High insularity (mostly internal transactions)
         *        - May indicate related-party transactions or collusion
         *
         *     Returns graph visualization data for D3.js/vis-network rendering.
         */
        post: operations["analyze_fraud_graph_endpoint_api_v1_forensic_fraud_graph__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/fraud-graph/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Report Fraud Graph
         * @description Analyze fraud patterns for an existing report's transactions.
         *
         *     Automatically extracts transactions from the report's financial data
         *     and runs fraud graph analysis.
         */
        post: operations["analyze_report_fraud_graph_api_v1_forensic_fraud_graph_report__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/{report_id}/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Forensic Orchestrator
         * @description Run the full forensic analysis pipeline via ForensicOrchestrator.
         *
         *     Coordinates Prophet forecasting, fraud graph analysis, BLS benchmarks,
         *     anomaly ensemble, and P&L reconstruction into a unified ForensicReport.
         *
         *     Results are cached in MongoDB for subsequent retrieval via GET.
         */
        post: operations["run_forensic_orchestrator_api_v1_forensic__report_id__analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/forensic/{report_id}/results": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Forensic Orchestrator Results
         * @description Retrieve cached forensic orchestrator results for a report.
         *
         *     Returns previously computed ForensicOrchestrator results from MongoDB.
         *     If no results exist, returns success=False with a descriptive error.
         */
        get: operations["get_forensic_orchestrator_results_api_v1_forensic__report_id__results_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/analyze/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Case
         * @description Build comprehensive case analysis for plaintiff attorney.
         *     Requires authentication.
         *
         *     This endpoint:
         *     1. Retrieves the report from database
         *     2. Runs rule-based case analysis
         *     3. Uses Claude AI for strategic insights
         *     4. Caches results for subsequent requests
         *
         *     Used by the Accountant Dashboard for attorney-side analysis.
         */
        post: operations["analyze_case_api_v1_attorney_analyze__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/cache/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Clear Analysis Cache
         * @description Clear cached attorney analysis for a report. Requires authentication.
         */
        delete: operations["clear_analysis_cache_api_v1_attorney_cache__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Log Error
         * @description Log a frontend API error for owner review.
         *     Called automatically by the frontend api utility on server errors.
         */
        post: operations["log_error_api_v1_errors_log_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Errors
         * @description List logged errors for owner review.
         *     Only accessible by owners/admins.
         */
        get: operations["list_errors_api_v1_errors_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Error Summary
         * @description Get error summary statistics for owner dashboard.
         *     Only accessible by owners/admins.
         */
        get: operations["error_summary_api_v1_errors_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/errors/{error_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Resolve Error
         * @description Mark an error as resolved with optional notes.
         *     Only accessible by owners/admins.
         */
        put: operations["resolve_error_api_v1_errors__error_id__resolve_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/mediation/calculate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Fair Settlement
         * @description Calculate fair settlement value using Monte Carlo simulation.
         *
         *     This endpoint:
         *     1. Retrieves the report from database
         *     2. Fetches cached adjuster and attorney analyses
         *     3. Runs Monte Carlo simulation to find fair settlement
         *     4. Calculates gap bridge analysis
         *     5. Generates settlement scenarios
         *     6. Caches results for subsequent requests
         *
         *     Used by the Report Detail page for mediation insights.
         */
        post: operations["calculate_fair_settlement_api_v1_mediation_calculate__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/mediation/cache/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Clear Fair Settlement Cache
         * @description Clear cached fair settlement analysis for a report. Requires authentication.
         */
        delete: operations["clear_fair_settlement_cache_api_v1_mediation_cache__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/mediation/gap-bridge/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Gap Bridge Analysis
         * @description Get detailed gap bridge analysis showing value increase for each addressable gap.
         *
         *     Returns what the claim value would be if specific gaps are addressed:
         *     - "If you fix gap X, claim increases by $Y"
         *     - Cumulative totals showing path to maximum recovery
         */
        get: operations["get_gap_bridge_analysis_api_v1_mediation_gap_bridge__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/outcomes/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit Outcome
         * @description Submit the final outcome of a report/claim.
         *     This data is used to build internal settlement benchmarks.
         */
        post: operations["submit_outcome_api_v1_outcomes_submit_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/outcomes/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Outcome For Report
         * @description Get the outcome data for a specific report.
         */
        get: operations["get_outcome_for_report_api_v1_outcomes_report__report_id__get"];
        /**
         * Update Outcome
         * @description Update an existing outcome submission.
         */
        put: operations["update_outcome_api_v1_outcomes_report__report_id__put"];
        post?: never;
        /**
         * Delete Outcome
         * @description Delete an outcome submission.
         */
        delete: operations["delete_outcome_api_v1_outcomes_report__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/outcomes/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Outcomes
         * @description List all submitted outcomes with optional filtering.
         */
        get: operations["list_outcomes_api_v1_outcomes_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/outcomes/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Outcome Stats
         * @description Get aggregate statistics from all submitted outcomes for benchmarking.
         */
        get: operations["get_outcome_stats_api_v1_outcomes_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/outcomes/closed-reports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Closed Reports
         * @description Get list of completed reports that can have outcomes submitted.
         *     Shows which ones already have outcomes and which don't.
         */
        get: operations["get_closed_reports_api_v1_outcomes_closed_reports_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/send-document-request/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Document Request
         * @description Send document request email based on claim health assessment.
         *     Uses the AI checklist to determine what documents are needed.
         */
        post: operations["send_document_request_api_v1_notifications_send_document_request__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/send-status-update/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Status Update
         * @description Send claim status update email based on current health assessment.
         */
        post: operations["send_status_update_api_v1_notifications_send_status_update__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/send-reminder/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Reminder
         * @description Send reminder email for missing documents.
         */
        post: operations["send_reminder_api_v1_notifications_send_reminder__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/email-history/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email History
         * @description Get email history for a report.
         */
        get: operations["get_email_history_api_v1_notifications_email_history__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/check-stale-claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Check Stale Claims
         * @description Check for claims that need follow-up and optionally send reminders.
         *     Useful for batch processing stale claims.
         */
        post: operations["check_stale_claims_api_v1_notifications_check_stale_claims_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/upload-portal/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Portal Info
         * @description PUBLIC ENDPOINT - Get claim info for upload portal.
         *     Used by clients to see what documents are needed.
         *     Supports both finalized reports AND in-progress drafts.
         *
         *     SECURITY (audit 2026-04-19 PM): requires ``?token=<magic_token>``
         *     that maps to ``report_id`` via portal_access or
         *     clarification_requests. Raw report_id alone is no longer
         *     sufficient — it's a UUID but not secret (logs, referrers,
         *     screenshots). Whitelisted in the critical-endpoints auth
         *     regression guard because Clerk JWT is not used here.
         */
        get: operations["get_upload_portal_info_api_v1_notifications_upload_portal__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/upload-document/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload Document Public
         * @description PUBLIC ENDPOINT - Upload a document for a claim.
         *     Used by clients through the upload portal (magic link).
         *     Supports both finalized reports AND in-progress drafts.
         *
         *     Routes to the unified save-first pipeline for proper extraction.
         *
         *     SECURITY (audit 2026-04-19 PM): requires ``?token=<magic_token>``
         *     bound to this report_id. Previously anyone with a disclosed
         *     report_id could POST files into the claim's evidence pipeline.
         */
        post: operations["upload_document_public_api_v1_notifications_upload_document__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/track-upload-analytics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Track Upload Analytics
         * @description PUBLIC ENDPOINT - Track upload portal analytics.
         *     Used for monitoring drop-off rates and optimizing the upload experience.
         */
        post: operations["track_upload_analytics_api_v1_notifications_track_upload_analytics_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/upload-analytics/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Analytics Stats
         * @description Get aggregated upload analytics for monitoring portal performance.
         */
        get: operations["get_upload_analytics_stats_api_v1_notifications_upload_analytics_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/send-unified-request/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Unified Request Email
         * @description Send UNIFIED email combining document requests AND transaction clarifications.
         *
         *     This is the recommended way to communicate with clients - sends a single email
         *     with two distinct CTAs instead of multiple separate emails.
         *
         *     Features:
         *     - CTA 1: "Upload Documents Securely" → Opens /upload/:reportId
         *     - CTA 2: "Categorize Transactions" → Opens /clarify/:token (magic link)
         *     - Conditional sections based on what's actually needed
         *     - Respects rate limiting (24h between emails unless forced)
         */
        post: operations["send_unified_request_email_api_v1_notifications_send_unified_request__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/check-unified-status/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check Unified Status
         * @description Check what's pending for a report - documents and/or clarifications.
         *     Useful for determining if a unified email should be sent.
         */
        get: operations["check_unified_status_api_v1_notifications_check_unified_status__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/track/open/{tracking_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Track Email Open
         * @description Track email opens via 1x1 pixel. Called when email is opened and image is loaded.
         *     Returns a transparent 1x1 GIF.
         *
         *     tracking_id format: {email_id}_{report_id}_{email_type}
         */
        get: operations["track_email_open_api_v1_notifications_track_open__tracking_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/track/click/{tracking_id}/{action}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Track Email Click
         * @description Track email link clicks and redirect to destination.
         *
         *     action: 'upload' | 'clarify' | 'view'
         *     tracking_id format: {email_id}_{report_id}_{email_type}
         */
        get: operations["track_email_click_api_v1_notifications_track_click__tracking_id___action__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/track/conversion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Track Conversion
         * @description Track conversion events (document uploaded, clarification submitted).
         *     Called from frontend after successful action.
         *
         *     action: 'document_uploaded' | 'clarification_submitted'
         */
        post: operations["track_conversion_api_v1_notifications_track_conversion_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/notifications/analytics/email-performance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Performance Analytics
         * @description Get comprehensive email performance analytics.
         *
         *     Returns:
         *     - Open rates (total opens / emails sent)
         *     - Click rates per CTA (upload clicks, clarify clicks)
         *     - Conversion rates (documents uploaded, clarifications submitted)
         *     - Breakdown by email type (unified, document_request, clarification_request)
         */
        get: operations["get_email_performance_analytics_api_v1_notifications_analytics_email_performance_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/inbound/webhook": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Handle Inbound Email
         * @description Webhook endpoint for Resend Inbound emails.
         *
         *     Handles two types of emails:
         *     1. Document uploads: docs+{reportId}@updates.claimsync.io
         *     2. Clarification replies: clarify+{reportId}-{requestId}@updates.claimsync.io
         *
         *     Configure in Resend Dashboard:
         *     - Inbound domain: updates.claimsync.io
         *     - Webhook URL: https://your-api.com/api/v1/inbound/webhook
         *     - Signing secret: set RESEND_WEBHOOK_SECRET env var to the `whsec_...`
         *       value shown in the dashboard so this endpoint can verify every
         *       incoming request. Without it, every webhook is rejected (fail-closed).
         */
        post: operations["handle_inbound_email_api_v1_inbound_webhook_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/inbound/email-address/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Inbound Email Address
         * @description Get the inbound email address for a specific report.
         *     Clients can send documents to this address.
         */
        get: operations["get_inbound_email_address_api_v1_inbound_email_address__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/inbound/received/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Received Emails
         * @description Get list of emails received for a report. Scoped to caller's org.
         */
        get: operations["get_received_emails_api_v1_inbound_received__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/inbound/attachments/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Email Attachments
         * @description Get list of attachments received via email for a report. Scoped to caller's org.
         */
        get: operations["get_email_attachments_api_v1_inbound_attachments__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Clarification Request
         * @description Create a new clarification request for specific transactions.
         *     Works with both reports and wizard drafts.
         */
        post: operations["create_clarification_request_api_v1_clarifications_create_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/send/{request_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Clarification Email
         * @description Send the clarification email to the client with magic link.
         */
        post: operations["send_clarification_email_api_v1_clarifications_send__request_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Clarifications
         * @description Get pending clarification requests.
         */
        get: operations["get_pending_clarifications_api_v1_clarifications_pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/review-queue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Review Queue
         * @description Get all transactions across all reports that need clarification review.
         *     This is the "Transaction Review Queue" for bulk review.
         *     Includes client-provided categorizations from the magic link portal.
         *
         *     Supports two view modes:
         *     - grouped: Returns data organized by law firm → claim (default)
         *     - flat: Returns a flat list of all items (for bulk processing)
         */
        get: operations["get_review_queue_api_v1_clarifications_review_queue_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/pending-ai-suggestions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Ai Suggestions
         * @description Get client responses that have AI-parsed category suggestions awaiting specialist approval.
         *     This is a simplified endpoint for the dashboard widget.
         */
        get: operations["get_pending_ai_suggestions_api_v1_clarifications_pending_ai_suggestions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/responses/manual": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit Manual Response
         * @description Manually submit responses on behalf of the client (data specialist workflow).
         */
        post: operations["submit_manual_response_api_v1_clarifications_responses_manual_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/responses/{response_id}/review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Review Ai Parsed Response
         * @description Review and approve/correct an AI-parsed clarification response.
         *     When approved, optionally updates the transaction category in the wizard draft.
         */
        post: operations["review_ai_parsed_response_api_v1_clarifications_responses__response_id__review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Clarification Stats
         * @description Get statistics on clarification requests and responses.
         */
        get: operations["get_clarification_stats_api_v1_clarifications_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/cleanup-orphaned": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cleanup Orphaned Clarifications
         * @description Clean up orphaned clarification requests that reference deleted reports/drafts.
         *
         *     This resolves the "Unassigned Firm" issue caused by clarification requests
         *     that reference non-existent reports.
         */
        post: operations["cleanup_orphaned_clarifications_api_v1_clarifications_cleanup_orphaned_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/responses/bulk-approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Approve Clarifications
         * @description Bulk approve/reject multiple client clarification responses.
         *     Optionally applies approved categories to wizard draft data.
         */
        post: operations["bulk_approve_clarifications_api_v1_clarifications_responses_bulk_approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/flag-transaction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Flag Transaction For Clarification
         * @description Flag a single transaction for clarification.
         *     This can be used from the Report Detail page to quickly flag items.
         */
        post: operations["flag_transaction_for_clarification_api_v1_clarifications_flag_transaction_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/client/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Client Clarification Portal
         * @description Public endpoint for clients to access their clarification request via magic link.
         *     No authentication required - token is the auth.
         */
        get: operations["get_client_clarification_portal_api_v1_clarifications_client__token__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/client/{token}/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit Client Clarifications
         * @description Public endpoint for clients to submit their transaction categorizations.
         *     No authentication required - token is the auth.
         */
        post: operations["submit_client_clarifications_api_v1_clarifications_client__token__submit_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/client/{token}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Client Submission Status
         * @description Public endpoint for clients to check the status of their submission.
         */
        get: operations["get_client_submission_status_api_v1_clarifications_client__token__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/scheduler/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Scheduler Status
         * @description Get current scheduler status and upcoming jobs.
         */
        get: operations["get_scheduler_status_api_v1_clarifications_scheduler_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/scheduler/trigger-sweep": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Daily Sweep
         * @description Manually trigger the daily sweep for unsent clarification requests.
         *     Useful for testing or immediate processing.
         */
        post: operations["trigger_daily_sweep_api_v1_clarifications_scheduler_trigger_sweep_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/scheduler/trigger-reminder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Reminder Sweep
         * @description Manually trigger the reminder sweep for awaiting responses.
         */
        post: operations["trigger_reminder_sweep_api_v1_clarifications_scheduler_trigger_reminder_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/clarifications/scheduler/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Scheduler Logs
         * @description Get recent scheduler execution logs.
         */
        get: operations["get_scheduler_logs_api_v1_clarifications_scheduler_logs_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/chat": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Chat With Assistant
         * @description Send a message to the QA Assistant and get a response with full conversation context.
         */
        post: operations["chat_with_assistant_api_v1_assistant_chat_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/suggestions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Proactive Suggestions
         * @description Get proactive suggestions based on current claim state.
         */
        post: operations["get_proactive_suggestions_api_v1_assistant_suggestions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/history/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Chat History
         * @description Get chat history for a claim, optionally filtered by session.
         */
        get: operations["get_chat_history_api_v1_assistant_history__claim_id__get"];
        put?: never;
        post?: never;
        /**
         * Clear Chat History
         * @description Clear chat history for a claim to start a fresh conversation.
         */
        delete: operations["clear_chat_history_api_v1_assistant_history__claim_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/sessions/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Chat Sessions
         * @description Get list of chat sessions for a claim.
         */
        get: operations["get_chat_sessions_api_v1_assistant_sessions__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/voice/speak": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Text To Speech
         * @description Convert text to speech using OpenAI TTS.
         *     Returns audio as base64-encoded MP3.
         *
         *     Voices: alloy, ash, coral, echo, fable, nova, onyx, sage, shimmer
         *     Models: tts-1 (fast), tts-1-hd (high quality)
         *     Speed: 0.25 to 4.0 (default 1.0)
         */
        post: operations["text_to_speech_api_v1_assistant_voice_speak_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/voice/speak/raw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Text To Speech Raw
         * @description Convert text to speech and return raw audio bytes.
         *     Useful for direct audio playback.
         */
        post: operations["text_to_speech_raw_api_v1_assistant_voice_speak_raw_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/voice/transcribe": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Speech To Text
         * @description Transcribe audio to text using OpenAI Whisper.
         *
         *     Supported formats: mp3, mp4, mpeg, mpga, m4a, wav, webm
         *     Max file size: 25MB
         */
        post: operations["speech_to_text_api_v1_assistant_voice_transcribe_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/voice/chat": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Voice Chat
         * @description Full voice conversation endpoint.
         *
         *     1. Transcribes audio input (STT)
         *     2. Sends to QA Assistant (Claude)
         *     3. Converts response to speech (TTS)
         *
         *     Returns both text and audio response.
         */
        post: operations["voice_chat_api_v1_assistant_voice_chat_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/voice/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Voice Config
         * @description Get available voice configuration options.
         */
        get: operations["get_voice_config_api_v1_assistant_voice_config_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/preview-recategorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview Recategorization
         * @description Preview the impact of recategorizing transactions.
         *     Does NOT apply changes - just shows what would happen.
         */
        post: operations["preview_recategorization_api_v1_assistant_actions_preview_recategorize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/apply-recategorize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Recategorization
         * @description Apply recategorization to transactions in the claim.
         *     Updates the draft/report with new categories.
         */
        post: operations["apply_recategorization_api_v1_assistant_actions_apply_recategorize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/flag-for-client": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Flag Transactions For Client
         * @description Flag transactions with questions for client verification.
         *     These will appear in the clarification queue and magic link portal.
         */
        post: operations["flag_transactions_for_client_api_v1_assistant_actions_flag_for_client_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/pending-questions/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Client Questions
         * @description Get all transactions with pending client questions for a claim.
         */
        get: operations["get_pending_client_questions_api_v1_assistant_actions_pending_questions__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/parse-client-responses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Client Responses
         * @description Use AI to parse client responses and suggest final categorizations.
         *
         *     This is called after a client submits answers in the portal.
         *     The AI reads their notes/selections and suggests the best BI category.
         *
         *     Returns suggested categories with confidence scores for specialist approval.
         */
        post: operations["parse_client_responses_api_v1_assistant_actions_parse_client_responses_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/parse-all-pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse All Pending Responses
         * @description Batch parse ALL pending client responses across all claims.
         *
         *     This fetches all clarification requests with status 'client_responded'
         *     that have unparsed transactions, sends them to Claude in batches,
         *     and stores the AI suggestions.
         *
         *     Returns:
         *         - total_processed: Number of responses processed
         *         - high_confidence: Number with confidence >= 0.8
         *         - needs_review: Number with confidence < 0.8
         *         - parsed_responses: List of all parsed suggestions
         */
        post: operations["parse_all_pending_responses_api_v1_assistant_actions_parse_all_pending_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/apply-parsed-category": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Parsed Category
         * @description Apply an AI-suggested category to a transaction after specialist approval.
         *
         *     This completes the AI-Human-in-the-Loop workflow:
         *     1. AI suggests a question for the client
         *     2. Client answers in the portal
         *     3. AI parses the answer and suggests a category
         *     4. Specialist reviews and approves (this endpoint)
         *     5. Category is applied to the transaction
         */
        post: operations["apply_parsed_category_api_v1_assistant_actions_apply_parsed_category_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/pending-client-responses/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Client Responses
         * @description Get all client responses that are awaiting AI parsing or specialist approval.
         */
        get: operations["get_pending_client_responses_api_v1_assistant_actions_pending_client_responses__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/generate-batch-questions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Batch Questions
         * @description Analyze transactions and group similar ones for consolidated client questions.
         *
         *     This helps reduce client fatigue by asking one question for multiple similar
         *     transactions instead of asking the same question multiple times.
         *
         *     Grouping logic:
         *     1. Similar descriptions (fuzzy matching)
         *     2. Same vendor/payee
         *     3. Similar amounts
         *     4. Same current category
         *
         *     Returns groups with consolidated questions ready to send to client.
         */
        post: operations["generate_batch_questions_api_v1_assistant_actions_generate_batch_questions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/send-batch-questions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Batch Questions
         * @description Send the batch questions to the client.
         *     Creates clarification requests for each group.
         */
        post: operations["send_batch_questions_api_v1_assistant_actions_send_batch_questions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/smart-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Smart Review
         * @description "Smart Review" Mode - One-click comprehensive analysis of a claim.
         *
         *     This endpoint:
         *     1. Identifies all items needing attention (anomalies, low-confidence, pending clarifications)
         *     2. Uses AI to analyze and suggest actions for each
         *     3. Provides a prioritized action list
         *     4. Optionally auto-applies high-confidence suggestions
         *
         *     Perfect for power users who want to quickly process a claim.
         */
        post: operations["smart_review_api_v1_assistant_actions_smart_review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/assistant/actions/apply-smart-review-actions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Smart Review Actions
         * @description Apply selected actions from smart review.
         *     Batch process multiple recommended actions at once.
         */
        post: operations["apply_smart_review_actions_api_v1_assistant_actions_apply_smart_review_actions_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/portal/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Unified Portal Data
         * @description Get all data needed for the unified client portal.
         *
         *     Returns combined document requirements and clarification requests
         *     for a single portal experience.
         *
         *     Token must be either:
         *     - A portal_access token (for document uploads)
         *     - A magic_token from clarification_requests
         *
         *     SECURITY (audit 2026-04-19 PM): the raw-report_id fallback was
         *     removed. Report IDs are UUIDs but not secret — they appear in logs,
         *     referrers, and copy-paste screenshots, so accepting them as portal
         *     auth let anyone with a disclosed UUID view claim metadata.
         */
        get: operations["get_unified_portal_data_api_v1_portal__token__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/portal/{token}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Portal Status
         * @description Get current status of a portal session.
         *
         *     SECURITY (audit 2026-04-19 PM): token must resolve to a
         *     portal_access or clarification_requests row. The raw-report_id
         *     fallback was removed — a disclosed UUID is not auth.
         */
        get: operations["get_portal_status_api_v1_portal__token__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/chart-upload/upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload Chart Image
         * @description Upload a chart image (PNG) for inclusion in PDF/Word reports.
         *
         *     The image is stored in MongoDB as base64 for simplicity.
         *     For production, consider S3 storage.
         *
         *     Args:
         *         file: PNG image file
         *         report_id: Report/Draft ID this chart belongs to
         *         chart_name: Name identifier (e.g., 'monte_carlo', 'expense_breakdown')
         *
         *     Returns:
         *         {"success": true, "chart_id": "...", "chart_name": "..."}
         */
        post: operations["upload_chart_image_api_v1_chart_upload_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/chart-upload/list/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Chart Images
         * @description List all chart images uploaded for a report.
         */
        get: operations["list_chart_images_api_v1_chart_upload_list__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/chart-upload/{chart_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Chart Image
         * @description Delete a chart image.
         */
        delete: operations["delete_chart_image_api_v1_chart_upload__chart_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/schedule": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Beat Schedule
         * @description Get current Celery Beat schedule.
         *     Shows all scheduled tasks with their timing.
         */
        get: operations["get_beat_schedule_api_v1_beat_test_schedule_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/stale-draft-reminder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Stale Draft Reminder
         * @description Manually trigger the stale draft reminder task.
         *     Finds drafts untouched for 7+ days and sends reminders.
         */
        post: operations["test_stale_draft_reminder_api_v1_beat_test_stale_draft_reminder_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/weekly-attorney-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Weekly Attorney Summary
         * @description Manually trigger the weekly attorney summary task.
         *     Sends case progress summaries to law firms.
         */
        post: operations["test_weekly_attorney_summary_api_v1_beat_test_weekly_attorney_summary_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/low-confidence-digest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Low Confidence Digest
         * @description Manually trigger the low confidence review digest task.
         *     Notifies about AI responses needing human review.
         */
        post: operations["test_low_confidence_digest_api_v1_beat_test_low_confidence_digest_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/reprocess-failed-uploads": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Reprocess Failed Uploads
         * @description Manually trigger the reprocess failed uploads task.
         *     Retries OCR/parsing jobs that previously failed.
         */
        post: operations["test_reprocess_failed_uploads_api_v1_beat_test_reprocess_failed_uploads_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/orphan-cleanup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Orphan Cleanup
         * @description Manually trigger the orphan cleanup task.
         *     Removes abandoned uploads, stale chart images, expired tokens.
         */
        post: operations["test_orphan_cleanup_api_v1_beat_test_orphan_cleanup_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/beat-test/run-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Run All Tasks
         * @description Run all Beat tasks sequentially for testing.
         *     ⚠️ Use with caution - this will send real emails if configured!
         */
        post: operations["test_run_all_tasks_api_v1_beat_test_run_all_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Attorney Login
         * @description Login for attorneys using law firm credentials
         */
        post: operations["attorney_login_api_v1_attorney_login_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/dashboard": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney Dashboard
         * @description Get list of released cases for attorney's law firm
         */
        get: operations["get_attorney_dashboard_api_v1_attorney_dashboard_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/dashboard/alerts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Dashboard Alerts
         * @description Get deadline alerts and quick insights for attorney dashboard
         */
        get: operations["get_dashboard_alerts_api_v1_attorney_dashboard_alerts_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/clients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney Clients
         * @description Get list of clients submitted by this attorney
         */
        get: operations["get_attorney_clients_api_v1_attorney_clients_get"];
        put?: never;
        /**
         * Submit New Client
         * @description Attorney submits a new client for their law firm.
         *     Creates a draft case and sends portal email to client.
         *
         *     This is equivalent to Steps 1 & 2 of the wizard:
         *     - Step 1: Client info (name, email, phone, business name)
         *     - Step 2: Event details (event type, business type, event date)
         *
         *     After submission:
         *     - Creates draft case linked to law firm
         *     - Creates portal access token for client
         *     - Sends email to client with link to upload documents
         */
        post: operations["submit_new_client_api_v1_attorney_clients_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Detail
         * @description Get detailed view of a released case including analysis sections
         */
        get: operations["get_case_detail_api_v1_attorney_case__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}/context": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Context
         * @description Get contextual summary of a case for AI assistant and negotiation tools
         */
        get: operations["get_case_context_api_v1_attorney_case__case_id__context_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}/claim-type": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update Claim Type
         * @description Update the claim type for a case (first_party or third_party)
         */
        patch: operations["update_claim_type_api_v1_attorney_case__case_id__claim_type_patch"];
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}/download/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Case Pdf
         * @description Download PDF report for a released case
         */
        get: operations["download_case_pdf_api_v1_attorney_case__case_id__download_pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}/download/docx": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Case Docx
         * @description Download Word report for a released case
         */
        get: operations["download_case_docx_api_v1_attorney_case__case_id__download_docx_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/case/{case_id}/policy-document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Policy Document
         * @description Download the policy document for a released case
         */
        get: operations["download_policy_document_api_v1_attorney_case__case_id__policy_document_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/admin/law-firms/{law_firm_id}/set-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Set Attorney Password
         * @description Admin endpoint to set/reset attorney password for a law firm
         */
        post: operations["set_attorney_password_api_v1_attorney_admin_law_firms__law_firm_id__set_password_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/admin/cases/{case_id}/release": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Release Case To Attorney
         * @description Admin endpoint to release a case to the attorney.
         *     Returns 202 Accepted immediately with a task_id.
         *     The actual release work (DB update, email, orchestrator) runs in the background.
         *     Poll GET /admin/cases/{case_id}/release-status?task_id=<task_id> for progress.
         */
        post: operations["release_case_to_attorney_api_v1_attorney_admin_cases__case_id__release_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/admin/cases/{case_id}/release-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Release Status
         * @description Check case release status.
         *
         *     If task_id is provided, returns the status of a specific async release task:
         *       - {"status": "processing"} while running
         *       - {"status": "complete", "result": {...}} when done
         *       - {"status": "failed", "error": "..."} on failure
         *
         *     If task_id is not provided, returns the current release state of the case
         *     (backward-compatible with the original endpoint behavior).
         */
        get: operations["get_release_status_api_v1_attorney_admin_cases__case_id__release_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/forgot-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Request Password Reset
         * @description Request a password reset email for attorney
         */
        post: operations["request_password_reset_api_v1_attorney_forgot_password_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/reset-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset Password
         * @description Reset attorney password using token
         */
        post: operations["reset_password_api_v1_attorney_reset_password_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate Data
         * @description Validate transaction data against Pandera schemas.
         *
         *     Performs schema validation and quality scoring for:
         *     - Data type verification
         *     - Range constraints
         *     - Required field checks
         *     - Category validation
         *
         *     Returns quality score (0-100) and detailed issues.
         */
        post: operations["validate_data_api_v1_data_quality_validate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/expectations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate With Expectations
         * @description Validate data using Great Expectations business rules.
         *
         *     Runs expectation suites for:
         *     - Transactions: amount ranges, date formats, category validity
         *     - Periods: year/month constraints, revenue non-negativity, uniqueness
         *
         *     Returns detailed expectation results with pass/fail status.
         */
        post: operations["validate_with_expectations_api_v1_data_quality_expectations_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Profile Data
         * @description Generate statistical profile for transaction or period data.
         *
         *     Provides:
         *     - Column-level statistics (mean, std, min, max, quartiles)
         *     - Distribution analysis (skewness, kurtosis)
         *     - Anomaly detection (outliers, missing data, high cardinality)
         *     - Correlation matrix for numeric columns
         *
         *     Uses ydata-profiling for comprehensive analysis.
         */
        post: operations["profile_data_api_v1_data_quality_profile_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/cross-validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cross Validate Documents
         * @description Validate consistency across multiple documents.
         *
         *     Performs:
         *     - Balance reconciliation between bank statements and P&L
         *     - Totals matching across documents
         *     - Date range consistency checks
         *     - Duplicate detection across files
         *     - Period coverage analysis
         *
         *     Requires at least 2 documents for meaningful cross-validation.
         */
        post: operations["cross_validate_documents_api_v1_data_quality_cross_validate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Report
         * @description Generate comprehensive quality report combining all validation sources.
         *
         *     Aggregates results from:
         *     - Pandera schema validation
         *     - Great Expectations business rules
         *     - Statistical profiling
         *     - Cross-document validation
         *
         *     Available formats:
         *     - json: Machine-readable report object
         *     - text: Human-readable text summary
         *     - court_ready: Formal documentation for legal proceedings
         *     - markdown: Markdown formatted report
         */
        post: operations["generate_report_api_v1_data_quality_report_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/data-quality/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Data Quality Health
         * @description Health check for data quality services.
         *
         *     Verifies all components are operational:
         *     - Pandera validation service
         *     - Great Expectations validator
         *     - Data profiler
         *     - Cross-document validator
         *     - Quality reporter
         */
        get: operations["data_quality_health_api_v1_data_quality_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/explainability/train": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Train Explainable Model
         * @description Train an Isolation Forest model with SHAP explainability.
         *
         *     This trains a model on historical transaction data to detect anomalies
         *     and provide SHAP-based explanations for why transactions are flagged.
         *
         *     Args:
         *         transactions: Training data (historical transactions)
         *         contamination: Expected proportion of anomalies (default 0.1 = 10%)
         *         n_estimators: Number of trees in the forest (default 100)
         *         feature_columns: Optional specific columns to use as features
         */
        post: operations["train_explainable_model_api_v1_explainability_train_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/explainability/explain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Explain Anomaly
         * @description Generate SHAP explanation for a single transaction.
         *
         *     Returns detailed breakdown of which features contributed to
         *     the anomaly score, with human-readable narratives.
         *
         *     Requires model to be trained first via /train endpoint.
         */
        post: operations["explain_anomaly_api_v1_explainability_explain_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/explainability/explain-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Explain Batch
         * @description Generate SHAP explanations for multiple transactions.
         *
         *     By default, only explains transactions flagged as anomalies.
         *     Set only_anomalies=False to explain all transactions.
         */
        post: operations["explain_batch_api_v1_explainability_explain_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/explainability/feature-importance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Feature Importance
         * @description Get global feature importance from the trained model.
         *
         *     Returns the average absolute SHAP value for each feature,
         *     normalized as percentages summing to 100%.
         *
         *     Requires model to be trained first.
         */
        get: operations["get_feature_importance_api_v1_explainability_feature_importance_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/explainability/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Explainability Health
         * @description Health check for explainability services.
         *
         *     Verifies SHAP and scikit-learn availability and model status.
         */
        get: operations["explainability_health_api_v1_explainability_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload And Extract
         * @description Upload a file and extract data using the smart extraction pipeline.
         *
         *     - **file**: The file to process
         *     - **skip_cache**: Skip cache lookup and force re-processing
         *     - **force_tier**: Force a specific processing tier (local, api, hybrid)
         */
        post: operations["upload_and_extract_api_v1_extraction_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/status/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Status
         * @description Get the status of an extraction job.
         *
         *     - **job_id**: The ID of the extraction job
         */
        get: operations["get_extraction_status_api_v1_extraction_status__job_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/results/{job_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Results
         * @description Get the results of a completed extraction job.
         *
         *     - **job_id**: The ID of the extraction job
         */
        get: operations["get_extraction_results_api_v1_extraction_results__job_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Stats
         * @description Get extraction pipeline statistics.
         */
        get: operations["get_extraction_stats_api_v1_extraction_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/cache/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Recent Cache Entries
         * @description Get recent cache entries.
         *
         *     - **limit**: Maximum number of entries to return (default: 10)
         */
        get: operations["get_recent_cache_entries_api_v1_extraction_cache_recent_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/cache/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Clear Cache
         * @description Clear the extraction cache.
         */
        post: operations["clear_cache_api_v1_extraction_cache_clear_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/cache/{fingerprint}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Invalidate Cache Entry
         * @description Invalidate a specific cache entry.
         *
         *     - **fingerprint**: SHA-256 fingerprint of the file
         */
        delete: operations["invalidate_cache_entry_api_v1_extraction_cache__fingerprint__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Extraction Health
         * @description Health check for the extraction pipeline.
         */
        get: operations["extraction_health_api_v1_extraction_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/upload/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Upload
         * @description Upload multiple files for batch extraction.
         *
         *     - **files**: List of files to process
         *     - **skip_cache**: Skip cache lookup
         *
         *     Returns summary with job IDs for each file.
         */
        post: operations["batch_upload_api_v1_extraction_upload_batch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/upload/with-postprocessing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload With Postprocessing
         * @description Upload a file and extract with automatic post-processing.
         *
         *     Post-processing includes:
         *     - Date normalization to ISO format
         *     - Currency normalization
         *     - Duplicate detection (optional)
         *     - Quality scoring
         */
        post: operations["upload_with_postprocessing_api_v1_extraction_upload_with_postprocessing_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/analyze/quality": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Quality
         * @description Analyze quality of extracted records.
         *
         *     - **records**: List of record dictionaries to analyze
         */
        post: operations["analyze_quality_api_v1_extraction_analyze_quality_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/normalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Normalize Records
         * @description Normalize extracted records.
         *
         *     - **records**: Records to normalize
         *     - **field_types**: Optional field type hints (date, currency, number, text)
         */
        post: operations["normalize_records_api_v1_extraction_normalize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/detect-duplicates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Detect Duplicates
         * @description Detect duplicates in extracted records.
         *
         *     - **records**: Records to analyze
         *     - **key_fields**: Fields to use for duplicate detection
         *     - **deduplicate**: If true, return deduplicated records
         */
        post: operations["detect_duplicates_api_v1_extraction_detect_duplicates_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/infer-schema": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Infer Schema
         * @description Infer schema from uploaded file.
         *
         *     Returns column types, names, and constraints.
         */
        post: operations["infer_schema_api_v1_extraction_infer_schema_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/extraction/supported-formats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Supported Formats
         * @description Get list of supported file formats and their extraction pipelines.
         */
        get: operations["get_supported_formats_api_v1_extraction_supported_formats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Vendor Summary
         * @description Get summary of vendor intelligence across all claims.
         *
         *     Returns:
         *     - Total vendors detected
         *     - Top vendors by frequency
         *     - Category distribution
         *     - Disaster recovery vendors
         */
        get: operations["get_vendor_summary_api_v1_vendor_intelligence_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/known-vendors": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Known Vendors
         * @description Get list of all known vendors in the vendor intelligence database.
         */
        get: operations["get_known_vendors_api_v1_vendor_intelligence_known_vendors_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Vendor
         * @description Extract vendor from a transaction description using NER.
         *
         *     Request body:
         *     - description: Transaction description text
         *     - event_type: Optional event type for context
         */
        post: operations["extract_vendor_api_v1_vendor_intelligence_extract_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/category-breakdown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Category Breakdown
         * @description Get detailed breakdown of transactions by category with vendor insights.
         */
        get: operations["get_category_breakdown_api_v1_vendor_intelligence_category_breakdown_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/discovered": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Discovered Vendors
         * @description Get list of discovered vendors pending admin review.
         *
         *     These are vendors that have been seen multiple times but are not
         *     in the known vendor database.
         */
        get: operations["get_discovered_vendors_api_v1_vendor_intelligence_discovered_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/discovered/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve Discovered Vendor
         * @description Approve a discovered vendor and add to the known vendors database.
         *
         *     Request body:
         *     - vendor_name: Name of the vendor to approve
         *     - category: Category to assign
         *     - subcategory: Subcategory to assign
         *     - confidence: Optional confidence score (default 0.85)
         */
        post: operations["approve_discovered_vendor_api_v1_vendor_intelligence_discovered_approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/discovered/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reject Discovered Vendor
         * @description Reject a discovered vendor (won't be flagged again).
         *
         *     Request body:
         *     - vendor_name: Name of the vendor to reject
         */
        post: operations["reject_discovered_vendor_api_v1_vendor_intelligence_discovered_reject_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/learned": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Learned Vendors
         * @description Get all learned (admin-approved) vendors from the database.
         */
        get: operations["get_learned_vendors_api_v1_vendor_intelligence_learned_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Vendor Intelligence Stats
         * @description Get comprehensive vendor intelligence statistics.
         */
        get: operations["get_vendor_intelligence_stats_api_v1_vendor_intelligence_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/classification-tiers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Classification Tier Stats
         * @description Get classification tier breakdown showing Tier 1 (local DB) vs Tier 2 (AI API) hit rates
         *     and cost savings from the expanded vendor database.
         *
         *     Returns:
         *     - tier_breakdown: Count of transactions classified by each tier
         *     - cost_savings: Estimated $ saved by avoiding API calls
         *     - hit_rates: Percentage of transactions resolved at each tier
         */
        get: operations["get_classification_tier_stats_api_v1_vendor_intelligence_classification_tiers_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/vendor-intelligence/classification-history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Classification History
         * @description Get historical classification tier breakdown by month.
         *     Shows how the local database learning improves classification rates over time.
         *
         *     Returns monthly data for:
         *     - tier_1_rate: % resolved by local vendor database
         *     - tier_2_rate: % resolved by local ML
         *     - tier_3_rate: % requiring paid AI APIs
         *     - cost_savings: Cumulative $ saved that month
         */
        get: operations["get_classification_history_api_v1_vendor_intelligence_classification_history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Negotiation
         * @description Run comprehensive game theory analysis for settlement negotiation.
         *
         *     Provides:
         *     - Nash Equilibrium calculation
         *     - ZOPA (Zone of Possible Agreement) analysis
         *     - BATNA (Best Alternative) evaluation
         *     - Concession strategy recommendations
         *     - Reservation price estimates
         */
        post: operations["analyze_negotiation_api_v1_game_theory_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/quick-analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Quick Analyze
         * @description Quick game theory analysis with auto-generated adjuster/attorney values.
         *
         *     Automatically estimates:
         *     - Adjuster value: 75% of claim
         *     - Attorney value: 125% of claim
         */
        post: operations["quick_analyze_api_v1_game_theory_quick_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Analyze From Report
         * @description Run game theory analysis using data from an existing report.
         *
         *     Extracts claim values from report's calculation detail and
         *     adjuster/attorney analyses if available.
         */
        get: operations["analyze_from_report_api_v1_game_theory_report__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/styles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Negotiation Styles
         * @description Get available negotiation styles with descriptions.
         */
        get: operations["get_negotiation_styles_api_v1_game_theory_styles_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/zopa-calculator": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Calculate Zopa
         * @description Simple ZOPA (Zone of Possible Agreement) calculator.
         *
         *     ZOPA exists when insurer's maximum >= claimant's minimum.
         */
        get: operations["calculate_zopa_api_v1_game_theory_zopa_calculator_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/game-theory/nash-point": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Calculate Nash Point
         * @description Calculate Nash Bargaining Solution point.
         *
         *     The Nash solution maximizes the product of both parties' gains
         *     relative to their disagreement points.
         */
        get: operations["calculate_nash_point_api_v1_game_theory_nash_point_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/cases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Available Cases
         * @description Get list of cases available for settlement analysis.
         *     Only returns cases with calculated claim values.
         */
        get: operations["list_available_cases_api_v1_settlement_intelligence_cases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/sensitivity/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Sensitivity Analysis
         * @description Run comprehensive sensitivity analysis with tornado chart data.
         *
         *     Returns:
         *     - Tornado chart data (variable impact ranking)
         *     - Top value drivers with recommendations
         *     - Interaction effects between variables
         *     - Elasticity calculations
         *     - Automated insights
         */
        post: operations["run_sensitivity_analysis_api_v1_settlement_intelligence_sensitivity_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/sensitivity/quick": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Quick Sensitivity Analysis
         * @description Quick sensitivity analysis using typical expense ratios.
         *     Automatically estimates expenses based on claim value.
         */
        post: operations["quick_sensitivity_analysis_api_v1_settlement_intelligence_sensitivity_quick_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/sensitivity/tornado-format": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Tornado Chart Format
         * @description Get information about tornado chart data format for visualization.
         */
        get: operations["get_tornado_chart_format_api_v1_settlement_intelligence_sensitivity_tornado_format_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/historical/compare": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare To Historical
         * @description Compare current settlement against historical benchmarks.
         *
         *     Returns:
         *     - Percentile ranking of current settlement
         *     - Industry benchmark comparison
         *     - Event-type adjusted benchmarks
         *     - Strategic recommendations based on position
         */
        post: operations["compare_to_historical_api_v1_settlement_intelligence_historical_compare_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/historical/industries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Industries
         * @description Get list of industries with benchmark data
         */
        get: operations["get_available_industries_api_v1_settlement_intelligence_historical_industries_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/historical/event-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Event Types
         * @description Get list of event types with adjustment factors
         */
        get: operations["get_event_types_api_v1_settlement_intelligence_historical_event_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Whatif Templates
         * @description Get available what-if scenario templates.
         *
         *     Returns pre-built scenario templates that can be used for quick analysis.
         */
        get: operations["list_whatif_templates_api_v1_settlement_intelligence_whatif_templates_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Whatif Scenarios
         * @description Run what-if analysis comparing multiple scenarios.
         *
         *     Compares different approaches (documentation, expert witnesses, etc.)
         *     and calculates ROI for each. Returns recommendation based on
         *     risk-adjusted benefit.
         */
        post: operations["run_whatif_scenarios_api_v1_settlement_intelligence_whatif_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/single": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Single Scenario
         * @description Analyze a single scenario from a template.
         *
         *     Allows selecting specific modifications from the template
         *     for more targeted analysis.
         */
        post: operations["analyze_single_scenario_api_v1_settlement_intelligence_whatif_single_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/custom": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Custom Scenario
         * @description Analyze a fully custom scenario with user-defined modifications.
         */
        post: operations["analyze_custom_scenario_api_v1_settlement_intelligence_whatif_custom_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/roi-guide": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Roi Guide
         * @description Get guidance on interpreting ROI calculations for what-if scenarios.
         */
        get: operations["get_roi_guide_api_v1_settlement_intelligence_whatif_roi_guide_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/modifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Modifications
         * @description Get all available modifications from all templates.
         *     Used for "Build Your Own Strategy" feature.
         */
        get: operations["get_all_modifications_api_v1_settlement_intelligence_whatif_modifications_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/whatif/build-strategy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Build Custom Strategy
         * @description Build a custom strategy by mixing modifications from any template.
         *
         *     Select individual modifications and get a combined ROI analysis.
         */
        post: operations["build_custom_strategy_api_v1_settlement_intelligence_whatif_build_strategy_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/case/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Settlement Data
         * @description Fetch case data formatted for Settlement Intelligence tools.
         *
         *     Pre-populates all analysis tools with real case data:
         *     - Sensitivity Analysis inputs
         *     - Historical Comparison inputs
         *     - What-If Modeler inputs
         *     - Game Theory inputs
         *     - Litigation Economics inputs
         */
        get: operations["get_case_settlement_data_api_v1_settlement_intelligence_case__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/litigation/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Litigation Economics
         * @description Analyze settlement vs litigation path using NPV calculations.
         *
         *     Compares:
         *     - Settlement path (immediate, certain)
         *     - Litigation path (delayed, uncertain, with costs)
         *
         *     Returns:
         *     - Expected value comparison
         *     - Break-even settlement amount
         *     - Recommendation (accept/negotiate/litigate)
         *     - Scenario breakdown with probabilities
         */
        post: operations["analyze_litigation_economics_api_v1_settlement_intelligence_litigation_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/settlement-intelligence/litigation/guide": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Litigation Guide
         * @description Get guidance on litigation economics concepts.
         */
        get: operations["get_litigation_guide_api_v1_settlement_intelligence_litigation_guide_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/bad-faith/analyze": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Bad Faith
         * @description 🚨 BAD FAITH TRACKER - Analyze carrier conduct
         *
         *     Monitors insurance company response times against state statutory deadlines.
         *     Identifies potential bad faith indicators and estimates damages.
         *
         *     Returns:
         *     - Bad faith score (0-100)
         *     - Statutory violations with severity
         *     - Estimated damages including penalties
         *     - Actionable recommendations
         */
        post: operations["analyze_bad_faith_api_v1_attorney_tools_bad_faith_analyze_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/bad-faith/deadlines/{state}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get State Deadlines
         * @description Get statutory deadlines for a specific state.
         *
         *     Returns acknowledgment, investigation, decision, and payment deadlines.
         */
        get: operations["get_state_deadlines_api_v1_attorney_tools_bad_faith_deadlines__state__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/bad-faith/states": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Supported States
         * @description List all states with specific statutory deadline rules
         */
        get: operations["list_supported_states_api_v1_attorney_tools_bad_faith_states_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/bad-faith/upcoming-deadlines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Upcoming Deadlines
         * @description Get upcoming deadlines for a claim.
         *
         *     Useful for proactive monitoring of carrier obligations.
         */
        post: operations["get_upcoming_deadlines_api_v1_attorney_tools_bad_faith_upcoming_deadlines_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/case-law/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Search Case Law
         * @description 🔍 CASE LAW RAG - Semantic search for similar cases
         *
         *     Uses AI embeddings to find semantically similar cases based on:
         *     - Natural language query
         *     - Event type
         *     - Jurisdiction
         *     - Year range
         *
         *     Returns relevant cases with similarity scores.
         */
        post: operations["search_case_law_api_v1_attorney_tools_case_law_search_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/case-law/benchmarks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Settlement Benchmarks
         * @description 📊 SETTLEMENT BENCHMARKS - Historical settlement analysis
         *
         *     Analyzes similar cases to provide:
         *     - Average and median settlement ratios
         *     - Estimated settlement range for your claim
         *     - Key success factors
         *     - Litigation duration estimates
         */
        post: operations["get_settlement_benchmarks_api_v1_attorney_tools_case_law_benchmarks_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/case-law/initialize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Initialize Case Law Db
         * @description Initialize case law database with sample data.
         *
         *     This populates the case_law collection with example cases
         *     and generates embeddings for semantic search.
         */
        post: operations["initialize_case_law_db_api_v1_attorney_tools_case_law_initialize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/case-law/event-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Event Types
         * @description List available event types in case law database
         */
        get: operations["list_event_types_api_v1_attorney_tools_case_law_event_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/case-law/jurisdictions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Jurisdictions
         * @description List states with case law data
         */
        get: operations["list_jurisdictions_api_v1_attorney_tools_case_law_jurisdictions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/demand-letter/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Demand Letter
         * @description 📝 DEMAND LETTER GENERATOR - Auto-generate professional demand letters
         *
         *     Generates demand letters auto-populated from case data with:
         *     - Multiple letter types (initial, follow-up, bad faith notice, final, appraisal)
         *     - State-specific statutory references
         *     - Loss calculations and policy references
         *     - Sections flagged for attorney review
         *
         *     Required case_data fields:
         *     - insured_name: Name of the insured
         *     - carrier_name: Insurance company name
         *     - policy_number: Policy number
         *     - claim_number: Claim number
         *     - claim_amount: Total claimed amount
         *     - state: State for statutory references
         *     - attorney_name: Representing attorney name
         *     - attorney_firm: Law firm name
         *
         *     Optional fields:
         *     - insured_address, carrier_address, adjuster_name, event_type, event_date,
         *     - loss_period_days, loss_breakdown, attorney_address, attorney_phone, etc.
         */
        post: operations["generate_demand_letter_api_v1_attorney_tools_demand_letter_generate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/demand-letter/export/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Export Demand Letter Pdf
         * @description 📄 EXPORT DEMAND LETTER AS PDF
         *
         *     Generates a professional PDF document from the demand letter.
         *     Returns the PDF file for download.
         */
        post: operations["export_demand_letter_pdf_api_v1_attorney_tools_demand_letter_export_pdf_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/demand-letter/export/docx": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Export Demand Letter Docx
         * @description 📝 EXPORT DEMAND LETTER AS DOCX
         *
         *     Generates a Microsoft Word document from the demand letter.
         *     Returns the DOCX file for download.
         */
        post: operations["export_demand_letter_docx_api_v1_attorney_tools_demand_letter_export_docx_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/demand-letter/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Letter Types
         * @description List available demand letter types
         */
        get: operations["list_letter_types_api_v1_attorney_tools_demand_letter_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/demand-letter/state-statutes/{state}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get State Statutes
         * @description Get state-specific statutory references for demand letters
         */
        get: operations["get_state_statutes_api_v1_attorney_tools_demand_letter_state_statutes__state__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/litigation/predict-timeline": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Predict Litigation Timeline
         * @description ⏱️ LITIGATION TIMELINE PREDICTOR - Forecast litigation duration and costs
         *
         *     Predicts:
         *     - Timeline through each litigation phase
         *     - Estimated costs per phase
         *     - Settlement probability at each stage
         *     - Optimistic, base, and pessimistic scenarios
         *     - Risk factors that could extend timeline
         *
         *     Case data fields that affect prediction:
         *     - claim_amount: Total claimed amount (higher = more complex)
         *     - jurisdiction: State code (affects court speed)
         *     - coverage_disputed: Whether coverage is in dispute
         *     - multiple_parties: Multiple claimants or defendants
         *     - experts_needed: Number of expert witnesses (0-10)
         *     - bad_faith_claim: Whether bad faith is alleged
         *     - novel_issues: Novel legal issues present
         *     - document_pages: Volume of documentation
         */
        post: operations["predict_litigation_timeline_api_v1_attorney_tools_litigation_predict_timeline_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/litigation/cost-breakdown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get Litigation Costs
         * @description 💰 LITIGATION COST BREAKDOWN - Detailed cost estimates by phase
         *
         *     Returns estimated costs for each litigation phase including:
         *     - Attorney fees
         *     - Expert fees
         *     - Court costs
         *     - Discovery costs
         *     - Trial costs
         */
        post: operations["get_litigation_costs_api_v1_attorney_tools_litigation_cost_breakdown_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/litigation/complexity-assessment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Assess Case Complexity
         * @description 📊 CASE COMPLEXITY ASSESSMENT - Determine litigation complexity level
         *
         *     Assesses case complexity based on multiple factors to help
         *     predict timeline and costs.
         */
        get: operations["assess_case_complexity_api_v1_attorney_tools_litigation_complexity_assessment_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/litigation/phases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Litigation Phases
         * @description List all litigation phases with descriptions
         */
        get: operations["list_litigation_phases_api_v1_attorney_tools_litigation_phases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/policy-dna/extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Policy Dna
         * @description 🧬 POLICY DNA EXTRACTOR - Deep analysis of insurance policies
         *
         *     Extracts comprehensive structural information from insurance policies:
         *     - Coverage limits and sublimits (BI, Extra Expense, Civil Authority)
         *     - Exclusion clauses (virus, flood, earthquake, etc.)
         *     - Waiting periods, coinsurance, period of indemnity
         *     - Endorsements and amendments
         *     - Key definitions (direct physical loss, period of restoration, etc.)
         *     - Strategic notes for litigation (strengths, weaknesses, opportunities)
         *
         *     This is the advanced policy analysis tool for attorney case preparation.
         */
        post: operations["extract_policy_dna_api_v1_attorney_tools_policy_dna_extract_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/policy-dna/retrieve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retrieve Policy Dna
         * @description 📋 RETRIEVE STORED POLICY DNA - Get previously extracted policy analysis
         *
         *     Retrieves policy DNA that was previously extracted and stored for a case.
         */
        post: operations["retrieve_policy_dna_api_v1_attorney_tools_policy_dna_retrieve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/policy-dna/exclusion-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Exclusion Types
         * @description 📜 LIST EXCLUSION TYPES - Get all recognized exclusion types
         *
         *     Returns the list of exclusion types that the Policy DNA Extractor
         *     can identify and analyze.
         */
        get: operations["list_exclusion_types_api_v1_attorney_tools_policy_dna_exclusion_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/policy-dna/coverage-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Coverage Types
         * @description 💰 LIST COVERAGE TYPES - Get all recognized coverage types
         *
         *     Returns the list of coverage types that the Policy DNA Extractor
         *     can identify in insurance policies.
         */
        get: operations["list_coverage_types_api_v1_attorney_tools_policy_dna_coverage_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-tools/policy-dna/key-definitions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Key Definitions
         * @description 📖 LIST KEY DEFINITIONS - Get important policy terms to extract
         *
         *     Returns the list of key policy definitions that are critical
         *     for business interruption litigation.
         */
        get: operations["list_key_definitions_api_v1_attorney_tools_policy_dna_key_definitions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/pl-grid/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pl Grid
         * @description Get year-at-a-glance P&L grid with reconciliation status.
         *
         *     Returns P&L structure with monthly values for all years in the report.
         *     Includes reconciliation status for each cell (not_started, in_review, reconciled).
         *
         *     Example Response:
         *     {
         *         "report_id": "507f1f77bcf86cd799439011",
         *         "years": [2020, 2021, 2022],
         *         "pl_structure": {
         *             "sections": ["INCOME", "COST OF GOODS SOLD", "OPERATING EXPENSES"],
         *             "line_items": {...}
         *         },
         *         "pl_grid": {
         *             "2022": {
         *                 "INCOME": {
         *                     "Sales": [1200, 1500, ..., 15000],
         *                     ...
         *                 }
         *             }
         *         },
         *         "reconciliation_status": {
         *             "2022-01-Sales": "reconciled",
         *             "2022-01-Utilities": "in_review",
         *             ...
         *         }
         *     }
         */
        get: operations["get_pl_grid_api_v1_reconciliation_pl_grid__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/cell-transactions/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Cell Transactions
         * @description Drill into a specific P&L cell to see all supporting transactions.
         *
         *     Returns:
         *     - All transactions that contributed to this P&L cell
         *     - Expected amount (from P&L)
         *     - Actual amount (sum of transactions)
         *     - Variance
         *     - Anomalies detected
         *     - Reconciliation status
         *
         *     Example:
         *         GET /cell-transactions/123?year=2022&month=1&section=INCOME&line_item=Sales
         *
         *     Returns 50 transactions for "Sales" in January 2022 with variance calculation.
         */
        get: operations["get_cell_transactions_api_v1_reconciliation_cell_transactions__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/transactions/{report_id}/{transaction_id}/reclassify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reclassify Transaction
         * @description Reclassify a transaction to a different P&L line item.
         *
         *     Creates audit trail entry and updates transaction in database.
         *     Accountant must provide a reason for the reclassification.
         *
         *     OPTIMIZED: Uses MongoDB array filters to update single transaction
         *     instead of rewriting entire array (100x performance improvement).
         *
         *     Example:
         *         POST /transactions/123/txn_456/reclassify
         *         {
         *             "new_category": "Office & Supplies",
         *             "new_subcategory": "Office Supplies",
         *             "reason": "Per invoice review, this is office supplies not utilities"
         *         }
         */
        post: operations["reclassify_transaction_api_v1_reconciliation_transactions__report_id___transaction_id__reclassify_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/history/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Reclassification History
         * @description Get complete reclassification audit trail for a report.
         *
         *     Returns all reclassifications with user, timestamp, and reason.
         */
        get: operations["get_reclassification_history_api_v1_reconciliation_history__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/cells/{report_id}/{cell_id}/sign-off": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sign Off Cell
         * @description Sign off reconciliation for a P&L cell.
         *
         *     Forensic accountant attests that they have reviewed all transactions
         *     for this cell and accepts the variance (if any).
         *
         *     Example:
         *         POST /cells/123/2022-01-Sales/sign-off
         *         {
         *             "notes": "Variance explained by 2 missing deposits, totaling $150. Client to provide documentation.",
         *             "variance_accepted": true
         *         }
         */
        post: operations["sign_off_cell_api_v1_reconciliation_cells__report_id___cell_id__sign_off_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/transactions/{report_id}/{transaction_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update Transaction Flags
         * @description Update transaction review status (checked, flagged).
         *
         *     Used for marking transactions as reviewed or flagging for further investigation.
         *
         *     OPTIMIZED: Uses MongoDB array filters to update single transaction
         *     instead of rewriting entire array (100x performance improvement).
         *
         *     Example:
         *         PATCH /transactions/123/txn_456
         *         {
         *             "checked": true,
         *             "flagged": false
         *         }
         */
        patch: operations["update_transaction_flags_api_v1_reconciliation_transactions__report_id___transaction_id__patch"];
        trace?: never;
    };
    "/api/v1/reconciliation/export/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Reconciliation Workpaper
         * @description Export Forensic Reconciliation Workpaper (Task 9 — granular).
         *
         *     Default behavior (no filters, format=xlsx): 6-sheet whole-case
         *     workbook — P&L summary, transaction detail, anomalies,
         *     reclassification audit, variance analysis, sign-off docs.
         *
         *     With filters: the same workbook scoped to the requested slice, or
         *     a single CSV of the transaction-detail sheet when format=csv.
         *     Accountants use the narrow slice for court exhibits tied to one
         *     month or line item; they use CSV to link figures back into Excel
         *     workpapers as live formulas.
         *
         *     Example:
         *         GET /export/abc?year=2023&month=5&format=csv
         *         → transactions_abc_2023-05.csv
         *
         *         GET /export/abc?line_item=Gross+Sales&format=xlsx
         *         → Reconciliation_Workpaper_abc_filtered_<date>.xlsx
         */
        get: operations["export_reconciliation_workpaper_api_v1_reconciliation_export__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/multi-source/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Multi Source Reconciliation
         * @description Multi-source P&L reconciliation view.
         *
         *     Returns P&L line item totals broken down by document source
         *     (bank statements, credit card statements, tax returns, P&L statements).
         *     This enables accountants to see where each number comes from and
         *     identify discrepancies between sources.
         *
         *     Response structure:
         *     {
         *         "report_id": "...",
         *         "years": [2022, 2023],
         *         "sources_found": ["bank_statements", "credit_card", "tax_returns"],
         *         "source_labels": {"bank_statements": "Bank Statements", ...},
         *         "source_document_counts": {"bank_statements": 12, ...},
         *         "source_grids": {
         *             "bank_statements": {
         *                 2022: {"INCOME": {"Sales": [1200, ...]}, ...}
         *             },
         *             "credit_card": { ... },
         *             "combined": { ... }
         *         },
         *         "line_item_comparison": {
         *             2022: {
         *                 "INCOME": {
         *                     "Sales": {
         *                         "bank_statements": 145000,
         *                         "credit_card": 0,
         *                         "tax_returns": 148000,
         *                         "combined": 145000,
         *                         "variance": -3000,
         *                         "variance_pct": -2.03
         *                     }
         *                 }
         *             }
         *         }
         *     }
         */
        get: operations["get_multi_source_reconciliation_api_v1_reconciliation_multi_source__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/multi-source/{report_id}/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Multi Source Reconciliation
         * @description Export the multi-source reconciliation view as an XLSX workbook.
         *
         *     One sheet per source (bank, card, tax, P&L), plus a
         *     "Variance vs Tax Return" sheet highlighting per-line-item gaps.
         *     Accountants use this file as a court exhibit showing that every
         *     P&L line triangulates across sources — or surfacing exactly where
         *     sources disagree.
         */
        get: operations["export_multi_source_reconciliation_api_v1_reconciliation_multi_source__report_id__export_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/export-exhibit-package/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Export Bates Exhibit Package
         * @description Build the Bates-indexed court-production ZIP for the case.
         *
         *     The ZIP contains:
         *       * One stamped PDF per uploaded source file (bottom-right Bates
         *         numbers on every page).
         *       * A Document_Index.xlsx mapping each file to its Bates range.
         *       * Optionally, the Reconciliation_Workpaper.xlsx so one ZIP can
         *         be handed to opposing counsel as a complete production.
         *       * A README.txt describing the scheme.
         */
        post: operations["export_bates_exhibit_package_api_v1_reconciliation_export_exhibit_package__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/transactions/{report_id}/bulk-flag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk Update Transaction Flags
         * @description Bulk update flags for multiple transactions.
         *
         *     OPTIMIZED: Uses MongoDB bulk operations for efficient updates.
         *
         *     Example:
         *         POST /transactions/123/bulk-flag
         *         {
         *             "transaction_ids": ["txn_001", "txn_002", "txn_003"],
         *             "checked": true
         *         }
         */
        post: operations["bulk_update_transaction_flags_api_v1_reconciliation_transactions__report_id__bulk_flag_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/stats/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Reconciliation Stats
         * @description Get reconciliation statistics for a report.
         *
         *     Returns counts of checked, flagged, and reclassified transactions.
         */
        get: operations["get_reconciliation_stats_api_v1_reconciliation_stats__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/audit-trail/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Audit Trail
         * @description Export the audit trail for a report.
         *
         *     Returns reclassification history, sign-offs, and flag changes.
         *     Useful for compliance documentation and case review.
         *
         *     Args:
         *         report_id: The report/case ID
         *         export_format: "json" or "csv"
         *         include_signoffs: Include sign-off records in export
         *         include_flags: Include flag change history
         *
         *     Returns:
         *         JSON response or CSV file download
         */
        get: operations["get_audit_trail_api_v1_reconciliation_audit_trail__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/source-pdf/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Source Pdf Url
         * @description Get presigned URL for viewing a source document.
         *
         *     Returns a temporary URL valid for 1 hour that allows viewing the PDF.
         *     Also returns document metadata like total pages.
         */
        get: operations["get_source_pdf_url_api_v1_reconciliation_source_pdf__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/source-pdf-stream/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Stream Source Pdf
         * @description Stream a source PDF directly from S3 through the backend.
         *
         *     This is a fallback for when presigned URLs don't work due to IAM issues.
         *     Accepts JWT token as query param for iframe authentication.
         */
        get: operations["stream_source_pdf_api_v1_reconciliation_source_pdf_stream__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/source-pdf-text/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Source Pdf Text
         * @description Get OCR text for a source PDF to enable text search.
         *
         *     Returns the full extracted text organized by page for search functionality.
         */
        get: operations["get_source_pdf_text_api_v1_reconciliation_source_pdf_text__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/source-pdf-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Source Pdf Url Direct
         * @description Get presigned URL for downloading/viewing a source document by S3 key.
         *
         *     This endpoint generates a temporary URL (valid for 1 hour) for direct access
         *     to any document stored in S3, given its key.
         *
         *     Returns:
         *         - url: Presigned URL for the document
         *         - filename: Original filename extracted from the key
         *         - expires_in: Seconds until URL expires
         */
        get: operations["get_source_pdf_url_direct_api_v1_reconciliation_source_pdf_url_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/source-file/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Source File For Period
         * @description Get the source bank statement PDF for a specific year/month period.
         *
         *     This is used for drill-down from P&L grid cells to show the original
         *     bank statement where transactions came from.
         *
         *     Returns presigned URL and file info for the matching statement.
         */
        get: operations["get_source_file_for_period_api_v1_reconciliation_source_file__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/transactions/{report_id}/batch-reclassify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Reclassify Transactions
         * @description Batch reclassify multiple transactions to the same category.
         *
         *     Useful when multiple similar transactions need the same correction.
         *     Creates individual audit trail entries for each transaction.
         *
         *     Example:
         *         POST /transactions/123/batch-reclassify
         *         {
         *             "transaction_ids": ["txn_001", "txn_002", "txn_003"],
         *             "new_category": "Office & Supplies",
         *             "new_subcategory": "Office Supplies",
         *             "reason": "Per vendor invoice review, these are all office supply purchases"
         *         }
         */
        post: operations["batch_reclassify_transactions_api_v1_reconciliation_transactions__report_id__batch_reclassify_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/batch-process/start": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start Batch Processing
         * @description Start batch processing of multiple documents.
         *
         *     Returns a batch_id that can be used to check status.
         */
        post: operations["start_batch_processing_api_v1_batch_process_start_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/batch-process/status/{batch_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Batch Status
         * @description Get the status of a batch processing job.
         */
        get: operations["get_batch_status_api_v1_batch_process_status__batch_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/batch-process/list-s3-documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List S3 Documents
         * @description List available documents in S3 that can be processed.
         */
        get: operations["list_s3_documents_api_v1_batch_process_list_s3_documents_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ws/report/{report_id}/viewers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Viewers
         * @description REST endpoint to get current viewers of a report.
         *     Useful for initial page load before WebSocket connects.
         */
        get: operations["get_report_viewers_api_v1_ws_report__report_id__viewers_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/supported-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Supported Types
         * @description Get list of document types that support semantic extraction.
         */
        get: operations["get_supported_types_api_v1_semantic_extraction_supported_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Document
         * @description Manually trigger semantic extraction on raw text.
         *
         *     This is useful for:
         *     - Testing extraction on specific documents
         *     - Re-extracting documents that failed during upload
         *     - Extracting from external text sources
         */
        post: operations["extract_document_api_v1_semantic_extraction_extract_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/results/{document_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Result
         * @description Get stored semantic extraction result by document ID.
         */
        get: operations["get_extraction_result_api_v1_semantic_extraction_results__document_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Extraction Result
         * @description Delete a semantic extraction result.
         */
        delete: operations["delete_extraction_result_api_v1_semantic_extraction_results__document_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/results/by-report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extractions By Report
         * @description Get all semantic extraction results for a report.
         */
        get: operations["get_extractions_by_report_api_v1_semantic_extraction_results_by_report__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/results/by-case/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extractions By Case
         * @description Get all semantic extraction results for a case.
         */
        get: operations["get_extractions_by_case_api_v1_semantic_extraction_results_by_case__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/semantic-extraction/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extraction Stats
         * @description Get overall semantic extraction statistics.
         */
        get: operations["get_extraction_stats_api_v1_semantic_extraction_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/cases/{case_id}/timeline": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Timeline
         * @description 📋 GET TIMELINE - Retrieve current timeline and predictions
         *
         *     Returns:
         *     - Current phase and milestones
         *     - Upcoming deadlines
         *     - Overdue items
         *     - Risk assessment
         *     - Predictions
         */
        get: operations["get_timeline_api_v1_bi_timeline_cases__case_id__timeline_get"];
        put?: never;
        /**
         * Create Timeline
         * @description 📊 CREATE TIMELINE - Initialize litigation timeline for a BI claim
         *
         *     Creates a new timeline with:
         *     - State-specific deadline calculations
         *     - Carrier behavior profile loading
         *     - Initial predictions and risk assessment
         *     - Milestone templates
         */
        post: operations["create_timeline_api_v1_bi_timeline_cases__case_id__timeline_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/cases/{case_id}/timeline/milestones": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record Milestone
         * @description ✓ RECORD MILESTONE - Mark a milestone as completed
         *
         *     Updates timeline phase and regenerates predictions.
         *     Checks for bad faith indicators.
         */
        post: operations["record_milestone_api_v1_bi_timeline_cases__case_id__timeline_milestones_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/cases/{case_id}/timeline/predict": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Predictions
         * @description 🔮 GET PREDICTIONS - Detailed outcome predictions
         *
         *     Returns:
         *     - Predicted outcome and probabilities
         *     - Resolution timeline
         *     - Recovery range estimates
         *     - Bad faith assessment
         *     - Risk factors
         */
        get: operations["get_predictions_api_v1_bi_timeline_cases__case_id__timeline_predict_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/cases/{case_id}/timeline/deadlines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Deadlines
         * @description ⏰ GET DEADLINES - Upcoming and overdue deadlines
         *
         *     Returns categorized deadlines:
         *     - Upcoming (within N days)
         *     - Overdue (past deadline)
         *     - Critical (high impact)
         */
        get: operations["get_deadlines_api_v1_bi_timeline_cases__case_id__timeline_deadlines_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/state-rules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List State Rules
         * @description 📍 LIST STATES - Get all configured states
         */
        get: operations["list_state_rules_api_v1_bi_timeline_state_rules_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/state-rules/{state_code}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get State Rule Details
         * @description 📜 GET STATE RULES - Detailed rules for a specific state
         *
         *     Returns:
         *     - Proof of Loss deadlines
         *     - Carrier response requirements
         *     - Bad faith requirements
         *     - Penalties and remedies
         *     - Appraisal rules
         *     - Special state-specific rules
         */
        get: operations["get_state_rule_details_api_v1_bi_timeline_state_rules__state_code__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers/{carrier_name}/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Carrier Profile
         * @description 🏢 GET CARRIER PROFILE - Historical behavior profile
         *
         *     Returns:
         *     - Response patterns (acknowledgment, payment, denial times)
         *     - Outcome patterns (denial, underpayment, litigation rates)
         *     - Settlement patterns
         *     - Bad faith indicators
         */
        get: operations["get_carrier_profile_api_v1_bi_timeline_carriers__carrier_name__profile_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Carriers
         * @description 📋 LIST CARRIERS - Get all carrier profiles
         */
        get: operations["list_carriers_api_v1_bi_timeline_carriers_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/milestone-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Milestone Types
         * @description 📌 LIST MILESTONE TYPES - All available milestone types
         */
        get: operations["list_milestone_types_api_v1_bi_timeline_milestone_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/claim-phases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Claim Phases
         * @description 📈 LIST CLAIM PHASES - All claim phases
         */
        get: operations["list_claim_phases_api_v1_bi_timeline_claim_phases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/notifications/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check Deadline Notifications
         * @description 🔔 CHECK DEADLINES - Find all upcoming and overdue deadlines
         *
         *     Scans all active timelines for deadlines within notification thresholds
         *     (30, 14, 7, 3, 1 days) and overdue items.
         */
        get: operations["check_deadline_notifications_api_v1_bi_timeline_notifications_check_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/notifications/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Deadline Notifications
         * @description 📧 SEND NOTIFICATIONS - Send email alerts for deadlines
         *
         *     Checks all deadlines and sends email notifications to attorneys.
         */
        post: operations["send_deadline_notifications_api_v1_bi_timeline_notifications_send_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/cases/{case_id}/notifications/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Notification History
         * @description 📋 NOTIFICATION HISTORY - Get past notifications for a case
         */
        get: operations["get_notification_history_api_v1_bi_timeline_cases__case_id__notifications_history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers/learn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record Case For Learning
         * @description 📚 RECORD CASE RESOLUTION - Feed outcome data for carrier profile learning
         *
         *     Records a case resolution to improve carrier behavior predictions.
         *     After enough cases are recorded (5+), the carrier profile will be updated.
         */
        post: operations["record_case_for_learning_api_v1_bi_timeline_carriers_learn_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers/{carrier_name}/learned-profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Learned Carrier Profile
         * @description 📊 GET LEARNED PROFILE - Retrieve learned behavior profile for a carrier
         */
        get: operations["get_learned_carrier_profile_api_v1_bi_timeline_carriers__carrier_name__learned_profile_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers/learned-profiles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Learned Profiles
         * @description 📋 LIST LEARNED PROFILES - All carrier profiles derived from case outcomes
         */
        get: operations["list_learned_profiles_api_v1_bi_timeline_carriers_learned_profiles_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/carriers/learning-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Learning Stats
         * @description 📈 LEARNING STATS - Statistics about the carrier learning system
         */
        get: operations["get_learning_stats_api_v1_bi_timeline_carriers_learning_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/digest/preferences/{attorney_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Digest Preferences
         * @description 📋 GET DIGEST PREFERENCES - Get attorney's weekly digest settings
         *
         *     Returns current preference settings including:
         *     - weekly_digest_enabled: Whether digest is enabled (opt-in, default: false)
         *     - sections: Which sections to include (deadlines, predictions, actions)
         *     - delivery_day: Day of week (default: monday)
         *     - delivery_hour: Hour in UTC (default: 8)
         */
        get: operations["get_digest_preferences_api_v1_bi_timeline_digest_preferences__attorney_id__get"];
        /**
         * Update Digest Preferences
         * @description ⚙️ UPDATE DIGEST PREFERENCES - Update attorney's weekly digest settings
         *
         *     Allows updating:
         *     - weekly_digest_enabled: Enable/disable the weekly digest
         *     - sections: Choose which sections to include
         *       - deadlines: Upcoming and overdue deadlines
         *       - predictions: Settlement probability, risk alerts
         *       - actions: Recommended priority actions
         */
        put: operations["update_digest_preferences_api_v1_bi_timeline_digest_preferences__attorney_id__put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/digest/preview/{attorney_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview Digest
         * @description 👁️ PREVIEW DIGEST - Generate a preview of the weekly digest
         *
         *     Generates the digest content without sending an email.
         *     Useful for testing and previewing what the digest will look like.
         */
        post: operations["preview_digest_api_v1_bi_timeline_digest_preview__attorney_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/digest/send/{attorney_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Digest To Attorney
         * @description 📧 SEND DIGEST - Send weekly digest to a specific attorney
         *
         *     Manually triggers a digest email for the specified attorney,
         *     regardless of their schedule preferences.
         */
        post: operations["send_digest_to_attorney_api_v1_bi_timeline_digest_send__attorney_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/digest/send-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send All Digests
         * @description 📧 SEND ALL DIGESTS - Send weekly digests to all opted-in attorneys
         *
         *     Manually triggers digest emails for all attorneys who have enabled
         *     the weekly digest. This is normally run by the scheduled job on Mondays.
         */
        post: operations["send_all_digests_api_v1_bi_timeline_digest_send_all_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/bi-timeline/digest/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Digest Stats
         * @description 📊 DIGEST STATS - Get statistics about digest usage
         *
         *     Returns:
         *     - Total opted-in attorneys
         *     - Last digest sent timestamp
         *     - Digest send history
         */
        get: operations["get_digest_stats_api_v1_bi_timeline_digest_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/analyze/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze Report
         * @description Trigger adjuster analysis for a report.
         *
         *     This runs the conservative insurance adjuster analysis on the specified report,
         *     analyzing documentation gaps, causation, and building a defensible position.
         *
         *     Args:
         *         report_id: The report ID to analyze
         *         request: Optional analysis configuration
         *
         *     Returns:
         *         Analysis result with job status
         */
        post: operations["analyze_report_api_v1_adjuster_analyze__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/analysis/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Analysis
         * @description Get completed adjuster analysis for a report.
         *
         *     Args:
         *         report_id: The report ID
         *
         *     Returns:
         *         Full AdjusterAnalysisResult or 404 if not found
         */
        get: operations["get_analysis_api_v1_adjuster_analysis__report_id__get"];
        put?: never;
        post?: never;
        /**
         * Delete Analysis
         * @description Delete adjuster analysis for a report.
         *
         *     Args:
         *         report_id: The report ID
         *
         *     Returns:
         *         Deletion confirmation
         */
        delete: operations["delete_analysis_api_v1_adjuster_analysis__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/analysis/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Analysis Summary
         * @description Get summary view of adjuster analysis (for dashboards).
         *
         *     Args:
         *         report_id: The report ID
         *
         *     Returns:
         *         AdjusterAnalyzeSummary with key metrics
         */
        get: operations["get_analysis_summary_api_v1_adjuster_analysis__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/compare/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Adjuster Attorney
         * @description Get side-by-side comparison of Adjuster vs Attorney positions.
         *
         *     This endpoint provides a detailed comparison showing:
         *     - Each claim item's adjuster vs attorney valuation
         *     - Variance percentages
         *     - Adjuster's rationale for each reduction
         *
         *     Args:
         *         report_id: The report ID
         *
         *     Returns:
         *         AdjusterComparisonResult with item-by-item comparison
         */
        post: operations["compare_adjuster_attorney_api_v1_adjuster_compare__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/analyze-with-issues/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Analyze With Issues
         * @description Run adjuster analysis AND log issues to Issue Tracker.
         *
         *     This is the Phase 2.5 adapter endpoint that:
         *     1. Runs the standard adjuster analysis
         *     2. Logs documentation gaps as MISSING_DOCUMENT issues
         *     3. Logs causation concerns as CAUSATION_CONCERN issues
         *     4. Skips items with existing or resolved issues
         *
         *     Use this endpoint instead of /analyze when you want automatic issue tracking.
         *
         *     Args:
         *         report_id: The report ID to analyze
         *         force_refresh: Force re-run even if analysis exists
         *
         *     Returns:
         *         Analysis result plus issue tracking summary
         */
        post: operations["analyze_with_issues_api_v1_adjuster_analyze_with_issues__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjuster/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Adjuster Health
         * @description Health check for adjuster analyzer service.
         */
        get: operations["adjuster_health_api_v1_adjuster_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check for Issue Tracker service
         */
        get: operations["health_check_api_v1_issues_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List All Pending Issues
         * @description Get all pending issues across all reports for the work queue
         */
        get: operations["list_all_pending_issues_api_v1_issues_pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/matches/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Pending Matches
         * @description Get all document matches pending human review
         */
        get: operations["list_pending_matches_api_v1_issues_matches_pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/matches/{match_id}/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm Match
         * @description Confirm or reject a document-to-issue match.
         *
         *     If confirmed: resolves the issue and triggers reprocessing
         *     If rejected: keeps issue in current state
         */
        post: operations["confirm_match_api_v1_issues_matches__match_id__confirm_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List All Issues
         * @description List all issues across all reports.
         *     This is the global list endpoint for the Issue Tracker Dashboard.
         */
        get: operations["list_all_issues_api_v1_issues_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Global Issue Stats
         * @description Get global statistics for all issues.
         *     Used by the Issue Tracker Dashboard.
         */
        get: operations["get_global_issue_stats_api_v1_issues_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/detail/{issue_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Issue
         * @description Get a single issue by ID
         */
        get: operations["get_issue_api_v1_issues_detail__issue_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/requests/{report_id}/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Preview Request
         * @description Preview what the client request would look like.
         *
         *     Shows compiled text from all approved issues without creating a request.
         */
        get: operations["preview_request_api_v1_issues_requests__report_id__preview_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/requests/{report_id}/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Request
         * @description Create and send a batched request to the client.
         *
         *     1. Compiles all approved issues into a single request
         *     2. Sends to client email
         *     3. Updates all issues to REQUESTED status
         */
        post: operations["send_request_api_v1_issues_requests__report_id__send_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/on-document-upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Handle Document Upload
         * @description Handle notification of a new document upload.
         *
         *     Matches the document to open issues and routes based on confidence.
         */
        post: operations["handle_document_upload_api_v1_issues_on_document_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Issue
         * @description Create a new issue.
         *
         *     Issues are typically created by AI agents, but can also be created manually.
         *     Priority is auto-assigned if not provided.
         */
        post: operations["create_issue_api_v1_issues_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Issues
         * @description List all issues for a report.
         *
         *     Optionally filter by status (DETECTED, PENDING_REVIEW, etc.)
         */
        get: operations["list_issues_api_v1_issues__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{report_id}/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Pending Issues
         * @description Get issues pending human review for a report
         */
        get: operations["list_pending_issues_api_v1_issues__report_id__pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{report_id}/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Issue Stats
         * @description Get issue statistics for a report
         */
        get: operations["get_issue_stats_api_v1_issues__report_id__stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{issue_id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve Issue
         * @description Approve an issue for client notification.
         *
         *     Transitions: PENDING_REVIEW → APPROVED
         */
        post: operations["approve_issue_api_v1_issues__issue_id__approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{issue_id}/dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dismiss Issue
         * @description Dismiss an issue as not needed.
         *
         *     Transitions: PENDING_REVIEW → DISMISSED
         */
        post: operations["dismiss_issue_api_v1_issues__issue_id__dismiss_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{issue_id}/wont-fix": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mark Wont Fix
         * @description Mark issue as won't fix - client cannot provide.
         *
         *     Transitions: PENDING_REVIEW/REQUESTED/STALE → WONT_FIX
         */
        post: operations["mark_wont_fix_api_v1_issues__issue_id__wont_fix_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/disagreements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Disagreement
         * @description Create a new agent disagreement record.
         *
         *     Called when multiple agents disagree on an assessment or value.
         */
        post: operations["create_disagreement_api_v1_issues_disagreements_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/disagreements/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Pending Disagreements
         * @description Get all pending (unresolved) disagreements across all reports
         */
        get: operations["get_all_pending_disagreements_api_v1_issues_disagreements_pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/{report_id}/disagreements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Disagreements For Report
         * @description Get all disagreements for a specific report
         */
        get: operations["get_disagreements_for_report_api_v1_issues__report_id__disagreements_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/disagreements/{disagreement_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Disagreement
         * @description Get a single disagreement by ID
         */
        get: operations["get_disagreement_api_v1_issues_disagreements__disagreement_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/disagreements/{disagreement_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve Disagreement
         * @description Resolve a disagreement, optionally creating an issue.
         *
         *     Args:
         *         resolution: The resolution decision (which agent's position was accepted)
         *         resolution_notes: Optional explanation
         *         create_issue: Whether to create an issue from this disagreement
         */
        post: operations["resolve_disagreement_api_v1_issues_disagreements__disagreement_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/admin/trigger-batch-requests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Batch Requests
         * @description [Admin] Manually trigger the batch request task.
         *     Useful for testing or running outside the schedule.
         */
        post: operations["trigger_batch_requests_api_v1_issues_admin_trigger_batch_requests_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/admin/trigger-stale-detection": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Stale Detection
         * @description [Admin] Manually trigger stale issue detection.
         */
        post: operations["trigger_stale_detection_api_v1_issues_admin_trigger_stale_detection_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/issues/admin/trigger-stale-reminders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Stale Reminders
         * @description [Admin] Manually trigger stale issue reminders.
         */
        post: operations["trigger_stale_reminders_api_v1_issues_admin_trigger_stale_reminders_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analysis/unified/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run Unified Analysis
         * @description Run complete unified analysis across all adapters.
         *
         *     This endpoint:
         *     1. Runs forensic analysis
         *     2. Runs attorney and adjuster in parallel
         *     3. Validates adjuster ≤ attorney invariant
         *     4. Runs settlement calculation with real bounds
         *     5. Detects disagreements between agents
         *
         *     Performance target: < 90 seconds
         */
        post: operations["run_unified_analysis_api_v1_analysis_unified__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analysis/unified/{report_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Unified Analysis Status
         * @description Get status/health check for unified analysis service.
         *
         *     Returns available adapters and service status.
         */
        get: operations["get_unified_analysis_status_api_v1_analysis_unified__report_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/analysis/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Unified Analysis Health
         * @description Health check for unified analysis service.
         */
        get: operations["unified_analysis_health_api_v1_analysis_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/case": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Query Case Data
         * @description Query data for a specific case (Tier 1).
         *
         *     SECURITY: All queries are automatically filtered by case_id.
         *     User can only see their own case data.
         *
         *     Collections available:
         *     - reports, issues, adjuster_analyses, attorney_analyses
         *     - forensic_analyses, fair_settlement_analyses
         *     - uploaded_files, issue_matches, resolution_requests
         */
        post: operations["query_case_data_api_v1_query_case_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/case/{case_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Summary
         * @description Get a complete summary of a case including all related data.
         *
         *     Returns aggregated data from all relevant collections.
         */
        get: operations["get_case_summary_api_v1_query_case__case_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/case/{case_id}/issues": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Issues
         * @description Get issues for a specific case with optional filters.
         */
        get: operations["get_case_issues_api_v1_query_case__case_id__issues_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/case/{case_id}/timeline": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Timeline
         * @description Get a chronological timeline of all events for a case.
         */
        get: operations["get_case_timeline_api_v1_query_case__case_id__timeline_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/case/collections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Queryable Collections
         * @description List collections that can be queried in Tier 1.
         */
        get: operations["list_queryable_collections_api_v1_query_case_collections_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/benchmarks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Available Benchmarks
         * @description List all available benchmark queries.
         *
         *     Returns pre-defined benchmark IDs with descriptions and parameters.
         */
        get: operations["list_available_benchmarks_api_v1_query_benchmarks_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/benchmark/{benchmark_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Benchmark Info
         * @description Get information about a specific benchmark.
         */
        get: operations["get_benchmark_info_api_v1_query_benchmark__benchmark_id__get"];
        put?: never;
        /**
         * Execute Benchmark
         * @description Execute a pre-defined benchmark query (Tier 2).
         *
         *     SECURITY:
         *     - Only pre-defined benchmark IDs accepted
         *     - Results are anonymized aggregates
         *     - No identifying information returned
         *     - Minimum sample sizes enforced
         *     - Counts are fuzzified
         *
         *     Available benchmarks:
         *     - settlement_stats: Settlement amount statistics
         *     - duration_stats: Claim duration statistics
         *     - doc_completeness: Documentation completeness rates
         *     - anomaly_frequency: Anomaly detection rates
         *     - loss_ratio_stats: Loss ratio statistics
         *     - issue_resolution_stats: Issue resolution rates
         */
        post: operations["execute_benchmark_api_v1_query_benchmark__benchmark_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/query/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Query Service Health
         * @description Health check for query services.
         */
        get: operations["query_service_health_api_v1_query_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-assistant/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Check AI assistant service health
         */
        get: operations["health_check_api_v1_ai_assistant_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-assistant/match-documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Match Documents
         * @description Suggest documents that might resolve an issue.
         *
         *     Uses AI to analyze the issue and available documents,
         *     returning matches ranked by confidence.
         */
        post: operations["match_documents_api_v1_ai_assistant_match_documents_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-assistant/draft-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Draft Email
         * @description Generate a professional email requesting missing documents.
         *
         *     Uses AI to create an empathetic, clear email that lists
         *     what's needed and why it matters for the claim.
         */
        post: operations["draft_email_api_v1_ai_assistant_draft_email_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-assistant/priority-scores": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Priority Scores
         * @description Calculate priority scores for issues based on blocking impact.
         *
         *     Issues blocking more calculations or affecting larger amounts
         *     get higher scores. Useful for triaging what to resolve first.
         */
        post: operations["calculate_priority_scores_api_v1_ai_assistant_priority_scores_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-assistant/batch-match/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Match Documents
         * @description Match documents for all pending issues in a report.
         *
         *     Runs document matching for each issue and returns
         *     aggregated results.
         */
        post: operations["batch_match_documents_api_v1_ai_assistant_batch_match__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Summary
         * @description Get orchestration summary for a case.
         *
         *     Returns current state, allowed transitions, open issues, and recent history.
         */
        get: operations["get_case_summary_api_v1_orchestrator_cases__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/state": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case State
         * @description Get current case state.
         */
        get: operations["get_case_state_api_v1_orchestrator_cases__report_id__state_get"];
        put?: never;
        /**
         * Update Case State
         * @description Manually update case state.
         *
         *     Only valid transitions are allowed.
         */
        post: operations["update_case_state_api_v1_orchestrator_cases__report_id__state_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/events/document-uploaded": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Document Uploaded
         * @description Trigger document uploaded event.
         *
         *     Call this AFTER a document has been successfully processed by the upload pipeline.
         *     This does NOT upload a document - it notifies the orchestrator that an upload completed.
         */
        post: operations["trigger_document_uploaded_api_v1_orchestrator_cases__report_id__events_document_uploaded_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/events/analysis-completed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Analysis Completed
         * @description Trigger analysis completed event.
         *
         *     Call this AFTER an AI analysis has completed.
         */
        post: operations["trigger_analysis_completed_api_v1_orchestrator_cases__report_id__events_analysis_completed_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/events/issue-created": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Issue Created
         * @description Trigger issue created event.
         *
         *     Call this AFTER an issue has been created in the Issue Tracker.
         */
        post: operations["trigger_issue_created_api_v1_orchestrator_cases__report_id__events_issue_created_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/events/issue-resolved": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Issue Resolved
         * @description Trigger issue resolved event.
         *
         *     Call this AFTER an issue has been resolved.
         */
        post: operations["trigger_issue_resolved_api_v1_orchestrator_cases__report_id__events_issue_resolved_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Config
         * @description Get current orchestrator configuration.
         */
        get: operations["get_config_api_v1_orchestrator_config_get"];
        /**
         * Update Config
         * @description Update orchestrator configuration.
         */
        put: operations["update_config_api_v1_orchestrator_config_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/states": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get States
         * @description Get all valid orchestrator states.
         */
        get: operations["get_states_api_v1_orchestrator_states_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/readiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Assess Readiness
         * @description Assess case readiness for AI agent processing.
         *
         *     Returns:
         *     - Document status (processed, pending, failed)
         *     - Classification completeness
         *     - Agent readiness (can run, has run, needs rerun)
         *     - Blocking issues
         *     - Recommended next actions
         */
        get: operations["assess_readiness_api_v1_orchestrator_cases__report_id__readiness_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/readiness/full": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Assess Readiness Full
         * @description Get full readiness assessment with all details.
         *
         *     Includes file-level details, all recommendations, and complete agent status.
         */
        get: operations["assess_readiness_full_api_v1_orchestrator_cases__report_id__readiness_full_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/readiness/configure": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Configure Readiness
         * @description Configure readiness thresholds for a specific assessment.
         *
         *     Args:
         *         classification_threshold: Required % of transactions classified (0.0-1.0)
         *         min_transactions: Minimum transaction count for analysis
         */
        post: operations["configure_readiness_api_v1_orchestrator_cases__report_id__readiness_configure_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/dispatch-queue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Dispatch Queue
         * @description List dispatch queue items.
         *
         *     Query Parameters:
         *         report_id: Filter by specific case
         *         status: Filter by status (PENDING_APPROVAL, APPROVED, DISPATCHED, etc.)
         *         include_completed: Include completed/failed items
         *         limit: Max items to return
         *
         *     Returns:
         *         List of dispatch records with summary stats
         */
        get: operations["list_dispatch_queue_api_v1_orchestrator_dispatch_queue_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/dispatch-queue/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Dispatch Summary
         * @description Get dispatch queue summary for dashboard.
         *
         *     Returns counts by status and list of pending actions.
         */
        get: operations["get_dispatch_summary_api_v1_orchestrator_dispatch_queue_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/dispatch-queue/{dispatch_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Dispatch
         * @description Get a specific dispatch record.
         */
        get: operations["get_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/dispatch-queue/{dispatch_id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve Dispatch
         * @description Approve a pending dispatch and trigger execution.
         *
         *     This moves the dispatch from PENDING_APPROVAL to APPROVED,
         *     then queues a Celery task for execution.
         *
         *     Only works for SEMI_AUTO mode dispatches that are PENDING_APPROVAL.
         */
        post: operations["approve_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/dispatch-queue/{dispatch_id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel Dispatch
         * @description Cancel a pending or approved dispatch.
         *
         *     Cannot cancel dispatches that are already running (DISPATCHED) or completed.
         */
        post: operations["cancel_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__cancel_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases/{report_id}/dispatch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Manual Dispatch
         * @description Manually create a dispatch for a case.
         *
         *     This bypasses readiness checks and creates a dispatch immediately.
         *     Use for re-running analysis or forcing a specific action.
         *
         *     Args:
         *         action: One of: run_unified_analysis, run_forensic, run_attorney,
         *                 run_adjuster, run_settlement, reprocess_affected
         *         priority: CRITICAL, HIGH, MEDIUM, LOW
         */
        post: operations["manual_dispatch_api_v1_orchestrator_cases__report_id__dispatch_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/pipeline": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pipeline Stats
         * @description Get case counts by pipeline state for dashboard funnel.
         *
         *     Returns counts for each state and "stuck" indicators.
         */
        get: operations["get_pipeline_stats_api_v1_orchestrator_pipeline_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/cases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Cases List
         * @description Get filtered list of cases with state and blocker info.
         *
         *     Query Parameters:
         *         state: Filter by dashboard state (INTAKE, GATHERING, etc.)
         *         include_complete: Include COMPLETE cases (default: False)
         *         limit: Max cases to return
         *         offset: Pagination offset
         */
        get: operations["get_cases_list_api_v1_orchestrator_cases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/orchestrator/admin/trigger-analysis/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Admin Trigger Analysis
         * @description Admin endpoint to trigger the analysis pipeline for a stuck case.
         *
         *     This bypasses the normal event-driven flow and directly runs
         *     forensic + attorney analysis, storing results in the DB.
         *     Use for cases that were stuck before the automation fix.
         */
        post: operations["admin_trigger_analysis_api_v1_orchestrator_admin_trigger_analysis__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/intelligence/chat": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Chat
         * @description Chat with the Case Intelligence Agent.
         *
         *     The agent can:
         *     - Answer questions about the case
         *     - Run calculations and simulations
         *     - Provide multiple perspectives (attorney, adjuster, forensic)
         *     - Search case documents
         *     - Cite sources for every claim
         *
         *     Args:
         *         report_id: The case to query (sandboxed)
         *         message: Your question or request
         *         conversation_id: Optional - provide to continue a conversation
         *         voice_mode: Optional - set True for shorter, voice-optimized responses
         *
         *     Returns:
         *         - response: The agent's answer
         *         - tool_calls: List of tools the agent used
         *         - citations: Sources for claims made
         *         - suggested_followups: Suggested next questions
         *         - conversation_id: Use this to continue the conversation
         */
        post: operations["chat_api_v1_intelligence_chat_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/intelligence/conversations/{conversation_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Conversation
         * @description Get conversation history by ID.
         *
         *     Use this to restore a previous conversation or review what was discussed.
         */
        get: operations["get_conversation_api_v1_intelligence_conversations__conversation_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/intelligence/tools": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Tools
         * @description List all tools available to the Intelligence Agent.
         *
         *     This is useful for understanding what the agent can do
         *     and for building tool-aware UIs.
         */
        get: operations["list_tools_api_v1_intelligence_tools_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/intelligence/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check for the Intelligence Agent service.
         */
        get: operations["health_check_api_v1_intelligence_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Evidence Checklist
         * @description 📋 GET EVIDENCE CHECKLIST
         *
         *     Returns unified evidence requirements from all sources:
         *     - Issue Tracker: Documentation gaps
         *     - Adjuster AI: Documentation needs and causation concerns
         *     - Attorney AI: Vulnerabilities requiring evidence
         *     - Readiness Evaluator: Blocking items requiring documents
         *
         *     Features:
         *     - Deduplicates across sources
         *     - Prioritizes by financial impact
         *     - Groups by priority level
         *     - Tracks status (obtained/pending/requested)
         *
         *     Query Parameters:
         *     - include_resolved: Also return items that have been obtained
         *     - format: json (default), pdf, or docx
         */
        get: operations["get_evidence_checklist_api_v1_evidence_checklist__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Checklist Pdf
         * @description 📄 DOWNLOAD EVIDENCE CHECKLIST AS PDF
         *
         *     Generates a professional PDF checklist that attorneys can:
         *     - Print for client meetings
         *     - Send to clients via email
         *     - Include in case files
         *
         *     PDF includes:
         *     - Summary statistics
         *     - Items grouped by priority (Critical → Low)
         *     - Checkboxes for tracking
         *     - Financial impact for each item
         *     - Source attribution
         */
        get: operations["get_checklist_pdf_api_v1_evidence_checklist__report_id__pdf_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/docx": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Checklist Docx
         * @description 📝 DOWNLOAD EVIDENCE CHECKLIST AS DOCX
         *
         *     Generates an editable Word document that attorneys can:
         *     - Customize for specific clients
         *     - Add firm branding
         *     - Edit instructions
         *     - Share with staff for follow-up
         *
         *     DOCX includes:
         *     - Summary statistics
         *     - Items grouped by priority
         *     - Editable checkboxes
         *     - All item details
         */
        get: operations["get_checklist_docx_api_v1_evidence_checklist__report_id__docx_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Checklist Summary
         * @description 📊 GET CHECKLIST SUMMARY STATS
         *
         *     Quick statistics without full item list:
         *     - Total items by status (pending/requested/obtained)
         *     - Count by priority (critical/high/medium/low)
         *     - Total financial impact at risk
         *     - Progress percentage
         *     - Breakdown by source
         *
         *     Use this for dashboards and quick status checks.
         */
        get: operations["get_checklist_summary_api_v1_evidence_checklist__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/item/{item_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve Evidence Item
         * @description ✅ RESOLVE EVIDENCE ITEM
         *
         *     Mark an evidence item as obtained/resolved.
         *
         *     This updates the source system:
         *     - Issue Tracker items: Updates issue status to RESOLVED
         *     - Other items: Records resolution in evidence_resolutions collection
         *
         *     Parameters:
         *     - report_id: The report ID
         *     - item_id: The evidence item ID (e.g., "issue-abc123", "readiness-doc-tax")
         *     - document_id: Optional ID of the document that resolves this need
         *     - notes: Optional resolution notes
         */
        post: operations["resolve_evidence_item_api_v1_evidence_checklist__report_id__item__item_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/critical": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Critical Items
         * @description ⚠️ GET CRITICAL ITEMS ONLY
         *
         *     Returns only CRITICAL priority evidence items.
         *     These block calculation or destroy credibility if not addressed.
         */
        get: operations["get_critical_items_api_v1_evidence_checklist__report_id__critical_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/checklist/{report_id}/by-source": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Items By Source
         * @description 📂 GET ITEMS GROUPED BY SOURCE
         *
         *     Returns evidence items grouped by their source system:
         *     - issue_tracker: From Issue Tracker
         *     - adjuster_analyzer: From Adjuster AI
         *     - case_builder: From Attorney AI
         *     - readiness: From Readiness Evaluator
         *
         *     Useful for understanding which systems are identifying gaps.
         */
        get: operations["get_items_by_source_api_v1_evidence_checklist__report_id__by_source_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/portal/{report_id}/upload-slots": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Portal Upload Slots
         * @description 📤 GET UPLOAD SLOTS FOR CLIENT PORTAL
         *
         *     Returns evidence items formatted as upload slots for the client portal.
         *     Items are sorted by priority (Critical first) and include:
         *     - Upload slot ID (evidence_item_id)
         *     - Document name and description
         *     - Priority badge color
         *     - Expected document type for validation
         *     - Upload status (pending/uploaded)
         *
         *     Used by UnifiedClientPortal to render dynamic upload slots.
         */
        get: operations["get_portal_upload_slots_api_v1_evidence_portal__report_id__upload_slots_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/portal/{report_id}/validate-upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate Upload Type
         * @description ✅ VALIDATE UPLOAD TYPE
         *
         *     Checks if the detected document type matches the expected type for an evidence slot.
         *     Returns a soft warning if mismatch (allow upload anyway).
         *
         *     Used by frontend to show validation warning before confirming upload.
         */
        post: operations["validate_upload_type_api_v1_evidence_portal__report_id__validate_upload_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/{report_id}/send-request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send Evidence Request To Client
         * @description 📧 SEND EVIDENCE REQUEST TO CLIENT
         *
         *     Sends an email to the client with a list of required evidence documents
         *     and a link to the upload portal. Creates a portal access token if needed.
         *
         *     Flow:
         *     1. Fetch the evidence checklist for the report
         *     2. Get client info from the report
         *     3. Generate/retrieve portal access token
         *     4. Send branded email via Resend with portal link
         *
         *     Returns:
         *     - success: Boolean
         *     - email_id: Resend email ID if sent
         *     - portal_url: The URL sent to the client
         *     - items_count: Number of evidence items included
         */
        post: operations["send_evidence_request_to_client_api_v1_evidence__report_id__send_request_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/evidence/{report_id}/email-analytics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Evidence Email Analytics
         * @description 📊 GET EMAIL ENGAGEMENT ANALYTICS
         *
         *     Retrieve tracking analytics for evidence request emails sent for this report.
         *     Includes:
         *     - Number of emails sent
         *     - Open rates (via tracking pixel)
         *     - Click rates (via tracked links)
         *     - Conversion tracking (portal uploads)
         *
         *     Returns aggregated and per-email metrics.
         */
        get: operations["get_evidence_email_analytics_api_v1_evidence__report_id__email_analytics_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/documents/extract-text": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Text From File
         * @description 📄 EXTRACT TEXT FROM UPLOADED FILE
         *
         *     Extracts text content from PDF, DOCX, or TXT files.
         *     Used by Policy DNA and other features that need document text.
         *
         *     Supported formats:
         *     - PDF (.pdf) - Uses PyMuPDF for extraction
         *     - DOCX (.docx) - Uses python-docx
         *     - TXT (.txt) - Direct read
         *
         *     Returns:
         *     - text: Extracted text content
         *     - source_filename: Original filename
         *     - file_type: Detected file type
         *     - char_count: Number of characters extracted
         *     - page_count: Number of pages (PDF only)
         */
        post: operations["extract_text_from_file_api_v1_documents_extract_text_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Action Items
         * @description Get all action items for a report.
         *
         *     Supports filtering by status, action_type, and blocking status.
         */
        get: operations["get_action_items_api_v1_action_items__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{report_id}/blocking": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Blocking Items
         * @description Get blocking items preventing case readiness.
         */
        get: operations["get_blocking_items_api_v1_action_items__report_id__blocking_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Action Item Summary
         * @description Get summary of action items for a report.
         */
        get: operations["get_action_item_summary_api_v1_action_items__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{item_id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve Action Item
         * @description Manually resolve an action item.
         */
        post: operations["resolve_action_item_api_v1_action_items__item_id__resolve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{item_id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel Action Item
         * @description Cancel an action item.
         */
        post: operations["cancel_action_item_api_v1_action_items__item_id__cancel_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/{item_id}/escalate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Escalate Action Item
         * @description Escalate an action item for human review.
         */
        post: operations["escalate_action_item_api_v1_action_items__item_id__escalate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/action-items/pending/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Pending Items
         * @description Get all pending action items across all reports.
         *     For admin/case worker dashboard.
         */
        get: operations["get_all_pending_items_api_v1_action_items_pending_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Requests For Report
         * @description Get all document requests for a report.
         *
         *     Args:
         *         report_id: The report/case ID
         *         status: Optional status filter (pending, sent, fulfilled, etc.)
         *
         *     Returns:
         *         List of document requests
         */
        get: operations["get_requests_for_report_api_v1_client_requests__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{report_id}/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Requests
         * @description Get pending (unfulfilled) document requests for a report.
         *
         *     Returns only requests that are pending, sent, or partially fulfilled.
         */
        get: operations["get_pending_requests_api_v1_client_requests__report_id__pending_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Request Summary
         * @description Get summary statistics for document requests.
         *
         *     Includes counts of requests, items, fulfillment status, and alerts.
         */
        get: operations["get_request_summary_api_v1_client_requests__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{request_id}/mark-fulfilled": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mark Request Fulfilled
         * @description Manually mark a document request as fulfilled.
         *
         *     Use when documents are received through alternative channels
         *     (e.g., physical mail, different portal, etc.)
         */
        post: operations["mark_request_fulfilled_api_v1_client_requests__request_id__mark_fulfilled_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{request_id}/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend Request Email
         * @description Resend the document request email.
         *
         *     Useful if the client didn't receive the original email
         *     or needs a fresh link.
         */
        post: operations["resend_request_email_api_v1_client_requests__request_id__resend_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/{request_id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel Request
         * @description Cancel a document request.
         *
         *     Stops all reminders and marks the request as cancelled.
         */
        post: operations["cancel_request_api_v1_client_requests__request_id__cancel_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/admin/due-reminders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Due Reminders
         * @description Admin: Get all requests with due reminders.
         *
         *     Returns requests that have reminders scheduled for today or earlier.
         */
        get: operations["get_due_reminders_api_v1_client_requests_admin_due_reminders_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/admin/process-reminders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Reminder Processing
         * @description Admin: Manually trigger reminder processing.
         *
         *     Processes all due reminders immediately instead of waiting
         *     for the scheduled job.
         */
        post: operations["trigger_reminder_processing_api_v1_client_requests_admin_process_reminders_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/admin/expired": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Expired Requests
         * @description Admin: Get all expired requests.
         *
         *     Returns requests that have passed their expiration date
         *     but haven't been fulfilled or cancelled.
         */
        get: operations["get_expired_requests_api_v1_client_requests_admin_expired_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/admin/process-expired": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Expired Processing
         * @description Admin: Process expired requests.
         *
         *     Escalates all expired requests to case workers.
         */
        post: operations["trigger_expired_processing_api_v1_client_requests_admin_process_expired_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/client-requests/portal/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Upload Portal Info
         * @description Public endpoint for magic link upload portal.
         *
         *     Returns information needed to display the upload portal
         *     for the client. No authentication required - token is auth.
         */
        get: operations["get_upload_portal_info_api_v1_client_requests_portal__token__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/evaluation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Latest Case Evaluation
         * @description Get the most recent Attorney AI evaluation for a case.
         */
        get: operations["get_case_evaluation_api_v1_attorney_ai__report_id__evaluation_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/evaluation/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Evaluation History
         * @description Get the evaluation history for a case.
         */
        get: operations["get_evaluation_history_api_v1_attorney_ai__report_id__evaluation_history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/evaluate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger Case Evaluation
         * @description Manually trigger an Attorney AI evaluation for a case.
         */
        post: operations["trigger_evaluation_api_v1_attorney_ai__report_id__evaluate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/strength-breakdown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Strength Breakdown
         * @description Get detailed breakdown of case strength calculation.
         */
        get: operations["get_strength_breakdown_api_v1_attorney_ai__report_id__strength_breakdown_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/readiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness Status
         * @description Get the ready/not-ready decision for a case.
         */
        get: operations["get_readiness_status_api_v1_attorney_ai__report_id__readiness_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/{report_id}/improvement-potential": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Improvement Potential
         * @description Calculate potential score improvement if issues are resolved.
         */
        get: operations["get_improvement_potential_api_v1_attorney_ai__report_id__improvement_potential_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney AI Configuration
         * @description Get current orchestration configuration thresholds.
         */
        get: operations["get_attorney_ai_config_api_v1_attorney_ai_config_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney-ai/dashboard-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Automation Dashboard Stats
         * @description Get aggregated stats for the automation system dashboard.
         */
        get: operations["get_dashboard_stats_api_v1_attorney_ai_dashboard_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Roadmap Summary
         * @description Get the current roadmap summary for a report.
         *
         *     Returns a summary view with progress and top actions.
         */
        get: operations["get_roadmap_summary_api_v1_roadmap__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/full": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Roadmap Full
         * @description Get the full roadmap with all details (STAFF ONLY).
         *
         *     Includes:
         *     - All financial impact data (dollar values)
         *     - Calculation methods and IDs
         *     - Full state analysis
         *
         *     WARNING: This data should NOT be shown to clients.
         */
        get: operations["get_roadmap_full_api_v1_roadmap__report_id__full_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/client-view": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Roadmap Client View
         * @description Get the client-safe roadmap view.
         *
         *     IMPORTANT: This view has NO dollar values or potential legal advice.
         *     Safe to share with clients.
         *
         *     Removed data:
         *     - value_unlock, risk_mitigated
         *     - impact_description (may reference $)
         *     - calculation details
         *     - state financial estimates
         */
        get: operations["get_roadmap_client_view_api_v1_roadmap__report_id__client_view_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Roadmap
         * @description Generate or refresh the case strengthening roadmap.
         *
         *     This aggregates findings from all AI agents (Attorney, Adjuster, Forensic, Anomaly)
         *     and generates a prioritized action plan.
         *
         *     Args:
         *         report_id: The case/report ID
         *         force_refresh: Query param - If True, regenerate even if a current roadmap exists
         *
         *     Returns:
         *         The generated roadmap summary
         */
        post: operations["generate_roadmap_api_v1_roadmap__report_id__generate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/action/{action_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update Action Status
         * @description Update the status of a specific roadmap action.
         *
         *     Valid statuses:
         *     - pending: Not started
         *     - in_progress: Work started
         *     - completed: Action finished
         *     - blocked: Cannot proceed
         *     - skipped: Decided not to do this action
         */
        patch: operations["update_action_status_api_v1_roadmap__report_id__action__action_id__patch"];
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Roadmap History
         * @description Get the version history of roadmaps for a report.
         *
         *     Each time a roadmap is regenerated, a new version is created.
         *     This endpoint returns all versions with their progress.
         */
        get: operations["get_roadmap_history_api_v1_roadmap__report_id__history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/action/{action_id}/match-document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Match Document To Action
         * @description Manually match a document to a roadmap action and mark it complete.
         *
         *     This is used when automatic matching fails or for manual document processing.
         */
        post: operations["match_document_to_action_api_v1_roadmap__report_id__action__action_id__match_document_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/pending-actions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pending Actions
         * @description Get all pending actions that need attention.
         *
         *     Returns actions that are not yet completed or skipped.
         */
        get: operations["get_pending_actions_api_v1_roadmap__report_id__pending_actions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/action/{action_id}/generate-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Client Email
         * @description Generate a client-safe email for a specific roadmap action.
         *
         *     Uses the existing email_service.py with ClaimSync HTML branding.
         *
         *     IMPORTANT: This email contains NO dollar values or legal advice.
         *     It is safe to send directly to clients.
         */
        post: operations["generate_client_email_api_v1_roadmap__report_id__action__action_id__generate_email_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/action/{action_id}/generate-email/staff": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Staff Email View
         * @description Generate full email view for staff including financial data.
         *
         *     This response includes:
         *     - The client-safe email (using existing email_service.py)
         *     - Financial impact data (value_unlock, risk_mitigated)
         *
         *     STAFF ONLY - Do not share financial data with clients.
         */
        post: operations["generate_staff_email_view_api_v1_roadmap__report_id__action__action_id__generate_email_staff_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/strength-breakdown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Strength Breakdown
         * @description Get detailed case strength breakdown from Monte Carlo and real calculations.
         *
         *     Returns:
         *     - Data quality score (from forensic analysis)
         *     - Evidence completeness score (documents present vs needed)
         *     - Confidence interval score (from Monte Carlo)
         *     - Vulnerability penalty (from attorney analysis)
         *     - Total strength score
         */
        get: operations["get_strength_breakdown_api_v1_roadmap__report_id__strength_breakdown_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/dependency-graph": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Dependency Graph
         * @description Get the dependency graph for roadmap actions.
         *
         *     Returns actions organized by dependency level:
         *     - Level 0: Can start immediately
         *     - Level 1: Blocked by level 0 actions
         *     - Level N: Blocked by at least one level N-1 action
         */
        get: operations["get_dependency_graph_api_v1_roadmap__report_id__dependency_graph_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/roadmap/{report_id}/next-actions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Next Actions
         * @description Get the next actions that can be started (no blocking dependencies).
         */
        get: operations["get_next_actions_api_v1_roadmap__report_id__next_actions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness Config
         * @description Get current readiness criteria configuration.
         */
        get: operations["get_readiness_config_api_v1_readiness_config_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness Status
         * @description Get current readiness status for a case.
         *
         *     Returns a summary of the most recent readiness evaluation.
         */
        get: operations["get_readiness_status_api_v1_readiness__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/full": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness Full
         * @description Get full readiness evaluation with all details.
         *
         *     Includes:
         *     - All criteria results
         *     - All risk flags with details
         *     - Decision metadata
         */
        get: operations["get_readiness_full_api_v1_readiness__report_id__full_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/evaluate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Evaluate Readiness
         * @description Evaluate readiness for a case.
         *
         *     This runs a fresh evaluation of all criteria and risk flags.
         *     Does NOT execute the decision (use /execute for that).
         */
        post: operations["evaluate_readiness_api_v1_readiness__report_id__evaluate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/execute": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Execute Readiness
         * @description Execute a readiness decision.
         *
         *     This will:
         *     1. Evaluate readiness
         *     2. Create audit log
         *     3. Update case status
         *     4. Send notifications (if applicable)
         *     5. Trigger package generation (if ready)
         */
        post: operations["execute_readiness_api_v1_readiness__report_id__execute_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/reverse": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reverse Readiness
         * @description Reverse a readiness decision within the reversal window.
         *
         *     The reversal window is typically 72 hours from the decision.
         */
        post: operations["reverse_readiness_api_v1_readiness__report_id__reverse_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness History
         * @description Get readiness decision history for a case.
         */
        get: operations["get_readiness_history_api_v1_readiness__report_id__history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/risk-flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Risk Flags
         * @description Get risk flags for a case.
         *
         *     Optionally filter by severity level.
         */
        get: operations["get_risk_flags_api_v1_readiness__report_id__risk_flags_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/readiness/{report_id}/criteria": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Criteria Breakdown
         * @description Get detailed criteria breakdown for a case.
         *
         *     Shows each criterion with actual vs required values.
         */
        get: operations["get_criteria_breakdown_api_v1_readiness__report_id__criteria_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Check
         * @description Health check endpoint.
         */
        get: operations["health_check_api_v1_packages_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Package
         * @description Get the latest package for a report.
         *
         *     Returns the most recent complete package if available.
         */
        get: operations["get_package_api_v1_packages__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Package Summary
         * @description Get package summary for a report.
         *
         *     Lighter weight than full package details.
         */
        get: operations["get_package_summary_api_v1_packages__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Package Status
         * @description Get package generation status.
         *
         *     Useful for polling during async generation.
         */
        get: operations["get_package_status_api_v1_packages__report_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate Package
         * @description Generate attorney package for a report.
         *
         *     This may take several seconds. Poll /status for progress.
         */
        post: operations["generate_package_api_v1_packages__report_id__generate_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/deliver": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Deliver Package
         * @description Deliver package to attorney.
         *
         *     Sends email with secure access link.
         */
        post: operations["deliver_package_api_v1_packages__report_id__deliver_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/token/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Verify Access Token
         * @description Verify package access token.
         *
         *     Public endpoint - no auth required.
         *     Used by attorneys accessing their package.
         */
        get: operations["verify_access_token_api_v1_packages_token__token__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/access/{token}/package": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Package By Token
         * @description Get package details using access token.
         *
         *     Public endpoint - used by attorneys to view their package.
         */
        get: operations["get_package_by_token_api_v1_packages_access__token__package_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/access/{token}/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record Package Download
         * @description Record that the package was downloaded.
         *
         *     Public endpoint - used when attorney downloads PDF.
         */
        post: operations["record_package_download_api_v1_packages_access__token__download_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/history/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Package History
         * @description Get package generation history.
         *
         *     Admin view of all packages.
         */
        get: operations["get_package_history_api_v1_packages_history_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/deliveries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Delivery History
         * @description Get delivery history for a report's packages.
         */
        get: operations["get_delivery_history_api_v1_packages__report_id__deliveries_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{report_id}/defense-matrix": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Defense Matrix
         * @description Get defense matrix from the package.
         *
         *     Useful for reviewing vulnerability strategies separately.
         */
        get: operations["get_defense_matrix_api_v1_packages__report_id__defense_matrix_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Queue Stats
         * @description Get aggregate queue statistics.
         *
         *     Shows how many cases are in each queue, staleness metrics, and total value.
         *     Optionally filtered by user role to show relevant "needs attention" count.
         *
         *     Use fast=true (default) for quick aggregation using pre-stored queue assignments.
         *     Use fast=false to recalculate all assignments (slower but more accurate).
         */
        get: operations["get_queue_stats_api_v1_queue_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/data-specialist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Data Specialist Queue
         * @description Get queue for Data Specialists with pagination.
         *
         *     Returns cases that need transaction review/categorization.
         *     Stale cases (no activity in 5+ days) are highlighted first.
         */
        get: operations["get_data_specialist_queue_api_v1_queue_data_specialist_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Queue
         * @description Get queue for Accountants with pagination.
         *
         *     Returns cases ready for review/sign-off.
         *     Includes both ACCOUNTANT and READY queues.
         */
        get: operations["get_accountant_queue_api_v1_queue_accountant_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/attorney": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney Queue
         * @description Get queue for Attorneys with pagination.
         *
         *     Returns cases that have been released to attorney.
         */
        get: operations["get_attorney_queue_api_v1_queue_attorney_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get All Cases With Queues
         * @description Get all cases with their queue assignments.
         *
         *     Optionally filter by queue type (client, data_specialist, accountant,
         *     ai_processing, ready, attorney).
         *
         *     Scoped to the caller's org — no cross-tenant enumeration.
         */
        get: operations["get_all_cases_with_queues_api_v1_queue_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/case/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Queue Assignment
         * @description Get queue assignment for a specific case.
         *
         *     Returns detailed queue assignment including signoff checklist if applicable.
         */
        get: operations["get_case_queue_assignment_api_v1_queue_case__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Refresh Queue Assignments
         * @description Refresh queue assignments for specified cases.
         *
         *     Re-calculates queue assignment based on current case state.
         *     Useful after manual updates or to sync queue state.
         */
        post: operations["refresh_queue_assignments_api_v1_queue_refresh_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/stale": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Stale Cases
         * @description Get all stale cases across all queues.
         *
         *     Returns cases with no activity for the specified number of days, scoped
         *     to the caller's org.
         */
        get: operations["get_stale_cases_api_v1_queue_stale_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/pipeline-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pipeline Summary
         * @description Get a summary of cases by pipeline stage.
         *
         *     Returns counts for each stage: intake, collecting, processing, review,
         *     ready, delivered — scoped to the caller's org.
         */
        get: operations["get_pipeline_summary_api_v1_queue_pipeline_summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/batch-update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch Update All Queue Assignments
         * @description Batch update queue assignments for cases.
         *
         *     Call this endpoint after system updates or periodically to ensure
         *     all cases have pre-calculated queue assignments for fast listing.
         *
         *     Set force_refresh=true to recalculate all cases, not just those missing queue data.
         */
        post: operations["batch_update_all_queue_assignments_api_v1_queue_batch_update_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/ensure-indexes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Ensure Queue Indexes
         * @description Create database indexes for queue queries and overall performance.
         *
         *     Call this once after deployment to optimize query performance.
         *     Creates indexes across all major collections for fast queries.
         */
        post: operations["ensure_queue_indexes_api_v1_queue_ensure_indexes_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Stats
         * @description Get statistics for the accountant queue.
         *
         *     Scoped to the caller's org. The caller's identity is derived from the JWT
         *     — never from a query param — so an attacker cannot enumerate another
         *     accountant's portfolio.
         *
         *     Returns:
         *     - available_count: Number of unclaimed, ready cases in caller's org
         *     - my_claims_count: Number of cases claimed by this accountant
         *     - ready_count: Number of cases ready for attorney review in caller's org
         *     - total_portfolio_value: Sum of claim amounts for caller's claimed cases
         */
        get: operations["get_accountant_stats_api_v1_queue_accountant_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/nowline-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Nowline Stats
         * @description Get Now-Line dashboard statistics.
         *
         *     Scoped to the caller's org. No client-supplied user_id — the JWT is the
         *     source of truth.
         *
         *     Returns cases split into:
         *     - needs_attention: Cases that need THIS user to act
         *     - no_action_needed: Cases being handled by AI or waiting on others
         *
         *     The logic varies by role:
         *     - Data Specialist: attention if transactions need review or stale
         *     - Accountant: attention if ready for sign-off or has anomalies
         *     - Attorney: attention if released to them
         *
         *     SSoT: queries db.drafts only — drafts are the canonical case record per
         *     CLAUDE.md ("Claims = db.drafts"). Earlier versions iterated db.drafts
         *     AND db.reports, which double-counted cases that had both a draft and a
         *     report record (e.g. a case in progress with one or more historical
         *     report artifacts). Same anti-pattern PR #182 fixed for /queue/stats.
         */
        get: operations["get_nowline_stats_api_v1_queue_nowline_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/dashboard-overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Dashboard Overview
         * @description Returns portfolio-level overview data for the accountant dashboard sidebar.
         *     Includes pipeline breakdown, recent activity, and aggregate metrics.
         */
        get: operations["get_accountant_dashboard_overview_api_v1_queue_accountant_dashboard_overview_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Cases For Accountant
         * @description Get available (unclaimed) cases for accountants.
         *
         *     Returns cases that:
         *     - Belong to the caller's org
         *     - Are in the accountant or ready queue
         *     - Are NOT currently claimed by anyone
         *     - (Optionally) Have passed document readiness checks if ready_only=true
         *
         *     The caller's identity is derived from the JWT — never from query params.
         */
        get: operations["get_available_cases_for_accountant_api_v1_queue_accountant_available_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/my-cases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get My Claimed Cases
         * @description Get cases claimed by the current accountant.
         *
         *     The caller's identity is derived from the JWT — never from query params.
         */
        get: operations["get_my_claimed_cases_api_v1_queue_accountant_my_cases_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/claim/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Claim Case
         * @description Claim a case for review.
         *     Once claimed, only this accountant can edit (others see "Claimed by [Name]").
         *
         *     The accountant identity (id/name/email) is derived from the authenticated
         *     user — never from query params — so the stored claimer cannot be spoofed.
         */
        post: operations["claim_case_api_v1_queue_accountant_claim__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/release/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Release Case
         * @description Release a case back to the pool.
         *     Only the accountant who claimed it (or an admin/owner) can release.
         *
         *     The actor is derived from the JWT so it cannot be spoofed via query params.
         */
        post: operations["release_case_api_v1_queue_accountant_release__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/accountant/reassign/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reassign Case
         * @description Reassign a case to a different accountant (admin only).
         */
        post: operations["reassign_case_api_v1_queue_accountant_reassign__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/case/{case_id}/priorities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Priorities
         * @description Get top priority items for a specific case.
         *     Aggregates blocking issues, roadmap actions, and AI recommendations.
         */
        get: operations["get_case_priorities_api_v1_queue_case__case_id__priorities_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/case/{case_id}/readiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Readiness
         * @description Get detailed readiness assessment for a case.
         *     Shows which document checks have passed/failed and what's blocking progress.
         */
        get: operations["get_case_readiness_api_v1_queue_case__case_id__readiness_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/queue/case/{case_id}/estimated-value": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Set Case Estimated Value
         * @description Set the estimated value for a case.
         *
         *     This value takes priority over calculated values in the queue display.
         *     Can be set by the wizard during case setup or by an accountant during review.
         *
         *     Priority order for value display:
         *     1. BI calculation result (result.final_claim_amount)
         *     1b. Future Closure Engine result (future_closure_calculations.results.total_demand)
         *     2. Wizard-set value (data.claim_info.estimated_value) <- THIS ENDPOINT SETS THIS
         *     3. Roadmap current_state.estimated_value
         *     4. Cached calculated value
         *     5. Runtime calculation from periods (avg_monthly_revenue * 12)
         *
         *     Supported calculator engines:
         *     - BI Engine: Historical Period Claim Calculator
         *     - Future Closure Engine: Forced Future Closure Calculator (business interruption)
         *     - IMPACT Calculator: Used internally for case strengthening roadmaps
         */
        post: operations["set_case_estimated_value_api_v1_queue_case__case_id__estimated_value_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/feature-flags/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Feature Flags
         * @description Get all feature flags with their current values.
         *
         *     Returns:
         *         Dict mapping flag names to enabled status
         *
         *     Example response:
         *         {
         *             "client_portal_unified": false,
         *             "unified_work_queue": false,
         *             ...
         *         }
         */
        get: operations["get_feature_flags_api_v1_feature_flags__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/feature-flags/detailed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Feature Flags Detailed
         * @description Get all feature flags with descriptions.
         *     Useful for admin dashboards.
         *
         *     Returns:
         *         Dict with detailed flag info
         *
         *     Example response:
         *         {
         *             "unified_work_queue": {
         *                 "key": "unified_work_queue",
         *                 "enabled": false,
         *                 "description": "Single queue for all data specialist work items"
         *             },
         *             ...
         *         }
         */
        get: operations["get_feature_flags_detailed_api_v1_feature_flags_detailed_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/feature-flags/{flag_name}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Feature Flag
         * @description Get a specific feature flag's status.
         *
         *     Args:
         *         flag_name: The feature flag key (e.g., "unified_work_queue")
         *
         *     Returns:
         *         Dict with flag info
         *
         *     Example response:
         *         {
         *             "key": "unified_work_queue",
         *             "enabled": false,
         *             "description": "Single queue for all data specialist work items"
         *         }
         */
        get: operations["get_feature_flag_api_v1_feature_flags__flag_name__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/feature-flags/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Feature Flags Health
         * @description Health check for feature flags system.
         */
        get: operations["feature_flags_health_api_v1_feature_flags_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/document-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Document Types
         * @description Get all available document types for upload dropdown.
         *
         *     Returns grouped list of document types that can be selected
         *     when uploading documents.
         */
        get: operations["get_document_types_api_v1_document_pipeline_document_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/classify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Classify Document
         * @description Classify an uploaded document.
         *
         *     Determines document type and appropriate processing pipeline.
         *     Uses user hint if provided, otherwise auto-detects.
         *
         *     Args:
         *         file: The uploaded file
         *         user_hint: User-selected document type from dropdown
         *         business_type: Optional business entity type for context
         *
         *     Returns:
         *         ClassificationResponse with document type and routing info
         */
        post: operations["classify_document_api_v1_document_pipeline_classify_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/parse-pl": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Parse Pl Document
         * @description Parse a P&L document to canonical format.
         *
         *     Extracts P&L data from Excel, CSV, or PDF files.
         *     Returns structured data ready for BI integration.
         *
         *     Args:
         *         file: P&L document (Excel, CSV, or PDF)
         *         business_name: Optional business name hint
         *         fiscal_year: Optional fiscal year end month
         *         accounting_method: Optional accounting method (cash/accrual)
         *
         *     Returns:
         *         PLParseResponse with extracted canonical P&L data
         */
        post: operations["parse_pl_document_api_v1_document_pipeline_parse_pl_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/pl-status/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pl Status
         * @description Get P&L status for a case.
         *
         *     Returns whether a case has:
         *     - Provided P&L (bypass mode)
         *     - Reconstructed P&L (from transactions)
         *     - No P&L data yet
         */
        get: operations["get_pl_status_api_v1_document_pipeline_pl_status__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/pl-expenses/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pl Expenses
         * @description Get all expense line items from a case's P&L for editing.
         *
         *     Returns expenses with their AI-assigned categories and confidence scores.
         *     Handles both parsed_pl_statement format and legacy financial_data format.
         */
        get: operations["get_pl_expenses_api_v1_document_pipeline_pl_expenses__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/pl-expenses/{case_id}/corrections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Expense Corrections
         * @description Save user corrections to expense categories.
         *
         *     Updates the P&L data with user-corrected categories and marks items
         *     as manually reviewed with 100% confidence.
         */
        post: operations["save_expense_corrections_api_v1_document_pipeline_pl_expenses__case_id__corrections_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-pipeline/reclassify-draft-files/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reclassify Draft Files
         * @description Scan S3 for ALL files belonging to a draft and classify each using
         *     DocumentRouter content analysis. This discovers files that may not
         *     be in file_results (e.g., tax documents uploaded separately).
         *
         *     Process:
         *     1. List ALL files in S3 under uploads/drafts/{draft_id}/
         *     2. Download each file and classify with DocumentRouter (content analysis)
         *     3. Merge with existing file_results (preserving transaction data)
         *     4. Extract tax documents into tax1065Files
         *     5. Save everything to draft
         *
         *     Also accepts file_results from frontend to merge/restore.
         */
        post: operations["reclassify_draft_files_api_v1_document_pipeline_reclassify_draft_files__draft_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-signoff/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sign Off Case
         * @description Sign off on a case, marking it ready for attorney delivery.
         *
         *     Prerequisites:
         *     - All blocking issues must be resolved (or override_warnings=true)
         *     - Accountant should have claimed the case (recommended but not required)
         *
         *     Effects:
         *     - Sets case status to 'ready_for_attorney'
         *     - Updates assigned_queue to 'ready' (or 'attorney' if auto-release enabled)
         *     - Creates sign-off record in history
         *     - Logs activity
         */
        post: operations["sign_off_case_api_v1_case_signoff__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-signoff/{case_id}/undo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Undo Sign Off
         * @description Undo a sign-off, returning the case to accountant queue.
         *
         *     Only allowed if case hasn't been released to attorney yet.
         */
        post: operations["undo_sign_off_api_v1_case_signoff__case_id__undo_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-signoff/{case_id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Sign Off History
         * @description Get sign-off history for a case.
         */
        get: operations["get_sign_off_history_api_v1_case_signoff__case_id__history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-signoff/{case_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Sign Off Status
         * @description Get current sign-off status for a case.
         */
        get: operations["get_sign_off_status_api_v1_case_signoff__case_id__status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/finalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Finalize Attestation
         * @description Seal the attestation. Flips status `ready_for_attorney` → `final`.
         *
         *     Errors per a3 §finalize:
         *     - 400 if `signature_confirmation` doesn't match attester name on file.
         *     - 409 if report status != `ready_for_attorney` (illegal transition).
         *     - 412 if not all 12 engines approved or waived (readiness gate).
         */
        post: operations["finalize_attestation_api_v1_external_accountant_review__report_id__finalize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/unfinalize": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Unfinalize Attestation
         * @description Reverse a `final` attestation back to `ready_for_attorney`.
         *
         *     Only valid if the report hasn't been delivered downstream
         *     (`released_to_attorney` or `automation_status == "delivered"` — same
         *     pattern as `case_signoff.py:247-256`).
         *
         *     Errors:
         *     - 404 if report not found.
         *     - 409 if already released (must use attorney challenge instead).
         *     - 409 if status != `final`.
         */
        post: operations["unfinalize_attestation_api_v1_external_accountant_review__report_id__unfinalize_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Witness List Engine Reviews
         * @description Per-engine review status for all 12 engines on a report — witness path.
         *
         *     Engines without a row in `engine_reviews` surface as `status=unreviewed`
         *     so the witness UI always renders all 12 cards.
         */
        get: operations["witness_list_engine_reviews_api_v1_external_accountant_review__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/{engine_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Witness Get Engine Review Detail
         * @description Full review status for one engine — witness path.
         *
         *     Same shape as the in-house detail endpoint; the witness UI renders
         *     against the same TypeScript types so no per-mode response massaging
         *     is needed downstream.
         */
        get: operations["witness_get_engine_review_detail_api_v1_external_accountant_review__report_id___engine_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/{engine_id}/start-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Witness Start Review */
        post: operations["witness_start_review_api_v1_external_accountant_review__report_id___engine_id__start_review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/{engine_id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Witness Approve Engine */
        post: operations["witness_approve_engine_api_v1_external_accountant_review__report_id___engine_id__approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/{engine_id}/dispute": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Witness Dispute Engine */
        post: operations["witness_dispute_engine_api_v1_external_accountant_review__report_id___engine_id__dispute_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/review/{report_id}/{engine_id}/waive": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Witness Waive Engine */
        post: operations["witness_waive_engine_api_v1_external_accountant_review__report_id___engine_id__waive_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/external-accountant/home-feed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Home Feed
         * @description Aggregate the witness accountant's engagements into priority buckets.
         *
         *     Returns:
         *       {
         *         "buckets": {
         *           "pending_first_review": { "items": [...], "total": N },
         *           "stale_after_rerun":    { "items": [...], "total": N },
         *           "open_disputes":        { "items": [...], "total": N },
         *           "ready_for_signoff":    { "items": [...], "total": N },
         *           "recently_attested":    { "items": [...], "total": N }
         *         },
         *         "total_active": N  // sum of buckets except recently_attested
         *       }
         */
        get: operations["get_home_feed_api_v1_external_accountant_home_feed_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/production-export/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Compliant production export — admin-only
         * @description Return the production-export ZIP for ``report_id``.
         *
         *     Both scopes always include the same engine_outputs / engine_reviews
         *     / engine_overrides / external_attestation_history / audit_chain
         *     snapshots — those collections don't carry deliberation-style
         *     sensitivity tags. Only ``case_deliberations.events`` is filtered.
         */
        get: operations["get_production_export_api_v1_admin_production_export__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/overlay/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get Overlay */
        get: operations["get_overlay_api_v1_attorney_overlay__report_id__get"];
        put?: never;
        /** Upsert Overlay */
        post: operations["upsert_overlay_api_v1_attorney_overlay__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/overlay/{report_id}/versions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List Overlay Versions */
        get: operations["list_overlay_versions_api_v1_attorney_overlay__report_id__versions_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/war-room/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney War Room
         * @description Read-only union of deliberation + consensus + verifier + helpers.
         */
        get: operations["get_attorney_war_room_api_v1_attorney_war_room__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/challenge/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** File Challenge */
        post: operations["file_challenge_api_v1_attorney_challenge__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/attorney/war-room/{report_id}/query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Query War Room */
        post: operations["query_war_room_api_v1_attorney_war_room__report_id__query_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/war-room/consensus/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Consensus
         * @description Return the consensus doc for a report.
         *
         *     - `run_id` supplied → exact run (historical versions remain
         *       queryable because `war_room_consensus` is append-only).
         *     - `run_id` absent → most recent consensus for the report.
         *     - No matching doc → 404 with a helpful message.
         */
        get: operations["get_consensus_api_v1_war_room_consensus__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/war-room/verifier/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Verifier
         * @description Return the verifier report for a given report (or specific run).
         *
         *     Phase 10 task 10.6 — wired through ``filter_verifier_by_role`` for
         *     defense-in-depth. The verifier's free-text fields are deterministic
         *     QA outputs (not strategy work product), so the filter is identity
         *     today; the wire-in lets a future leak surface be addressed without
         *     touching every consumer.
         */
        get: operations["get_verifier_api_v1_war_room_verifier__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/rerun": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Rerun Engine
         * @description Queue a rerun for the given engine and optionally cascade.
         *
         *     - 400 if `engine_id` is not in the canonical 12-engine set.
         *     - 503 if the cascade pipeline is disabled (default state until all
         *       of Phase 05 lands).
         */
        post: operations["rerun_engine_api_v1_engine_review__report_id___engine_id__rerun_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/view/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report For In House Review
         * @description In-house equivalent of the witness `/collaboration/reports/{id}/view`.
         *
         *     Returns the full report document so `EngineDetailViews.useEngineReportData`
         *     can render any of the 11 routed engines (every engine except
         *     `merchant_reconciliation`, which has its own bespoke card path).
         *
         *     Lookup precedence (TS-FU14, 2026-05-03):
         *         1. `db.reports` by `_id` — finalized reports keyed by their own UUID.
         *         2. `db.reports` by `draft_id` — the typical case for active claims.
         *            When a claim's `_id` is the DRAFT uuid (most URLs in the
         *            accountant surface use the draft id), the corresponding report
         *            is keyed by its own report uuid and linked back via
         *            `draft_id`. Filter excludes archived/cancelled/deleted/voided
         *            statuses so a stale report doesn't shadow the active one.
         *         3. `db.drafts` by `_id` — fallback when no report exists yet
         *            (claim created but `/reports/generate` never ran). Returns
         *            the draft document; the frontend renders the
         *            `engine-output-missing` fallback because there's no
         *            `result.calculation_detail` yet.
         *
         *     Why this precedence matters: the original implementation checked
         *     `drafts` first. For active claims (the 99% case), this returned the
         *     draft document immediately — which has no `result.calculation_detail`.
         *     The frontend then rendered "engine output not available yet" even
         *     when a perfectly-good completed report existed in `db.reports` linked
         *     by `draft_id`. The wizard-regenerate-cards-populated.spec.ts e2e
         *     fires if this precedence regresses.
         */
        get: operations["get_report_for_in_house_review_api_v1_engine_review_view__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/view-typed/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Typed engine review detail bundle (5 supplemental engines)
         * @description Return the 5 typed engine detail blocks for the accountant review surface.
         *
         *     This endpoint exists to provide a typed schema for the frontend codegen
         *     (openapi-typescript). The legacy /view/{report_id} endpoint returns the
         *     full report bundle as a free-form dict; this one returns only the slice
         *     that drives the accountant cards, with full Pydantic typing.
         */
        get: operations["get_engine_review_view_typed_api_v1_engine_review_view_typed__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Engine Reviews
         * @description Return per-engine review status for all 12 engines on a report.
         *
         *     Engines without a row in ``engine_reviews`` are surfaced as
         *     ``status=unreviewed`` so the UI always renders all 12 cards.
         */
        get: operations["list_engine_reviews_api_v1_engine_review__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Engine Review Detail
         * @description Return the full review status for one engine.
         *
         *     Phase 07.1 surfaces the review state + active overrides + upstream
         *     provenance. Future tasks expand this to include verifier_status,
         *     consensus_entries, and attestation_history as the review UI
         *     consumes them.
         */
        get: operations["get_engine_review_detail_api_v1_engine_review__report_id___engine_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/start-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Start Review */
        post: operations["start_review_api_v1_engine_review__report_id___engine_id__start_review_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve Engine
         * @description In-house approve. The state-machine guard (SM1) only permits
         *     approve from `under_review` or `unreviewed`, so the UI's
         *     ReviewActionBar gates the button accordingly via
         *     ``getActionsForState``.
         */
        post: operations["approve_engine_api_v1_engine_review__report_id___engine_id__approve_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/dispute": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Dispute Engine */
        post: operations["dispute_engine_api_v1_engine_review__report_id___engine_id__dispute_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/waive": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Waive Engine */
        post: operations["waive_engine_api_v1_engine_review__report_id___engine_id__waive_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/override": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create Override */
        post: operations["create_override_api_v1_engine_review__report_id___engine_id__override_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/override/{override_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Inactivate Override */
        delete: operations["inactivate_override_api_v1_engine_review__report_id___engine_id__override__override_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/engine-review/{report_id}/{engine_id}/overrides": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List Overrides */
        get: operations["list_overrides_api_v1_engine_review__report_id___engine_id__overrides_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/supporting-documents/extract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract Document
         * @description Extract structured data from a supporting document using AI.
         *
         *     Supports:
         *     - Lease agreements → rent, escalation, dates, terms
         *     - Insurance policies → coverage limits, deductibles, BI terms
         *     - Loan documents → payment schedule, interest, principal
         *     - Generic contracts → parties, dates, obligations
         *
         *     The document must already be uploaded and have OCR text available.
         */
        post: operations["extract_document_api_v1_supporting_documents_extract_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/supporting-documents/case/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Supporting Documents
         * @description Get all extracted supporting documents for a case.
         */
        get: operations["get_case_supporting_documents_api_v1_supporting_documents_case__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/supporting-documents/document/{document_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Extracted Document
         * @description Get extraction result for a specific document.
         */
        get: operations["get_extracted_document_api_v1_supporting_documents_document__document_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/supporting-documents/document/{document_id}/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Verify Extraction
         * @description Mark an extraction as verified, optionally applying corrections.
         */
        put: operations["verify_extraction_api_v1_supporting_documents_document__document_id__verify_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/supporting-documents/case/{case_id}/extract-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract All Supporting Documents
         * @description Extract data from all supporting documents in a case.
         *     Useful for batch processing after initial document upload.
         */
        post: operations["extract_all_supporting_documents_api_v1_supporting_documents_case__case_id__extract_all_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/continuation-rates/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Continuation Rates
         * @description Get continuation rates for a case.
         *
         *     Returns case-specific rates if set, otherwise returns defaults.
         */
        get: operations["get_continuation_rates_api_v1_continuation_rates__report_id__get"];
        /**
         * Save Continuation Rates
         * @description Save custom continuation rates for a case.
         */
        put: operations["save_continuation_rates_api_v1_continuation_rates__report_id__put"];
        post?: never;
        /**
         * Reset Continuation Rates
         * @description Reset continuation rates to defaults for a case.
         */
        delete: operations["reset_continuation_rates_api_v1_continuation_rates__report_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/continuation-rates/defaults/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Default Rates
         * @description Get default continuation rates with descriptions.
         */
        get: operations["get_default_rates_api_v1_continuation_rates_defaults_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/continuation-rates/presets/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Rate Presets
         * @description Get preset continuation rate configurations by business type.
         */
        get: operations["get_rate_presets_api_v1_continuation_rates_presets_list_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pl-benchmark/industries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Available Industries
         * @description Get list of available industries for P&L benchmarking.
         *
         *     Returns all supported industry types with their display names.
         */
        get: operations["get_available_industries_api_v1_pl_benchmark_industries_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pl-benchmark/compare/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Compare Report Pl To Benchmark
         * @description Compare a report's parsed P&L against industry benchmarks.
         *
         *     This endpoint:
         *     1. Retrieves the parsed P&L statement from the report
         *     2. Identifies the appropriate industry benchmark
         *     3. Calculates expense ratios and margins
         *     4. Compares against industry norms
         *     5. Returns deviation analysis and forensic implications
         *
         *     The comparison helps identify:
         *     - Whether expense ratios are reasonable for the industry
         *     - Potential red flags (unusually high/low metrics)
         *     - Impact on claim calculations (continuing expenses, lost profits)
         */
        get: operations["compare_report_pl_to_benchmark_api_v1_pl_benchmark_compare__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pl-benchmark/compare-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Compare Pl Data To Benchmark
         * @description Compare arbitrary P&L data against industry benchmarks.
         *
         *     Use this endpoint to compare P&L data without saving to a report.
         *     Useful for quick comparisons or testing.
         */
        post: operations["compare_pl_data_to_benchmark_api_v1_pl_benchmark_compare_data_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pl-benchmark/cached/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Cached Benchmark
         * @description Get cached benchmark comparison for a report.
         *
         *     Returns previously calculated benchmark comparison without re-running.
         *     Useful for displaying in UI without waiting for calculation.
         */
        get: operations["get_cached_benchmark_api_v1_pl_benchmark_cached__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pl-benchmark/industry/{industry_key}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Industry Benchmarks
         * @description Get benchmark values for a specific industry.
         *
         *     Returns the expected ranges for all metrics in the specified industry.
         */
        get: operations["get_industry_benchmarks_api_v1_pl_benchmark_industry__industry_key__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/top-priorities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Top Priorities
         * @description Get top priority items that need attention.
         *     Aggregates from drafts needing cleanup, reports needing review, etc.
         */
        get: operations["get_top_priorities_api_v1_dashboard_top_priorities_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/data-quality": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Data Quality
         * @description Get data quality score and missing documents for a draft or report.
         *     If no ID provided, returns aggregate across all user's work.
         */
        get: operations["get_data_quality_api_v1_dashboard_data_quality_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/alerts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Alerts
         * @description Get alerts for the current user.
         */
        get: operations["get_alerts_api_v1_dashboard_alerts_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/alerts/{alert_id}/dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dismiss Alert
         * @description Dismiss an alert.
         */
        post: operations["dismiss_alert_api_v1_dashboard_alerts__alert_id__dismiss_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/alerts/{alert_id}/read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mark Alert Read
         * @description Mark an alert as read.
         */
        post: operations["mark_alert_read_api_v1_dashboard_alerts__alert_id__read_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/forensic-insights/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Forensic Insights
         * @description Get forensic analysis insights for a report.
         *     Includes Benford's Law analysis, outlier detection, data integrity.
         */
        get: operations["get_forensic_insights_api_v1_dashboard_forensic_insights__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/insurance-questions/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Insurance Questions
         * @description Get likely adjuster questions with pre-populated answers.
         *     Uses AI to generate questions based on claim data.
         */
        get: operations["get_insurance_questions_api_v1_dashboard_insurance_questions__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/next-actions/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Next Actions
         * @description Get dynamic checklist of next actions based on claim state.
         */
        get: operations["get_next_actions_api_v1_dashboard_next_actions__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/anomaly-review/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Anomaly Review
         * @description Get anomalies for accountant review.
         *
         *     Fetches anomaly data from the draft's cached_anomaly_analysis and
         *     canonical_data periods. Returns everything the AnomalyResolver component
         *     needs to render the review UI.
         */
        get: operations["get_anomaly_review_api_v1_dashboard_anomaly_review__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/anomaly-review/{report_id}/accountant-action": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Save Accountant Anomaly Action
         * @description Save accountant action on an anomaly (approve, reject, flag, add note).
         *
         *     Actions:
         *     - approve_resolution: Accountant approves an existing resolution
         *     - reject_resolution: Accountant rejects a resolution (sends back for re-review)
         *     - add_note: Accountant adds a forensic note
         *     - flag: Accountant flags for follow-up
         */
        post: operations["save_accountant_anomaly_action_api_v1_dashboard_anomaly_review__report_id__accountant_action_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/next-actions/{action_id}/complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Complete Next Action
         * @description Mark a next-action checklist item as complete.
         *     Stores completion in the report's action_completions array.
         */
        post: operations["complete_next_action_api_v1_dashboard_next_actions__action_id__complete_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/cache-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Classification Cache Stats
         * @description Get classification cache statistics.
         *     Shows how many classifications are cached to save API costs.
         */
        get: operations["get_classification_cache_stats_api_v1_dashboard_cache_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/accountant-payload/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Accountant Dashboard Payload
         * @description Single payload for the accountant dashboard view.
         *
         *     Reads from: claims, forensic_analyses, uploaded_files, case_deliberations.
         *     Uses DocumentRequirementsService for accurate document completeness
         *     (handles conditional P&L / bank statement logic).
         */
        get: operations["get_accountant_dashboard_payload_api_v1_dashboard_accountant_payload__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/case-details/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Details
         * @description Batched sidebar payload for the accountant dashboard.
         *
         *     Collapses five serial fetches into one parallel asyncio.gather. Per-section
         *     failures return {"error": "<message>"} in that slot so one broken section
         *     doesn't blank the whole sidebar (infrastructure failures still 5xx).
         *
         *     Org filter: the report must belong to the caller's org — we short-circuit
         *     with 404 otherwise, before fanning anything out. Individual section
         *     helpers re-assert the same check so even a partial-auth bypass can't
         *     leak cross-org data.
         */
        get: operations["get_case_details_api_v1_dashboard_case_details__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/trends": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Dashboard Trends
         * @description Op-FU7 — real WoW math for Dashboard Total Claims / Total Value cards.
         *
         *     Returns current totals + the totals as of `days` ago + signed delta and
         *     optional pct delta. Multi-tenant safe: scoped to caller's org_id.
         *
         *     "Total Claims" = count of `db.drafts` belonging to the org.
         *     "Total Value" = sum of `result.final_claim_amount` across those drafts —
         *     same field the frontend already aggregates client-side at
         *     `DashboardNew.tsx:348`. Drafts without a `final_claim_amount` (still
         *     in-progress) contribute 0 via `$ifNull`.
         *
         *     `delta_pct` is `None` when previous=0 to avoid divide-by-zero. The
         *     frontend must hide the chip rather than render "+∞%".
         */
        get: operations["get_dashboard_trends_api_v1_dashboard_trends_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pipeline/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Aggregated Pipeline Status
         * @description Get aggregated pipeline status across all active claims.
         *
         *     Uses Redis cache (45s TTL) for instant page loads.
         *     Falls back to live query if cache is empty or Redis unavailable.
         */
        get: operations["get_aggregated_pipeline_status_api_v1_pipeline_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pipeline/status/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim Pipeline Status
         * @description Get pipeline status for a specific claim.
         *     Shows which AI agents have run and their results.
         */
        get: operations["get_claim_pipeline_status_api_v1_pipeline_status__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pipeline/{report_id}/start": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start Pipeline
         * @description Start the full analysis pipeline for a claim.
         */
        post: operations["start_pipeline_api_v1_pipeline__report_id__start_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pipeline/{report_id}/run-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pipeline Run Status
         * @description Get the latest pipeline run status for a claim.
         *
         *     Returns the most recent ``pipeline_runs`` document (sorted by created_at
         *     descending) so the caller can inspect per-stage progress.
         */
        get: operations["get_pipeline_run_status_api_v1_pipeline__report_id__run_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pipeline/{report_id}/retry/{stage}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry Stage
         * @description Manually retry a failed pipeline stage.
         *
         *     Only stages with ``status == "failed"`` can be retried.  The stage is
         *     reset to ``not_started`` and a new Celery task is dispatched.
         */
        post: operations["retry_stage_api_v1_pipeline__report_id__retry__stage__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/document-requirements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Document Requirements
         * @description Get document requirements for a case.
         *
         *     Returns full list of requirements with upload status, completion stats,
         *     and any blocking issues preventing advancement to accountant queue.
         */
        get: operations["get_document_requirements_api_v1_reports__report_id__document_requirements_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/readiness": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Readiness Status
         * @description Check if case is ready for accountant queue.
         *
         *     Returns:
         *         - ready_for_accountant: Boolean indicating if all requirements met
         *         - blockers: List of issues preventing advancement
         *         - warnings: List of recommended but non-blocking items
         */
        get: operations["get_readiness_status_api_v1_reports__report_id__readiness_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/case-type": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Update Case Type
         * @description Update case type and optionally entity type.
         *
         *     Valid case types: BI, FC, LP, FRAUD, VAL, PD, CONTRACT, TRADE,
         *                       EMP_WT, EMP_WH, EMP_DISC, FAM_DIV, FAM_CS,
         *                       PI_WAGE, PI_EARN, CUSTOM
         *
         *     Valid entity types: sole_prop, partnership, s_corp, c_corp, llc, individual
         */
        post: operations["update_case_type_api_v1_reports__report_id__case_type_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{report_id}/custom-requirements": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Update Custom Requirements
         * @description Set custom document requirements for a case.
         *
         *     Used when case_type is CUSTOM or when overriding default requirements.
         *
         *     Requirements dict should be: {doc_type: status}
         *     where status is 'required', 'optional', or 'n/a'
         */
        post: operations["update_custom_requirements_api_v1_reports__report_id__custom_requirements_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Requirement Templates
         * @description Get all saved requirement templates.
         *
         *     Templates can be saved when setting custom requirements and reused
         *     for similar case types.
         */
        get: operations["get_requirement_templates_api_v1_document_templates_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Types
         * @description Get all available case types with their display names.
         */
        get: operations["get_case_types_api_v1_case_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/document-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Document Types
         * @description Get all available document types with their details.
         */
        get: operations["get_document_types_api_v1_document_types_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/requirements-matrix/{case_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Requirements For Case Type
         * @description Get document requirements for a specific case type.
         *
         *     This endpoint doesn't require a case ID - useful for planning
         *     before a case is created or for displaying requirements templates.
         *
         *     Args:
         *         case_type: Case type code (BI, FC, LP, etc.)
         *         entity_type: Entity type (sole_prop, partnership, s_corp, etc.)
         *         has_pl: Whether P&L statements are uploaded
         *         has_bank: Whether bank statements are uploaded
         *         claim_source: "first_party" (own insurance) or "third_party" (someone else's liability)
         *
         *     Note: P&L and Bank Statements are mutually satisfying - either one satisfies
         *     the financial source requirement.
         */
        get: operations["get_requirements_for_case_type_api_v1_requirements_matrix__case_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Pattern Templates
         * @description List available pattern templates for new events
         */
        get: operations["list_pattern_templates_api_v1_patterns_templates_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Patterns
         * @description List all patterns for a specific event.
         *
         *     Example: GET /patterns/smitty_supply_2025
         */
        get: operations["list_patterns_api_v1_patterns__event_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}/pattern/{pattern_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pattern
         * @description Get a specific pattern by ID
         */
        get: operations["get_pattern_api_v1_patterns__event_id__pattern__pattern_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}/suggestions/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Suggestions For Report
         * @description Get pattern-based reclassification suggestions for all transactions in a report.
         *
         *     Only returns suggestions for transactions with AI confidence < 85%.
         *
         *     Example: GET /patterns/smitty_supply_2025/suggestions/rpt_xyz789
         *
         *     Response:
         *     {
         *         "report_id": "rpt_xyz789",
         *         "event_id": "smitty_supply_2025",
         *         "suggestion_count": 12,
         *         "suggestions": {
         *             "txn_abc123": [
         *                 {
         *                     "pattern_id": "SM-006",
         *                     "match_score": 0.85,
         *                     "suggested_category": "Evacuation",
         *                     "suggested_subcategory": "Temporary Relocation Housing",
         *                     "confidence": "HIGH",
         *                     "rationale": "..."
         *                 }
         *             ]
         *         }
         *     }
         */
        get: operations["get_suggestions_for_report_api_v1_patterns__event_id__suggestions__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}/suggestions/{report_id}/transaction/{transaction_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Suggestions For Transaction
         * @description Get pattern suggestions for a single transaction.
         */
        get: operations["get_suggestions_for_transaction_api_v1_patterns__event_id__suggestions__report_id__transaction__transaction_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{pattern_id}/accept": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Accept Suggestion
         * @description Accept a pattern suggestion and apply the reclassification.
         *
         *     This will:
         *     1. Update the transaction's category/subcategory
         *     2. Log the decision to pl_audit_log
         *     3. Increment the pattern's accept_count
         *     4. Check if confidence adjustment is needed
         */
        post: operations["accept_suggestion_api_v1_patterns__pattern_id__accept_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{pattern_id}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reject Suggestion
         * @description Reject a pattern suggestion.
         *
         *     This will:
         *     1. Log the rejection to pl_audit_log
         *     2. Increment the pattern's reject_count
         *     3. Check if confidence adjustment or pattern disabling is needed
         */
        post: operations["reject_suggestion_api_v1_patterns__pattern_id__reject_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Pattern
         * @description Create a new classification pattern (Admin only).
         */
        post: operations["create_pattern_api_v1_patterns_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{pattern_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Pattern
         * @description Update an existing pattern (Admin only).
         */
        put: operations["update_pattern_api_v1_patterns__pattern_id__put"];
        post?: never;
        /**
         * Deactivate Pattern
         * @description Deactivate a pattern (Admin only).
         *     Does not delete - just sets active=False.
         */
        delete: operations["deactivate_pattern_api_v1_patterns__pattern_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Event Stats
         * @description Get aggregate statistics for all patterns in an event.
         *
         *     Useful for monitoring pattern library performance.
         */
        get: operations["get_event_stats_api_v1_patterns__event_id__stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/{event_id}/stats/{pattern_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pattern Stats
         * @description Get detailed statistics for a specific pattern
         */
        get: operations["get_pattern_stats_api_v1_patterns__event_id__stats__pattern_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/patterns/seed/{event_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Seed Event Patterns
         * @description Seed patterns for a specific event.
         *
         *     Supported built-in events:
         *     - smitty_supply_2025: Industrial explosion patterns (25 patterns)
         *
         *     Or use templates for new events:
         *     - template=hurricane: Coastal storm patterns (12 patterns)
         *     - template=fire: Fire/smoke damage patterns (10 patterns)
         *     - template=pandemic: COVID-19/business interruption (10 patterns)
         *     - template=civil_authority: Mandatory closure patterns (5 patterns)
         *
         *     Example: POST /patterns/seed/hurricane_ian_2024?template=hurricane
         */
        post: operations["seed_event_patterns_api_v1_patterns_seed__event_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/thresholds": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Thresholds
         * @description List all variance thresholds
         */
        get: operations["list_thresholds_api_v1_alerts_thresholds_get"];
        put?: never;
        /**
         * Create Threshold
         * @description Create a new variance threshold (Admin only)
         */
        post: operations["create_threshold_api_v1_alerts_thresholds_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/thresholds/{threshold_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Threshold
         * @description Update an existing variance threshold (Admin only)
         */
        put: operations["update_threshold_api_v1_alerts_thresholds__threshold_id__put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/thresholds/seed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Seed Default Thresholds
         * @description Seed default variance thresholds
         */
        post: operations["seed_default_thresholds_api_v1_alerts_thresholds_seed_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/report/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Alerts
         * @description Get all variance alerts for a report
         */
        get: operations["get_report_alerts_api_v1_alerts_report__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/report/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Report Alert Summary
         * @description Get alert summary for a report (counts by severity)
         */
        get: operations["get_report_alert_summary_api_v1_alerts_report__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/{alert_id}/acknowledge": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Acknowledge Alert
         * @description Acknowledge a variance alert
         */
        post: operations["acknowledge_alert_api_v1_alerts__alert_id__acknowledge_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/alerts/report/{report_id}/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Check Report Cells
         * @description Check all P&L cells in a report for variance alerts.
         *
         *     Request body should contain cells array with:
         *     - section: P&L section name
         *     - line_item: P&L line item name
         *     - year: Year
         *     - month: Optional month
         *     - expected: Expected amount
         *     - actual: Actual amount
         */
        post: operations["check_report_cells_api_v1_alerts_report__report_id__check_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Test Transaction Patterns
         * @description Test a transaction description against all patterns.
         *
         *     This is useful for:
         *     - Verifying pattern configurations before deploying
         *     - Understanding why a transaction did/didn't get a suggestion
         *     - Testing new patterns before adding them
         *
         *     Example:
         *     ```json
         *     {
         *         "vendor": "EnviroClean Services",
         *         "description": "Hazmat cleanup and soil remediation",
         *         "amount": 15000,
         *         "event_id": "smitty_supply_2025"
         *     }
         *     ```
         */
        post: operations["test_transaction_patterns_api_v1_pattern_admin_test_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List All Patterns
         * @description List all patterns with full details for admin management.
         */
        get: operations["list_all_patterns_api_v1_pattern_admin_patterns_get"];
        put?: never;
        /**
         * Create Pattern
         * @description Create a new classification pattern.
         */
        post: operations["create_pattern_api_v1_pattern_admin_patterns_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns/{pattern_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Pattern
         * @description Update an existing pattern.
         */
        put: operations["update_pattern_api_v1_pattern_admin_patterns__pattern_id__put"];
        post?: never;
        /**
         * Delete Pattern
         * @description Delete or deactivate a pattern.
         *     By default, patterns are soft-deleted (deactivated).
         */
        delete: operations["delete_pattern_api_v1_pattern_admin_patterns__pattern_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/candidates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pattern Candidates
         * @description Get discovered pattern candidates.
         *
         *     Pattern candidates are automatically generated when:
         *     - 3+ identical manual reclassifications across different cases
         *     - Repeated corrections to the same vendor/category combination
         */
        get: operations["get_pattern_candidates_api_v1_pattern_admin_candidates_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/candidates/{candidate_id}/promote": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Promote Candidate
         * @description Promote a discovered candidate to an active pattern.
         */
        post: operations["promote_candidate_api_v1_pattern_admin_candidates__candidate_id__promote_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/candidates/{candidate_id}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reject Candidate
         * @description Reject a pattern candidate.
         */
        post: operations["reject_candidate_api_v1_pattern_admin_candidates__candidate_id__reject_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/ai-suggest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Ai Suggest Reclassification
         * @description Get AI-powered reclassification suggestion using Claude.
         *
         *     This is used as a fallback when no patterns match.
         *     Uses Claude to analyze the transaction and suggest appropriate category.
         */
        post: operations["ai_suggest_reclassification_api_v1_pattern_admin_ai_suggest_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns/import": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Import Patterns
         * @description Bulk import patterns from a list.
         */
        post: operations["import_patterns_api_v1_pattern_admin_patterns_import_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Patterns
         * @description Export patterns as JSON for backup or transfer.
         */
        get: operations["export_patterns_api_v1_pattern_admin_patterns_export_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/maintenance/apply-decay": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Confidence Decay
         * @description Apply confidence decay to patterns based on inactivity.
         *
         *     Patterns lose 10% confidence per 30 days of inactivity (max 30%).
         *     This helps ensure stale patterns don't pollute suggestions.
         *
         *     Run this periodically (e.g., daily via cron).
         */
        post: operations["apply_confidence_decay_api_v1_pattern_admin_maintenance_apply_decay_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/maintenance/consolidate-aliases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Consolidate Vendor Aliases
         * @description Scan patterns and consolidate similar vendor names into aliases.
         *
         *     Uses fuzzy matching (85% threshold) to identify vendor name variations
         *     like "SYSCO ATLANTA" and "SYSCO-ATL" and consolidate them.
         *
         *     Run this periodically to clean up the pattern library.
         */
        post: operations["consolidate_vendor_aliases_api_v1_pattern_admin_maintenance_consolidate_aliases_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/vendors/similar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Find Similar Vendors
         * @description Find existing pattern vendors that are similar to the given vendor.
         *
         *     Useful for checking if a vendor might be an alias of an existing pattern
         *     before creating a new pattern.
         */
        get: operations["find_similar_vendors_api_v1_pattern_admin_vendors_similar_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns/{pattern_id}/aliases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add Vendor Alias To Pattern
         * @description Add a vendor alias to a specific pattern.
         *
         *     Aliases are alternative vendor names that should match the same pattern.
         */
        post: operations["add_vendor_alias_to_pattern_api_v1_pattern_admin_patterns__pattern_id__aliases_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/patterns/{pattern_id}/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pattern Statistics
         * @description Get detailed statistics for a pattern including:
         *     - Accept/reject counts and rates
         *     - Confidence decay information
         *     - Auto-deprecation warnings
         */
        get: operations["get_pattern_statistics_api_v1_pattern_admin_patterns__pattern_id__stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/pattern-admin/event/{event_id}/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pattern Library Health
         * @description Get overall health metrics for the pattern library.
         *
         *     Includes:
         *     - Pattern counts by status and confidence
         *     - Patterns needing review (low acceptance)
         *     - Patterns with decay
         *     - Deprecated pattern count
         */
        get: operations["get_pattern_library_health_api_v1_pattern_admin_event__event_id__health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/event-templates/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Templates
         * @description List all available event templates.
         *     Returns both system templates and the caller's org custom templates.
         */
        get: operations["list_templates_api_v1_event_templates__get"];
        put?: never;
        /**
         * Create Template
         * @description Create a new custom event template
         */
        post: operations["create_template_api_v1_event_templates__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/event-templates/{template_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Template
         * @description Get a specific template by ID (org-scoped for custom templates).
         */
        get: operations["get_template_api_v1_event_templates__template_id__get"];
        /**
         * Update Template
         * @description Update an existing custom template (cannot update system templates)
         */
        put: operations["update_template_api_v1_event_templates__template_id__put"];
        post?: never;
        /**
         * Delete Template
         * @description Delete a custom template (soft delete - sets is_active=False)
         */
        delete: operations["delete_template_api_v1_event_templates__template_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/event-templates/{template_id}/apply/{draft_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Apply Template To Draft
         * @description Apply a template's defaults to an existing draft.
         *     This pre-populates the draft with template settings.
         */
        post: operations["apply_template_to_draft_api_v1_event_templates__template_id__apply__draft_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Shallow
         * @description Quick health check for load balancers. No auth required.
         */
        get: operations["health_shallow_api_v1_health_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/health/deep": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Health Deep
         * @description Deep health check -- verifies each backing service.
         *     Returns 200 if all services are reachable, 503 otherwise.
         */
        get: operations["health_deep_api_v1_health_deep_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-activity/recent/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Recent Ai Activity
         * @description Recent AI activity across all cases — for dashboard card.
         */
        get: operations["get_recent_ai_activity_api_v1_ai_activity_recent_all_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-activity/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Ai Activity
         * @description AI activity timeline for a specific case.
         */
        get: operations["get_case_ai_activity_api_v1_ai_activity__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/ai-activity/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Ai Summary
         * @description AI activity summary stats for a case (agent breakdown, totals).
         */
        get: operations["get_case_ai_summary_api_v1_ai_activity__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/memory/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Memory Stats
         * @description Get procedural memory system statistics.
         */
        get: operations["get_memory_stats_api_v1_memory_stats_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/memory/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Memories
         * @description Search procedural memories by semantic similarity.
         *
         *     Useful for debugging and monitoring what the system has learned.
         *     Returns memories with similarity scores.
         */
        get: operations["search_memories_api_v1_memory_search_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/memory/{memory_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete Memory
         * @description Delete a specific procedural memory.
         */
        delete: operations["delete_memory_api_v1_memory__memory_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/memory/backfill": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Backfill Memories
         * @description Backfill procedural memories from existing AI activity logs.
         *
         *     Use this once to bootstrap the memory system from historical data.
         *     Subsequent interactions are captured automatically.
         */
        post: operations["backfill_memories_api_v1_memory_backfill_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit-chain/{report_id}/chain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Audit Chain
         * @description Return the full hash-chained audit trail for a report.
         *
         *     Each entry contains the action performed, the actor, a timestamp,
         *     the SHA-256 hash, and the link to the previous hash.
         */
        get: operations["get_audit_chain_api_v1_audit_chain__report_id__chain_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/audit-chain/{report_id}/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Verify Audit Chain
         * @description Verify the integrity of the audit chain for a report.
         *
         *     Re-computes every hash in the chain and confirms they match the
         *     stored values. If any record has been tampered with, returns
         *     ``valid: false`` with details about where the chain broke.
         */
        get: operations["verify_audit_chain_api_v1_audit_chain__report_id__verify_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/mitigation/calculate/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Calculate Mitigation Credit
         * @description Calculate mitigation credit for a report and save to MongoDB.
         *
         *     Fetches the report's financial data (pre-loss revenue, claimed loss, loss period),
         *     runs the mitigation calculator, and persists the result to the mitigation_credits collection.
         */
        post: operations["calculate_mitigation_credit_api_v1_mitigation_calculate__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/mitigation/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Mitigation Credit
         * @description Retrieve saved mitigation credit for a report.
         */
        get: operations["get_mitigation_credit_api_v1_mitigation__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/calculations/enrich/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Enrich Report
         * @description Run Big 4 forensic enrichments on an existing BI or Future Closure report.
         *
         *     Steps:
         *     1. Bottom-Up (ISO CP 00 30) + dual-method reconciliation
         *     2. Saved / Avoided Costs
         *     3. Non-Damage Factor Separation
         *     4. Extended Period of Indemnity (EPI)
         *     5. Policy Deductions waterfall
         *     6. Present Value discounting
         *
         *     Each step is fault-tolerant -- individual failures do not block others.
         */
        post: operations["enrich_report_api_v1_calculations_enrich__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{case_id}/expert-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Generate Expert Report
         * @description Generate an expert BI assessment report as a DOCX download.
         *
         *     Loads case data from MongoDB, resolves the appropriate event-specific
         *     DOCX template, renders it with the case context, and returns the
         *     file as a download.
         */
        get: operations["generate_expert_report_api_v1_reports__case_id__expert_report_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reports/{case_id}/demand-letter/{letter_type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Generate Demand Letter Template
         * @description Generate a demand letter DOCX auto-populated from case data.
         *
         *     Loads case data from MongoDB, resolves the appropriate demand letter
         *     DOCX template, renders it with the case context, and returns the
         *     file as a download.
         *
         *     Args:
         *         case_id: The MongoDB case/report ID.
         *         letter_type: One of: initial, follow_up, bad_faith, final, appraisal.
         */
        get: operations["generate_demand_letter_template_api_v1_reports__case_id__demand_letter__letter_type__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/packages/{package_id}/docx": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download Attorney Package Docx
         * @description Download an attorney package as a DOCX file.
         *
         *     Loads a previously assembled attorney package from MongoDB,
         *     renders it as a professional Word document using the DOCX
         *     template system, and returns it as a file download.
         */
        get: operations["download_attorney_package_docx_api_v1_packages__package_id__docx_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Deliberation
         * @description Get full CaseDeliberation for a report.
         *
         *     Phase 10 task 10.4 — events and nested issue.human_inputs are filtered
         *     by the caller's role. Clerk users see all sensitivities (identity
         *     filter); CPA-equivalent roles would see only calculation-tagged
         *     content if auth were ever widened to accept their tokens.
         */
        get: operations["get_deliberation_api_v1_deliberation__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/issues": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Issues
         * @description Get list of disputed issues for a report.
         *
         *     Phase 10 task 10.4 — issue.human_inputs lists are filtered by caller
         *     role. Issues themselves are preserved (they don't carry sensitivity);
         *     only the embedded events within human_inputs are stripped for CPA-
         *     equivalent callers.
         */
        get: operations["get_issues_api_v1_deliberation__report_id__issues_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/timeline": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Timeline
         * @description Get events sorted by timestamp (ascending).
         *
         *     Phase 10 task 10.4 — events are filtered by caller role. The returned
         *     ``count`` reflects post-filter visible events for the caller, NOT the
         *     raw event count. Clerk users see the full count; CPA-equivalent
         *     callers (if auth were widened) would see only calculation-tagged
         *     events and a correspondingly smaller count.
         */
        get: operations["get_timeline_api_v1_deliberation__report_id__timeline_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Summary
         * @description Get computed deliberation summary.
         */
        get: operations["get_summary_api_v1_deliberation__report_id__summary_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/resolution-paths": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Resolution Paths
         * @description Get resolution paths grouped by responsible_party.
         */
        get: operations["get_resolution_paths_api_v1_deliberation__report_id__resolution_paths_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/input": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Post Human Input
         * @description Create a human_input event and attach it to the deliberation.
         *
         *     The event is added to the deliberation's event list and the
         *     matching issue's human_inputs list, then stored back to MongoDB.
         */
        post: operations["post_human_input_api_v1_deliberation__report_id__input_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/trigger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger War Room Analysis
         * @description Trigger War Room analysis for a report/draft.
         *
         *     Fetches draft data from MongoDB, runs toolkit-enabled agents
         *     (forensic, attorney, adjuster), aggregates deliberation events,
         *     and stores the CaseDeliberation. Returns immediately with a Celery
         *     task_id (used as run_id); status is queryable via the status endpoint.
         */
        post: operations["trigger_war_room_analysis_api_v1_deliberation__report_id__trigger_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/trigger/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Trigger Status
         * @description Check the status of a running War Room analysis.
         *
         *     Queries Celery AsyncResult for live task state. Falls back to the
         *     in-memory status dict if task_id is not available (e.g. legacy runs).
         */
        get: operations["get_trigger_status_api_v1_deliberation__report_id__trigger_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/debug/data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Data Availability
         * @description Temporary diagnostic: check what data exists for this report_id.
         */
        get: operations["debug_data_availability_api_v1_deliberation__report_id__debug_data_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/challenge-round": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Challenge Round
         * @description Get challenge round results for a report.
         */
        get: operations["get_challenge_round_api_v1_deliberation__report_id__challenge_round_get"];
        put?: never;
        /**
         * Trigger Challenge Round
         * @description Trigger adversarial challenge round for a report.
         *
         *     Requires that War Room analysis has already completed (deliberation exists).
         *     The adjuster challenges the attorney's case, the attorney rebuts,
         *     and a vulnerability assessment is computed.
         */
        post: operations["trigger_challenge_round_api_v1_deliberation__report_id__challenge_round_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/challenge-round/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Challenge Round Status
         * @description Check the status of a running challenge round.
         */
        get: operations["get_challenge_round_status_api_v1_deliberation__report_id__challenge_round_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/vulnerabilities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Vulnerabilities
         * @description Get vulnerability assessment — case strength and unresolved weaknesses.
         */
        get: operations["get_vulnerabilities_api_v1_deliberation__report_id__vulnerabilities_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create Claim
         * @description Create a new claim. Returns claim_id immediately.
         *     Called when wizard loads without ?claim= param.
         */
        post: operations["create_claim_api_v1_claims_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim
         * @description Get claim data (user-entered fields + status + cached canonical).
         *     Multi-tenant isolated by org_id.
         */
        get: operations["get_claim_api_v1_claims__claim_id__get"];
        /**
         * Update Claim
         * @description Update user-entered claim data (auto-save target).
         *     Protected fields (cached_canonical_data, status, _id) are filtered out.
         *     Upserts: creates the claim if it doesn't exist yet (e.g. localStorage-only cases).
         */
        put: operations["update_claim_api_v1_claims__claim_id__put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update Claim Status
         * @description Transition claim status.
         *     Called by orchestrator and queue handlers.
         */
        put: operations["update_claim_status_api_v1_claims__claim_id__status_put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/canonical-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Canonical Data
         * @description Get canonical financial data for this claim.
         *     Returns cached data or rebuilds from uploaded_files.
         *     This is THE endpoint the frontend calls for transaction data.
         */
        get: operations["get_canonical_data_api_v1_claims__claim_id__canonical_data_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Claim Files
         * @description List all uploaded files for this claim.
         */
        get: operations["get_claim_files_api_v1_claims__claim_id__files_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/invalidate-cache": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Invalidate Cache
         * @description Manually invalidate the canonical data cache for a claim.
         *     Useful after reprocessing or debugging.
         */
        post: operations["invalidate_cache_api_v1_claims__claim_id__invalidate_cache_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/audit-buckets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Audit Transaction Buckets
         * @description Diagnostic endpoint: audit how transactions are bucketed into P&L categories.
         *
         *     Returns per-year bucket totals, top transactions per bucket, suspicious
         *     revenue (transfers/loans/owner draws that inflate gross revenue), and
         *     a comparison against tax return data when available.
         */
        get: operations["audit_transaction_buckets_api_v1_claims__claim_id__audit_buckets_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/migrate-claimsync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Migrate Claimsync To Claimgenius
         * @description Migrate all documents from 'claimsync' DB to 'claimgenius' DB.
         *     Only copies documents whose _id doesn't already exist in the target.
         *     Returns a summary of what was migrated.
         */
        get: operations["migrate_claimsync_to_claimgenius_api_v1_admin_migrate_claimsync_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/normalize-claim-ids": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Normalize Claim Ids
         * @description Set claim_id from draft_id or report_id on all uploaded_files missing claim_id.
         */
        get: operations["normalize_claim_ids_api_v1_admin_normalize_claim_ids_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/db-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check Db Config
         * @description Show current database configuration (for debugging db_name issues).
         */
        get: operations["check_db_config_api_v1_admin_db_config_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/search-files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search Uploaded Files
         * @description Search uploaded_files by S3 key or filename pattern (regex).
         */
        get: operations["search_uploaded_files_api_v1_admin_search_files_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/find-case/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Find Case Everywhere
         * @description Search for a case ID across both databases and all collections.
         */
        get: operations["find_case_everywhere_api_v1_admin_find_case__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/case-claim-fields/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Case Claim Fields
         * @description Show claim/queue fields for a case to debug My Cases visibility.
         */
        get: operations["get_case_claim_fields_api_v1_admin_case_claim_fields__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/file-detail/{file_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get File Detail
         * @description Show full detail of an uploaded_file to debug parsed_data structure.
         */
        get: operations["get_file_detail_api_v1_admin_file_detail__file_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/sample-transactions/{claim_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Sample Transactions
         * @description Show sample raw transactions from uploaded_files to debug date format.
         */
        get: operations["sample_transactions_api_v1_admin_sample_transactions__claim_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/fix-case-owner/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Fix Case Owner
         * @description Set claimed_by_accountant_id and/or user_id on a case in drafts/reports.
         *     Use to restore My Cases visibility.
         */
        post: operations["fix_case_owner_api_v1_admin_fix_case_owner__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/invalidate-canonical-cache/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Invalidate Canonical Cache
         * @description Clear cached canonical data so the next request triggers a full rebuild.
         *     Use after deploying changes to canonical data format.
         */
        post: operations["invalidate_canonical_cache_api_v1_admin_invalidate_canonical_cache__case_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/invalidate-all-canonical-caches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Invalidate All Canonical Caches
         * @description Invalidate canonical caches for ALL drafts and reports.
         *     Use after deploying changes to enrichment/classification logic.
         *     Next time each case is loaded, canonical data will be rebuilt with current code.
         */
        post: operations["invalidate_all_canonical_caches_api_v1_admin_invalidate_all_canonical_caches_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/nuclear-reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Nuclear Reset
         * @description DESTRUCTIVE: Wipe ALL case data from MongoDB and ALL files from S3.
         *     Leaves the database schema intact but removes all user data.
         *
         *     Requires ?confirm=YES_DELETE_EVERYTHING to execute.
         */
        post: operations["nuclear_reset_api_v1_admin_nuclear_reset_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/check-claimsync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check Claimsync Db
         * @description Check what exists in the 'claimsync' database without migrating.
         */
        get: operations["check_claimsync_db_api_v1_admin_check_claimsync_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/debug-canonical/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Canonical Rebuild
         * @description Debug why canonical-data returns empty for a case.
         *     Runs the same queries as rebuild_canonical_cache but shows diagnostics.
         */
        get: operations["debug_canonical_rebuild_api_v1_admin_debug_canonical__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/debug-draft-fields/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Draft Fields
         * @description Show key fields from draft data subdocument for debugging.
         */
        get: operations["debug_draft_fields_api_v1_admin_debug_draft_fields__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/debug-cleanup-txns/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Cleanup Transactions
         * @description Check what cleanup_transactions exist for a claim and their category distribution.
         */
        get: operations["debug_cleanup_transactions_api_v1_admin_debug_cleanup_txns__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/debug-buckets/{case_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Debug Bucket Distribution
         * @description Show P&L bucket distribution and sample transactions per bucket.
         *     Useful for diagnosing COGS = $0 or other bucketing issues.
         */
        get: operations["debug_bucket_distribution_api_v1_admin_debug_buckets__case_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/admin/merge-databases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Merge Databases
         * @description Merge claimgenius and claimsync databases bidirectionally.
         *
         *     For each collection:
         *     - Documents only in claimgenius → copy to claimsync
         *     - Documents only in claimsync → copy to claimgenius
         *     - Documents in BOTH → merge fields (claimgenius fields win for top-level,
         *       claimsync 'data' sub-fields win for SSoT-generated data like financial_data/tax1065Files)
         *
         *     After this, both databases are identical and the app can use either one.
         */
        post: operations["merge_databases_api_v1_admin_merge_databases_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/workbook/wb1/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Wb1
         * @description Generate and download WB1 Operating P&L workbook (8 tabs).
         */
        get: operations["export_wb1_api_v1_workbook_wb1__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/workbook/wb2/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Export Wb2
         * @description Generate and download WB2 BI Forensic workbook (13 tabs).
         */
        get: operations["export_wb2_api_v1_workbook_wb2__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/claims/{claim_id}/financial-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Recalculate financial data after cell edit
         * @description Apply an accountant's cell edit and recalculate all derived values.
         *
         *     - Validates the field against the whitelist
         *     - Recalculates GP, OpEx, NOI, margins for the edited period
         *     - Recalculates annual totals for the year
         *     - Creates an immutable audit trail entry
         *     - Returns updated period + annual totals + audit entry
         */
        patch: operations["recalculate_financial_data_api_v1_claims__claim_id__financial_data_patch"];
        trace?: never;
    };
    "/api/v1/deliberation/{report_id}/agent-summaries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get per-agent summaries for a deliberation
         * @description Return pre-computed per-agent statistics for a War Room deliberation.
         *
         *     - Groups events by agent_name
         *     - Per agent: events_count, tools_used, confidence, position_value, key_finding
         *     - Summary: total_events, total_tools_used, disagreements_found, consensus_reached
         *     - Sort: ai:forensic → ai:attorney → ai:adjuster → human:*
         */
        get: operations["get_agent_summaries_api_v1_deliberation__report_id__agent_summaries_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/dashboard/attorney-payload/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Attorney Payload
         * @description Return the full attorney dashboard payload for *user_id*.
         *
         *     Loads all claims owned by (user_id OR org_id), enriches each with
         *     forensic / attorney / settlement / game-theory analyses, then returns
         *     a pre-sorted, pre-formatted portfolio payload.
         */
        get: operations["get_attorney_payload_api_v1_dashboard_attorney_payload__user_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/case-pipeline/{claim_id}/pipeline-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Pipeline Status
         * @description Get full pipeline status for a case.
         *
         *     Loads claim from db.drafts (`_id` is a UUID string).
         *     Loads uploaded_files for the claim.
         *     Builds and returns display-ready pipeline status payload.
         */
        get: operations["get_pipeline_status_api_v1_case_pipeline__claim_id__pipeline_status_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/reconciliation/override/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List overrides + override-applied reconciliation view */
        get: operations["list_overrides_api_v1_reconciliation_override__report_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Record one accountant override on the reconciliation
         * @description Append one override to the draft and emit an audit-chain entry.
         *
         *     Raises 422 on unknown action or malformed target, 404 on
         *     cross-org / missing draft, 403 on empty org.
         */
        patch: operations["record_override_api_v1_reconciliation_override__report_id__patch"];
        trace?: never;
    };
    "/api/v1/adjustments/payroll/{report_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List payroll adjustments for a case */
        get: operations["list_adjustments_api_v1_adjustments_payroll__report_id__get"];
        put?: never;
        /** Record one accountant payroll adjustment */
        post: operations["record_adjustment_api_v1_adjustments_payroll__report_id__post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/adjustments/payroll/{report_id}/{adjustment_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete a payroll adjustment (the default revert path)
         * @description Revert a previously-entered adjustment by filtering it out of
         *     the list. Default #3 says 'deletion (filter out) is sufficient' —
         *     the full override history is preserved by the audit chain, not
         *     by the mutable adjustments array. We emit a separate
         *     ``payroll_adjustment.deleted`` chain entry so the deletion
         *     itself is audit-visible.
         */
        delete: operations["delete_adjustment_api_v1_adjustments_payroll__report_id___adjustment_id__delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/internal/engine-outputs/{report_id}/{engine_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Latest Engine Output
         * @description Most recent run for this (report, engine).
         */
        get: operations["get_latest_engine_output_api_v1_internal_engine_outputs__report_id___engine_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/internal/engine-outputs/{report_id}/run/{run_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Engine Outputs For Run
         * @description All engines that participated in one logical analysis run.
         */
        get: operations["get_engine_outputs_for_run_api_v1_internal_engine_outputs__report_id__run__run_id__get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/internal/engine-outputs/{report_id}/{engine_id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Engine Output History
         * @description Timeline of runs for one engine — newest first.
         */
        get: operations["get_engine_output_history_api_v1_internal_engine_outputs__report_id___engine_id__history_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/waitlist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get Waitlist
         * @description Get all waitlist signups (admin only - add auth later)
         */
        get: operations["get_waitlist_api_waitlist_get"];
        put?: never;
        /**
         * Join Waitlist
         * @description Add a user to the waitlist
         */
        post: operations["join_waitlist_api_waitlist_post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * AIReclassifyRequest
         * @description Request for AI-powered reclassification suggestion
         */
        AIReclassifyRequest: {
            /** Vendor */
            vendor: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Current Category */
            current_category?: string | null;
            /**
             * Event Context
             * @description Event context for classification
             * @default business_interruption
             */
            event_context: string;
        };
        /**
         * AIReclassifyResponse
         * @description Response from AI reclassification
         */
        AIReclassifyResponse: {
            /** Suggested Category */
            suggested_category: string;
            /** Suggested Subcategory */
            suggested_subcategory: string;
            /** Confidence */
            confidence: number;
            /** Rationale */
            rationale: string;
            /** Alternative Categories */
            alternative_categories: {
                [key: string]: unknown;
            }[];
        };
        /**
         * APIKeyCreate
         * @description Request to create API key
         */
        APIKeyCreate: {
            /** Org Id */
            org_id: string;
            /**
             * Name
             * @description Friendly name for the key
             */
            name: string;
            /**
             * Permissions
             * @description Permissions: read:reports, read:pdf, write:reports, manage:shares, admin
             * @default [
             *       "read:reports"
             *     ]
             */
            permissions: string[];
            /**
             * Rate Limit
             * @description Requests per hour
             * @default 1000
             */
            rate_limit: number;
            /**
             * Expires In Days
             * @description Days until expiration
             * @default 365
             */
            expires_in_days: number | null;
        };
        /**
         * APIKeyResponse
         * @description Response with API key info
         */
        APIKeyResponse: {
            /** Id */
            id: string;
            /** Org Id */
            org_id: string;
            /** Name */
            name: string;
            /** Key Prefix */
            key_prefix: string;
            /** Permissions */
            permissions: string[];
            /** Rate Limit */
            rate_limit: number;
            /** Created At */
            created_at: string;
            /** Expires At */
            expires_at: string | null;
            /** Last Used */
            last_used: string | null;
            /** Is Active */
            is_active: boolean;
        };
        /**
         * APIKeyWithSecret
         * @description Response with full API key (only shown once)
         */
        APIKeyWithSecret: {
            /** Id */
            id: string;
            /** Org Id */
            org_id: string;
            /** Name */
            name: string;
            /** Key Prefix */
            key_prefix: string;
            /** Permissions */
            permissions: string[];
            /** Rate Limit */
            rate_limit: number;
            /** Created At */
            created_at: string;
            /** Expires At */
            expires_at: string | null;
            /** Last Used */
            last_used: string | null;
            /** Is Active */
            is_active: boolean;
            /** Api Key */
            api_key: string;
        };
        /**
         * AcceptInviteRequest
         * @description Request to accept an invite
         */
        AcceptInviteRequest: {
            /** Invite Token */
            invite_token: string;
        };
        /**
         * AcceptSuggestionRequest
         * @description Request to accept a pattern suggestion
         */
        AcceptSuggestionRequest: {
            /** Transaction Id */
            transaction_id: string;
            /** Report Id */
            report_id: string;
            /** Suggestion Id */
            suggestion_id?: string | null;
        };
        /**
         * AccountantAuthResponse
         * @description Response after successful authentication
         */
        AccountantAuthResponse: {
            /** Access Token */
            access_token: string;
            /**
             * Token Type
             * @default bearer
             */
            token_type: string;
            accountant: components["schemas"]["ForensicAccountantProfile"];
        };
        /**
         * AccountantCaseResponse
         * @description Response model for a single case in the accountant queue.
         */
        AccountantCaseResponse: {
            /** Id */
            id: string;
            /** Business Name */
            business_name: string;
            /** Client Name */
            client_name?: string | null;
            /** Claimant Name */
            claimant_name?: string | null;
            /** Law Firm */
            law_firm?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Date */
            event_date?: string | null;
            /** Business Type */
            business_type?: string | null;
            /** Assigned Queue */
            assigned_queue: string;
            /** Pipeline Stage */
            pipeline_stage: string;
            /** Workflow Status */
            workflow_status?: string | null;
            /** Queue Reason */
            queue_reason?: string | null;
            /**
             * Is Claimed
             * @default false
             */
            is_claimed: boolean;
            /** Claimed By Id */
            claimed_by_id?: string | null;
            /** Claimed By Name */
            claimed_by_name?: string | null;
            /** Claimed At */
            claimed_at?: string | null;
            /**
             * Signed Off
             * @default false
             */
            signed_off: boolean;
            /** Signed Off At */
            signed_off_at?: string | null;
            /**
             * Is Ready For Review
             * @default false
             */
            is_ready_for_review: boolean;
            /** Readiness Issues */
            readiness_issues?: string[];
            /**
             * Estimated Value
             * @default 0
             */
            estimated_value: number;
            /**
             * Case Strength
             * @default 0
             */
            case_strength: number;
            /**
             * Completion Percentage
             * @default 0
             */
            completion_percentage: number;
            /**
             * Days Stale
             * @default 0
             */
            days_stale: number;
            /**
             * Transactions Need Review
             * @default 0
             */
            transactions_need_review: number;
            /**
             * Anomalies Count
             * @default 0
             */
            anomalies_count: number;
            /** Next Action */
            next_action?: string | null;
            /** Next Action Impact */
            next_action_impact?: string | null;
            /**
             * Pending Classifications
             * @default 0
             */
            pending_classifications: number;
            /** Last Updated */
            last_updated?: string | null;
            /**
             * Primary Action
             * @default View
             */
            primary_action: string;
            /**
             * Primary Action Url
             * @default
             */
            primary_action_url: string;
            /** Wizard Url */
            wizard_url?: string | null;
            /** Reconciliation Url */
            reconciliation_url?: string | null;
            /** Narrator Url */
            narrator_url?: string | null;
            /** Report Url */
            report_url?: string | null;
            /** Documents Url */
            documents_url?: string | null;
            /** Auto Generation Error */
            auto_generation_error?: {
                [key: string]: unknown;
            } | null;
        };
        /** AccountantProfileCreate */
        AccountantProfileCreate: {
            /** Full Name */
            full_name: string;
            /** Cpa License Number */
            cpa_license_number: string;
            /** License State */
            license_state: string;
            /**
             * Additional Licenses
             * @default []
             */
            additional_licenses: components["schemas"]["License"][];
            /**
             * Degrees
             * @default []
             */
            degrees: components["schemas"]["Degree"][];
            /**
             * Certifications
             * @default []
             */
            certifications: string[];
            /** Years In Practice */
            years_in_practice: number;
            /**
             * Specializations
             * @default []
             */
            specializations: string[];
            /**
             * Court Testimony Count
             * @default 0
             */
            court_testimony_count: number;
            /**
             * Professional Memberships
             * @default []
             */
            professional_memberships: string[];
            /**
             * Bio Statement
             * @default
             */
            bio_statement: string | null;
        };
        /** AccountantProfileResponse */
        AccountantProfileResponse: {
            /** Accountant Id */
            accountant_id: string;
            /** Full Name */
            full_name: string;
            /** Credentials */
            credentials: {
                [key: string]: unknown;
            };
            /** Education */
            education: {
                [key: string]: unknown;
            };
            /** Certifications */
            certifications: string[];
            /** Experience */
            experience: {
                [key: string]: unknown;
            };
            /** Professional Memberships */
            professional_memberships: string[];
            /** Bio Statement */
            bio_statement: string;
            /** Profile Completed */
            profile_completed: boolean;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
        };
        /**
         * AccountantQueueListResponse
         * @description Response for accountant queue listing.
         */
        AccountantQueueListResponse: {
            /** Cases */
            cases: components["schemas"]["AccountantCaseResponse"][];
            /** Total Count */
            total_count: number;
            /** Available Count */
            available_count: number;
            /** Claimed By Me Count */
            claimed_by_me_count: number;
            /**
             * Page
             * @default 1
             */
            page: number;
            /**
             * Page Size
             * @default 50
             */
            page_size: number;
            /**
             * Total Pages
             * @default 1
             */
            total_pages: number;
        };
        /**
         * AccountantStatsResponse
         * @description Response for accountant-specific queue statistics.
         * @example {
         *       "available_count": 5,
         *       "my_claims_count": 3,
         *       "ready_count": 2,
         *       "total_portfolio_value": 125000
         *     }
         */
        AccountantStatsResponse: {
            /**
             * Available Count
             * @default 0
             */
            available_count: number;
            /**
             * My Claims Count
             * @default 0
             */
            my_claims_count: number;
            /**
             * Ready Count
             * @default 0
             */
            ready_count: number;
            /**
             * Total Portfolio Value
             * @default 0
             */
            total_portfolio_value: number;
        };
        /**
         * AccuracyDriftPoint
         * @description Accuracy drift data point
         */
        AccuracyDriftPoint: {
            /** Date */
            date: string;
            /** Ai Accuracy */
            ai_accuracy: number;
            /** Human Agreement */
            human_agreement: number;
            /** Sample Size */
            sample_size: number;
        };
        /**
         * ActionItemListResponse
         * @description Response model for list of action items.
         */
        ActionItemListResponse: {
            /** Items */
            items: components["schemas"]["ActionItemResponse"][];
            /** Count */
            count: number;
            /**
             * Total Blocking
             * @default 0
             */
            total_blocking: number;
        };
        /**
         * ActionItemResponse
         * @description Response model for a single action item.
         */
        ActionItemResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Source Agent */
            source_agent: string;
            /** Action Type */
            action_type: string;
            /** Urgency */
            urgency: string;
            /** Is Blocking */
            is_blocking: boolean;
            /** Title */
            title: string;
            /** Description */
            description: string;
            /** Reason */
            reason: string;
            /** Document Type */
            document_type?: string | null;
            /** Document Period */
            document_period?: string | null;
            /** Status */
            status: string;
            /** Created At */
            created_at: string;
            /**
             * Request Count
             * @default 0
             */
            request_count: number;
        };
        /**
         * ActionItemSummaryResponse
         * @description Summary of action items for a report.
         */
        ActionItemSummaryResponse: {
            /** Report Id */
            report_id: string;
            /** Counts By Status */
            counts_by_status: {
                [key: string]: unknown;
            };
            /** Total Blocking */
            total_blocking: number;
            /** Pending Document Requests */
            pending_document_requests: number;
            /** Blocking Items */
            blocking_items: {
                [key: string]: unknown;
            }[];
        };
        /**
         * ActionSummary
         * @description Summary of a roadmap action for list views.
         */
        ActionSummary: {
            /** Id */
            id: string;
            /** Priority */
            priority: number;
            /** Action */
            action: string;
            /** Action Type */
            action_type: string;
            /** Status */
            status: string;
            /** Deadline Days */
            deadline_days: number;
            /** Deadline Date */
            deadline_date?: string | null;
            /**
             * Difficulty
             * @default moderate
             */
            difficulty: string;
            /**
             * Estimated Minutes
             * @default 30
             */
            estimated_minutes: number;
        };
        /** ActivityLogResponse */
        ActivityLogResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** User Id */
            user_id: string;
            /** User Name */
            user_name: string;
            /** User Email */
            user_email: string;
            /** Action Type */
            action_type: string;
            /** Action Details */
            action_details: string | null;
            /** Section */
            section: string | null;
            /** Metadata */
            metadata: {
                [key: string]: unknown;
            };
            /** Ip Address */
            ip_address: string | null;
            /** User Agent */
            user_agent: string | null;
            /** Timestamp */
            timestamp: string;
        };
        /**
         * AddEventRequest
         * @description Add an event to settlement timeline
         */
        AddEventRequest: {
            event_type: components["schemas"]["SettlementEventType"];
            /** Description */
            description: string;
            /** Amount */
            amount?: number | null;
            /**
             * Created By
             * @default system
             */
            created_by: string;
            /** Metadata */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        /** AddTagRequest */
        AddTagRequest: {
            /** Report Id */
            report_id: string;
            /** Tags */
            tags: string[];
        };
        /**
         * AdjusterAnalyzeRequest
         * @description Request to run adjuster analysis
         */
        AdjusterAnalyzeRequest: {
            /**
             * Force Refresh
             * @default false
             */
            force_refresh: boolean;
            /** Options */
            options?: {
                [key: string]: unknown;
            };
        };
        /**
         * AdjusterAnalyzeSummary
         * @description Summary view for dashboard
         */
        AdjusterAnalyzeSummary: {
            /**
             * Supported Total
             * @default 0
             */
            supported_total: number;
            /**
             * Questioned Total
             * @default 0
             */
            questioned_total: number;
            /**
             * Denied Total
             * @default 0
             */
            denied_total: number;
            /** Attorney Comparison */
            attorney_comparison?: {
                [key: string]: unknown;
            };
            /** Top Reduction Factors */
            top_reduction_factors?: string[];
            /** @default MEDIUM */
            confidence_level: components["schemas"]["app__models__adjuster_models__ConfidenceLevel"];
        };
        /**
         * AdjusterComparisonItem
         * @description Item comparison between Adjuster and Attorney
         */
        AdjusterComparisonItem: {
            /** Description */
            description: string;
            /** Attorney Amount */
            attorney_amount: number;
            /** Adjuster Amount */
            adjuster_amount: number;
            /** Variance */
            variance: number;
            /** Adjuster Rationale */
            adjuster_rationale: string;
        };
        /**
         * AdjusterComparisonResult
         * @description Side-by-side comparison result
         */
        AdjusterComparisonResult: {
            /** Report Id */
            report_id: string;
            /** Attorney Position */
            attorney_position: {
                [key: string]: unknown;
            };
            /** Adjuster Position */
            adjuster_position: {
                [key: string]: unknown;
            };
            /** Items */
            items?: components["schemas"]["AdjusterComparisonItem"][];
            /**
             * Total Variance
             * @default 0
             */
            total_variance: number;
            /**
             * Variance Percentage
             * @default 0
             */
            variance_percentage: number;
        };
        /** AgentProgress */
        AgentProgress: {
            /**
             * Current
             * @default 0
             */
            current: number;
            /**
             * Total
             * @default 0
             */
            total: number;
            /**
             * Percentage
             * @default 0
             */
            percentage: number;
        };
        /** AgentResult */
        AgentResult: {
            /** Summary */
            summary: string;
            /** Details */
            details?: {
                [key: string]: unknown;
            } | null;
            /**
             * Itemsneedingreview
             * @default 0
             */
            itemsNeedingReview: number;
        };
        /** AgentStatusResponse */
        AgentStatusResponse: {
            /** Agentid */
            agentId: string;
            /** Agentname */
            agentName: string;
            /** Persona */
            persona: string;
            /** Icon */
            icon: string;
            /** Status */
            status: string;
            progress?: components["schemas"]["AgentProgress"] | null;
            result?: components["schemas"]["AgentResult"] | null;
            /** Startedat */
            startedAt?: string | null;
            /** Completedat */
            completedAt?: string | null;
            /** Nextagent */
            nextAgent?: string | null;
        };
        /**
         * AgentSummariesResponse
         * @description Full response for GET /deliberation/{report_id}/agent-summaries.
         */
        AgentSummariesResponse: {
            /** Report Id */
            report_id: string;
            /** Agents */
            agents: components["schemas"]["AgentSummaryResponse"][];
            summary: components["schemas"]["OverallSummaryResponse"];
        };
        /**
         * AgentSummaryResponse
         * @description Per-agent summary in the response.
         */
        AgentSummaryResponse: {
            /** Agent Name */
            agent_name: string;
            /** Display Name */
            display_name: string;
            /** Events Count */
            events_count: number;
            /** Tools Used */
            tools_used: string[];
            /** Confidence */
            confidence?: number | null;
            /** Position Value */
            position_value?: number | null;
            /** Key Finding */
            key_finding?: string | null;
            /**
             * Resolution Paths Count
             * @default 0
             */
            resolution_paths_count: number;
        };
        /** AnalyzeDocumentRequest */
        AnalyzeDocumentRequest: {
            /** Document Text */
            document_text: string;
            /** Claim Context */
            claim_context: {
                [key: string]: unknown;
            };
        };
        /**
         * AnnotationAuthor
         * @description Author information for an annotation
         */
        AnnotationAuthor: {
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Type */
            type: string;
            /** Firm */
            firm?: string | null;
        };
        /**
         * AnnotationResponse
         * @description Response model for an annotation
         */
        AnnotationResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            target: components["schemas"]["AnnotationTarget"];
            /** Text */
            text: string;
            /** Annotation Type */
            annotation_type: string;
            author: components["schemas"]["AnnotationAuthor"];
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at?: string | null;
            /**
             * Resolved
             * @default false
             */
            resolved: boolean;
            /** Resolved At */
            resolved_at?: string | null;
            /** Resolved By */
            resolved_by?: string | null;
            /** Parent Id */
            parent_id?: string | null;
            /**
             * Reply Count
             * @default 0
             */
            reply_count: number;
            /**
             * Status
             * @default active
             */
            status: string;
        };
        /**
         * AnnotationSummary
         * @description Summary of annotations for a report
         */
        AnnotationSummary: {
            /** Total */
            total: number;
            /** By Type */
            by_type: {
                [key: string]: unknown;
            };
            /** By Section */
            by_section: {
                [key: string]: unknown;
            };
            /** Unresolved */
            unresolved: number;
            /** Latest Activity */
            latest_activity?: string | null;
        };
        /**
         * AnnotationTarget
         * @description Target location for an annotation
         */
        AnnotationTarget: {
            /**
             * Section
             * @description Report section (e.g., 'calculation_detail', 'financial_summary')
             */
            section: string;
            /**
             * Field
             * @description Specific field (e.g., 'variable_margin_pct')
             */
            field?: string | null;
            /**
             * Row Id
             * @description Row identifier for tables
             */
            row_id?: string | null;
            /**
             * Year
             * @description Year if targeting yearly data
             */
            year?: string | null;
            /**
             * Month
             * @description Month if targeting monthly data
             */
            month?: number | null;
            /**
             * Value
             * @description The value being annotated (for reference)
             */
            value?: string | null;
        };
        /**
         * AnomalousClusterItem
         * @description Anomalous transaction cluster
         */
        AnomalousClusterItem: {
            /** Cluster Id */
            cluster_id: number;
            /** Entities */
            entities: string[];
            /** Entity Count */
            entity_count: number;
            /** Internal Transactions */
            internal_transactions: number;
            /** Internal Volume */
            internal_volume: number;
            /** External Transactions */
            external_transactions: number;
            /** Density */
            density: number;
            /** Insularity Score */
            insularity_score: number;
            /** Risk Level */
            risk_level: string;
            /** Explanation */
            explanation: string;
        };
        /**
         * AnomalyDetection
         * @description Request model for anomaly detection
         */
        AnomalyDetection: {
            /** Financial Data */
            financial_data: {
                [key: string]: unknown;
            };
        };
        /**
         * AnomalyResponse
         * @description Single anomaly response
         */
        AnomalyResponse: {
            /** Id */
            id: string;
            /** Job Id */
            job_id: string;
            /** Anomaly Type */
            anomaly_type: string;
            /** Severity */
            severity: string;
            /** Title */
            title: string;
            /** Description */
            description: string;
            /** Explanation */
            explanation: string;
            /**
             * Affected Transactions
             * @default []
             */
            affected_transactions: string[];
            /** Transaction Id */
            transaction_id?: string | null;
            /** Affected Period */
            affected_period?: string | null;
            /** Affected Category */
            affected_category?: string | null;
            /** Affected Vendor */
            affected_vendor?: string | null;
            /** Expected Value */
            expected_value?: number | null;
            /** Actual Value */
            actual_value?: number | null;
            /** Related Amount */
            related_amount?: number | null;
            /** Deviation Percent */
            deviation_percent?: number | null;
            /**
             * Is Resolved
             * @default false
             */
            is_resolved: boolean;
            /** Resolution Note */
            resolution_note?: string | null;
            /** Resolved By */
            resolved_by?: string | null;
            /** Resolved At */
            resolved_at?: string | null;
            /** Created At */
            created_at: string;
        };
        /** AnomalyResult */
        AnomalyResult: {
            /** Transaction Index */
            transaction_index: number;
            /** Anomaly Type */
            anomaly_type: string;
            /** Severity */
            severity: string;
            /** Reason */
            reason: string;
            /** Recommendation */
            recommendation: string;
        };
        /**
         * AnomalySummaryResponse
         * @description Anomaly summary for a job
         */
        AnomalySummaryResponse: {
            /** Total Anomalies */
            total_anomalies: number;
            /** By Severity */
            by_severity: {
                [key: string]: number;
            };
            /** By Type */
            by_type: {
                [key: string]: number;
            };
            /** Critical Count */
            critical_count: number;
            /** High Count */
            high_count: number;
            /** Resolved Count */
            resolved_count: number;
            /** Unresolved Count */
            unresolved_count: number;
        };
        /**
         * AnomalyTypeInfo
         * @description Information about an anomaly type
         */
        AnomalyTypeInfo: {
            /** Type */
            type: string;
            /** Name */
            name: string;
            /** Description */
            description: string;
            /** Default Severity */
            default_severity: string;
        };
        /**
         * ApplyMultiYearRequest
         * @description Request to apply template estimates to P&L data with multi-year support
         */
        ApplyMultiYearRequest: {
            /** Yearly Revenues */
            yearly_revenues: {
                [key: string]: unknown;
            };
            /** Coverage Year */
            coverage_year: number;
        };
        /**
         * ApplyPredictionsRequest
         * @description Request to apply predictions to current data
         */
        ApplyPredictionsRequest: {
            /** Current Data */
            current_data: {
                [key: string]: unknown;
            };
            /** Predictions */
            predictions: {
                [key: string]: unknown;
            };
            /**
             * Override Existing
             * @default false
             */
            override_existing: boolean;
        };
        /**
         * ApplyTemplateRequest
         * @description Request to apply template estimates to P&L data
         */
        ApplyTemplateRequest: {
            /** Annual Revenue */
            annual_revenue: number;
            /** Coverage Year */
            coverage_year?: number | null;
            /** Yearly Revenues */
            yearly_revenues?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * ApplyWinnerRequest
         * @description Request to apply a winning variant
         */
        ApplyWinnerRequest: {
            /**
             * Email Type
             * @default evidence_request
             */
            email_type: string;
            /**
             * Test Key
             * @description subject_line or cta_button
             */
            test_key: string;
            /**
             * Variant Id
             * @description A, B, or C
             */
            variant_id: string;
        };
        /** ApproveEngineRequest */
        ApproveEngineRequest: {
            /** Note */
            note?: string | null;
            /**
             * Acknowledges Verifier Warnings
             * @default false
             */
            acknowledges_verifier_warnings: boolean;
        };
        /**
         * ApproveIssueRequest
         * @description Request to approve an issue for client notification
         */
        ApproveIssueRequest: {
            /** Request Text */
            request_text: string;
        };
        /**
         * ApproveSuggestionRequest
         * @description Request model for approving AI suggestions
         */
        ApproveSuggestionRequest: {
            /** Audit Id */
            audit_id: string;
            /** Approved */
            approved: boolean;
        };
        /**
         * AskQuestionRequest
         * @description Request to ask a question.
         */
        AskQuestionRequest: {
            /** Question */
            question: string;
            /** Report Id */
            report_id: string;
            /**
             * Conversation History
             * @default []
             */
            conversation_history: components["schemas"]["ChatMessage"][] | null;
        };
        /**
         * AskQuestionResponse
         * @description Response from asking a question.
         */
        AskQuestionResponse: {
            /** Answer */
            answer: string;
            /** Confidence */
            confidence: number;
            /** Sources */
            sources: string[];
            /** Follow Up Suggestions */
            follow_up_suggestions: string[];
            /** Model */
            model?: string | null;
            /** Tokens Used */
            tokens_used?: number | null;
        };
        /**
         * AttorneyAnalysisResponse
         * @description Response from attorney analysis
         */
        AttorneyAnalysisResponse: {
            /** Success */
            success: boolean;
            /** Analysis Id */
            analysis_id?: string | null;
            /** Analyzed At */
            analyzed_at?: string | null;
            /**
             * Cached
             * @default false
             */
            cached: boolean;
            /** Claim Amount */
            claim_amount?: number | null;
            /** Potential Claim */
            potential_claim?: number | null;
            /** Additional Recovery */
            additional_recovery?: number | null;
            /** Executive Summary */
            executive_summary?: string | null;
            /** Case Strength */
            case_strength?: string | null;
            /** Settlement Probability */
            settlement_probability?: string | null;
            /** Unclaimed Losses */
            unclaimed_losses?: {
                [key: string]: unknown;
            }[] | null;
            /** Total Unclaimed */
            total_unclaimed?: number | null;
            /** Vulnerabilities */
            vulnerabilities?: {
                [key: string]: unknown;
            }[] | null;
            /** Total Risk */
            total_risk?: number | null;
            /** Settlement Strategy */
            settlement_strategy?: {
                [key: string]: unknown;
            } | null;
            /** Client Actions */
            client_actions?: {
                [key: string]: unknown;
            } | null;
            /** Recommendations */
            recommendations?: string[] | null;
            /** Error */
            error?: string | null;
        };
        /** AttorneyAuthResponse */
        AttorneyAuthResponse: {
            /** Access Token */
            access_token: string;
            /**
             * Token Type
             * @default bearer
             */
            token_type: string;
            attorney: components["schemas"]["AttorneyProfile"];
        };
        /**
         * AttorneyClientsResponse
         * @description Response for GET /api/v1/attorney/clients.
         */
        AttorneyClientsResponse: {
            /** Clients */
            clients: components["schemas"]["SubmittedClientItem"][];
            /** Total */
            total: number;
        };
        /**
         * AttorneyDashboardResponse
         * @description Response for GET /api/v1/attorney/dashboard.
         *
         *     Phase 09 retrofit FU1 — Layer 1 typed response. Renaming any field
         *     here breaks frontend tsc via the openapi-typescript pipeline.
         */
        AttorneyDashboardResponse: {
            /** Cases */
            cases: components["schemas"]["ReleasedCaseListItem"][];
            /** Total */
            total: number;
            /** Law Firm */
            law_firm: string;
        };
        /** AttorneyLogin */
        AttorneyLogin: {
            /** Email */
            email: string;
            /** Password */
            password: string;
        };
        /**
         * AttorneyOverlay
         * @description Attorney work product paired with an attested calculation run.
         *
         *     Versioning: one overlay per (report_id, version). Version 1 is
         *     created the first time the attorney saves anything. A new version
         *     is auto-created via `create_version_from_previous` whenever a
         *     re-attestation produces a new `attested_calc_run_id` — the prior
         *     version is frozen but preserved.
         */
        AttorneyOverlay: {
            /** Id */
            _id: string;
            /** Report Id */
            report_id: string;
            /** Version */
            version: number;
            /** Attested Calc Ref */
            attested_calc_ref: string;
            /** Attorney Id */
            attorney_id: string;
            /** Attorney Name */
            attorney_name: string;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at: string;
            /** @default draft */
            status: components["schemas"]["OverlayStatus"];
            /** Content Blocks */
            content_blocks?: components["schemas"]["ContentBlock"][];
        };
        /** AttorneyProfile */
        AttorneyProfile: {
            /** Id */
            id: string;
            /** Email */
            email: string;
            /** Name */
            name: string;
            /** Law Firm Id */
            law_firm_id: string;
            /** Law Firm Name */
            law_firm_name: string;
            /** Phone */
            phone?: string | null;
            /** Last Login */
            last_login?: string | null;
        };
        /**
         * AuditChange
         * @description Single field change record
         */
        AuditChange: {
            /** Field */
            field: string;
            /** Original */
            original: unknown;
            /** Updated */
            updated: unknown;
            /** Original Source */
            original_source?: string | null;
        };
        /** AutoCategorizeRequest */
        AutoCategorizeRequest: {
            /** Report Data */
            report_data: {
                [key: string]: unknown;
            };
        };
        /** AutoTagReportRequest */
        AutoTagReportRequest: {
            /** Report Id */
            report_id: string;
        };
        /**
         * AvailableBenchmarkResponse
         * @description Available benchmark information
         */
        AvailableBenchmarkResponse: {
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Description */
            description: string;
            /** Min Sample Size */
            min_sample_size: number;
            /** Parameters */
            parameters: string[];
        };
        /**
         * AvailableIndustry
         * @description Available industry for benchmarking
         */
        AvailableIndustry: {
            /** Naics Code */
            naics_code: string;
            /** Industry Name */
            industry_name: string;
        };
        /** BICategoryResponse */
        BICategoryResponse: {
            /** Id */
            id: number;
            /** Name */
            name: string;
            /** Cost Type */
            cost_type: string;
            /** Cost Type Label */
            cost_type_label: string;
            /** Description */
            description: string;
        };
        /** BIMappingRequest */
        BIMappingRequest: {
            /** Categories */
            categories: string[];
        };
        /** BIMappingResult */
        BIMappingResult: {
            /** Bi Id */
            bi_id: number;
            /** Bi Category */
            bi_category: string;
            /** Cost Type */
            cost_type: string;
            /** Cost Type Label */
            cost_type_label: string;
            /** Confidence */
            confidence: number;
            /** Match Method */
            match_method: string;
            /** Original Category */
            original_category: string;
            /** Needs Review */
            needs_review: boolean;
        };
        /** BackfillResponse */
        BackfillResponse: {
            /** Status */
            status: string;
            /**
             * Ingested
             * @default 0
             */
            ingested: number;
            /**
             * Skipped
             * @default 0
             */
            skipped: number;
            /**
             * Total Processed
             * @default 0
             */
            total_processed: number;
            /** Error */
            error?: string | null;
        };
        /**
         * BadFaithAnalysisRequest
         * @description Request for bad faith analysis
         */
        BadFaithAnalysisRequest: {
            /**
             * State
             * @description State code (e.g., CA, TX, FL)
             */
            state: string;
            /**
             * Claim Amount
             * @description Total claim amount
             */
            claim_amount: number;
            /**
             * Claim Events
             * @description List of claim events with dates
             */
            claim_events: components["schemas"]["ClaimEvent"][];
        };
        /**
         * BatchClassificationResponse
         * @description Response for batch classification
         */
        BatchClassificationResponse: {
            /** Transactions */
            transactions: components["schemas"]["ClassificationResult"][];
            /** Summary */
            summary: {
                [key: string]: unknown;
            };
        };
        /** BatchExpenseInput */
        BatchExpenseInput: {
            /** Expenses */
            expenses: string[];
            /**
             * Threshold
             * @default 65
             */
            threshold: number | null;
        };
        /**
         * BatchForensicRequest
         * @description Request to batch-analyze anomalies with forensic AI
         */
        BatchForensicRequest: {
            /** Draft Id */
            draft_id: string;
            /** Anomaly Ids */
            anomaly_ids: string[];
            /**
             * Force Refresh
             * @default false
             */
            force_refresh: boolean;
        };
        /**
         * BatchProcessRequest
         * @description Request to process multiple documents
         */
        BatchProcessRequest: {
            /** S3 Keys */
            s3_keys: string[];
            /** Report Id */
            report_id?: string | null;
            /** Org Id */
            org_id?: string | null;
            /**
             * Create New Report
             * @default false
             */
            create_new_report: boolean;
            /**
             * Report Title Prefix
             * @default Batch Processed
             */
            report_title_prefix: string;
        };
        /**
         * BatchQuestionRequest
         * @description Request to generate batch questions for similar transactions.
         */
        BatchQuestionRequest: {
            /** Claim Id */
            claim_id: string;
            /**
             * Min Transactions Per Group
             * @default 2
             */
            min_transactions_per_group: number;
            /**
             * Max Groups
             * @default 10
             */
            max_groups: number;
        };
        /**
         * BatchQueueUpdateRequest
         * @description Request model for batch queue updates.
         */
        BatchQueueUpdateRequest: {
            /** Case Ids */
            case_ids: string[];
        };
        /**
         * BatchQueueUpdateResponse
         * @description Response model for batch queue updates.
         */
        BatchQueueUpdateResponse: {
            /** Updated */
            updated: number;
            /** Results */
            results: {
                [key: string]: unknown;
            }[];
        };
        /**
         * BatchReclassificationRequest
         * @description Request to reclassify multiple transactions at once
         */
        BatchReclassificationRequest: {
            /**
             * Transaction Ids
             * @description List of transaction IDs to reclassify
             */
            transaction_ids: string[];
            /**
             * New Category
             * @description New category for all transactions
             */
            new_category: string;
            /**
             * New Subcategory
             * @description New subcategory
             */
            new_subcategory?: string | null;
            /**
             * Reason
             * @description Reason for batch reclassification
             */
            reason: string;
        };
        /**
         * BatesExhibitRequest
         * @description Body for POST /export-exhibit-package/{report_id}.
         */
        BatesExhibitRequest: {
            /**
             * Bates Prefix
             * @description Prefix stamped before every Bates number.
             * @default CLM-
             */
            bates_prefix: string;
            /**
             * Bates Start
             * @description First Bates number. Page-1 of the first PDF becomes {prefix}{bates_start:06d}.
             * @default 1
             */
            bates_start: number;
            /**
             * Include Workpaper
             * @description When true (default), bundle the reconciliation workpaper XLSX into the ZIP. Disable if the accountant is shipping only the source exhibits.
             * @default true
             */
            include_workpaper: boolean;
        };
        /**
         * BenchmarkQueryRequest
         * @description Request for Tier 2 benchmark query
         */
        BenchmarkQueryRequest: {
            /**
             * Parameters
             * @description Filter parameters (business_type, event_type)
             */
            parameters?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * BenchmarkQueryResponse
         * @description Response for Tier 2 benchmark query
         */
        BenchmarkQueryResponse: {
            /** Success */
            success: boolean;
            /** Benchmark Id */
            benchmark_id: string;
            /** Data */
            data: {
                [key: string]: unknown;
            };
            /** Sample Size */
            sample_size: string;
            /** Query Time Ms */
            query_time_ms: number;
            /** Error */
            error?: string | null;
            /**
             * Insufficient Data
             * @default false
             */
            insufficient_data: boolean;
        };
        /**
         * BenchmarkSummary
         * @description Summary of benchmark comparison.
         */
        BenchmarkSummary: {
            /** Total Metrics */
            total_metrics: number;
            /** Favorable Count */
            favorable_count: number;
            /** Normal Count */
            normal_count: number;
            /** High Deviation Count */
            high_deviation_count: number;
            /** Health Score */
            health_score: number;
            /** Overall Assessment */
            overall_assessment: string;
        };
        /**
         * BlockAnchor
         * @description Where an annotation block attaches to the attested calculation.
         *
         *     Only used for `block_type == "annotation"`. Other block types render
         *     in the overlay's own section per `position` ordering.
         */
        BlockAnchor: {
            /** Engine Id */
            engine_id?: string | null;
            /** Field Id */
            field_id?: string | null;
        };
        /** BlockAnchorIn */
        BlockAnchorIn: {
            /** Engine Id */
            engine_id?: string | null;
            /** Field Id */
            field_id?: string | null;
        };
        /**
         * BlockType
         * @enum {string}
         */
        BlockType: BlockType;
        /**
         * BlockVisibility
         * @enum {string}
         */
        BlockVisibility: BlockVisibility;
        /** Body_batch_upload_api_v1_extraction_upload_batch_post */
        Body_batch_upload_api_v1_extraction_upload_batch_post: {
            /** Files */
            files: string[];
            /**
             * Skip Cache
             * @default false
             */
            skip_cache: boolean;
        };
        /** Body_bulk_update_transaction_flags_api_v1_reconciliation_transactions__report_id__bulk_flag_post */
        Body_bulk_update_transaction_flags_api_v1_reconciliation_transactions__report_id__bulk_flag_post: {
            /**
             * Transaction Ids
             * @description List of transaction IDs to update
             */
            transaction_ids: string[];
            /**
             * Checked
             * @description Set checked status
             */
            checked?: boolean | null;
            /**
             * Flagged
             * @description Set flagged status
             */
            flagged?: boolean | null;
        };
        /** Body_bulk_upload_documents_api_v1_documents_bulk_upload_post */
        Body_bulk_upload_documents_api_v1_documents_bulk_upload_post: {
            /** Files */
            files: string[];
        };
        /** Body_check_document_messiness_api_v1_cleanup_check_messiness_post */
        Body_check_document_messiness_api_v1_cleanup_check_messiness_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_classify_document_api_v1_document_pipeline_classify_post */
        Body_classify_document_api_v1_document_pipeline_classify_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /**
             * User Hint
             * @description User-selected document type
             */
            user_hint?: string | null;
            /**
             * Business Type
             * @description Business entity type
             */
            business_type?: string | null;
        };
        /** Body_compare_pl_data_to_benchmark_api_v1_pl_benchmark_compare_data_post */
        Body_compare_pl_data_to_benchmark_api_v1_pl_benchmark_compare_data_post: {
            /**
             * Parsed Pl
             * @description Parsed P&L statement data
             */
            parsed_pl: {
                [key: string]: unknown;
            };
            /**
             * Business Type
             * @description Business type for benchmark selection
             */
            business_type?: string | null;
        };
        /** Body_detect_zero_payroll_api_v1_edge_cases_detect_zero_payroll_post */
        Body_detect_zero_payroll_api_v1_edge_cases_detect_zero_payroll_post: {
            /** Monthly Data */
            monthly_data: {
                [key: string]: unknown;
            }[];
            /** Historical Claims */
            historical_claims?: {
                [key: string]: unknown;
            }[] | null;
        };
        /** Body_extract_pdf_api_v1_ai_extract_pdf_post */
        Body_extract_pdf_api_v1_ai_extract_pdf_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_extract_text_from_file_api_v1_documents_extract_text_post */
        Body_extract_text_from_file_api_v1_documents_extract_text_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_flag_transaction_for_clarification_api_v1_clarifications_flag_transaction_post */
        Body_flag_transaction_for_clarification_api_v1_clarifications_flag_transaction_post: {
            /** Report Id */
            report_id: string;
            /** Transaction Id */
            transaction_id: string;
            /** Date */
            date: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Question */
            question: string;
            /** Options */
            options?: string[] | null;
        };
        /** Body_get_upcoming_deadlines_api_v1_attorney_tools_bad_faith_upcoming_deadlines_post */
        Body_get_upcoming_deadlines_api_v1_attorney_tools_bad_faith_upcoming_deadlines_post: {
            /** State */
            state: string;
            /** Claim Filed Date */
            claim_filed_date: string;
            /**
             * Events Completed
             * @default []
             */
            events_completed: string[];
        };
        /** Body_infer_schema_api_v1_extraction_infer_schema_post */
        Body_infer_schema_api_v1_extraction_infer_schema_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_1065_api_v1_tax_parse_1065_post */
        Body_parse_1065_api_v1_tax_parse_1065_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_1065_demo_api_v1_tax_parse_1065_demo_post */
        Body_parse_1065_demo_api_v1_tax_parse_1065_demo_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_bank_statement_api_v1_financial_docs_parse_bank_statement_post */
        Body_parse_bank_statement_api_v1_financial_docs_parse_bank_statement_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_bank_statement_demo_api_v1_financial_docs_parse_bank_statement_demo_post */
        Body_parse_bank_statement_demo_api_v1_financial_docs_parse_bank_statement_demo_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_excel_spreadsheet_api_v1_financial_docs_parse_excel_post */
        Body_parse_excel_spreadsheet_api_v1_financial_docs_parse_excel_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_form_1065_api_v1_financial_docs_parse_1065_post */
        Body_parse_form_1065_api_v1_financial_docs_parse_1065_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_form_1065_demo_api_v1_financial_docs_parse_1065_demo_post */
        Body_parse_form_1065_demo_api_v1_financial_docs_parse_1065_demo_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_pl_document_api_v1_document_pipeline_parse_pl_post */
        Body_parse_pl_document_api_v1_document_pipeline_parse_pl_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /**
             * Business Name
             * @description Business name
             */
            business_name?: string | null;
            /**
             * Fiscal Year
             * @description Fiscal year end month
             */
            fiscal_year?: string | null;
            /**
             * Accounting Method
             * @description Cash or accrual
             */
            accounting_method?: string | null;
        };
        /** Body_parse_profit_loss_api_v1_financial_docs_parse_profit_loss_post */
        Body_parse_profit_loss_api_v1_financial_docs_parse_profit_loss_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_parse_profit_loss_demo_api_v1_financial_docs_parse_profit_loss_demo_post */
        Body_parse_profit_loss_demo_api_v1_financial_docs_parse_profit_loss_demo_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_process_single_document_api_v1_documents_process_single_post */
        Body_process_single_document_api_v1_documents_process_single_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_speech_to_text_api_v1_assistant_voice_transcribe_post */
        Body_speech_to_text_api_v1_assistant_voice_transcribe_post: {
            /**
             * Audio
             * Format: binary
             */
            audio: string;
            /** Language */
            language?: string | null;
            /** Prompt */
            prompt?: string | null;
        };
        /** Body_start_streaming_upload_api_v1_upload_stream_post */
        Body_start_streaming_upload_api_v1_upload_stream_post: {
            /**
             * Files
             * @description Files to process
             */
            files: string[];
            /**
             * Metadata
             * @description JSON metadata
             * @default {}
             */
            metadata: string;
            /**
             * Report Id
             * @description Draft/Report ID to link files to
             */
            report_id?: string;
            /**
             * Claim Id
             * @description Claim ID (alias for report_id)
             */
            claim_id?: string;
        };
        /** Body_three_way_reconciliation_api_v1_financial_docs_three_way_reconciliation_post */
        Body_three_way_reconciliation_api_v1_financial_docs_three_way_reconciliation_post: {
            /**
             * Form 1065 File
             * Format: binary
             */
            form_1065_file: string;
            /**
             * Bank Statement File
             * Format: binary
             */
            bank_statement_file: string;
            /**
             * Pl Statement File
             * Format: binary
             */
            pl_statement_file: string;
        };
        /** Body_three_way_reconciliation_demo_api_v1_financial_docs_three_way_reconciliation_demo_post */
        Body_three_way_reconciliation_demo_api_v1_financial_docs_three_way_reconciliation_demo_post: {
            /**
             * Form 1065 File
             * Format: binary
             */
            form_1065_file: string;
            /**
             * Bank Statement File
             * Format: binary
             */
            bank_statement_file: string;
            /**
             * Pl Statement File
             * Format: binary
             */
            pl_statement_file: string;
        };
        /** Body_unified_batch_upload_api_v1_upload_savefirst_unified_batch_post */
        Body_unified_batch_upload_api_v1_upload_savefirst_unified_batch_post: {
            /** Files */
            files: string[];
            /** Claim Id */
            claim_id?: string | null;
            /** Draft Id */
            draft_id?: string | null;
            /**
             * Uploader Type
             * @default specialist
             */
            uploader_type: string;
            /** Uploader Id */
            uploader_id?: string | null;
            /** Client Name */
            client_name?: string | null;
            /** Org Id */
            org_id?: string | null;
            /** Case Id */
            case_id?: string | null;
            /** Doc Type */
            doc_type?: string | null;
        };
        /** Body_unified_upload_api_v1_upload_savefirst_unified_post */
        Body_unified_upload_api_v1_upload_savefirst_unified_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /** Claim Id */
            claim_id?: string | null;
            /** Draft Id */
            draft_id?: string | null;
            /**
             * Uploader Type
             * @default specialist
             */
            uploader_type: string;
            /** Uploader Id */
            uploader_id?: string | null;
            /** Client Name */
            client_name?: string | null;
            /** Org Id */
            org_id?: string | null;
            /** Case Id */
            case_id?: string | null;
            /** Doc Type */
            doc_type?: string | null;
            /** Evidence Item Id */
            evidence_item_id?: string | null;
        };
        /** Body_upload_and_extract_api_v1_extraction_upload_post */
        Body_upload_and_extract_api_v1_extraction_upload_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /**
             * Skip Cache
             * @default false
             */
            skip_cache: boolean;
            /** Force Tier */
            force_tier?: string | null;
        };
        /** Body_upload_chart_image_api_v1_chart_upload_upload_post */
        Body_upload_chart_image_api_v1_chart_upload_upload_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /** Report Id */
            report_id: string;
            /** Chart Name */
            chart_name: string;
        };
        /** Body_upload_claim_documents_api_v1_upload_claim_documents_post */
        Body_upload_claim_documents_api_v1_upload_claim_documents_post: {
            /**
             * Files
             * @description Files to process (CSV, Excel, PDF)
             */
            files: string[];
            /**
             * Metadata
             * @description JSON metadata for the claim
             * @default {}
             */
            metadata: string;
        };
        /** Body_upload_cleanup_documents_api_v1_cleanup_upload_post */
        Body_upload_cleanup_documents_api_v1_cleanup_upload_post: {
            /** Files */
            files: string[];
            /**
             * Report Id
             * @description Link to existing report
             */
            report_id?: string | null;
        };
        /** Body_upload_document_public_api_v1_notifications_upload_document__report_id__post */
        Body_upload_document_public_api_v1_notifications_upload_document__report_id__post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /**
             * Doc Type
             * @default unknown
             */
            doc_type: string;
        };
        /** Body_upload_with_postprocessing_api_v1_extraction_upload_with_postprocessing_post */
        Body_upload_with_postprocessing_api_v1_extraction_upload_with_postprocessing_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
            /**
             * Normalize Dates
             * @default true
             */
            normalize_dates: boolean;
            /**
             * Normalize Currency
             * @default true
             */
            normalize_currency: boolean;
            /**
             * Detect Duplicates
             * @default false
             */
            detect_duplicates: boolean;
            /**
             * Score Quality
             * @default true
             */
            score_quality: boolean;
            /**
             * Skip Cache
             * @default false
             */
            skip_cache: boolean;
        };
        /** Body_upload_zip_batch_api_v1_documents_upload_zip_post */
        Body_upload_zip_batch_api_v1_documents_upload_zip_post: {
            /**
             * File
             * Format: binary
             */
            file: string;
        };
        /** Body_voice_chat_api_v1_assistant_voice_chat_post */
        Body_voice_chat_api_v1_assistant_voice_chat_post: {
            /**
             * Audio
             * Format: binary
             */
            audio: string;
            /** Claim Id */
            claim_id: string;
            /** Current Step */
            current_step?: number | null;
            /** Session Id */
            session_id?: string | null;
            /**
             * Response Voice
             * @default nova
             */
            response_voice: string;
            /** Language */
            language?: string | null;
        };
        /**
         * BoostQueryRequest
         * @description Request for classification boost
         */
        BoostQueryRequest: {
            /** Payee */
            payee: string;
            /** Description */
            description: string;
            /** Ai Category */
            ai_category: string;
            /** Ai Confidence */
            ai_confidence: number;
        };
        /**
         * BrandingConfig
         * @description Complete branding configuration
         */
        BrandingConfig: {
            /** Company Name */
            company_name: string;
            /** Company Tagline */
            company_tagline?: string | null;
            /** Logo Url */
            logo_url?: string | null;
            /** Logo Dark Url */
            logo_dark_url?: string | null;
            /** Favicon Url */
            favicon_url?: string | null;
            colors?: components["schemas"]["ColorScheme"];
            pdf?: components["schemas"]["PDFBranding"];
            ui?: components["schemas"]["UIBranding"];
            /** Contact Email */
            contact_email?: string | null;
            /** Contact Phone */
            contact_phone?: string | null;
            /** Website Url */
            website_url?: string | null;
            /** Address */
            address?: string | null;
        };
        /**
         * BrandingResponse
         * @description Response with branding data
         */
        BrandingResponse: {
            /** Id */
            id: string;
            /** Org Id */
            org_id: string;
            config: components["schemas"]["BrandingConfig"];
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
            /** Is Active */
            is_active: boolean;
        };
        /**
         * BuildStrategyRequest
         * @description Request for custom strategy builder
         * @example {
         *       "base_settlement": 500000,
         *       "modification_ids": [
         *         "better_documentation_detailed_p&l_analysis",
         *         "expert_witness_forensic_accountant_report"
         *       ]
         *     }
         */
        BuildStrategyRequest: {
            /** Base Settlement */
            base_settlement: number;
            /** Modification Ids */
            modification_ids: string[];
        };
        /**
         * BulkApprovalItem
         * @description Single item for bulk approval.
         */
        BulkApprovalItem: {
            /** Response Id */
            response_id: string;
            /**
             * Approved
             * @default true
             */
            approved: boolean;
            /** Corrected Category */
            corrected_category?: string | null;
        };
        /**
         * BulkApprovalRequest
         * @description Request body for bulk approval of client clarifications.
         */
        BulkApprovalRequest: {
            /** Items */
            items: components["schemas"]["BulkApprovalItem"][];
            /**
             * Apply To Draft
             * @default true
             */
            apply_to_draft: boolean;
        };
        /** BulkDeleteRequest */
        BulkDeleteRequest: {
            /** Job Ids */
            job_ids: string[];
        };
        /**
         * BulkImportClient
         * @description Client data for bulk import
         */
        BulkImportClient: {
            /** Claimant Name */
            claimant_name: string;
            /** Claimant Email */
            claimant_email?: string | null;
            /** Claimant Phone */
            claimant_phone?: string | null;
            /** Business Name */
            business_name?: string | null;
            /** Business Address */
            business_address?: string | null;
            /** Event */
            event?: string | null;
            /** Event Date */
            event_date?: string | null;
        };
        /** BulkImportRequest */
        BulkImportRequest: {
            /** Clients */
            clients: components["schemas"]["BulkImportClient"][];
        };
        /**
         * BulkRecategorizeRequest
         * @description Request to recategorize multiple transactions.
         */
        BulkRecategorizeRequest: {
            /** Claim Id */
            claim_id: string;
            /** Transactions */
            transactions: components["schemas"]["TransactionRecategorizationItem"][];
            /**
             * Apply Immediately
             * @default false
             */
            apply_immediately: boolean;
        };
        /**
         * BulkReminderResponse
         * @description Response for bulk reminder operation.
         */
        BulkReminderResponse: {
            /** Total Checked */
            total_checked: number;
            /** Emails Sent */
            emails_sent: number;
            /** Emails Skipped */
            emails_skipped: number;
            /** Errors */
            errors: string[];
        };
        /**
         * BulkReviewRequest
         * @description Bulk review multiple transactions
         */
        BulkReviewRequest: {
            /** Transaction Ids */
            transaction_ids: string[];
            /** Action */
            action: string;
            /** New Category */
            new_category?: string | null;
            /** Note */
            note?: string | null;
        };
        /** BulkUploadResponse */
        BulkUploadResponse: {
            /** Upload Id */
            upload_id: string;
            /** Total Files */
            total_files: number;
            /** Successful */
            successful: number;
            /** Failed */
            failed: number;
            /** By Type */
            by_type: {
                [key: string]: unknown;
            };
            /** Documents */
            documents: components["schemas"]["DocumentResult"][];
            /** Organized Data */
            organized_data: {
                [key: string]: unknown;
            };
        };
        /** CacheStatsResponse */
        CacheStatsResponse: {
            /** Hits */
            hits: number;
            /** Misses */
            misses: number;
            /** Hit Rate */
            hit_rate: number;
            /** Stores */
            stores: number;
            /** Evictions */
            evictions: number;
            /** Memory Entries */
            memory_entries: number;
        };
        /**
         * CanonicalAnomaly
         * @description Anomaly detected in canonical data
         */
        CanonicalAnomaly: {
            /** Id */
            id: string;
            /** Anomaly Type */
            anomaly_type: string;
            /** Severity */
            severity: string;
            /** Title */
            title: string;
            /** Description */
            description: string;
            /** Explanation */
            explanation: string;
            /** Affected Period */
            affected_period?: string | null;
            /** Affected Vendor */
            affected_vendor?: string | null;
            /** Related Amount */
            related_amount?: number | null;
            /** Deviation Percent */
            deviation_percent?: number | null;
            /** Transaction Id */
            transaction_id?: string | null;
            /** Transaction Ids */
            transaction_ids?: string[] | null;
            /**
             * Is Resolved
             * @default false
             */
            is_resolved: boolean;
            /** Resolution Reason */
            resolution_reason?: string | null;
            /** Resolution Note */
            resolution_note?: string | null;
            /** Resolved At */
            resolved_at?: string | null;
            /** Ai Analysis */
            ai_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Likely False Positive */
            likely_false_positive?: boolean | null;
            /** Ai Recommendation */
            ai_recommendation?: string | null;
            /** Forensic Insight */
            forensic_insight?: string | null;
            /** Forensic Analysis */
            forensic_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Categories */
            categories?: {
                [key: string]: unknown;
            }[] | null;
            /** Transactions */
            transactions?: {
                [key: string]: unknown;
            }[] | null;
            /** Prev Period Revenue */
            prev_period_revenue?: number | null;
            /** Curr Period Revenue */
            curr_period_revenue?: number | null;
        };
        /**
         * CanonicalAnomalyRequest
         * @description Request format for canonical_data from UnifiedUploader
         */
        CanonicalAnomalyRequest: {
            /** Periods */
            periods: {
                [key: string]: unknown;
            }[];
            /**
             * Business Type
             * @default general
             */
            business_type: string | null;
            /** Business Context */
            business_context?: {
                [key: string]: unknown;
            } | null;
            /** Resolved Anomalies */
            resolved_anomalies?: {
                [key: string]: unknown;
            }[] | null;
            /**
             * Enable Ai Analysis
             * @default false
             */
            enable_ai_analysis: boolean;
            /** Draft Id */
            draft_id?: string | null;
        };
        /** CanonicalAnomalyResponse */
        CanonicalAnomalyResponse: {
            /** Success */
            success: boolean;
            /** Anomalies */
            anomalies: components["schemas"]["CanonicalAnomaly"][];
            /** Summary */
            summary: {
                [key: string]: number;
            };
            /** Thresholds Used */
            thresholds_used?: {
                [key: string]: number;
            } | null;
            /** Ai Analyzed Count */
            ai_analyzed_count?: number | null;
        };
        /** CanonicalDataResponse */
        CanonicalDataResponse: {
            /**
             * Canonical Data
             * @description Merged canonical financial data
             */
            canonical_data?: {
                [key: string]: unknown;
            };
            /**
             * Financial Data
             * @description Year-keyed financial data built from canonical periods
             */
            financial_data?: {
                [key: string]: unknown;
            };
            /**
             * Tax1065Files
             * @description Tax file entries extracted from uploaded docs
             */
            tax1065Files?: unknown[];
            /**
             * Calculated Years
             * @description Years with financial data
             */
            calculated_years?: unknown[];
        };
        /** CaseDetailResponse */
        CaseDetailResponse: {
            /** Id */
            id: string;
            /** Client Name */
            client_name: string;
            /** Business Name */
            business_name?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Date */
            event_date?: string | null;
            /** Total Demand */
            total_demand?: number | null;
            /** Released At */
            released_at: string;
            /** Calculation Mode */
            calculation_mode?: string | null;
            /** Attorney Analysis */
            attorney_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Adjuster Analysis */
            adjuster_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Fair Settlement */
            fair_settlement?: {
                [key: string]: unknown;
            } | null;
            /** Pro Forma Summary */
            pro_forma_summary?: {
                [key: string]: unknown;
            } | null;
            /** Monte Carlo Results */
            monte_carlo_results?: {
                [key: string]: unknown;
            } | null;
            policy_coverage?: components["schemas"]["PolicyCoverageResponse"] | null;
        };
        /**
         * CaseLawSearchRequest
         * @description Request for case law search
         */
        CaseLawSearchRequest: {
            /**
             * Query
             * @description Natural language search query
             */
            query: string;
            /**
             * Jurisdiction
             * @description State code filter
             */
            jurisdiction?: string | null;
            /**
             * Event Type
             * @description Event type filter
             */
            event_type?: string | null;
            /**
             * Year Min
             * @description Minimum year
             */
            year_min?: number | null;
            /**
             * Year Max
             * @description Maximum year
             */
            year_max?: number | null;
            /**
             * Bad Faith Only
             * @description Only return bad faith cases
             * @default false
             */
            bad_faith_only: boolean;
            /**
             * Top K
             * @description Number of results
             * @default 5
             */
            top_k: number;
        };
        /**
         * CaseQueryRequest
         * @description Request for Tier 1 case query
         */
        CaseQueryRequest: {
            /**
             * Collection
             * @description Collection to query
             */
            collection: string;
            /**
             * Case Id
             * @description Case/Report ID (required)
             */
            case_id: string;
            /**
             * Filters
             * @description Additional filters
             */
            filters?: {
                [key: string]: unknown;
            } | null;
            /**
             * Projection
             * @description Fields to include/exclude
             */
            projection?: {
                [key: string]: unknown;
            } | null;
            /**
             * Sort
             * @description Sort order [[field, 1/-1], ...]
             */
            sort?: unknown[][] | null;
            /**
             * Limit
             * @description Max results
             * @default 100
             */
            limit: number;
            /**
             * Skip
             * @description Results to skip
             * @default 0
             */
            skip: number;
        };
        /**
         * CaseQueryResponse
         * @description Response for Tier 1 case query
         */
        CaseQueryResponse: {
            /** Success */
            success: boolean;
            /** Data */
            data: {
                [key: string]: unknown;
            }[];
            /** Count */
            count: number;
            /** Query Time Ms */
            query_time_ms: number;
            /** Collection */
            collection: string;
            /** Case Id */
            case_id: string;
            /** Error */
            error?: string | null;
        };
        /**
         * CaseReadinessResponse
         * @description Response for case readiness check.
         */
        CaseReadinessResponse: {
            /** Case Id */
            case_id: string;
            /** Is Ready */
            is_ready: boolean;
            /** Status */
            status: string;
            /** Overall Message */
            overall_message: string;
            /** Checks */
            checks: {
                [key: string]: unknown;
            }[];
            /** Blocking Issues */
            blocking_issues: string[];
            /** Warnings */
            warnings: string[];
            /** Entity Type */
            entity_type: string | null;
            /** Assessed At */
            assessed_at: string;
        };
        /**
         * CaseResolutionRequest
         * @description Request to record a case resolution for learning
         */
        CaseResolutionRequest: {
            /** Case Id */
            case_id: string;
            /** Carrier Name */
            carrier_name: string;
            /**
             * Resolution Type
             * @description settlement, verdict, denial_upheld, etc.
             */
            resolution_type: string;
            /** Claimed Amount */
            claimed_amount: number;
            /** Paid Amount */
            paid_amount: number;
            /** Resolution Date */
            resolution_date: string;
            /** Days To Resolution */
            days_to_resolution: number;
            /**
             * Went To Litigation
             * @default false
             */
            went_to_litigation: boolean;
            /**
             * Went To Appraisal
             * @default false
             */
            went_to_appraisal: boolean;
            /**
             * Bad Faith Filed
             * @default false
             */
            bad_faith_filed: boolean;
            /**
             * State
             * @default
             */
            state: string;
            /**
             * Notes
             * @default
             */
            notes: string;
        };
        /**
         * CaseSummaryResponse
         * @description Response model for a case in the queue.
         */
        CaseSummaryResponse: {
            /** Id */
            id: string;
            /** Business Name */
            business_name: string;
            /** Law Firm */
            law_firm?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Assigned Queue */
            assigned_queue: string;
            /** Queue Reason */
            queue_reason: string;
            /** Pipeline Stage */
            pipeline_stage: string;
            /** Workflow Status */
            workflow_status?: string | null;
            /**
             * Estimated Value
             * @default 0
             */
            estimated_value: number;
            /**
             * Case Strength
             * @default 0
             */
            case_strength: number;
            /**
             * Transactions Need Review
             * @default 0
             */
            transactions_need_review: number;
            /**
             * Completion Percentage
             * @default 0
             */
            completion_percentage: number;
            /**
             * Days Stale
             * @default 0
             */
            days_stale: number;
            /** Last Updated */
            last_updated?: string | null;
            /** Expected Ready Date */
            expected_ready_date?: string | null;
            /** Primary Action */
            primary_action: string;
            /** Primary Action Url */
            primary_action_url: string;
            /** Next Action */
            next_action?: string | null;
            /** Next Action Impact */
            next_action_impact?: string | null;
            /** Readiness Issues */
            readiness_issues?: string[];
        };
        /**
         * CaseTypeUpdateRequest
         * @description Request to update case type.
         */
        CaseTypeUpdateRequest: {
            /** Case Type */
            case_type: string;
            /** Entity Type */
            entity_type?: string | null;
        };
        /**
         * CategoryCorrection
         * @description Model for a user's category correction
         */
        CategoryCorrection: {
            /** User Id */
            user_id: string;
            /** Description */
            description: string;
            /** Payee */
            payee?: string | null;
            /** Original Category */
            original_category: string;
            /** Corrected Category */
            corrected_category: string;
            /** Amount */
            amount?: number | null;
            /** Transaction Id */
            transaction_id?: string | null;
            /** Job Id */
            job_id?: string | null;
        };
        /**
         * CategoryMetric
         * @description Metric for a specific category
         */
        CategoryMetric: {
            /** Category */
            category: string;
            /** Count */
            count: number;
            /** Rate */
            rate: number;
            /**
             * Trend
             * @default stable
             */
            trend: string;
        };
        /**
         * CategorySuggestion
         * @description Request model for category suggestions
         */
        "CategorySuggestion-Input": {
            /** Transactions */
            transactions: {
                [key: string]: unknown;
            }[];
        };
        /**
         * CategorySuggestion
         * @description Model for a suggested category based on learning
         */
        "CategorySuggestion-Output": {
            /** Category */
            category: string;
            /** Confidence */
            confidence: number;
            /** Source */
            source: string;
            /**
             * Match Count
             * @default 0
             */
            match_count: number;
            /** Learned From */
            learned_from?: string | null;
        };
        /**
         * CellCheckRequest
         * @description Request to check cells for variance alerts
         */
        CellCheckRequest: {
            /** Cells */
            cells: {
                [key: string]: unknown;
            }[];
        };
        /**
         * CellTransactionsResponse
         * @description Response with transactions for a specific P&L cell
         */
        CellTransactionsResponse: {
            /** Cell Id */
            cell_id?: string | null;
            /** Section */
            section: string;
            /** Line Item */
            line_item: string;
            /** Year */
            year: number;
            /** Month */
            month: number;
            /** Expected Amount */
            expected_amount: number;
            /** Actual Amount */
            actual_amount?: number | null;
            /** Variance */
            variance?: number | null;
            /** Variance Percent */
            variance_percent?: number | null;
            /** Transactions */
            transactions: {
                [key: string]: unknown;
            }[];
            /** Summary */
            summary?: {
                [key: string]: unknown;
            } | null;
            /** Anomalies */
            anomalies: {
                [key: string]: unknown;
            }[];
            /** Reconciliation Status */
            reconciliation_status?: string | null;
            /**
             * Data Source
             * @default transactions
             */
            data_source: string | null;
            /** Message */
            message?: string | null;
            /**
             * Can Edit
             * @default true
             */
            can_edit: boolean;
        };
        /** ChallengeRequest */
        ChallengeRequest: {
            /** Target Engine Id */
            target_engine_id: string;
            /** Target Field Id */
            target_field_id?: string | null;
            /** Proposed Change */
            proposed_change: string;
            /** Rationale */
            rationale: string;
        };
        /** ChallengeResponse */
        ChallengeResponse: {
            /** Success */
            success: boolean;
            /** Challenge Id */
            challenge_id: string;
            /** Round Number */
            round_number: number;
            /** Remaining Rounds */
            remaining_rounds: number;
            /** Engines Invalidated */
            engines_invalidated: string[];
            /** Affected Agents */
            affected_agents: string[];
            /** Max Rounds Reached */
            max_rounds_reached: boolean;
        };
        /**
         * ChatMessage
         * @description A single chat message.
         */
        ChatMessage: {
            /**
             * Role
             * @description 'user' or 'assistant'
             */
            role: string;
            /** Content */
            content: string;
            /** Timestamp */
            timestamp?: string | null;
        };
        /** ChatResponse */
        ChatResponse: {
            /** Response */
            response: string;
            /** Action Buttons */
            action_buttons?: {
                [key: string]: string;
            }[] | null;
            /** Suggestions */
            suggestions?: string[] | null;
        };
        /**
         * ChatResponseModel
         * @description Response from chat endpoint.
         */
        ChatResponseModel: {
            /** Response */
            response: string;
            /** Tool Calls */
            tool_calls: {
                [key: string]: unknown;
            }[];
            /** Citations */
            citations: {
                [key: string]: unknown;
            }[];
            /** Suggested Followups */
            suggested_followups: string[];
            /** Conversation Id */
            conversation_id: string;
            /** Tokens Used */
            tokens_used?: number | null;
        };
        /** CheckFailed */
        CheckFailed: {
            /** Check Name */
            check_name: string;
            severity: components["schemas"]["CheckSeverity"];
            /** Details */
            details: string;
            /** Affected Engines */
            affected_engines?: string[] | null;
            /** Affected Events */
            affected_events?: string[] | null;
        };
        /** CheckPassed */
        CheckPassed: {
            /** Check Name */
            check_name: string;
            /** Details */
            details?: string | null;
        };
        /**
         * CheckSeverity
         * @enum {string}
         */
        CheckSeverity: CheckSeverity;
        /**
         * CircularPaymentItem
         * @description Circular payment pattern
         */
        CircularPaymentItem: {
            /** Cycle Id */
            cycle_id: string;
            /** Entities */
            entities: string[];
            /** Cycle Length */
            cycle_length: number;
            /** Total Amount */
            total_amount: number;
            /** Average Amount */
            average_amount: number;
            /** Transaction Count */
            transaction_count: number;
            /** Risk Level */
            risk_level: string;
            /** Explanation */
            explanation: string;
        };
        /**
         * ClaimActionResponse
         * @description Response for claim/release/reassign actions.
         */
        ClaimActionResponse: {
            /** Success */
            success: boolean;
            /** Case Id */
            case_id: string;
            /** Action */
            action: string;
            /** Message */
            message: string;
            /** Claimed By Id */
            claimed_by_id?: string | null;
            /** Claimed By Name */
            claimed_by_name?: string | null;
            /** Claimed At */
            claimed_at?: string | null;
        };
        /**
         * ClaimCaseRequest
         * @description Request to claim a case.
         */
        ClaimCaseRequest: {
            /** Notes */
            notes?: string | null;
        };
        /**
         * ClaimCreateRequest
         * @description External API request to create a claim
         */
        ClaimCreateRequest: {
            /** Client Name */
            client_name: string;
            /** Business Type */
            business_type: string;
            /** Event Type */
            event_type?: string | null;
            /** Event Start Date */
            event_start_date?: string | null;
            /** Event End Date */
            event_end_date?: string | null;
            /** Benchmark Revenue */
            benchmark_revenue?: number | null;
            /** Actual Revenue */
            actual_revenue?: number | null;
            /** Metadata */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * ClaimEvent
         * @description Single claim event
         */
        ClaimEvent: {
            /**
             * Type
             * @description Event type: claim_filed, claim_acknowledged, investigation_started, decision_made, payment_sent
             */
            type: string;
            /**
             * Date
             * @description ISO date string
             */
            date: string;
        };
        /** ClaimFilesResponse */
        ClaimFilesResponse: {
            /**
             * Files
             * @description List of uploaded files for this claim
             */
            files?: unknown[];
            /**
             * Count
             * @description Number of files
             * @default 0
             */
            count: number;
        };
        /**
         * ClaimResponse
         * @description External API response for a claim
         */
        ClaimResponse: {
            /** Id */
            id: string;
            /** Client Name */
            client_name: string;
            /** Business Type */
            business_type: string;
            /** Status */
            status: string;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
            /** Calculation Status */
            calculation_status: string;
            /** Result */
            result?: {
                [key: string]: unknown;
            } | null;
        };
        /** ClaimStatusEmailRequest */
        ClaimStatusEmailRequest: {
            /**
             * To Email
             * Format: email
             */
            to_email: string;
            /** Client Name */
            client_name: string;
            /** Claim Id */
            claim_id: string;
            /** Status */
            status: string;
            /**
             * Claim Value
             * @default 0
             */
            claim_value: number;
            /**
             * Event Type
             * @default
             */
            event_type: string;
        };
        /** ClaimStatusUpdate */
        ClaimStatusUpdate: {
            /**
             * Status
             * @description New status: intake, uploaded, processing, ready, review, complete
             */
            status: string;
        };
        /**
         * ClassificationResponse
         * @description Response from document classification
         */
        ClassificationResponse: {
            /** Category */
            category: string;
            /** Document Type */
            document_type: string;
            /** Confidence */
            confidence: number;
            /** Method */
            method: string;
            /** Pipeline */
            pipeline: string;
            /** Parser */
            parser: string | null;
            /** Bypasses Reconstruction */
            bypasses_reconstruction: boolean;
        };
        /**
         * ClassificationResult
         * @description Classification result for a transaction
         */
        ClassificationResult: {
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Category */
            category: string;
            /** Subcategory */
            subcategory: string | null;
            /** Confidence */
            confidence: number;
            /** Tier Used */
            tier_used: string;
            /** Needs Review */
            needs_review: boolean;
            /**
             * Ner Entities
             * @default {}
             */
            ner_entities: {
                [key: string]: unknown;
            };
        };
        /**
         * ClassifyRequest
         * @description Request to classify transactions
         */
        ClassifyRequest: {
            /** Transactions */
            transactions: components["schemas"]["app__api__v1__classification__TransactionInput"][];
            /**
             * Max Tier
             * @description Maximum tier: 1=rules, 2=ML, 3=AI
             * @default 3
             */
            max_tier: number;
            /**
             * Require Consensus
             * @description For Tier 3, require both AIs to agree
             * @default true
             */
            require_consensus: boolean;
        };
        /**
         * ClassifySingleRequest
         * @description Request to classify single transaction
         */
        ClassifySingleRequest: {
            transaction: components["schemas"]["app__api__v1__classification__TransactionInput"];
            /**
             * Max Tier
             * @default 3
             */
            max_tier: number;
        };
        /**
         * CleanupJobStatusResponse
         * @description Job status response
         */
        CleanupJobStatusResponse: {
            /** Job Id */
            job_id: string;
            status: components["schemas"]["JobStatus"];
            stats: components["schemas"]["JobStatistics"];
            /** Edge Cases */
            edge_cases: components["schemas"]["EdgeCaseType"][];
            /** Needs Review Count */
            needs_review_count: number;
            /** Progress Pct */
            progress_pct: number;
            /** Error */
            error?: string | null;
            /** Business Name */
            business_name?: string | null;
            /** Bank Name */
            bank_name?: string | null;
            /** Statement Period */
            statement_period?: string | null;
            /** Report Id */
            report_id?: string | null;
            /** Report Name */
            report_name?: string | null;
            /** Total Files */
            total_files?: number | null;
            /** Processed Files */
            processed_files?: number | null;
        };
        /**
         * CleanupUploadResponse
         * @description Response after upload
         */
        CleanupUploadResponse: {
            /** Job Id */
            job_id: string;
            status: components["schemas"]["JobStatus"];
            /** File Count */
            file_count: number;
            /** Message */
            message: string;
        };
        /**
         * ClearWinnerRequest
         * @description Request to clear a locked winner
         */
        ClearWinnerRequest: {
            /**
             * Email Type
             * @default evidence_request
             */
            email_type: string;
            /**
             * Test Key
             * @description subject_line or cta_button
             */
            test_key: string;
        };
        /**
         * ClientBatchSubmission
         * @description Batch submission of all client responses.
         */
        ClientBatchSubmission: {
            /** Submissions */
            submissions: components["schemas"]["ClientClarificationSubmission"][];
        };
        /**
         * ClientClarificationSubmission
         * @description Submission from client via magic link portal.
         */
        ClientClarificationSubmission: {
            /** Transaction Id */
            transaction_id: string;
            /** Selected Category */
            selected_category: string;
            /** New Category Name */
            new_category_name?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /**
         * ClientQuestionItem
         * @description Client question to attach to a transaction.
         */
        ClientQuestionItem: {
            /** Transaction Id */
            transaction_id: string;
            /** Date */
            date: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Question */
            question: string;
            /** Category */
            category?: string | null;
            /** Ai Suggested Category */
            ai_suggested_category?: string | null;
        };
        /**
         * ClientResponseItem
         * @description A client response to parse.
         */
        ClientResponseItem: {
            /** Transaction Id */
            transaction_id: string;
            /** Date */
            date: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Current Category */
            current_category: string;
            /** Original Question */
            original_question: string;
            /** Client Response */
            client_response: string;
            /** Client Notes */
            client_notes?: string | null;
        };
        /**
         * CollaborationActivityResponse
         * @description Response model for a collaboration activity entry
         */
        CollaborationActivityResponse: {
            /** Case Id */
            case_id: string;
            /** User Id */
            user_id: string;
            /** User Name */
            user_name: string;
            /** Action */
            action: string;
            /** Details */
            details?: string | null;
            /** Created At */
            created_at: string;
        };
        /**
         * CollaborationCaseResponse
         * @description Response model for a case shared with the current user
         */
        CollaborationCaseResponse: {
            /** Case Id */
            case_id: string;
            /** Case Name */
            case_name: string;
            /** Claimant Name */
            claimant_name: string;
            /** Role */
            role: string;
            /** Shared By */
            shared_by: string;
            /** Shared At */
            shared_at: string;
            /** Last Accessed */
            last_accessed?: string | null;
            /** Status */
            status: string;
            /** Event Type */
            event_type?: string | null;
            /** Final Claim Amount */
            final_claim_amount?: number | null;
        };
        /**
         * CollaborationCommentCreate
         * @description Request to add a comment to a shared case
         */
        CollaborationCommentCreate: {
            /**
             * Text
             * @description Comment text
             */
            text: string;
        };
        /**
         * CollaborationCommentResponse
         * @description Response model for a collaboration comment
         */
        CollaborationCommentResponse: {
            /** Comment Id */
            comment_id: string;
            /** Case Id */
            case_id: string;
            /** User Id */
            user_id: string;
            /** User Name */
            user_name: string;
            /** Text */
            text: string;
            /** Created At */
            created_at: string;
        };
        /**
         * CollaborationInviteRequest
         * @description Request to invite a user to collaborate on a case
         */
        CollaborationInviteRequest: {
            /**
             * Case Id
             * @description The case/report ID to share
             */
            case_id: string;
            /**
             * Invitee Email
             * Format: email
             * @description Email of the user to invite
             */
            invitee_email: string;
            /**
             * Role
             * @description Role to assign to the invitee
             * @default viewer
             * @enum {string}
             */
            role: CollaborationInviteRequestRole;
        };
        /**
         * CollaborationInviteResponse
         * @description Response model for a collaboration invite
         */
        CollaborationInviteResponse: {
            /** Invite Id */
            invite_id: string;
            /** Case Id */
            case_id: string;
            /** Inviter Id */
            inviter_id: string;
            /** Invitee Email */
            invitee_email: string;
            /** Role */
            role: string;
            /** Status */
            status: string;
            /** Created At */
            created_at: string;
            /** Accepted At */
            accepted_at?: string | null;
        };
        /**
         * ColorScheme
         * @description Color scheme configuration
         */
        ColorScheme: {
            /**
             * Primary
             * @description Primary brand color (hex)
             * @default #7c3aed
             */
            primary: string;
            /**
             * Secondary
             * @description Secondary color (hex)
             * @default #06b6d4
             */
            secondary: string;
            /**
             * Accent
             * @description Accent color (hex)
             * @default #f59e0b
             */
            accent: string;
            /**
             * Background
             * @description Background color (hex)
             * @default #f8fafc
             */
            background: string;
            /**
             * Text
             * @description Text color (hex)
             * @default #1e293b
             */
            text: string;
            /**
             * Success
             * @description Success color (hex)
             * @default #10b981
             */
            success: string;
            /**
             * Warning
             * @description Warning color (hex)
             * @default #f59e0b
             */
            warning: string;
            /**
             * Error
             * @description Error color (hex)
             * @default #ef4444
             */
            error: string;
        };
        /**
         * ComparisonRequest
         * @description Request to compare multiple reports
         */
        ComparisonRequest: {
            /** Report Ids */
            report_ids: string[];
            /**
             * Metrics
             * @description Specific metrics to compare. If empty, compare all.
             */
            metrics?: string[] | null;
        };
        /**
         * ComparisonResponse
         * @description Response with comparison data
         */
        ComparisonResponse: {
            /** Comparison Id */
            comparison_id: string;
            /** Reports */
            reports: components["schemas"]["ReportMetrics"][];
            /** Summary */
            summary: {
                [key: string]: unknown;
            };
            /** Charts Data */
            charts_data: {
                [key: string]: unknown;
            };
            /** Created At */
            created_at: string;
        };
        /**
         * ConfigUpdateRequest
         * @description Request to update orchestrator configuration.
         */
        ConfigUpdateRequest: {
            /** Mode */
            mode?: string | null;
            /** Auto Analyze On Upload */
            auto_analyze_on_upload?: boolean | null;
            /** Auto Create Issues */
            auto_create_issues?: boolean | null;
            /** Notify On State Change */
            notify_on_state_change?: boolean | null;
        };
        /**
         * ConfirmMatchRequest
         * @description Request to confirm or reject a document match
         */
        ConfirmMatchRequest: {
            /** Confirmed */
            confirmed: boolean;
            /** Notes */
            notes?: string | null;
        };
        /** ContentBlock */
        ContentBlock: {
            /** Block Id */
            block_id: string;
            block_type: components["schemas"]["BlockType"];
            /** Position */
            position: number;
            anchor?: components["schemas"]["BlockAnchor"] | null;
            /** Content */
            content: string;
            /**
             * Created At
             * Format: date-time
             */
            created_at: string;
            /**
             * Last Edited At
             * Format: date-time
             */
            last_edited_at: string;
            /** @default final_pdf */
            visibility: components["schemas"]["BlockVisibility"];
        };
        /**
         * ContentBlockIn
         * @description Inbound block payload. All fields except `block_type` and `content`
         *     are optional — service fills defaults (block_id UUID, timestamps,
         *     visibility=final_pdf, position=0).
         */
        ContentBlockIn: {
            /** Block Id */
            block_id?: string | null;
            /** @default narrative_section */
            block_type: components["schemas"]["BlockType"];
            /**
             * Position
             * @default 0
             */
            position: number;
            anchor?: components["schemas"]["BlockAnchorIn"] | null;
            /**
             * Content
             * @default
             */
            content: string;
            /** @default final_pdf */
            visibility: components["schemas"]["BlockVisibility"];
        };
        /**
         * ContinuationRateRange
         * @description A continuation rate range for a single expense category.
         */
        ContinuationRateRange: {
            /**
             * Min
             * @description Minimum rate (0-5, where 1 = 100%)
             */
            min: number;
            /**
             * Max
             * @description Maximum rate (0-5, where 1 = 100%)
             */
            max: number;
        };
        /**
         * ContinuationRates
         * @description Per-category expense continuation rates (0-100%)
         */
        ContinuationRates: {
            /**
             * Rent
             * @default 100
             */
            rent: number;
            /**
             * Utilities
             * @default 40
             */
            utilities: number;
            /**
             * Insurance
             * @default 100
             */
            insurance: number;
            /**
             * Payroll
             * @default 70
             */
            payroll: number;
            /**
             * Officer Compensation
             * @default 80
             */
            officer_compensation: number;
            /**
             * Loan Payments
             * @default 100
             */
            loan_payments: number;
            /**
             * Cogs
             * @default 10
             */
            cogs: number;
            /**
             * Marketing
             * @default 20
             */
            marketing: number;
            /**
             * Professional Fees
             * @default 50
             */
            professional_fees: number;
            /**
             * Other Fixed
             * @default 50
             */
            other_fixed: number;
        };
        /**
         * ContinuationRatesConfig
         * @description Full configuration of continuation rates for a case.
         */
        ContinuationRatesConfig: {
            officer_compensation?: components["schemas"]["ContinuationRateRange"];
            salaried_wages?: components["schemas"]["ContinuationRateRange"];
            hourly_wages?: components["schemas"]["ContinuationRateRange"];
            rent?: components["schemas"]["ContinuationRateRange"];
            utilities?: components["schemas"]["ContinuationRateRange"];
            insurance?: components["schemas"]["ContinuationRateRange"];
            professional_services?: components["schemas"]["ContinuationRateRange"];
            depreciation?: components["schemas"]["ContinuationRateRange"];
            debt_service?: components["schemas"]["ContinuationRateRange"];
            taxes_licenses?: components["schemas"]["ContinuationRateRange"];
            other_expenses?: components["schemas"]["ContinuationRateRange"];
        };
        /**
         * ContinuationRatesResponse
         * @description Response with continuation rates.
         */
        ContinuationRatesResponse: {
            /** Report Id */
            report_id: string;
            rates: components["schemas"]["ContinuationRatesConfig"];
            /** Is Default */
            is_default: boolean;
            /** Notes */
            notes?: string | null;
            /** Updated At */
            updated_at?: string | null;
            /** Updated By */
            updated_by?: string | null;
        };
        /**
         * ContractTerms
         * @description Extracted generic contract terms.
         */
        ContractTerms: {
            /** Contract Type */
            contract_type?: string | null;
            /** Parties */
            parties?: string[];
            /** Effective Date */
            effective_date?: string | null;
            /** Expiration Date */
            expiration_date?: string | null;
            /** Contract Value */
            contract_value?: number | null;
            /** Payment Terms */
            payment_terms?: string | null;
            /**
             * Auto Renewal
             * @default false
             */
            auto_renewal: boolean;
            /** Termination Notice Days */
            termination_notice_days?: number | null;
            /** Key Obligations */
            key_obligations?: string[];
        };
        /**
         * ConversationHistory
         * @description Stored conversation history for a report.
         */
        ConversationHistory: {
            /** Report Id */
            report_id: string;
            /** Messages */
            messages: components["schemas"]["ChatMessage"][];
            /** Updated At */
            updated_at: string;
        };
        /**
         * CorrectionStatsResponse
         * @description Correction statistics response
         */
        CorrectionStatsResponse: {
            /** Total Corrections */
            total_corrections: number;
            /** By Category */
            by_category: {
                [key: string]: unknown;
            }[];
            /** Common Corrections */
            common_corrections: {
                [key: string]: unknown;
            }[];
        };
        /**
         * CostBreakdownRequest
         * @description Request for litigation cost breakdown
         */
        CostBreakdownRequest: {
            /**
             * Complexity
             * @description Case complexity: simple, moderate, complex, highly_complex
             * @default moderate
             */
            complexity: string;
            /**
             * Phases
             * @description Specific phases to include (all if not specified)
             */
            phases?: string[] | null;
        };
        /**
         * CourtBundleRequest
         * @description Request model for court-ready PDF bundle generation
         */
        CourtBundleRequest: {
            /**
             * Documents
             * @default [
             *       "court_report",
             *       "forensic_report",
             *       "exhibits",
             *       "completed_pl"
             *     ]
             */
            documents: string[];
            /** Document Modules */
            document_modules?: components["schemas"]["DocumentModuleSelection"][] | null;
            /**
             * Include Charts
             * @default true
             */
            include_charts: boolean;
            /**
             * Include Raw Data
             * @default true
             */
            include_raw_data: boolean;
            /**
             * Include Fair Settlement
             * @default true
             */
            include_fair_settlement: boolean;
            /** Watermark */
            watermark?: string | null;
            /**
             * Force Regenerate
             * @default false
             */
            force_regenerate: boolean;
            /**
             * Save To Cache
             * @default true
             */
            save_to_cache: boolean;
        };
        /**
         * CoverageDetail
         * @description Individual coverage detail within a policy.
         */
        CoverageDetail: {
            /**
             * Coverage Type
             * @description property, liability, BI, etc.
             */
            coverage_type: string;
            /** Limit */
            limit?: number | null;
            /** Deductible */
            deductible?: number | null;
            /** Sublimit */
            sublimit?: number | null;
            /**
             * Waiting Period Days
             * @description For BI policies
             */
            waiting_period_days?: number | null;
            /** Coinsurance Percentage */
            coinsurance_percentage?: number | null;
        };
        /**
         * CreateAnnotationRequest
         * @description Request to create an annotation
         */
        CreateAnnotationRequest: {
            target: components["schemas"]["AnnotationTarget"];
            /** Text */
            text: string;
            /**
             * Annotation Type
             * @description Type: comment, question, concern, approval
             * @default comment
             */
            annotation_type: string;
            /**
             * Parent Id
             * @description Parent annotation ID for replies
             */
            parent_id?: string | null;
        };
        /**
         * CreateBrandingRequest
         * @description Request to create branding config
         */
        CreateBrandingRequest: {
            /**
             * Org Id
             * @description Organization ID
             */
            org_id: string;
            config: components["schemas"]["BrandingConfig"];
        };
        /**
         * CreateBundleRequest
         * @description Request to create bundle PDF
         */
        CreateBundleRequest: {
            /** Claim Id */
            claim_id: string;
            /**
             * Include Cover
             * @default true
             */
            include_cover: boolean;
            /**
             * Include Toc
             * @default true
             */
            include_toc: boolean;
        };
        /** CreateClaimResponse */
        CreateClaimResponse: {
            /**
             * Claim Id
             * @description UUID for the new claim
             */
            claim_id: string;
        };
        /**
         * CreateClarificationRequest
         * @description Request body to create a new clarification request.
         */
        CreateClarificationRequest: {
            /** Report Id */
            report_id: string;
            /**
             * Claimant Email
             * Format: email
             */
            claimant_email: string;
            /** Transactions */
            transactions: components["schemas"]["TransactionClarificationItem"][];
        };
        /**
         * CreateDisagreementRequest
         * @description Request body for creating a disagreement
         */
        CreateDisagreementRequest: {
            /** Report Id */
            report_id: string;
            /** Topic */
            topic: string;
            /** Positions */
            positions: {
                [key: string]: unknown;
            };
            /** Affected Item Ids */
            affected_item_ids?: string[] | null;
        };
        /**
         * CreateIssueRequest
         * @description Request to create a new issue
         */
        CreateIssueRequest: {
            /** Report Id */
            report_id: string;
            /** Detected By */
            detected_by: string;
            issue_type: components["schemas"]["IssueType"];
            /** Title */
            title: string;
            /** Description */
            description: string;
            /** What Would Fix */
            what_would_fix: string;
            /** Financial Impact */
            financial_impact?: number | null;
            /** Affected Items */
            affected_items?: string[];
            priority?: components["schemas"]["Priority"] | null;
        };
        /**
         * CreateSettlementRequest
         * @description Initialize settlement tracking for a report
         */
        CreateSettlementRequest: {
            /** Report Id */
            report_id: string;
            /** Initial Demand */
            initial_demand: number;
            /** Insurer Name */
            insurer_name?: string | null;
            /** Adjuster Name */
            adjuster_name?: string | null;
            /** Adjuster Email */
            adjuster_email?: string | null;
            /** Adjuster Phone */
            adjuster_phone?: string | null;
            /** Policy Number */
            policy_number?: string | null;
            /** Claim Number */
            claim_number?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /**
         * CreateTimelineRequest
         * @description Request to create a new litigation timeline.
         */
        CreateTimelineRequest: {
            /**
             * Loss Date
             * @description Date of loss (YYYY-MM-DD)
             */
            loss_date: string;
            /**
             * Carrier Name
             * @description Insurance carrier name
             */
            carrier_name: string;
            /**
             * State
             * @description State code (e.g., FL, TX, CA)
             */
            state: string;
            /**
             * Claimed Amount
             * @description Claimed amount in dollars
             */
            claimed_amount: number;
            /**
             * Claim Reported Date
             * @description Date claim was reported
             */
            claim_reported_date?: string | null;
            /** Policy Number */
            policy_number?: string | null;
            /** Claim Number */
            claim_number?: string | null;
            /**
             * Insured Name
             * @default
             */
            insured_name: string | null;
        };
        /**
         * CreateVersionRequest
         * @description Request to create a version snapshot
         */
        CreateVersionRequest: {
            /** Report Id */
            report_id: string;
            /** Change Summary */
            change_summary: string;
        };
        /**
         * CriteriaResultResponse
         * @description Criteria result in API response.
         */
        CriteriaResultResponse: {
            /** Name */
            name: string;
            /** Passed */
            passed: boolean;
            /** Actual Value */
            actual_value: unknown;
            /** Required Value */
            required_value: unknown;
            /** Message */
            message: string;
        };
        /**
         * CrossValidateRequest
         * @description Request for cross-document validation
         */
        CrossValidateRequest: {
            /** Documents */
            documents: components["schemas"]["DocumentInput"][];
            /** Checks */
            checks?: string[] | null;
        };
        /**
         * CrossValidateResponse
         * @description Response from cross-validation
         */
        CrossValidateResponse: {
            /** Success */
            success: boolean;
            /** Is Valid */
            is_valid: boolean;
            /** Documents Checked */
            documents_checked: number;
            /** Checks Performed */
            checks_performed: string[];
            /** Issue Count */
            issue_count: number;
            /** Issues By Severity */
            issues_by_severity: {
                [key: string]: number;
            };
            /** Issues */
            issues: {
                [key: string]: unknown;
            }[];
            /** Duplicate Groups Count */
            duplicate_groups_count: number;
            /** Duplicate Groups */
            duplicate_groups: {
                [key: string]: unknown;
            }[];
            /** Reconciliation Summary */
            reconciliation_summary: {
                [key: string]: unknown;
            };
        };
        /**
         * CustomRequirementsRequest
         * @description Request to set custom requirements.
         */
        CustomRequirementsRequest: {
            /** Requirements */
            requirements: {
                [key: string]: string;
            };
            /**
             * Save As Template
             * @default false
             */
            save_as_template: boolean;
            /** Template Name */
            template_name?: string | null;
        };
        /**
         * CustomScenarioRequest
         * @description Request for custom scenario analysis
         * @example {
         *       "base_settlement": 500000,
         *       "description": "Tailored approach for this case",
         *       "modifications": [
         *         {
         *           "description": "Specialized analysis",
         *           "effort_cost": 5000,
         *           "effort_hours": 25,
         *           "effort_level": "medium",
         *           "name": "Custom Report",
         *           "settlement_impact_pct": 10,
         *           "success_probability": 0.8
         *         }
         *       ],
         *       "name": "Custom Documentation Package"
         *     }
         */
        CustomScenarioRequest: {
            /** Base Settlement */
            base_settlement: number;
            /** Name */
            name: string;
            /**
             * Description
             * @default
             */
            description: string;
            /** Modifications */
            modifications: {
                [key: string]: unknown;
            }[];
        };
        /**
         * DashboardAlertsResponse
         * @description Response for GET /api/v1/attorney/dashboard/alerts.
         */
        DashboardAlertsResponse: {
            /** Deadline Alerts */
            deadline_alerts: components["schemas"]["DeadlineAlertItem"][];
            quick_insights: components["schemas"]["QuickInsights"];
        };
        /** DashboardOverviewResponse */
        DashboardOverviewResponse: {
            /** Pipeline */
            pipeline?: components["schemas"]["PipelineBreakdown"][];
            /** Recent Activity */
            recent_activity?: components["schemas"]["RecentActivityItem"][];
            /**
             * Total Portfolio Value
             * @default 0
             */
            total_portfolio_value: number;
            /**
             * Avg Case Strength
             * @default 0
             */
            avg_case_strength: number;
            /**
             * Cases Ready For Signoff
             * @default 0
             */
            cases_ready_for_signoff: number;
            /**
             * Cases Stale 7 Days
             * @default 0
             */
            cases_stale_7_days: number;
        };
        /**
         * DashboardStatsResponse
         * @description Response model for automation dashboard stats.
         */
        DashboardStatsResponse: {
            /**
             * Total Cases
             * @default 0
             */
            total_cases: number;
            /**
             * Ready Cases
             * @default 0
             */
            ready_cases: number;
            /**
             * Auto Ready Cases
             * @default 0
             */
            auto_ready_cases: number;
            /**
             * Blocked Cases
             * @default 0
             */
            blocked_cases: number;
            /**
             * Pending Action Items
             * @default 0
             */
            pending_action_items: number;
            /**
             * Avg Case Strength
             * @default 0
             */
            avg_case_strength: number;
        };
        /**
         * DashboardTrendsResponse
         * @description Op-FU7 (2026-04-29): real week-over-week math for the dashboard
         *     Total Claims / Total Value cards. Replaces PR #200's `+12%` mock-strip.
         */
        DashboardTrendsResponse: {
            total_claims: components["schemas"]["TrendStat"];
            total_value: components["schemas"]["TrendStat"];
            /** Window Days */
            window_days: number;
        };
        /** DeadlineAlertItem */
        DeadlineAlertItem: {
            /** Case Id */
            case_id: string;
            /** Client Name */
            client_name: string;
            /** Deadline Type */
            deadline_type: string;
            /** Deadline Date */
            deadline_date: string;
            /** Days Remaining */
            days_remaining: number;
            /**
             * Urgency
             * @enum {string}
             */
            urgency: DeadlineAlertItemUrgency;
        };
        /** Degree */
        Degree: {
            /** Degree */
            degree: string;
            /** Field */
            field: string;
            /** University */
            university: string;
            /** Year */
            year?: number | null;
        };
        /**
         * DeliberationView
         * @description Deliberation timeline + disputed-issues snapshot.
         */
        DeliberationView: {
            /**
             * Events
             * @description Chronological deliberation events (oldest → newest), trimmed to MAX_EVENTS_RETURNED.
             */
            events?: {
                [key: string]: unknown;
            }[];
            /**
             * Issues
             * @description Disputed-issue records with resolution status.
             */
            issues?: {
                [key: string]: unknown;
            }[];
            /**
             * Events Truncated
             * @description True if `events` was trimmed; older history accessed via paginated endpoint (deferred).
             * @default false
             */
            events_truncated: boolean;
        };
        /**
         * DeliverPackageRequest
         * @description Request to deliver package to attorney.
         */
        DeliverPackageRequest: {
            /**
             * Attorney Id
             * @description Attorney ID to deliver to
             */
            attorney_id: string;
            /**
             * Expiry Days
             * @description Days until access link expires
             * @default 30
             */
            expiry_days: number;
        };
        /**
         * DeliveryResponse
         * @description Package delivery result.
         */
        DeliveryResponse: {
            /** Success */
            success: boolean;
            /** Status */
            status: string;
            /** Package Id */
            package_id: string;
            /** Attorney Id */
            attorney_id: string;
            /** Access Link */
            access_link: string | null;
            /** Error */
            error: string | null;
            /** Delivered At */
            delivered_at: string | null;
        };
        /**
         * DemandLetterRequest
         * @description Request for demand letter generation
         */
        DemandLetterRequest: {
            /**
             * Letter Type
             * @description Letter type: initial_demand, follow_up, bad_faith_notice, final_demand, appraisal_demand
             * @default initial_demand
             */
            letter_type: string;
            /**
             * Case Data
             * @description Case data for letter generation
             */
            case_data: {
                [key: string]: unknown;
            };
            /**
             * Calculation Results
             * @description BI engine calculation output to wire into letter
             */
            calculation_results?: {
                [key: string]: unknown;
            } | null;
            /**
             * Include Calculations
             * @description Include loss calculations
             * @default true
             */
            include_calculations: boolean;
            /**
             * Include Bad Faith Warning
             * @description Include bad faith warning
             * @default true
             */
            include_bad_faith_warning: boolean;
            /**
             * Response Deadline Days
             * @description Days until response deadline
             * @default 30
             */
            response_deadline_days: number;
            /**
             * Output Format
             * @description Output format: text, html, markdown
             * @default text
             */
            output_format: string;
        };
        /**
         * DemandLetterResponse
         * @description Generated demand letter
         */
        DemandLetterResponse: {
            /** Status */
            status: string;
            /** Letter Content */
            letter_content: string;
            /** Pdf Url */
            pdf_url?: string | null;
            /** Generated At */
            generated_at: string;
        };
        /** DetectAnomaliesRequest */
        DetectAnomaliesRequest: {
            /** Transactions */
            transactions: components["schemas"]["app__api__v1__anomaly_detection__TransactionInput"][];
            /**
             * Business Type
             * @default general
             */
            business_type: string | null;
            /**
             * Sensitivity
             * @default medium
             */
            sensitivity: string | null;
        };
        /** DetectAnomaliesResponse */
        DetectAnomaliesResponse: {
            /** Success */
            success: boolean;
            /** Anomalies */
            anomalies: components["schemas"]["AnomalyResult"][];
            /** Total Analyzed */
            total_analyzed: number;
            /** Anomaly Count */
            anomaly_count: number;
            /** Rule Based Count */
            rule_based_count: number;
            /** Ai Detected Count */
            ai_detected_count: number;
        };
        /**
         * DigestPreferencesRequest
         * @description Request to update digest preferences
         */
        DigestPreferencesRequest: {
            /** Weekly Digest Enabled */
            weekly_digest_enabled?: boolean | null;
            /** Sections */
            sections?: {
                [key: string]: boolean;
            } | null;
            /** Delivery Day */
            delivery_day?: string | null;
            /** Delivery Hour */
            delivery_hour?: number | null;
        };
        /** DirectAddMemberRequest */
        DirectAddMemberRequest: {
            /**
             * Email
             * Format: email
             */
            email: string;
            /** Name */
            name: string;
            /**
             * Role
             * @default analyst
             */
            role: string;
            /** Temporary Password */
            temporary_password?: string | null;
        };
        /**
         * DismissIssueRequest
         * @description Request to dismiss an issue
         */
        DismissIssueRequest: {
            /** Reason */
            reason: string;
        };
        /**
         * DispatchApprovalRequest
         * @description Request to approve a dispatch action.
         */
        DispatchApprovalRequest: {
            /** Notes */
            notes?: string | null;
        };
        /** DisputeEngineRequest */
        DisputeEngineRequest: {
            /** Reason */
            reason: string;
            /** Requested Change */
            requested_change?: string | null;
            /** Disputed Fields */
            disputed_fields?: string[];
            /**
             * Severity
             * @default advisory
             */
            severity: string;
        };
        /** DissentEntry */
        DissentEntry: {
            /** Agent Name */
            agent_name: string;
            /** Alternative Value */
            alternative_value: unknown;
            /** Field Id */
            field_id: string;
            /** Rationale */
            rationale: string;
            resolved_by: components["schemas"]["ResolutionMethod"];
        };
        /**
         * DocumentInput
         * @description Document for cross-validation
         */
        DocumentInput: {
            /** Name */
            name: string;
            /** Type */
            type: string;
            /** Transactions */
            transactions: components["schemas"]["TransactionRecord"][];
            /** Metadata */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * DocumentMatch
         * @description A potential document match for resolving an issue
         */
        DocumentMatch: {
            /** Document Id */
            document_id: string;
            /** Document Name */
            document_name: string;
            /** Document Type */
            document_type: string;
            /** Match Confidence */
            match_confidence: number;
            /** Relevance Explanation */
            relevance_explanation: string;
            /** Suggested Action */
            suggested_action: string;
        };
        /** DocumentMatchRequest */
        DocumentMatchRequest: {
            /** Issue Id */
            issue_id: string;
        };
        /** DocumentMatchResponse */
        DocumentMatchResponse: {
            /** Issue Id */
            issue_id: string;
            /** Matches */
            matches: components["schemas"]["DocumentMatch"][];
        };
        /**
         * DocumentModuleSelection
         * @description Selection of modules within a document type
         */
        DocumentModuleSelection: {
            /** Type */
            type: string;
            /**
             * Modules
             * @default []
             */
            modules: string[];
        };
        /**
         * DocumentRequestPayload
         * @description Request body for sending document request email.
         */
        DocumentRequestPayload: {
            /**
             * Recipient Email
             * Format: email
             */
            recipient_email: string;
            /** Recipient Name */
            recipient_name?: string | null;
            /** Custom Message */
            custom_message?: string | null;
        };
        /** DocumentResult */
        DocumentResult: {
            /** Filename */
            filename: string;
            /** Status */
            status: string;
            /** Document Type */
            document_type?: string | null;
            /** Confidence */
            confidence?: number | null;
            /** Year */
            year?: number | null;
            /** Extracted Data */
            extracted_data?: {
                [key: string]: unknown;
            } | null;
            /** Error */
            error?: string | null;
        };
        /**
         * DocumentSummary
         * @description Summary of extracted documents for a case.
         */
        DocumentSummary: {
            /** Case Id */
            case_id: string;
            /** Total Documents */
            total_documents: number;
            /** Extracted Documents */
            extracted_documents: number;
            /** Pending Extraction */
            pending_extraction: number;
            /** Needs Review */
            needs_review: number;
            /** By Type */
            by_type?: {
                [key: string]: number;
            };
            /** Documents */
            documents?: components["schemas"]["ExtractedDocument"][];
        };
        /**
         * DocumentTypeChoice
         * @description A document type choice for dropdown
         */
        DocumentTypeChoice: {
            /** Value */
            value: string;
            /** Label */
            label: string;
            /** Category */
            category: string;
        };
        /**
         * DocumentTypesResponse
         * @description Response with all document type choices
         */
        DocumentTypesResponse: {
            /** Choices */
            choices: components["schemas"]["DocumentTypeChoice"][];
            /** Categories */
            categories: string[];
        };
        /**
         * DocumentUploadNotification
         * @description Notification of a new document upload
         */
        DocumentUploadNotification: {
            /** Document Id */
            document_id: string;
            /** Report Id */
            report_id: string;
            /** Document Type */
            document_type?: string | null;
            /** Filename */
            filename?: string | null;
            /** Date Start */
            date_start?: string | null;
            /** Date End */
            date_end?: string | null;
            /** Keywords */
            keywords?: string[] | null;
        };
        /** DraftResponse */
        DraftResponse: {
            /** Draft Id */
            draft_id: string;
            /** Step */
            step: number;
            /** Data */
            data: {
                [key: string]: unknown;
            };
            /** Last Modified */
            last_modified?: string | null;
            /** Created At */
            created_at?: string | null;
        };
        /** DraftSaveRequest */
        DraftSaveRequest: {
            /** Draft Id */
            draft_id?: string | null;
            /** Step */
            step: number;
            /** Data */
            data: {
                [key: string]: unknown;
            };
            /** Last Modified */
            last_modified: string;
        };
        /** DraftStatusUpdate */
        DraftStatusUpdate: {
            /** Workflow Status */
            workflow_status?: string | null;
            /** Priority */
            priority?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /**
         * DuplicateDetectionRequest
         * @description Request body for duplicate detection
         */
        DuplicateDetectionRequest: {
            /** Records */
            records: {
                [key: string]: unknown;
            }[];
            /** Key Fields */
            key_fields?: string[] | null;
            /**
             * Deduplicate
             * @default false
             */
            deduplicate: boolean;
        };
        /**
         * DuplicateReportResponse
         * @description Response for duplicate detection
         */
        DuplicateReportResponse: {
            /** Total Records */
            total_records: number;
            /** Duplicate Count */
            duplicate_count: number;
            /** Unique Count */
            unique_count: number;
            /** Duplicate Groups */
            duplicate_groups: {
                [key: string]: unknown;
            }[];
            /** Deduplicated Records */
            deduplicated_records?: {
                [key: string]: unknown;
            }[] | null;
        };
        /**
         * EPIDetail
         * @description Frontend reads calculation_detail.epi.{amount, period, justification}.
         */
        EPIDetail: {
            /**
             * Amount
             * @description Total Extended Period of Indemnity loss, USD
             */
            amount: number;
            /**
             * Period
             * @description EPI window description, e.g. '2024-01-01 → 2024-06-30 (180 days)'
             */
            period: string;
            /**
             * Justification
             * @description Methodology + skip-reason text shown on card
             */
            justification: string;
        };
        /**
         * EdgeCaseAnalysisRequest
         * @description Request model for edge case analysis
         */
        EdgeCaseAnalysisRequest: {
            /** Claim Data */
            claim_data: {
                [key: string]: unknown;
            };
            /** Historical Claims */
            historical_claims?: {
                [key: string]: unknown;
            }[] | null;
            /** Previous 1065 */
            previous_1065?: {
                [key: string]: unknown;
            } | null;
            /** User Id */
            user_id?: string | null;
        };
        /**
         * EdgeCaseType
         * @enum {string}
         */
        EdgeCaseType: EdgeCaseType;
        /**
         * EmailDraft
         * @description AI-generated email draft for client document request
         */
        EmailDraft: {
            /** Subject */
            subject: string;
            /** Body */
            body: string;
            /** Urgency */
            urgency: string;
            /** Missing Items */
            missing_items: string[];
            /** Deadline Suggestion */
            deadline_suggestion?: string | null;
        };
        /** EmailDraftRequest */
        EmailDraftRequest: {
            /** Issue Ids */
            issue_ids: string[];
            /** Client Name */
            client_name: string;
            /** Case Reference */
            case_reference: string;
            /**
             * Sender Name
             * @default Claims Team
             */
            sender_name: string | null;
        };
        /** EmailDraftResponse */
        EmailDraftResponse: {
            draft: components["schemas"]["EmailDraft"];
            /** Issue Count */
            issue_count: number;
        };
        /**
         * EmailResponse
         * @description Response containing generated email.
         */
        EmailResponse: {
            /** Subject */
            subject: string;
            /** Html */
            html: string;
            /** Document Count */
            document_count: number;
        };
        /** EmailTestRequest */
        EmailTestRequest: {
            /**
             * To Email
             * Format: email
             */
            to_email: string;
        };
        /** EngineConsensusEntry */
        EngineConsensusEntry: {
            /** Inputs */
            inputs?: {
                [key: string]: components["schemas"]["EngineInputEntry"];
            };
            method: components["schemas"]["EngineMethodEntry"];
            /** Dissents */
            dissents?: components["schemas"]["DissentEntry"][];
            /** Confidence */
            confidence: number;
        };
        /**
         * EngineInputEntry
         * @description One agreed-on input value for a specific engine field.
         */
        EngineInputEntry: {
            /** Value */
            value: unknown;
            source: components["schemas"]["InputSource"];
            /** Contributing Agents */
            contributing_agents?: string[];
            /**
             * Tool Call Refs
             * @description DeliberationEvent._id values for the source events.
             */
            tool_call_refs?: string[];
        };
        /** EngineMethodEntry */
        EngineMethodEntry: {
            /** Name */
            name: string;
            /** Rationale */
            rationale: string;
        };
        /**
         * EngineReviewDetail
         * @description Composite of the 5 supplemental review-engine detail blocks.
         *
         *     Used as the response_model for the typed engine-view endpoint added in
         *     Task 3. Each field name is the canonical calculation_detail slot key
         *     that EngineDetailViews.tsx reads.
         */
        EngineReviewDetail: {
            mitigation: components["schemas"]["MitigationDetail"];
            impact_period: components["schemas"]["ImpactPeriodDetail"];
            epi: components["schemas"]["EPIDetail"];
            policy_deductions: components["schemas"]["PolicyDeductionsDetail"];
            present_value: components["schemas"]["PresentValueDetail"];
        };
        /**
         * EngineReviewListResponse
         * @description Mirrors TypeScript ``EngineReviewListResponse``.
         */
        EngineReviewListResponse: {
            /** Report Id */
            report_id: string;
            /** Engines */
            engines: components["schemas"]["EngineReviewStatusResponse"][];
            /** All Approved */
            all_approved: boolean;
            /** Finalize Enabled */
            finalize_enabled: boolean;
        };
        /**
         * EngineReviewStatusResponse
         * @description Mirrors TypeScript ``EngineReviewStatus``.
         */
        EngineReviewStatusResponse: {
            /** Report Id */
            report_id: string;
            /** Engine Id */
            engine_id: string;
            /** Engine Name */
            engine_name: string;
            /** Status */
            status: string;
            /** Reviewed By */
            reviewed_by?: string | null;
            /** Reviewed By Name */
            reviewed_by_name?: string | null;
            /** Reviewed At */
            reviewed_at?: string | null;
            /** Verifier Status */
            verifier_status?: {
                [key: string]: unknown;
            } | null;
            /** Consensus Entries */
            consensus_entries?: {
                [key: string]: unknown;
            }[] | null;
            /**
             * Overrides Count
             * @default 0
             */
            overrides_count: number;
            /** Active Overrides */
            active_overrides?: {
                [key: string]: unknown;
            }[];
            /** Upstream Engines */
            upstream_engines?: components["schemas"]["UpstreamEngineSummary"][] | null;
            /** Attestation History */
            attestation_history?: {
                [key: string]: unknown;
            }[];
            /** Last Run At */
            last_run_at?: string | null;
            /** Output Snapshot Id */
            output_snapshot_id?: string | null;
        };
        /**
         * EnrichmentRequest
         * @description Request body for the enrichment endpoint.
         */
        EnrichmentRequest: {
            /**
             * Source
             * @default bi
             * @enum {string}
             */
            source: EnrichmentRequestSource;
            /** Policy Terms */
            policy_terms?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * EnrichmentResponse
         * @description Response from the enrichment endpoint.
         */
        EnrichmentResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /** Enrichment Id */
            enrichment_id: string;
            /** Enriched At */
            enriched_at: string;
            /** Steps */
            steps: components["schemas"]["StepStatus"][];
            /** Enriched Data */
            enriched_data?: {
                [key: string]: unknown;
            };
            /** Error */
            error?: string | null;
        };
        /**
         * EnsembleAnomalyItem
         * @description Individual anomaly from ensemble
         */
        EnsembleAnomalyItem: {
            /** Index */
            index: number;
            /** Period */
            period: string;
            /** Year */
            year: number;
            /** Month */
            month: number;
            /** Actual Value */
            actual_value: number;
            /** Anomaly Score */
            anomaly_score: number;
            /** Confidence Level */
            confidence_level: string;
            /** Algorithms Flagged */
            algorithms_flagged: string[];
            /** Vote Count */
            vote_count: number;
            /** Total Algorithms */
            total_algorithms: number;
            /** Vote Ratio */
            vote_ratio: number;
            /** Feature Contributions */
            feature_contributions: {
                [key: string]: number;
            };
            /** Explanation */
            explanation: string;
            /** Recommendation */
            recommendation: string;
        };
        /**
         * EnsembleAnomalyRequest
         * @description Request for PyOD ensemble anomaly detection
         */
        EnsembleAnomalyRequest: {
            /** Periods */
            periods: {
                [key: string]: unknown;
            }[];
            /** Features */
            features?: string[] | null;
            /**
             * Contamination
             * @default 0.1
             */
            contamination: number;
            /**
             * Vote Threshold
             * @default 2
             */
            vote_threshold: number;
        };
        /**
         * EnsembleAnomalyResponse
         * @description Response from PyOD ensemble detection
         */
        EnsembleAnomalyResponse: {
            /** Success */
            success: boolean;
            /** Status */
            status: string;
            /** Anomalies */
            anomalies: components["schemas"]["EnsembleAnomalyItem"][];
            /** Summary */
            summary: {
                [key: string]: unknown;
            };
            /** Algorithm Stats */
            algorithm_stats: {
                [key: string]: {
                    [key: string]: unknown;
                };
            };
            /** Error */
            error?: string | null;
        };
        /** ErrorLogCreate */
        ErrorLogCreate: {
            /** Status */
            status: number;
            /** Message */
            message: string;
            /** Endpoint */
            endpoint: string;
            /** Timestamp */
            timestamp: string;
            /** Details */
            details?: {
                [key: string]: unknown;
            } | null;
            /** User Agent */
            user_agent?: string | null;
            /** Url */
            url?: string | null;
        };
        /**
         * EvaluationHistoryResponse
         * @description Response model for evaluation history.
         */
        EvaluationHistoryResponse: {
            /** Report Id */
            report_id: string;
            /** Evaluations */
            evaluations: {
                [key: string]: unknown;
            }[];
            /** Count */
            count: number;
            /** Has More */
            has_more: boolean;
        };
        /**
         * EvaluationResponse
         * @description Response model for case evaluation.
         */
        EvaluationResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Case Strength */
            case_strength: number;
            /** Status */
            status: string;
            /** Is Ready */
            is_ready: boolean;
            /** Data Confidence */
            data_confidence: number;
            /** Forensic Confidence */
            forensic_confidence: number;
            /** Evidence Completeness */
            evidence_completeness: number;
            /** Blocking Count */
            blocking_count: number;
            /** Vulnerability Count */
            vulnerability_count: number;
            /** High Severity Count */
            high_severity_count: number;
            /** Action Items Pending */
            action_items_pending: number;
            /** Strategic Assessment */
            strategic_assessment?: string | null;
            /**
             * Recommendations
             * @default []
             */
            recommendations: string[];
            /** Evaluated At */
            evaluated_at: string;
            /** Trigger */
            trigger: string;
        };
        /**
         * EventDateValidationRequest
         * @description Request for validating event date against financial data
         */
        EventDateValidationRequest: {
            /** Event Start Date */
            event_start_date: string;
            /** Financial Data */
            financial_data?: {
                [key: string]: unknown;
            } | null;
            /** Plfiles */
            plFiles?: {
                [key: string]: unknown;
            }[] | null;
        };
        /**
         * EventTemplateCreate
         * @description Create a new event template
         */
        EventTemplateCreate: {
            /** Name */
            name: string;
            /**
             * Event Type
             * @description e.g., plant_explosion, hurricane, fire, pandemic
             */
            event_type: string;
            /** Description */
            description?: string | null;
            /**
             * Calculation Mode
             * @description standard_bi or future_closure
             * @default future_closure
             */
            calculation_mode: string;
            /**
             * Default Closure Months
             * @default 24
             */
            default_closure_months: number;
            continuation_rates?: components["schemas"]["ContinuationRates"] | null;
            /** Common Extra Expenses */
            common_extra_expenses?: string[];
            /** Attorney Notes */
            attorney_notes?: string | null;
        };
        /**
         * EventTemplateResponse
         * @description Template response
         */
        EventTemplateResponse: {
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Event Type */
            event_type: string;
            /** Description */
            description: string | null;
            /** Calculation Mode */
            calculation_mode: string;
            /** Default Closure Months */
            default_closure_months: number;
            /** Continuation Rates */
            continuation_rates: {
                [key: string]: number;
            };
            /** Common Extra Expenses */
            common_extra_expenses: string[];
            /** Attorney Notes */
            attorney_notes: string | null;
            /** Org Id */
            org_id: string | null;
            /** Is Active */
            is_active: boolean;
            /** Is System */
            is_system: boolean;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
            /** Usage Count */
            usage_count: number;
        };
        /**
         * EventTemplateUpdate
         * @description Update an existing template
         */
        EventTemplateUpdate: {
            /** Name */
            name?: string | null;
            /** Description */
            description?: string | null;
            /** Calculation Mode */
            calculation_mode?: string | null;
            /** Default Closure Months */
            default_closure_months?: number | null;
            continuation_rates?: components["schemas"]["ContinuationRates"] | null;
            /** Common Extra Expenses */
            common_extra_expenses?: string[] | null;
            /** Attorney Notes */
            attorney_notes?: string | null;
            /** Is Active */
            is_active?: boolean | null;
        };
        /**
         * ExecuteRequest
         * @description Request to execute a readiness decision.
         */
        ExecuteRequest: {
            /**
             * Skip Notifications
             * @description Skip sending notifications
             * @default false
             */
            skip_notifications: boolean;
        };
        /**
         * ExpenseCorrection
         * @description Single expense category correction.
         */
        ExpenseCorrection: {
            /** Item Id */
            item_id: string;
            /** Original Category */
            original_category: string;
            /** New Category */
            new_category: string;
            /** Reason */
            reason?: string | null;
        };
        /**
         * ExpenseCorrectionsRequest
         * @description Request to save expense corrections.
         */
        ExpenseCorrectionsRequest: {
            /** Corrections */
            corrections: components["schemas"]["ExpenseCorrection"][];
        };
        /**
         * ExpenseDefaults
         * @description Default expense percentages and fixed amounts
         */
        ExpenseDefaults: {
            /**
             * Cogs Pct
             * @default 35
             */
            cogs_pct: number;
            /**
             * Payroll Pct
             * @default 28
             */
            payroll_pct: number;
            /**
             * Rent Monthly
             * @default 5000
             */
            rent_monthly: number;
            /**
             * Utilities Monthly
             * @default 500
             */
            utilities_monthly: number;
            /**
             * Insurance Monthly
             * @default 300
             */
            insurance_monthly: number;
            /**
             * Marketing Pct
             * @default 3
             */
            marketing_pct: number;
            /**
             * Supplies Pct
             * @default 2
             */
            supplies_pct: number;
            /**
             * Other Expenses Pct
             * @default 5
             */
            other_expenses_pct: number;
        };
        /** ExpenseInput */
        ExpenseInput: {
            /** Description */
            description: string;
            /**
             * Threshold
             * @default 65
             */
            threshold: number | null;
        };
        /**
         * ExplainBatchRequest
         * @description Request to explain multiple transactions
         */
        ExplainBatchRequest: {
            /** Transactions */
            transactions: components["schemas"]["app__api__v1__explainability__TransactionInput"][];
            /**
             * Only Anomalies
             * @default true
             */
            only_anomalies: boolean;
        };
        /**
         * ExplainBatchResponse
         * @description Response with batch explanations
         */
        ExplainBatchResponse: {
            /** Success */
            success: boolean;
            /** Total Analyzed */
            total_analyzed: number;
            /** Anomalies Found */
            anomalies_found: number;
            /** Explanations */
            explanations: components["schemas"]["ExplainResponse"][];
        };
        /**
         * ExplainResponse
         * @description Response with anomaly explanation
         */
        ExplainResponse: {
            /** Success */
            success: boolean;
            /** Transaction Id */
            transaction_id: string | null;
            /** Anomaly Score */
            anomaly_score: number;
            /** Is Anomaly */
            is_anomaly: boolean;
            /** Narrative */
            narrative: string;
            /** Top Contributors */
            top_contributors: components["schemas"]["FeatureContributionResponse"][];
            /** All Contributions */
            all_contributions: components["schemas"]["FeatureContributionResponse"][];
            /** Waterfall Data */
            waterfall_data: {
                [key: string]: unknown;
            };
            /** Metadata */
            metadata: {
                [key: string]: unknown;
            };
        };
        /** ExtractFromDocumentRequest */
        ExtractFromDocumentRequest: {
            /** Document Text */
            document_text: string;
            /** Document Type */
            document_type: string;
        };
        /**
         * ExtractedDocument
         * @description Complete extracted document with metadata.
         */
        ExtractedDocument: {
            /**
             * Document Id
             * @description Reference to uploaded document
             */
            document_id: string;
            /** Case Id */
            case_id: string;
            document_type: components["schemas"]["SupportingDocumentType"];
            /** Extracted At */
            extracted_at?: string;
            /**
             * Extraction Method
             * @description ai, manual, ocr
             * @default ai
             */
            extraction_method: string;
            /** @default medium */
            confidence: components["schemas"]["ExtractionConfidence"];
            /**
             * Confidence Score
             * @default 0.8
             */
            confidence_score: number;
            /** Original Filename */
            original_filename?: string | null;
            /** Page Count */
            page_count?: number | null;
            /**
             * Ocr Text Preview
             * @description First 500 chars of OCR text
             */
            ocr_text_preview?: string | null;
            lease_terms?: components["schemas"]["LeaseTerms"] | null;
            insurance_terms?: components["schemas"]["InsuranceTerms"] | null;
            loan_terms?: components["schemas"]["LoanTerms"] | null;
            contract_terms?: components["schemas"]["ContractTerms"] | null;
            /**
             * Needs Review
             * @default false
             */
            needs_review: boolean;
            /** Review Notes */
            review_notes?: string | null;
            /** Verified By */
            verified_by?: string | null;
            /** Verified At */
            verified_at?: string | null;
            /** Extraction Warnings */
            extraction_warnings?: string[];
            /** Missing Fields */
            missing_fields?: string[];
        };
        /**
         * ExtractionConfidence
         * @description Confidence level of AI extraction.
         * @enum {string}
         */
        ExtractionConfidence: ExtractionConfidence;
        /**
         * ExtractionRequest
         * @description Request to extract data from a supporting document.
         */
        ExtractionRequest: {
            /** Document Id */
            document_id: string;
            /** Case Id */
            case_id: string;
            document_type?: components["schemas"]["SupportingDocumentType"] | null;
            /**
             * Force Reextract
             * @default false
             */
            force_reextract: boolean;
            /**
             * Document Text
             * @description Direct text input - bypasses document lookup if provided
             */
            document_text?: string | null;
        };
        /**
         * ExtractionResponse
         * @description Response from extraction operation.
         */
        ExtractionResponse: {
            /** Success */
            success: boolean;
            /** Document Id */
            document_id: string;
            /** Case Id */
            case_id: string;
            document_type?: components["schemas"]["SupportingDocumentType"] | null;
            extracted?: components["schemas"]["ExtractedDocument"] | null;
            /** Error */
            error?: string | null;
            /** Processing Time Ms */
            processing_time_ms?: number | null;
        };
        /** ExtractionResultResponse */
        ExtractionResultResponse: {
            /** Job Id */
            job_id: string;
            /** Filename */
            filename: string;
            /** Status */
            status: string;
            /** Success */
            success: boolean;
            /** Pipeline */
            pipeline?: string | null;
            /** Tier */
            tier?: string | null;
            /**
             * Records
             * @default []
             */
            records: {
                [key: string]: unknown;
            }[];
            /** Raw Text */
            raw_text?: string | null;
            /**
             * Tables
             * @default []
             */
            tables: {
                [key: string]: unknown;
            }[];
            /**
             * Quality Score
             * @default 0
             */
            quality_score: number;
            /**
             * Confidence
             * @default 0
             */
            confidence: number;
            /**
             * Warnings
             * @default []
             */
            warnings: string[];
            /**
             * Errors
             * @default []
             */
            errors: string[];
            /**
             * Processing Time Ms
             * @default 0
             */
            processing_time_ms: number;
            /**
             * Metadata
             * @default {}
             */
            metadata: {
                [key: string]: unknown;
            };
            /**
             * Cache Hit
             * @default false
             */
            cache_hit: boolean;
        };
        /** ExtractionStatusResponse */
        ExtractionStatusResponse: {
            /** Job Id */
            job_id: string;
            /** Filename */
            filename: string;
            /** Status */
            status: string;
            /** File Type */
            file_type?: {
                [key: string]: unknown;
            } | null;
            /**
             * Cache Hit
             * @default false
             */
            cache_hit: boolean;
            /** Created At */
            created_at: string;
            /** Started At */
            started_at?: string | null;
            /** Completed At */
            completed_at?: string | null;
            /** Error Message */
            error_message?: string | null;
        };
        /**
         * FairSettlementResponse
         * @description Response from fair settlement calculation
         */
        FairSettlementResponse: {
            /** Success */
            success: boolean;
            /**
             * Cached
             * @default false
             */
            cached: boolean;
            /** Analysis Id */
            analysis_id?: string | null;
            /** Analyzed At */
            analyzed_at?: string | null;
            /** Fair Settlement Value */
            fair_settlement_value?: number | null;
            /** Settlement Range */
            settlement_range?: {
                [key: string]: number;
            } | null;
            /** Confidence Interval 95 */
            confidence_interval_95?: {
                [key: string]: number;
            } | null;
            /** Adjuster Value */
            adjuster_value?: number | null;
            /** Attorney Value */
            attorney_value?: number | null;
            /** Base Claim */
            base_claim?: number | null;
            /** Monte Carlo */
            monte_carlo?: {
                [key: string]: unknown;
            } | null;
            /** Gap Bridge */
            gap_bridge?: {
                [key: string]: unknown;
            }[] | null;
            /** Scenarios */
            scenarios?: {
                [key: string]: unknown;
            }[] | null;
            /** Executive Summary */
            executive_summary?: string | null;
            /** Error */
            error?: string | null;
        };
        /**
         * FeatureContributionResponse
         * @description Feature contribution in explanation
         */
        FeatureContributionResponse: {
            /** Feature */
            feature: string;
            /** Value */
            value: unknown;
            /** Shap Value */
            shap_value: number;
            /** Contribution Percent */
            contribution_percent: number;
            /** Direction */
            direction: string;
            /** Description */
            description: string;
        };
        /**
         * FeatureImportanceResponse
         * @description Global feature importance
         */
        FeatureImportanceResponse: {
            /** Success */
            success: boolean;
            /** Model Trained */
            model_trained: boolean;
            /** Feature Importance */
            feature_importance: {
                [key: string]: number;
            };
            /** Total Features */
            total_features: number;
        };
        /** FemaSuggestionRequest */
        FemaSuggestionRequest: {
            /** State */
            state: string;
            /** Event Start */
            event_start: string;
            /** Event End */
            event_end?: string | null;
            /** Event Type */
            event_type?: string | null;
        };
        /** FemaValidationRequest */
        FemaValidationRequest: {
            /** Fema Number */
            fema_number: string;
            /** State */
            state?: string | null;
            /** Event Start */
            event_start?: string | null;
            /** Event End */
            event_end?: string | null;
        };
        /**
         * FileProcessingResult
         * @description Result of processing a single file
         */
        FileProcessingResult: {
            /** Filename */
            filename: string;
            /** File Type */
            file_type: string;
            /** Success */
            success: boolean;
            /** Transactions Extracted */
            transactions_extracted: number;
            /** Periods Count */
            periods_count: number;
            /** Extraction Method */
            extraction_method: string;
            /** Cache Hit */
            cache_hit: boolean;
            /** Cost Usd */
            cost_usd: number;
            /** Processing Time Seconds */
            processing_time_seconds: number;
            /** Errors */
            errors?: string[];
            /**
             * Needs Review Count
             * @default 0
             */
            needs_review_count: number;
            /**
             * Doc Type
             * @description Classified document type (e.g., 'tax_1065', 'bank_statement_pdf', 'pl_pdf')
             */
            doc_type?: string | null;
            /**
             * Doc Category
             * @description Document category (e.g., 'financial', 'tax', 'pl_statement')
             */
            doc_category?: string | null;
            /**
             * Classification Confidence
             * @description Classification confidence 0-1
             */
            classification_confidence?: number | null;
            /**
             * Classification Method
             * @description How classified: 'user_hint', 'extension', 'content', 'filename'
             */
            classification_method?: string | null;
            /**
             * S3 Key
             * @description S3 object key for the uploaded file
             */
            s3_key?: string | null;
        };
        /** FinalizeRequest */
        FinalizeRequest: {
            /**
             * Signature Confirmation
             * @description Attester must type their full name exactly as on file.
             */
            signature_confirmation: string;
            /** Final Notes */
            final_notes?: string | null;
        };
        /** FinalizeResponse */
        FinalizeResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /** New Status */
            new_status: string;
            /**
             * Attested At
             * Format: date-time
             */
            attested_at: string;
            /** Attested By */
            attested_by: {
                [key: string]: unknown;
            };
            /** Attested Calc Run Id */
            attested_calc_run_id: string;
            /** Attestation History Id */
            attestation_history_id: string;
            /** Audit Chain Entry Id */
            audit_chain_entry_id: string | null;
        };
        /**
         * FinancialEditRequest
         * @description Request body for PATCH /claims/{claim_id}/financial-data.
         */
        FinancialEditRequest: {
            /**
             * Year
             * @description Year of the period to edit
             */
            year: number;
            /**
             * Month
             * @description Month (1-12)
             */
            month: number;
            /**
             * Field
             * @description Field to edit. One of: revenue, cogs, payroll, fixed_costs, variable_costs, other_income, other_expense
             */
            field: string;
            /**
             * Value
             * @description New numeric value
             */
            value: number;
            /**
             * Reason
             * @description Reason for the edit (required)
             */
            reason: string;
            /**
             * User Id
             * @description ID of the user making the edit
             */
            user_id: string;
        };
        /**
         * FinancialEditResponse
         * @description Response for PATCH /claims/{claim_id}/financial-data.
         */
        FinancialEditResponse: {
            /** Claim Id */
            claim_id: string;
            /** Updated Period */
            updated_period: {
                [key: string]: unknown;
            };
            /** Recalculated Totals */
            recalculated_totals: {
                [key: string]: unknown;
            };
            /** Audit Entry */
            audit_entry: {
                [key: string]: unknown;
            };
        };
        /**
         * FixIssuesRequest
         * @description Request model for fix issues endpoint
         */
        FixIssuesRequest: {
            /**
             * Fix Types
             * @default [
             *       "aggregation",
             *       "cogs"
             *     ]
             */
            fix_types: string[];
        };
        /**
         * FlagForClientRequest
         * @description Request to flag transactions for client verification.
         */
        FlagForClientRequest: {
            /** Claim Id */
            claim_id: string;
            /** Questions */
            questions: components["schemas"]["ClientQuestionItem"][];
        };
        /**
         * ForensicAccountantCreate
         * @description Request model for accountant registration.
         *
         *     SECURITY (audit C-5, 2026-04-18): `invite_token` is REQUIRED. An accountant
         *     can only register after a user has issued an invite from `/collaboration/shares`.
         *     Without the token the endpoint returns 400 — this closes the open-signup
         *     vector where anyone on the internet could mint active accountant accounts.
         */
        ForensicAccountantCreate: {
            /**
             * Email
             * Format: email
             */
            email: string;
            /**
             * Password
             * @description Minimum 8 characters
             */
            password: string;
            /** Full Name */
            full_name: string;
            /** Firm Name */
            firm_name: string;
            /** License Number */
            license_number?: string | null;
            /** Phone */
            phone?: string | null;
            /**
             * Invite Token
             * @description Invite token issued by /collaboration/shares. Required.
             */
            invite_token: string;
        };
        /**
         * ForensicAccountantLogin
         * @description Request model for accountant login
         */
        ForensicAccountantLogin: {
            /**
             * Email
             * Format: email
             */
            email: string;
            /** Password */
            password: string;
        };
        /**
         * ForensicAccountantProfile
         * @description Response model for accountant profile
         */
        ForensicAccountantProfile: {
            /** Id */
            id: string;
            /** Email */
            email: string;
            /** Full Name */
            full_name: string;
            /** Firm Name */
            firm_name: string;
            /** License Number */
            license_number?: string | null;
            /** Phone */
            phone?: string | null;
            /** Created At */
            created_at: string;
            /** Last Login */
            last_login?: string | null;
            /** Status */
            status: string;
        };
        /**
         * ForensicAnalysisResponse
         * @description Response from forensic analysis
         */
        ForensicAnalysisResponse: {
            /** Success */
            success: boolean;
            /** Analysis Id */
            analysis_id?: string | null;
            /** Analyzed At */
            analyzed_at?: string | null;
            /**
             * Cached
             * @default false
             */
            cached: boolean;
            /** Claim Amount */
            claim_amount?: number | null;
            /** Executive Summary */
            executive_summary?: string | null;
            /** Claim Validity */
            claim_validity?: string | null;
            /** Confidence Level */
            confidence_level?: number | null;
            /** But For Analysis */
            but_for_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Critical Findings */
            critical_findings?: {
                [key: string]: unknown;
            }[] | null;
            /** Opportunities */
            opportunities?: {
                [key: string]: unknown;
            }[] | null;
            /** Data Quality */
            data_quality?: {
                [key: string]: unknown;
            } | null;
            /** Cross Validation */
            cross_validation?: {
                [key: string]: unknown;
            } | null;
            /** Pattern Analysis */
            pattern_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Recommendations */
            recommendations?: string[] | null;
            /** Financial Impact */
            financial_impact?: {
                [key: string]: unknown;
            } | null;
            /** Error */
            error?: string | null;
        };
        /**
         * ForensicAnomalyRequest
         * @description Request for forensic AI analysis of anomalies
         */
        ForensicAnomalyRequest: {
            /** Anomaly */
            anomaly: {
                [key: string]: unknown;
            };
            /** Periods */
            periods: {
                [key: string]: unknown;
            }[];
            /** Business Context */
            business_context?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * ForensicAnomalyResponse
         * @description Response with forensic accountant AI insights
         */
        ForensicAnomalyResponse: {
            /** Success */
            success: boolean;
            /** Forensic Insight */
            forensic_insight?: string | null;
            /** Severity Assessment */
            severity_assessment?: string | null;
            /** Claim Impact */
            claim_impact?: string | null;
            /** Recommended Action */
            recommended_action?: string | null;
            /** Supporting Evidence */
            supporting_evidence?: string[] | null;
            /** Error */
            error?: string | null;
        };
        /**
         * FraudGraphRequest
         * @description Request for fraud graph analysis
         */
        FraudGraphRequest: {
            /** Transactions */
            transactions: {
                [key: string]: unknown;
            }[];
            /**
             * Business Entity
             * @default BUSINESS
             */
            business_entity: string;
            /**
             * Max Cycle Length
             * @default 5
             */
            max_cycle_length: number;
            /**
             * Shell Threshold
             * @default 50000
             */
            shell_threshold: number;
            /**
             * Flow Ratio Threshold
             * @default 0.9
             */
            flow_ratio_threshold: number;
        };
        /**
         * FraudGraphResponse
         * @description Response from fraud graph analysis
         */
        FraudGraphResponse: {
            /** Success */
            success: boolean;
            /** Status */
            status: string;
            /** Graph Stats */
            graph_stats: {
                [key: string]: unknown;
            };
            /** Circular Payments */
            circular_payments: components["schemas"]["CircularPaymentItem"][];
            /** Shell Indicators */
            shell_indicators: components["schemas"]["ShellIndicatorItem"][];
            /** Anomalous Clusters */
            anomalous_clusters: components["schemas"]["AnomalousClusterItem"][];
            /** Entity Risk Scores */
            entity_risk_scores: {
                [key: string]: number;
            };
            /** Visualization Data */
            visualization_data: {
                [key: string]: unknown;
            };
            /** Error */
            error?: string | null;
        };
        /**
         * FutureClosureExpenseDefaults
         * @description BLS Median-based expense defaults for Future Closure calculations.
         *     All percentages are as % of average monthly revenue.
         *     Source: Bureau of Labor Statistics, NAICS sector data
         */
        FutureClosureExpenseDefaults: {
            /**
             * Officer Salary Pct
             * @default 0.08
             */
            officer_salary_pct: number;
            /**
             * Employee Wages Pct
             * @default 0.2
             */
            employee_wages_pct: number;
            /**
             * Rent Pct
             * @default 0.08
             */
            rent_pct: number;
            /**
             * Utilities Pct
             * @default 0.025
             */
            utilities_pct: number;
            /**
             * Insurance Pct
             * @default 0.015
             */
            insurance_pct: number;
            /**
             * Other Fixed Pct
             * @default 0.05
             */
            other_fixed_pct: number;
            /**
             * Officer Salary Continuation
             * @default 1
             */
            officer_salary_continuation: number;
            /**
             * Employee Wages Continuation
             * @default 0
             */
            employee_wages_continuation: number;
            /**
             * Rent Continuation
             * @default 1
             */
            rent_continuation: number;
            /**
             * Utilities Continuation
             * @default 0.25
             */
            utilities_continuation: number;
            /**
             * Insurance Continuation
             * @default 0.9
             */
            insurance_continuation: number;
            /**
             * Other Fixed Continuation
             * @default 0.3
             */
            other_fixed_continuation: number;
            /**
             * Source
             * @default BLS NAICS Sector Median
             */
            source: string;
            /**
             * Source Year
             * @default 2023
             */
            source_year: number;
        };
        /**
         * GXValidateRequest
         * @description Request for Great Expectations validation
         */
        GXValidateRequest: {
            /** Transactions */
            transactions?: components["schemas"]["TransactionRecord"][] | null;
            /** Periods */
            periods?: components["schemas"]["PeriodRecord"][] | null;
            /**
             * Data Type
             * @default transactions
             */
            data_type: string;
        };
        /**
         * GXValidateResponse
         * @description Response from Great Expectations validation
         */
        GXValidateResponse: {
            /** Success */
            success: boolean;
            /** Data Type */
            data_type: string;
            /** Total Expectations */
            total_expectations: number;
            /** Passed Expectations */
            passed_expectations: number;
            /** Failed Expectations */
            failed_expectations: number;
            /** Quality Score */
            quality_score: number;
            /** Quality Grade */
            quality_grade: string;
            /** Results */
            results: {
                [key: string]: unknown;
            }[];
            /** Report */
            report?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * GameTheoryRequest
         * @description Request model for game theory analysis
         */
        GameTheoryRequest: {
            /**
             * Claim Value
             * @description Base calculated claim amount
             */
            claim_value: number;
            /**
             * Adjuster Value
             * @description Adjuster's conservative valuation
             */
            adjuster_value: number;
            /**
             * Attorney Value
             * @description Attorney's aggressive valuation
             */
            attorney_value: number;
            /**
             * Negotiation Style
             * @description Negotiation approach: aggressive, competitive, cooperative, accommodating
             * @default competitive
             */
            negotiation_style: string;
            /**
             * Monte Carlo P50
             * @description Monte Carlo median (P50)
             */
            monte_carlo_p50?: number | null;
            /**
             * Monte Carlo Ci Low
             * @description Monte Carlo 95% CI low
             */
            monte_carlo_ci_low?: number | null;
            /**
             * Monte Carlo Ci High
             * @description Monte Carlo 95% CI high
             */
            monte_carlo_ci_high?: number | null;
        };
        /**
         * GenerateDemandLetterRequest
         * @description Request to generate demand letter
         */
        GenerateDemandLetterRequest: {
            /** Opportunity Index */
            opportunity_index: number;
            /**
             * Include Evidence
             * @default true
             */
            include_evidence: boolean;
            /**
             * Include Case Law
             * @default true
             */
            include_case_law: boolean;
        };
        /**
         * GenerateEmailRequest
         * @description Request to generate a client email for a roadmap action.
         */
        GenerateEmailRequest: {
            /** Client Name */
            client_name: string;
            /** Upload Link */
            upload_link: string;
            /**
             * Deadline Days
             * @default 7
             */
            deadline_days: number;
        };
        /**
         * GenerateNarrativeRequest
         * @description Request to generate AI narrative
         */
        GenerateNarrativeRequest: {
            /** Claim Data */
            claim_data: {
                [key: string]: unknown;
            };
            /** Calculation Results */
            calculation_results: {
                [key: string]: unknown;
            };
            /**
             * Event Type
             * @default Hurricane
             */
            event_type: string;
            /** Claim Id */
            claim_id: string;
        };
        /**
         * GeneratePackageRequest
         * @description Request to generate a new package.
         */
        GeneratePackageRequest: {
            /**
             * Regenerate
             * @description Force regeneration even if package exists
             * @default false
             */
            regenerate: boolean;
        };
        /** GenerateSampleRequest */
        GenerateSampleRequest: {
            /**
             * Num Transactions
             * @description Number of transactions to generate
             * @default 100
             */
            num_transactions: number;
            /**
             * Review Percentage
             * @description Percentage needing review (0.0-1.0)
             * @default 0.1
             */
            review_percentage: number;
        };
        /** GenerateTagsRequest */
        GenerateTagsRequest: {
            /** Text Content */
            text_content: string;
        };
        /** HTTPValidationError */
        HTTPValidationError: {
            /** Detail */
            detail?: components["schemas"]["ValidationError"][];
        };
        /**
         * HistoricalComparisonRequest
         * @description Request for historical settlement comparison
         * @example {
         *       "claim_value": 500000,
         *       "event_type": "fire",
         *       "industry": "restaurant",
         *       "loss_period_months": 12,
         *       "settlement_value": 375000,
         *       "state": "CA"
         *     }
         */
        HistoricalComparisonRequest: {
            /** Claim Value */
            claim_value: number;
            /** Settlement Value */
            settlement_value?: number | null;
            /**
             * Industry
             * @description Industry sector
             * @default general
             */
            industry: string;
            /**
             * Event Type
             * @description Type of loss event
             * @default general
             */
            event_type: string;
            /**
             * Loss Period Months
             * @default 12
             */
            loss_period_months: number;
            /**
             * State
             * @description State for regional benchmarks
             */
            state?: string | null;
        };
        /**
         * HistoryItemResponse
         * @description Single readiness history item.
         */
        HistoryItemResponse: {
            /** Id */
            id: string;
            /** Status */
            status: string;
            /** Is Ready */
            is_ready: boolean;
            /** Confidence */
            confidence: number;
            /** Reason */
            reason: string;
            /** Decided At */
            decided_at: string;
            /** Decided By */
            decided_by: string;
            /**
             * Reversed
             * @default false
             */
            reversed: boolean;
        };
        /**
         * HumanInputRequest
         * @description Request body for POST /{report_id}/input.
         */
        HumanInputRequest: {
            /** Issue Tag */
            issue_tag: string;
            /** Content */
            content: string;
            /** Author Role */
            author_role: string;
            /** Author Name */
            author_name: string;
        };
        /**
         * HumanOverrideEntry
         * @description Audit log entry for human overrides of AI automation
         */
        HumanOverrideEntry: {
            /** Case Id */
            case_id?: string | null;
            /** Step */
            step: string;
            /** Action */
            action: string;
            /** Changes */
            changes?: components["schemas"]["AuditChange"][];
            /** Original Values */
            original_values?: {
                [key: string]: unknown;
            } | null;
            /** Updated Values */
            updated_values?: {
                [key: string]: unknown;
            } | null;
            /** Timestamp */
            timestamp?: string | null;
            /** User */
            user?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /**
         * ImpactPeriodDetail
         * @description Frontend reads calculation_detail.impact_period.{start, end, days, indemnity_days}.
         *
         *     `days` and `indemnity_days` are Union[int, str] because the aggregator's
         *     no-dates branch emits "—" / "Not provided" so the card always renders
         *     a readable value instead of falling through to MissingEngineOutput.
         */
        ImpactPeriodDetail: {
            /**
             * Start
             * @description Impact period start (ISO date or 'Not provided')
             */
            start: string;
            /**
             * End
             * @description Impact period end (ISO date or 'Not provided')
             */
            end: string;
            /**
             * Days
             * @description Actual impact days, or '—' when unknown
             */
            days: number | string;
            /**
             * Indemnity Days
             * @description Days policy will indemnify, or '—'
             */
            indemnity_days: number | string;
        };
        /**
         * ImprovementPotentialResponse
         * @description Response model for improvement potential.
         */
        ImprovementPotentialResponse: {
            /** Report Id */
            report_id: string;
            /** Current Score */
            current_score: number;
            /** Potential Score */
            potential_score: number;
            /** Total Improvement */
            total_improvement: number;
            /** Breakdown */
            breakdown: {
                [key: string]: number;
            };
            /** Would Be Ready */
            would_be_ready: boolean;
            /** Would Be Auto Ready */
            would_be_auto_ready: boolean;
        };
        /**
         * IndustryBenchmarkRequest
         * @description Request for industry benchmark comparison
         */
        IndustryBenchmarkRequest: {
            /** Financial Data */
            financial_data: {
                [key: string]: unknown;
            };
            /** Naics Code */
            naics_code?: string | null;
            /** Business Type */
            business_type?: string | null;
        };
        /**
         * IndustryBenchmarkResponse
         * @description Response from industry benchmark comparison
         */
        IndustryBenchmarkResponse: {
            /** Success */
            success: boolean;
            /** Status */
            status: string;
            /** Naics Code */
            naics_code: string;
            /** Industry Name */
            industry_name: string;
            /** Benchmark Year */
            benchmark_year: number;
            /** Comparisons */
            comparisons: components["schemas"]["RatioComparisonItem"][];
            /** Summary */
            summary: {
                [key: string]: unknown;
            };
            /** Overall Assessment */
            overall_assessment: string;
            /** Forensic Implications */
            forensic_implications: string[];
            /** Error */
            error?: string | null;
        };
        /**
         * IndustryBenchmarks
         * @description Industry benchmark data for comparison
         */
        IndustryBenchmarks: {
            /**
             * Gross Margin Low
             * @default 30
             */
            gross_margin_low: number;
            /**
             * Gross Margin Avg
             * @default 45
             */
            gross_margin_avg: number;
            /**
             * Gross Margin High
             * @default 60
             */
            gross_margin_high: number;
            /**
             * Net Margin Low
             * @default 5
             */
            net_margin_low: number;
            /**
             * Net Margin Avg
             * @default 12
             */
            net_margin_avg: number;
            /**
             * Net Margin High
             * @default 20
             */
            net_margin_high: number;
            /**
             * Labor Cost Pct
             * @default 28
             */
            labor_cost_pct: number;
            /**
             * Rent Pct
             * @default 6
             */
            rent_pct: number;
        };
        /**
         * IndustryInfo
         * @description Available industry for benchmarking.
         */
        IndustryInfo: {
            /** Key */
            key: string;
            /** Name */
            name: string;
        };
        /**
         * InputSource
         * @enum {string}
         */
        InputSource: InputSource;
        /**
         * InsuranceTerms
         * @description Extracted insurance policy terms.
         */
        InsuranceTerms: {
            /** Policy Number */
            policy_number?: string | null;
            /** Carrier Name */
            carrier_name?: string | null;
            /** Insured Name */
            insured_name?: string | null;
            /** Insured Address */
            insured_address?: string | null;
            /** Policy Effective Date */
            policy_effective_date?: string | null;
            /** Policy Expiration Date */
            policy_expiration_date?: string | null;
            /** Annual Premium */
            annual_premium?: number | null;
            /**
             * Payment Frequency
             * @description annual, quarterly, monthly
             */
            payment_frequency?: string | null;
            /** Coverages */
            coverages?: components["schemas"]["CoverageDetail"][];
            /**
             * Bi Coverage Limit
             * @description Business Interruption limit
             */
            bi_coverage_limit?: number | null;
            /** Bi Deductible */
            bi_deductible?: number | null;
            /** Bi Waiting Period Days */
            bi_waiting_period_days?: number | null;
            /**
             * Bi Period Of Indemnity Months
             * @description Max coverage period
             */
            bi_period_of_indemnity_months?: number | null;
            /** Bi Coinsurance */
            bi_coinsurance?: number | null;
            /** Property Coverage Limit */
            property_coverage_limit?: number | null;
            /** Property Deductible */
            property_deductible?: number | null;
            /** General Liability Limit */
            general_liability_limit?: number | null;
            /** Professional Liability Limit */
            professional_liability_limit?: number | null;
            /** Named Perils */
            named_perils?: string[];
            /** Exclusions */
            exclusions?: string[];
            /** Endorsements */
            endorsements?: string[];
        };
        /**
         * InviteAccountantRequest
         * @description Request to invite an accountant to access a report
         */
        InviteAccountantRequest: {
            /** Report Id */
            report_id: string;
            /**
             * Email
             * Format: email
             */
            email: string;
            /** Message */
            message?: string | null;
            /**
             * Permissions
             * @default [
             *       "view",
             *       "comment",
             *       "edit",
             *       "sign"
             *     ]
             */
            permissions: InviteAccountantRequestPermissions[];
        };
        /** InviteMemberRequest */
        InviteMemberRequest: {
            /**
             * Email
             * Format: email
             */
            email: string;
            /**
             * Role
             * @default analyst
             */
            role: string;
            /** Name */
            name?: string | null;
            /**
             * Send Email
             * @default true
             */
            send_email: boolean;
        };
        /**
         * Issue
         * @description Central issue tracking model.
         *
         *     Issues are created by AI agents when they detect gaps or concerns.
         *     They flow through a lifecycle from DETECTED → RESOLVED/DISMISSED/WONT_FIX.
         */
        Issue: {
            /** Id */
            id?: string | null;
            /** Report Id */
            report_id: string;
            issue_type: components["schemas"]["IssueType"];
            /** Detected By */
            detected_by: string;
            /** Title */
            title: string;
            /** Description */
            description: string;
            /** What Would Fix */
            what_would_fix: string;
            /** Financial Impact */
            financial_impact?: string | null;
            /** Affected Items */
            affected_items?: string[];
            /** @default DETECTED */
            status: components["schemas"]["IssueStatus"];
            /** @default MEDIUM */
            priority: components["schemas"]["Priority"];
            /** Priority Reasoning */
            priority_reasoning?: string | null;
            /** Status History */
            status_history?: components["schemas"]["StatusChange"][];
            /** Request Text */
            request_text?: string | null;
            /** Request Id */
            request_id?: string | null;
            /** Requested At */
            requested_at?: string | null;
            /**
             * Reminder Count
             * @default 0
             */
            reminder_count: number;
            /** Resolved By Document */
            resolved_by_document?: string | null;
            resolution_confidence?: components["schemas"]["app__models__issue_models__ConfidenceLevel"] | null;
            /** Resolution Notes */
            resolution_notes?: string | null;
            /** Resolved At */
            resolved_at?: string | null;
            /**
             * Created At
             * Format: date-time
             */
            created_at?: string;
            /**
             * Updated At
             * Format: date-time
             */
            updated_at?: string;
        };
        /**
         * IssueListResponse
         * @description Response containing list of issues
         */
        IssueListResponse: {
            /** Issues */
            issues: components["schemas"]["Issue"][];
            /** Total */
            total: number;
            /** Pending Count */
            pending_count: number;
            /** Resolved Count */
            resolved_count: number;
        };
        /**
         * IssueMatch
         * @description Tracks document-to-issue matching results.
         *
         *     When a document is uploaded, the system attempts to match it to open issues.
         *     Matches are scored and routed based on confidence:
         *     - HIGH (>90%): Auto-process and resolve issue
         *     - MEDIUM (70-90%): Queue for human confirmation
         *     - LOW (<70%): Queue for human classification
         */
        IssueMatch: {
            /** Id */
            id?: string | null;
            /** Issue Id */
            issue_id: string;
            /** Document Id */
            document_id: string;
            /** Confidence Score */
            confidence_score: number;
            confidence_level: components["schemas"]["app__models__issue_models__ConfidenceLevel"];
            /** Match Factors */
            match_factors?: {
                [key: string]: number;
            };
            /** @default PENDING */
            status: components["schemas"]["MatchStatus"];
            /**
             * Requires Review
             * @default true
             */
            requires_review: boolean;
            /** Reviewed By */
            reviewed_by?: string | null;
            /** Reviewed At */
            reviewed_at?: string | null;
            /** Review Notes */
            review_notes?: string | null;
            /**
             * Created At
             * Format: date-time
             */
            created_at?: string;
        };
        /**
         * IssueStatus
         * @description Issue lifecycle states with enforced transitions
         * @enum {string}
         */
        IssueStatus: IssueStatus;
        /**
         * IssueType
         * @description Types of issues that can be detected by AI agents
         * @enum {string}
         */
        IssueType: IssueType;
        /**
         * JobStatistics
         * @description Job processing statistics
         */
        JobStatistics: {
            /**
             * Total Transactions
             * @default 0
             */
            total_transactions: number;
            /**
             * Auto Approved
             * @default 0
             */
            auto_approved: number;
            /**
             * Needs Review
             * @default 0
             */
            needs_review: number;
            /**
             * Reviewed
             * @default 0
             */
            reviewed: number;
            /**
             * Modified
             * @default 0
             */
            modified: number;
            /**
             * High Confidence
             * @default 0
             */
            high_confidence: number;
            /**
             * Medium Confidence
             * @default 0
             */
            medium_confidence: number;
            /**
             * Low Confidence
             * @default 0
             */
            low_confidence: number;
            /** Ocr Time Ms */
            ocr_time_ms?: number | null;
            /** Extraction Time Ms */
            extraction_time_ms?: number | null;
            /** Classification Time Ms */
            classification_time_ms?: number | null;
            /**
             * Estimated Cost Usd
             * @default 0
             */
            estimated_cost_usd: number;
        };
        /**
         * JobStatus
         * @enum {string}
         */
        JobStatus: JobStatus;
        /** LawFirmCreate */
        LawFirmCreate: {
            /** Name */
            name: string;
            /** Contact Name */
            contact_name?: string | null;
            /** Contact Email */
            contact_email?: string | null;
            /** Contact Phone */
            contact_phone?: string | null;
            /** Address */
            address?: string | null;
        };
        /** LawFirmUpdate */
        LawFirmUpdate: {
            /** Name */
            name?: string | null;
            /** Contact Name */
            contact_name?: string | null;
            /** Contact Email */
            contact_email?: string | null;
            /** Contact Phone */
            contact_phone?: string | null;
            /** Address */
            address?: string | null;
        };
        /**
         * LearnCorrectionRequest
         * @description Request to learn from human correction
         */
        LearnCorrectionRequest: {
            transaction: components["schemas"]["app__api__v1__classification__TransactionInput"];
            /**
             * Correct Category
             * @description The correct category for this transaction
             */
            correct_category: string;
        };
        /**
         * LearningStats
         * @description Statistics about the learning system
         */
        LearningStats: {
            /** Total Corrections */
            total_corrections: number;
            /** Unique Patterns */
            unique_patterns: number;
            /** Categories Learned */
            categories_learned: string[];
            /** Top Corrections */
            top_corrections: {
                [key: string]: unknown;
            }[];
        };
        /**
         * LeaseTerms
         * @description Extracted lease agreement terms.
         */
        LeaseTerms: {
            /**
             * Monthly Rent
             * @description Base monthly rent amount
             */
            monthly_rent?: number | null;
            /** Security Deposit */
            security_deposit?: number | null;
            /** Rent Due Day */
            rent_due_day?: number | null;
            /** Lease Start Date */
            lease_start_date?: string | null;
            /** Lease End Date */
            lease_end_date?: string | null;
            /** Lease Term Months */
            lease_term_months?: number | null;
            escalation?: components["schemas"]["RentEscalation"] | null;
            /**
             * Cam Charges
             * @description Common Area Maintenance
             */
            cam_charges?: number | null;
            /** Property Tax Passthrough */
            property_tax_passthrough?: number | null;
            /** Insurance Passthrough */
            insurance_passthrough?: number | null;
            /** Utilities Included */
            utilities_included?: string[];
            /** Landlord Name */
            landlord_name?: string | null;
            /** Tenant Name */
            tenant_name?: string | null;
            /** Property Address */
            property_address?: string | null;
            /**
             * Property Type
             * @description retail, office, industrial, etc.
             */
            property_type?: string | null;
            /** Square Footage */
            square_footage?: number | null;
            /**
             * Renewal Options
             * @description Number of renewal options
             */
            renewal_options?: number | null;
            /** Renewal Term Months */
            renewal_term_months?: number | null;
            /** Renewal Notice Days */
            renewal_notice_days?: number | null;
            /**
             * Early Termination Clause
             * @default false
             */
            early_termination_clause: boolean | null;
            /** Early Termination Penalty */
            early_termination_penalty?: number | null;
            /**
             * Assignment Sublease Allowed
             * @default false
             */
            assignment_sublease_allowed: boolean | null;
            /**
             * Personal Guarantee Required
             * @default false
             */
            personal_guarantee_required: boolean | null;
        };
        /** License */
        License: {
            /** State */
            state: string;
            /** License Number */
            license_number: string;
        };
        /**
         * LitigationAnalysisRequest
         * @description Request for litigation economics analysis
         * @example {
         *       "claim_value": 500000,
         *       "complexity": "medium",
         *       "current_offer": 300000,
         *       "documentation_strength": "strong",
         *       "fee_arrangement": "contingency"
         *     }
         */
        LitigationAnalysisRequest: {
            /**
             * Current Offer
             * @description Current settlement offer
             */
            current_offer: number;
            /**
             * Claim Value
             * @description Full calculated claim value
             */
            claim_value: number;
            /**
             * Complexity
             * @description Case complexity: low/medium/high/extreme
             * @default medium
             */
            complexity: string;
            /**
             * Documentation Strength
             * @description weak/medium/strong/very_strong
             * @default medium
             */
            documentation_strength: string;
            /**
             * Policy Clarity
             * @description weak/medium/strong/very_strong
             * @default medium
             */
            policy_clarity: string;
            /**
             * Causation Strength
             * @description weak/medium/strong/very_strong
             * @default medium
             */
            causation_strength: string;
            /**
             * Fee Arrangement
             * @description contingency/hourly/hybrid
             * @default contingency
             */
            fee_arrangement: string;
            /** Custom Win Probability */
            custom_win_probability?: number | null;
        };
        /**
         * LoanTerms
         * @description Extracted loan document terms.
         */
        LoanTerms: {
            /** Original Principal */
            original_principal?: number | null;
            /** Current Balance */
            current_balance?: number | null;
            /**
             * Interest Rate
             * @description Annual interest rate as decimal
             */
            interest_rate?: number | null;
            /**
             * Interest Type
             * @description fixed, variable, prime_plus
             */
            interest_type?: string | null;
            /** Monthly Payment */
            monthly_payment?: number | null;
            /** Payment Due Day */
            payment_due_day?: number | null;
            /** Loan Start Date */
            loan_start_date?: string | null;
            /** Loan Maturity Date */
            loan_maturity_date?: string | null;
            /** Loan Term Months */
            loan_term_months?: number | null;
            /** Lender Name */
            lender_name?: string | null;
            /** Borrower Name */
            borrower_name?: string | null;
            /**
             * Loan Type
             * @description term, line_of_credit, sba, etc.
             */
            loan_type?: string | null;
            /** Collateral Description */
            collateral_description?: string | null;
            /**
             * Is Secured
             * @default false
             */
            is_secured: boolean;
            /** Prepayment Penalty */
            prepayment_penalty?: number | null;
            /** Late Fee */
            late_fee?: number | null;
            /** Late Fee Grace Days */
            late_fee_grace_days?: number | null;
            /** Payment Schedule Summary */
            payment_schedule_summary?: components["schemas"]["PaymentScheduleEntry"][];
            /**
             * Is Sba Loan
             * @default false
             */
            is_sba_loan: boolean;
            /** Sba Guarantee Percentage */
            sba_guarantee_percentage?: number | null;
            /**
             * Eidl Loan
             * @default false
             */
            eidl_loan: boolean;
            /**
             * Ppp Loan
             * @default false
             */
            ppp_loan: boolean;
        };
        /** LogActivityRequest */
        LogActivityRequest: {
            /** Report Id */
            report_id: string;
            /** Action Type */
            action_type: string;
            /** Action Details */
            action_details?: string | null;
            /** Section */
            section?: string | null;
            /**
             * Metadata
             * @default {}
             */
            metadata: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * LossPeriodDetectionRequest
         * @description Request for auto-detecting loss period from financial data
         */
        LossPeriodDetectionRequest: {
            /** Plfiles */
            plFiles?: {
                [key: string]: unknown;
            }[] | null;
            /** Financial Data */
            financial_data?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * ManualClarificationResponse
         * @description Manual response entry from specialist.
         */
        ManualClarificationResponse: {
            /** Transaction Id */
            transaction_id: string;
            /** Category */
            category: string;
            /** Notes */
            notes?: string | null;
        };
        /**
         * ManualCorrectionRequest
         * @description Request to manually add a correction
         */
        ManualCorrectionRequest: {
            /** Job Id */
            job_id: string;
            /** Transaction Id */
            transaction_id: string;
            /** Original Category */
            original_category: string;
            /** Original Confidence */
            original_confidence: number;
            /** Corrected Category */
            corrected_category: string;
            /** Payee */
            payee: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Correction Reason */
            correction_reason?: string | null;
        };
        /**
         * ManualFulfillmentRequest
         * @description Request body for manual fulfillment.
         */
        ManualFulfillmentRequest: {
            /** Notes */
            notes?: string | null;
            /** Document Ids */
            document_ids?: string[] | null;
        };
        /**
         * MatchListResponse
         * @description Response containing list of pending matches
         */
        MatchListResponse: {
            /** Matches */
            matches: components["schemas"]["IssueMatch"][];
            /** Total */
            total: number;
        };
        /**
         * MatchStatus
         * @description Status of document-to-issue match
         * @enum {string}
         */
        MatchStatus: MatchStatus;
        /** MemoryStatsResponse */
        MemoryStatsResponse: {
            /**
             * Redis Count
             * @default 0
             */
            redis_count: number;
            /**
             * Mongo Count
             * @default 0
             */
            mongo_count: number;
            /**
             * Agents
             * @default {}
             */
            agents: {
                [key: string]: unknown;
            };
            /** Oldest Memory */
            oldest_memory?: string | null;
            /** Newest Memory */
            newest_memory?: string | null;
        };
        /**
         * MessinessCheckResponse
         * @description Response for messiness check
         */
        MessinessCheckResponse: {
            /** Needs Cleanup */
            needs_cleanup: boolean;
            /** Confidence */
            confidence: number;
            /** Reasons */
            reasons: string[];
            /** Recommendation */
            recommendation: string;
            /** File Type */
            file_type: string;
            /**
             * Issues
             * @default []
             */
            issues: components["schemas"]["MessinessIssue"][];
            /**
             * Details
             * @default {}
             */
            details: {
                [key: string]: unknown;
            };
        };
        /**
         * MessinessIssue
         * @description Individual messiness issue
         */
        MessinessIssue: {
            /** Type */
            type: string;
            /** Severity */
            severity: string;
            /** Message */
            message: string;
            /** Suggestion */
            suggestion: string;
            /**
             * Fixable
             * @default false
             */
            fixable: boolean;
        };
        /**
         * MetricComparison
         * @description Single metric comparison result.
         */
        MetricComparison: {
            /** Metric Key */
            metric_key: string;
            /** Metric Name */
            metric_name: string;
            /** Description */
            description: string;
            /** Business Value */
            business_value: number;
            /** Benchmark Low */
            benchmark_low: number;
            /** Benchmark Mid */
            benchmark_mid: number;
            /** Benchmark High */
            benchmark_high: number;
            /** Unit */
            unit: string;
            /** Deviation Percent */
            deviation_percent: number;
            /** Deviation Level */
            deviation_level: string;
            /** Percentile */
            percentile: number;
            /** Explanation */
            explanation: string;
            /** Claim Impact */
            claim_impact: string;
        };
        /**
         * MitigationCalculateRequest
         * @description Request body for mitigation credit calculation.
         */
        MitigationCalculateRequest: {
            mitigation_factors: components["schemas"]["MitigationFactorsInput"];
            /**
             * Industry Code
             * @description NAICS industry code (e.g. '722511')
             */
            industry_code?: string | null;
        };
        /**
         * MitigationDetail
         * @description Frontend reads calculation_detail.mitigation.{total_mitigation, method, adjusted_loss}.
         */
        MitigationDetail: {
            /**
             * Total Mitigation
             * @description Mitigation credit deducted from claimed loss, USD
             */
            total_mitigation: number;
            /**
             * Method
             * @description Methodology / industry adjustment note shown on the card
             */
            method: string;
            /**
             * Adjusted Loss
             * @description claimed_loss - total_mitigation, USD
             */
            adjusted_loss: number;
        };
        /**
         * MitigationFactorsInput
         * @description Input model for mitigation factor toggles.
         */
        MitigationFactorsInput: {
            /**
             * Marketing Maintained
             * @description Did the insured maintain marketing during the loss period?
             * @default false
             */
            marketing_maintained: boolean;
            /**
             * Temp Relocation
             * @description Did the insured establish temporary operations?
             * @default false
             */
            temp_relocation: boolean;
            /**
             * Alt Revenue
             * @description Did the insured pursue alternative revenue streams?
             * @default false
             */
            alt_revenue: boolean;
            /**
             * Expense Reduction
             * @description Did the insured reduce unnecessary expenses?
             * @default false
             */
            expense_reduction: boolean;
            /**
             * Resume Timeline
             * @description Operations resume timeline: on_time, delayed, significantly_delayed
             * @default significantly_delayed
             */
            resume_timeline: string;
        };
        /**
         * NewClientRequest
         * @description Request model for attorney submitting a new client
         */
        NewClientRequest: {
            /** Client Name */
            client_name: string;
            /** Client Email */
            client_email: string;
            /** Client Phone */
            client_phone?: string | null;
            /** Business Name */
            business_name?: string | null;
            /** Business Type */
            business_type?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Date */
            event_date?: string | null;
            /** Notes */
            notes?: string | null;
            /**
             * Send Email
             * @default true
             */
            send_email: boolean;
        };
        /**
         * NewClientResponse
         * @description Response when a new client is submitted
         */
        NewClientResponse: {
            /** Success */
            success: boolean;
            /** Client Id */
            client_id: string;
            /** Case Id */
            case_id: string;
            /** Portal Token */
            portal_token?: string | null;
            /** Portal Url */
            portal_url?: string | null;
            /**
             * Email Sent
             * @default false
             */
            email_sent: boolean;
            /** Message */
            message: string;
        };
        /**
         * NormalizationResponse
         * @description Response for data normalization
         */
        NormalizationResponse: {
            /** Success */
            success: boolean;
            /** Total Fields */
            total_fields: number;
            /** Fields Normalized */
            fields_normalized: number;
            /** Records */
            records: {
                [key: string]: unknown;
            }[];
            /** Summary */
            summary: {
                [key: string]: number;
            };
        };
        /**
         * NormalizeRequest
         * @description Request body for normalization
         */
        NormalizeRequest: {
            /** Records */
            records: {
                [key: string]: unknown;
            }[];
            /** Field Types */
            field_types?: {
                [key: string]: string;
            } | null;
        };
        /**
         * NotificationListResponse
         * @description List of notifications with metadata
         */
        NotificationListResponse: {
            /** Notifications */
            notifications: components["schemas"]["NotificationResponse"][];
            /** Total */
            total: number;
            /** Unread Count */
            unread_count: number;
        };
        /**
         * NotificationResponse
         * @description Single notification response
         */
        NotificationResponse: {
            /** Id */
            id: string;
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Message */
            message: string;
            /** Job Id */
            job_id?: string | null;
            /** Link */
            link?: string | null;
            /** Is Read */
            is_read: boolean;
            /** Read At */
            read_at?: string | null;
            /** Created At */
            created_at: string;
        };
        /**
         * NowLineBreakdown
         * @description Breakdown item for NowLine stats.
         */
        NowLineBreakdown: {
            /** Label */
            label: string;
            /** Count */
            count: number;
        };
        /**
         * NowLineSection
         * @description Section of NowLine stats (needs attention or no action).
         */
        NowLineSection: {
            /** Count */
            count: number;
            /**
             * Breakdown
             * @default []
             */
            breakdown: components["schemas"]["NowLineBreakdown"][];
        };
        /**
         * NowLineStatsResponse
         * @description Response for Now-Line dashboard split.
         */
        NowLineStatsResponse: {
            needs_attention: components["schemas"]["NowLineSection"];
            no_action_needed: components["schemas"]["NowLineSection"];
        };
        /**
         * OrchestratorAnalyzeRequest
         * @description Optional parameters for forensic orchestrator analysis
         */
        OrchestratorAnalyzeRequest: {
            /**
             * Include Prophet
             * @default true
             */
            include_prophet: boolean;
            /**
             * Include Fraud Graph
             * @default true
             */
            include_fraud_graph: boolean;
            /**
             * Include Bls Benchmarks
             * @default true
             */
            include_bls_benchmarks: boolean;
            /**
             * Include Anomaly Ensemble
             * @default true
             */
            include_anomaly_ensemble: boolean;
            /**
             * Force Refresh
             * @default false
             */
            force_refresh: boolean;
        };
        /**
         * OrchestratorAnalyzeResponse
         * @description Response from forensic orchestrator analysis
         */
        OrchestratorAnalyzeResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /**
             * Cached
             * @default false
             */
            cached: boolean;
            /** Results */
            results?: {
                [key: string]: unknown;
            } | null;
            /** Error */
            error?: string | null;
        };
        /** OrchestratorStatsResponse */
        OrchestratorStatsResponse: {
            /** Total Jobs */
            total_jobs: number;
            /** Cache Hits */
            cache_hits: number;
            /** Tier1 Count */
            tier1_count: number;
            /** Tier2 Count */
            tier2_count: number;
            /** Tier3 Count */
            tier3_count: number;
            /** Failed Count */
            failed_count: number;
            cache: components["schemas"]["CacheStatsResponse"];
            /** Active Jobs */
            active_jobs: number;
        };
        /** OrgResponse */
        OrgResponse: {
            /** Org Id */
            org_id: string;
            /** Tier */
            tier: string;
            /** Report Limit */
            report_limit: number;
            /** User Limit */
            user_limit: number;
            /** Reports Used */
            reports_used: number;
            /** Users Count */
            users_count: number;
        };
        /**
         * OutcomeResponse
         * @description Response schema for outcome data.
         */
        OutcomeResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Claimant Name */
            claimant_name?: string | null;
            /** Final Settlement Amount */
            final_settlement_amount: number;
            /** Settlement Date */
            settlement_date: string;
            /** Settlement Type */
            settlement_type: string;
            /** Time To Resolution Days */
            time_to_resolution_days?: number | null;
            /** Satisfaction Rating */
            satisfaction_rating?: number | null;
            /** Notes */
            notes?: string | null;
            /** Industry Type */
            industry_type?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Claim Amount Original */
            claim_amount_original?: number | null;
            /** Settlement Ratio */
            settlement_ratio?: number | null;
            /** Submitted By */
            submitted_by: string;
            /** Submitted At */
            submitted_at: string;
        };
        /**
         * OutcomeStats
         * @description Aggregate statistics for benchmarking.
         */
        OutcomeStats: {
            /** Total Outcomes */
            total_outcomes: number;
            /** Average Settlement Ratio */
            average_settlement_ratio: number;
            /** Average Time To Resolution */
            average_time_to_resolution: number;
            /** Average Satisfaction */
            average_satisfaction: number;
            /** Settlement Type Breakdown */
            settlement_type_breakdown: {
                [key: string]: unknown;
            };
            /** Industry Breakdown */
            industry_breakdown: {
                [key: string]: unknown;
            };
            /** Event Type Breakdown */
            event_type_breakdown: {
                [key: string]: unknown;
            };
        };
        /**
         * OutcomeSubmission
         * @description Schema for submitting a report outcome.
         * @example {
         *       "final_settlement_amount": 425000,
         *       "notes": "Settled at 95% of calculated value",
         *       "report_id": "b6569476-b210-4c79-8546-0807a39ebbd1",
         *       "satisfaction_rating": 4,
         *       "settlement_date": "2025-01-15",
         *       "settlement_type": "negotiated",
         *       "time_to_resolution_days": 45
         *     }
         */
        OutcomeSubmission: {
            /** Report Id */
            report_id: string;
            /**
             * Final Settlement Amount
             * @description Final settlement amount received
             */
            final_settlement_amount: number;
            /**
             * Settlement Date
             * @description Date settlement was finalized (YYYY-MM-DD)
             */
            settlement_date: string;
            /**
             * Settlement Type
             * @description How the claim was settled
             */
            settlement_type: string;
            /**
             * Time To Resolution Days
             * @description Days from claim filing to settlement
             */
            time_to_resolution_days?: number | null;
            /**
             * Satisfaction Rating
             * @description 1-5 rating of outcome
             */
            satisfaction_rating?: number | null;
            /**
             * Notes
             * @description Additional notes about the outcome
             */
            notes?: string | null;
            /** Industry Type */
            industry_type?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Claim Amount Original */
            claim_amount_original?: number | null;
        };
        /**
         * OverallMetrics
         * @description Overall monitoring metrics
         */
        OverallMetrics: {
            /**
             * Total Transactions
             * @default 0
             */
            total_transactions: number;
            /**
             * Total Jobs
             * @default 0
             */
            total_jobs: number;
            /**
             * Auto Approval Rate
             * @default 0
             */
            auto_approval_rate: number;
            /**
             * Human Review Rate
             * @default 0
             */
            human_review_rate: number;
            /**
             * Override Rate
             * @default 0
             */
            override_rate: number;
            /**
             * Avg Confidence
             * @default 0
             */
            avg_confidence: number;
            /**
             * Accuracy Score
             * @default 0
             */
            accuracy_score: number;
            /**
             * Processing Time Avg Sec
             * @default 0
             */
            processing_time_avg_sec: number;
        };
        /**
         * OverallStatus
         * @enum {string}
         */
        OverallStatus: OverallStatus;
        /**
         * OverallSummaryResponse
         * @description Overall deliberation summary.
         */
        OverallSummaryResponse: {
            /** Total Events */
            total_events: number;
            /** Total Tools Used */
            total_tools_used: number;
            /** Disagreements Found */
            disagreements_found: boolean;
            /** Consensus Reached */
            consensus_reached: boolean;
        };
        /**
         * OverlayStatus
         * @enum {string}
         */
        OverlayStatus: OverlayStatus;
        /** OverrideCreateRequest */
        OverrideCreateRequest: {
            /** Field Id */
            field_id: string;
            /** Override Value */
            override_value: unknown;
            /** Original Value */
            original_value: unknown;
            /** Note */
            note: string;
            /** @default manual */
            origin: components["schemas"]["OverrideOrigin"];
            /** Prompted By Ai Audit Id */
            prompted_by_ai_audit_id?: string | null;
            /**
             * Workpaper Schema Version
             * @default v1
             */
            workpaper_schema_version: string;
            /**
             * Auto Trigger Rerun
             * @default true
             */
            auto_trigger_rerun: boolean;
        };
        /** OverrideCreateResponse */
        OverrideCreateResponse: {
            /**
             * Success
             * @default true
             */
            success: boolean;
            /** Override Id */
            override_id: string;
            /** Superseded Override Id */
            superseded_override_id?: string | null;
            /**
             * Rerun Triggered
             * @default false
             */
            rerun_triggered: boolean;
            /** Rerun Task Id */
            rerun_task_id?: string | null;
            /** Downstream Engines Invalidated */
            downstream_engines_invalidated?: string[];
        };
        /** OverrideInactivateRequest */
        OverrideInactivateRequest: {
            /** Reason */
            reason: string;
        };
        /** OverrideInactivateResponse */
        OverrideInactivateResponse: {
            /**
             * Success
             * @default true
             */
            success: boolean;
            /** Override Id */
            override_id: string;
            /**
             * Rerun Triggered
             * @default false
             */
            rerun_triggered: boolean;
            /** Rerun Task Id */
            rerun_task_id?: string | null;
        };
        /** OverrideListItem */
        OverrideListItem: {
            /** Id */
            id: string;
            /** Field Id */
            field_id: string;
            /** Override Value */
            override_value: unknown;
            /** Original Value */
            original_value: unknown;
            /** Note */
            note: string;
            /** Origin */
            origin: string;
            /** Is Active */
            is_active: boolean;
            /** Created At */
            created_at: string;
            /** Created By User Id */
            created_by_user_id: string;
            /** Inactivated At */
            inactivated_at?: string | null;
            /** Inactivation Reason */
            inactivation_reason?: string | null;
        };
        /** OverrideListResponse */
        OverrideListResponse: {
            /** Report Id */
            report_id: string;
            /** Overrides */
            overrides: {
                [key: string]: unknown;
            }[];
            /** Reconciliation */
            reconciliation?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * OverrideOrigin
         * @description Two mutually exclusive entry points, one per endpoint.
         *
         *     Keeping them as separate endpoints (not a shared handler) makes
         *     "manual must have null ai audit id; ai-suggestion must have one"
         *     an API-layer invariant, not a post-hoc service check.
         * @enum {string}
         */
        OverrideOrigin: OverrideOrigin;
        /** OverrideRequest */
        OverrideRequest: {
            /**
             * Action
             * @description One of: correct_amount, rematch, skip_platform, unmatch
             */
            action: string;
            target: components["schemas"]["OverrideTarget"];
            /** New Value */
            new_value?: {
                [key: string]: unknown;
            };
            /** Reason */
            reason: string;
        };
        /**
         * OverrideTarget
         * @description Composite identifier for the override's subject.
         *
         *     Per-match overrides (unmatch / rematch / correct_amount) require
         *     year + ach_date + ach_platform + ach_net. skip_platform only needs
         *     ``platform``. We validate at the action level rather than making
         *     fields mandatory here.
         */
        OverrideTarget: {
            /** Year */
            year?: number | null;
            /** Ach Date */
            ach_date?: string | null;
            /** Ach Platform */
            ach_platform?: string | null;
            /** Ach Net */
            ach_net?: number | null;
            /** Platform */
            platform?: string | null;
        };
        /** OverrideWriteResponse */
        OverrideWriteResponse: {
            /** Report Id */
            report_id: string;
            /** Override */
            override: {
                [key: string]: unknown;
            };
            /** Overrides Count */
            overrides_count: number;
        };
        /**
         * PDFBranding
         * @description PDF-specific branding options
         */
        PDFBranding: {
            /**
             * Show Logo
             * @default true
             */
            show_logo: boolean;
            /**
             * Logo Position
             * @description Logo position: top-left, top-center, top-right
             * @default top-left
             */
            logo_position: string;
            /**
             * Logo Size
             * @description Logo size: small, medium, large
             * @default medium
             */
            logo_size: string;
            /**
             * Header Color
             * @description PDF header color
             * @default #7c3aed
             */
            header_color: string;
            /**
             * Footer Text
             * @description Custom footer text
             */
            footer_text?: string | null;
            /**
             * Show Page Numbers
             * @default true
             */
            show_page_numbers: boolean;
            /**
             * Watermark
             * @description Default watermark text
             */
            watermark?: string | null;
            /**
             * Include Disclaimer
             * @default true
             */
            include_disclaimer: boolean;
            /**
             * Disclaimer Text
             * @description Custom disclaimer
             */
            disclaimer_text?: string | null;
        };
        /**
         * PDFJobCreate
         * @description Request to create a PDF generation job
         */
        PDFJobCreate: {
            /** Report Id */
            report_id: string;
            /**
             * Include Appendices
             * @default true
             */
            include_appendices: boolean;
            /**
             * Include Supporting Docs
             * @default true
             */
            include_supporting_docs: boolean;
            /** Watermark */
            watermark?: string | null;
        };
        /**
         * PDFJobListResponse
         * @description Response model for listing PDF jobs
         */
        PDFJobListResponse: {
            /** Jobs */
            jobs: unknown[];
            /** Total */
            total: number;
        };
        /**
         * PDFJobResponse
         * @description Response model for PDF job
         */
        PDFJobResponse: {
            /** Job Id */
            job_id: string;
            /** Report Id */
            report_id: string;
            /** Status */
            status: string;
            /** Progress */
            progress: number;
            /** Progress Message */
            progress_message: string;
            /** Created At */
            created_at: string;
            /** Started At */
            started_at?: string | null;
            /** Completed At */
            completed_at?: string | null;
            /** Pdf Url */
            pdf_url?: string | null;
            /** Error */
            error?: string | null;
            /** Options */
            options: {
                [key: string]: unknown;
            };
        };
        /**
         * PLBenchmarkResponse
         * @description Response from P&L benchmark comparison.
         */
        PLBenchmarkResponse: {
            /** Success */
            success: boolean;
            /** Industry */
            industry: string;
            /** Industry Key */
            industry_key: string;
            /** Business Type Input */
            business_type_input?: string | null;
            /** Totals */
            totals?: {
                [key: string]: number;
            } | null;
            /** Comparisons */
            comparisons: components["schemas"]["MetricComparison"][];
            summary?: components["schemas"]["BenchmarkSummary"] | null;
            /**
             * Forensic Implications
             * @default []
             */
            forensic_implications: string[];
            /** Error */
            error?: string | null;
        };
        /**
         * PLParseResponse
         * @description Response from P&L parsing
         */
        PLParseResponse: {
            /** Success */
            success: boolean;
            /** Message */
            message: string;
            /** Canonical Pl */
            canonical_pl?: {
                [key: string]: unknown;
            } | null;
            /**
             * Confidence
             * @default 0
             */
            confidence: number;
            /**
             * Requires Review
             * @default false
             */
            requires_review: boolean;
            /**
             * Warnings
             * @default []
             */
            warnings: string[];
        };
        /**
         * PackageDetailResponse
         * @description Full package details.
         */
        PackageDetailResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Generated At */
            generated_at: string;
            /** Status */
            status: string;
            /** Case Name */
            case_name: string;
            /** Client Name */
            client_name: string;
            /** Event Type */
            event_type: string;
            /** Executive Summary */
            executive_summary: string;
            /** Settlement Calculation */
            settlement_calculation: {
                [key: string]: unknown;
            };
            /** Case Strength Report */
            case_strength_report: {
                [key: string]: unknown;
            };
            /** Vulnerability Matrix */
            vulnerability_matrix: {
                [key: string]: unknown;
            }[];
            /** Document Index */
            document_index: {
                [key: string]: unknown;
            }[];
            /** Confidence Scores */
            confidence_scores: {
                [key: string]: number;
            };
            /** Methodology Notes */
            methodology_notes: string;
            /** Total Documents */
            total_documents: number;
            /** Total Transactions */
            total_transactions: number;
            /** Pdf Url */
            pdf_url: string | null;
            /** Version */
            version: number;
        };
        /**
         * PackageSummaryResponse
         * @description Compact package summary.
         */
        PackageSummaryResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Status */
            status: string;
            /** Case Name */
            case_name: string;
            /** Settlement Amount */
            settlement_amount: number;
            /** Case Strength */
            case_strength: number;
            /** Generated At */
            generated_at: string;
            /** Pdf Available */
            pdf_available: boolean;
        };
        /**
         * ParseClientResponsesRequest
         * @description Request to parse client responses using AI.
         */
        ParseClientResponsesRequest: {
            /** Claim Id */
            claim_id: string;
            /** Responses */
            responses: components["schemas"]["ClientResponseItem"][];
        };
        /** PasswordResetConfirm */
        PasswordResetConfirm: {
            /** Token */
            token: string;
            /** New Password */
            new_password: string;
        };
        /** PasswordResetRequest */
        PasswordResetRequest: {
            /** Email */
            email: string;
        };
        /**
         * PatternConfidence
         * @description Pattern confidence levels
         * @enum {string}
         */
        PatternConfidence: PatternConfidence;
        /**
         * PatternMatchResult
         * @description Result from pattern matching
         */
        PatternMatchResult: {
            /** Pattern Id */
            pattern_id: string;
            /** Match Score */
            match_score: number;
            /** Matched Keywords */
            matched_keywords: string[];
            /** Suggested Category */
            suggested_category: string;
            /** Suggested Subcategory */
            suggested_subcategory: string;
            /** Confidence */
            confidence: string;
            /** Rationale */
            rationale: string;
        };
        /**
         * PatternTestRequest
         * @description Request to test a transaction against patterns
         */
        PatternTestRequest: {
            /**
             * Vendor
             * @description Vendor name
             */
            vendor: string;
            /**
             * Description
             * @description Transaction description
             * @default
             */
            description: string;
            /**
             * Amount
             * @description Transaction amount
             */
            amount?: number | null;
            /**
             * Mcc
             * @description Merchant Category Code
             */
            mcc?: string | null;
            /**
             * Event Id
             * @description Event ID to match against
             * @default smitty_supply_2025
             */
            event_id: string;
        };
        /**
         * PatternTestResponse
         * @description Response from pattern test
         */
        PatternTestResponse: {
            /** Matches */
            matches: components["schemas"]["PatternMatchResult"][];
            /** Total Patterns Checked */
            total_patterns_checked: number;
            best_match: components["schemas"]["PatternMatchResult"] | null;
            /** Ai Suggestion Available */
            ai_suggestion_available: boolean;
        };
        /**
         * PayeeInfoBatchRequest
         * @description Batch request to provide payee info for multiple transactions
         */
        PayeeInfoBatchRequest: {
            /** Payee Mappings */
            payee_mappings: components["schemas"]["PayeeInfoRequest"][];
        };
        /**
         * PayeeInfoRequest
         * @description Request to provide payee info for unclassified transaction
         */
        PayeeInfoRequest: {
            /**
             * Original Description
             * @description Original transaction description (e.g., 'CHECK #7202')
             */
            original_description: string;
            /**
             * Payee Name
             * @description Actual payee/vendor name
             */
            payee_name: string;
            /**
             * Category
             * @description Optional: category if known
             */
            category?: string | null;
            /**
             * Apply To Similar
             * @description Learn and apply to similar transactions
             * @default true
             */
            apply_to_similar: boolean;
        };
        /**
         * PaymentScheduleEntry
         * @description Single payment in amortization schedule.
         */
        PaymentScheduleEntry: {
            /** Payment Number */
            payment_number: number;
            /** Due Date */
            due_date?: string | null;
            /** Principal */
            principal: number;
            /** Interest */
            interest: number;
            /** Total Payment */
            total_payment: number;
            /** Remaining Balance */
            remaining_balance: number;
        };
        /** PayrollAdjustmentListResponse */
        PayrollAdjustmentListResponse: {
            /** Report Id */
            report_id: string;
            /** Adjustments */
            adjustments: {
                [key: string]: unknown;
            }[];
            /** Total Cents */
            total_cents: number;
        };
        /** PayrollAdjustmentRequest */
        PayrollAdjustmentRequest: {
            /**
             * Category
             * @description One of: bonus_timing, non_continuing_wages, officer_comp, other
             */
            category: string;
            /**
             * Amount Cents
             * @description Non-negative integer cents (no floats — court-grade math).
             */
            amount_cents: number;
            /**
             * Period
             * @description Month in YYYY-MM format.
             */
            period: string;
            /** Reason */
            reason: string;
        };
        /** PayrollAdjustmentWriteResponse */
        PayrollAdjustmentWriteResponse: {
            /** Report Id */
            report_id: string;
            /** Adjustment */
            adjustment: {
                [key: string]: unknown;
            };
            /** Total Cents */
            total_cents: number;
            /** Forensic Cache Invalidated */
            forensic_cache_invalidated: boolean;
        };
        /**
         * PeriodRecord
         * @description Period-level aggregated data
         */
        PeriodRecord: {
            /** Year */
            year: number;
            /** Month */
            month: number;
            /**
             * Gross Revenue
             * @default 0
             */
            gross_revenue: number | null;
            /**
             * Cogs
             * @default 0
             */
            cogs: number | null;
            /**
             * Fixed Costs
             * @default 0
             */
            fixed_costs: number | null;
            /**
             * Variable Costs
             * @default 0
             */
            variable_costs: number | null;
            /** Net Profit */
            net_profit?: number | null;
        };
        /** PipelineBreakdown */
        PipelineBreakdown: {
            /** Stage */
            stage: string;
            /** Count */
            count: number;
            /**
             * Value
             * @default 0
             */
            value: number;
        };
        /** PipelineStatusResponse */
        PipelineStatusResponse: {
            /** Claimid */
            claimId: string;
            /** Claimname */
            claimName: string;
            /** Agents */
            agents: components["schemas"]["AgentStatusResponse"][];
            /** Currentagent */
            currentAgent?: string | null;
            /**
             * Pendinghumanreview
             * @default 0
             */
            pendingHumanReview: number;
            /** Estimatedcompletion */
            estimatedCompletion?: string | null;
            /** Lastupdated */
            lastUpdated: string;
            /** Totalcases */
            totalCases?: number | null;
        };
        /** PolicyCoverageResponse */
        PolicyCoverageResponse: {
            /**
             * Claim Type
             * @default unknown
             */
            claim_type: string;
            /** Responsible Party */
            responsible_party?: string | null;
            /** Bi Limit */
            bi_limit?: number | null;
            /** Extra Expense Limit */
            extra_expense_limit?: number | null;
            /** Combined Limit */
            combined_limit?: number | null;
            /** Deductible */
            deductible?: number | null;
            /** Waiting Period Days */
            waiting_period_days?: number | null;
            /** Exclusions */
            exclusions?: string[] | null;
            /** Policy Document Url */
            policy_document_url?: string | null;
            /** Policy Number */
            policy_number?: string | null;
            /** Insurer Name */
            insurer_name?: string | null;
            /** Effective Date */
            effective_date?: string | null;
            /** Expiration Date */
            expiration_date?: string | null;
        };
        /**
         * PolicyDNARequest
         * @description Request for policy DNA extraction
         */
        PolicyDNARequest: {
            /**
             * Raw Text
             * @description Full text of the insurance policy
             */
            raw_text: string;
            /**
             * Policy Id
             * @description Optional policy identifier
             */
            policy_id?: string | null;
            /**
             * Case Id
             * @description Optional case ID for storage
             */
            case_id?: string | null;
        };
        /**
         * PolicyDNARetrieveRequest
         * @description Request to retrieve stored policy DNA
         */
        PolicyDNARetrieveRequest: {
            /**
             * Case Id
             * @description Case ID to retrieve policy DNA for
             */
            case_id: string;
            /**
             * Policy Id
             * @description Specific policy ID (optional)
             */
            policy_id?: string | null;
        };
        /**
         * PolicyDeductionsDetail
         * @description Frontend reads calculation_detail.policy_deductions.{deductible, coinsurance_pct, policy_limit, net_amount}.
         */
        PolicyDeductionsDetail: {
            /**
             * Deductible
             * @description Flat dollar deductible applied, USD
             */
            deductible: number;
            /**
             * Coinsurance Pct
             * @description Required coinsurance percent (0-100)
             */
            coinsurance_pct: number;
            /**
             * Policy Limit
             * @description Maximum coverage cap, USD
             */
            policy_limit: number;
            /**
             * Net Amount
             * @description Claim after deductions and policy-limit cap, USD
             */
            net_amount: number;
        };
        /** PredictDurationRequest */
        PredictDurationRequest: {
            /** Event Type */
            event_type: string;
            /** Business Type */
            business_type: string;
            /** Location */
            location: string;
        };
        /**
         * PredictRequest
         * @description Request to generate predictions
         */
        PredictRequest: {
            /** User Id */
            user_id: string;
            /** Event Type */
            event_type?: string | null;
            /**
             * Apply Seasonal
             * @default true
             */
            apply_seasonal: boolean;
        };
        /**
         * PresentValueDetail
         * @description Frontend reads calculation_detail.present_value.{discount_rate, pv_amount, undiscounted_total}.
         */
        PresentValueDetail: {
            /**
             * Discount Rate
             * @description Effective annual discount rate as percent (0-100)
             */
            discount_rate: number;
            /**
             * Pv Amount
             * @description Discounted present value of future losses, USD
             */
            pv_amount: number;
            /**
             * Undiscounted Total
             * @description Pre-discount total of future losses, USD
             */
            undiscounted_total: number;
        };
        /**
         * Priority
         * @description Issue priority levels for sorting and display
         * @enum {string}
         */
        Priority: Priority;
        /**
         * PriorityScore
         * @description Priority scoring for an issue based on blocking impact
         */
        PriorityScore: {
            /** Issue Id */
            issue_id: string;
            /** Priority Score */
            priority_score: number;
            /** Blocking Calculations */
            blocking_calculations: string[];
            /** Affected Amount */
            affected_amount: number;
            /** Urgency Reason */
            urgency_reason: string;
        };
        /** PriorityScoreRequest */
        PriorityScoreRequest: {
            /** Issue Ids */
            issue_ids?: string[] | null;
            /** Report Id */
            report_id?: string | null;
        };
        /** PriorityScoreResponse */
        PriorityScoreResponse: {
            /** Scores */
            scores: components["schemas"]["PriorityScore"][];
            /** Total Issues */
            total_issues: number;
        };
        /** ProactiveSuggestionsRequest */
        ProactiveSuggestionsRequest: {
            /** Claim Id */
            claim_id: string;
            /** Current Step */
            current_step?: number | null;
        };
        /**
         * ProfileRequest
         * @description Request for data profiling
         */
        ProfileRequest: {
            /** Transactions */
            transactions?: components["schemas"]["TransactionRecord"][] | null;
            /** Periods */
            periods?: components["schemas"]["PeriodRecord"][] | null;
            /**
             * Data Type
             * @default transactions
             */
            data_type: string;
            /**
             * Use Ydata
             * @default true
             */
            use_ydata: boolean;
            /** Title */
            title?: string | null;
        };
        /**
         * ProfileResponse
         * @description Response from data profiling
         */
        ProfileResponse: {
            /** Success */
            success: boolean;
            /** Profile Type */
            profile_type: string;
            /** Row Count */
            row_count: number;
            /** Column Count */
            column_count: number;
            /** Memory Size Mb */
            memory_size_mb: number;
            /** Total Anomalies */
            total_anomalies: number;
            /** High Severity Anomalies */
            high_severity_anomalies: number;
            /** Columns */
            columns: {
                [key: string]: unknown;
            };
            /** Correlations */
            correlations?: {
                [key: string]: {
                    [key: string]: number;
                };
            } | null;
            /** Metadata */
            metadata: {
                [key: string]: unknown;
            };
        };
        /**
         * QualityReportRequest
         * @description Request for quality report generation
         */
        QualityReportRequest: {
            /** Case Id */
            case_id?: string | null;
            /** Case Name */
            case_name?: string | null;
            /** Transactions */
            transactions?: components["schemas"]["TransactionRecord"][] | null;
            /** Periods */
            periods?: components["schemas"]["PeriodRecord"][] | null;
            /** Documents */
            documents?: components["schemas"]["DocumentInput"][] | null;
            /**
             * Format
             * @default json
             */
            format: string;
        };
        /** QueryRequest */
        QueryRequest: {
            /** Question */
            question: string;
            /** Focus Engine Id */
            focus_engine_id?: string | null;
        };
        /** QueryResponse */
        QueryResponse: {
            /** Answer */
            answer: string;
            /**
             * Referenced Events
             * @default []
             */
            referenced_events: string[];
            token_usage: components["schemas"]["TokenUsage"];
            /** Queries Today */
            queries_today: number;
            /** Queries Remaining */
            queries_remaining: number;
        };
        /**
         * QueueListResponse
         * @description Response model for queue listing.
         */
        QueueListResponse: {
            /** Cases */
            cases: components["schemas"]["CaseSummaryResponse"][];
            /** Total Count */
            total_count: number;
            /**
             * Page
             * @default 1
             */
            page: number;
            /**
             * Page Size
             * @default 50
             */
            page_size: number;
            /**
             * Total Pages
             * @default 1
             */
            total_pages: number;
            /** Queue Type */
            queue_type?: string | null;
            /** User Role */
            user_role?: string | null;
        };
        /**
         * QueueStatsResponse
         * @description Response model for queue statistics.
         */
        QueueStatsResponse: {
            /**
             * Total Cases
             * @default 0
             */
            total_cases: number;
            /**
             * Needs Attention
             * @default 0
             */
            needs_attention: number;
            /**
             * No Action Needed
             * @default 0
             */
            no_action_needed: number;
            /**
             * Client
             * @default 0
             */
            client: number;
            /**
             * Data Specialist
             * @default 0
             */
            data_specialist: number;
            /**
             * Accountant
             * @default 0
             */
            accountant: number;
            /**
             * Ai Processing
             * @default 0
             */
            ai_processing: number;
            /**
             * Ready
             * @default 0
             */
            ready: number;
            /**
             * Attorney
             * @default 0
             */
            attorney: number;
            /**
             * Stale 5 Days
             * @default 0
             */
            stale_5_days: number;
            /**
             * Stale 7 Days
             * @default 0
             */
            stale_7_days: number;
            /**
             * Stale 14 Days
             * @default 0
             */
            stale_14_days: number;
            /**
             * Total Value
             * @default 0
             */
            total_value: number;
            /**
             * Cases With Transactions Needing Review
             * @default 0
             */
            cases_with_transactions_needing_review: number;
        };
        /**
         * QuickAnalysisRequest
         * @description Simplified request for quick analysis
         */
        QuickAnalysisRequest: {
            /** Claim Value */
            claim_value: number;
            /**
             * Negotiation Style
             * @default competitive
             */
            negotiation_style: string;
        };
        /**
         * QuickBooksConnection
         * @description Response model for QuickBooks connection status
         */
        QuickBooksConnection: {
            /** Connected */
            connected: boolean;
            /** Company Name */
            company_name?: string | null;
            /** Company Id */
            company_id?: string | null;
            /** Expires At */
            expires_at?: string | null;
        };
        /**
         * QuickBooksImportResult
         * @description Response model for import results
         */
        QuickBooksImportResult: {
            /** Success */
            success: boolean;
            /** Message */
            message: string;
            /** Data */
            data?: {
                [key: string]: unknown;
            } | null;
            /**
             * Transactions Count
             * @default 0
             */
            transactions_count: number;
            /**
             * Accounts Count
             * @default 0
             */
            accounts_count: number;
        };
        /** QuickInsights */
        QuickInsights: {
            /** Cases Ready For Action */
            cases_ready_for_action: number;
            /** Total Demand Value */
            total_demand_value: number;
            /** Cases In Negotiation */
            cases_in_negotiation: number;
            /** Average Case Age Days */
            average_case_age_days: number;
        };
        /**
         * QuickSensitivityRequest
         * @description Quick sensitivity analysis with minimal inputs
         * @example {
         *       "claim_value": 500000,
         *       "perturbation_pct": 20
         *     }
         */
        QuickSensitivityRequest: {
            /**
             * Claim Value
             * @description Base claim value
             */
            claim_value: number;
            /**
             * Perturbation Pct
             * @description Perturbation percentage
             * @default 20
             */
            perturbation_pct: number;
        };
        /**
         * RatioComparisonItem
         * @description Individual ratio comparison
         */
        RatioComparisonItem: {
            /** Ratio Name */
            ratio_name: string;
            /** Business Value */
            business_value: number;
            /** Benchmark Value */
            benchmark_value: number;
            /** Deviation Percent */
            deviation_percent: number;
            /** Deviation Level */
            deviation_level: string;
            /** Explanation */
            explanation: string;
            /** Recommendation */
            recommendation: string;
            /** Impact On Claim */
            impact_on_claim: string;
        };
        /**
         * ReadinessConfigResponse
         * @description Readiness criteria configuration.
         */
        ReadinessConfigResponse: {
            /** Case Strength Minimum */
            case_strength_minimum: number;
            /** Blocking Items Maximum */
            blocking_items_maximum: number;
            /** Evidence Completeness Minimum */
            evidence_completeness_minimum: number;
            /** Data Confidence Minimum */
            data_confidence_minimum: number;
            /** Forensic Confidence Minimum */
            forensic_confidence_minimum: number;
            /** Max Critical Vulnerabilities */
            max_critical_vulnerabilities: number;
        };
        /**
         * ReadinessSummaryResponse
         * @description Compact readiness summary.
         */
        ReadinessSummaryResponse: {
            /** Report Id */
            report_id: string;
            /** Status */
            status: string;
            /** Is Ready */
            is_ready: boolean;
            /** Confidence */
            confidence: number;
            /** All Criteria Met */
            all_criteria_met: boolean;
            /** Failed Criteria Count */
            failed_criteria_count: number;
            /** Blocking Flag Count */
            blocking_flag_count: number;
            /** Review Flag Count */
            review_flag_count: number;
            /** Requires Human Review */
            requires_human_review: boolean;
            /** Reason */
            reason: string;
        };
        /**
         * ReassignCaseRequest
         * @description Request to reassign a case to another accountant (admin only).
         */
        ReassignCaseRequest: {
            /** New Accountant Id */
            new_accountant_id: string;
            /** New Accountant Name */
            new_accountant_name: string;
            /** New Accountant Email */
            new_accountant_email?: string | null;
            /** Reason */
            reason?: string | null;
        };
        /**
         * RecalculateAggregatesRequest
         * @description Request to recalculate transaction aggregates for a draft
         */
        RecalculateAggregatesRequest: {
            /** Draft Id */
            draft_id: string;
        };
        /** RecalculateRequest */
        RecalculateRequest: {
            /** Financial Data */
            financial_data: {
                [key: string]: unknown;
            };
        };
        /** RecentActivityItem */
        RecentActivityItem: {
            /** Action */
            action: string;
            /**
             * Description
             * @default
             */
            description: string;
            /** Report Id */
            report_id?: string | null;
            /** Business Name */
            business_name?: string | null;
            /** Timestamp */
            timestamp?: string | null;
        };
        /**
         * ReclassificationRequest
         * @description Request to reclassify a transaction
         */
        ReclassificationRequest: {
            /**
             * New Category
             * @description New category (e.g., 'Office & Supplies')
             */
            new_category: string;
            /**
             * New Subcategory
             * @description New subcategory
             */
            new_subcategory?: string | null;
            /**
             * Reason
             * @description Reason for reclassification (required for audit trail)
             */
            reason: string;
        };
        /**
         * ReconcileRequest
         * @description Request to reconcile tax data with P&L
         */
        ReconcileRequest: {
            /** Claim Id */
            claim_id: string;
            /** Tax Data */
            tax_data: {
                [key: string]: unknown;
            };
            /** Pl Data */
            pl_data: {
                [key: string]: unknown;
            };
        };
        /**
         * RecordMilestoneRequest
         * @description Request to record a milestone.
         */
        RecordMilestoneRequest: {
            /**
             * Milestone Type
             * @description Milestone type
             */
            milestone_type: string;
            /**
             * Actual Date
             * @description Date milestone occurred (YYYY-MM-DD)
             */
            actual_date: string;
            /**
             * Outcome
             * @description Outcome/result of milestone
             */
            outcome?: string | null;
            /**
             * Notes
             * @description Additional notes
             */
            notes?: string | null;
            /**
             * Documents
             * @description Related document IDs
             */
            documents?: string[] | null;
        };
        /**
         * RefineSectionRequest
         * @description Request to refine a section
         */
        RefineSectionRequest: {
            /** Section Name */
            section_name: string;
            /** Current Text */
            current_text: string;
            /** User Feedback */
            user_feedback: string;
            /** Claim Id */
            claim_id: string;
        };
        /**
         * RejectSuggestionRequest
         * @description Request to reject a pattern suggestion
         */
        RejectSuggestionRequest: {
            /** Transaction Id */
            transaction_id: string;
            /** Report Id */
            report_id: string;
            /** Suggestion Id */
            suggestion_id?: string | null;
            /** Reason */
            reason?: string | null;
        };
        /**
         * ReleaseCaseRequest
         * @description Request to release a case back to the pool.
         */
        ReleaseCaseRequest: {
            /** Reason */
            reason?: string | null;
        };
        /** ReleaseToAttorneyRequest */
        ReleaseToAttorneyRequest: {
            /** Law Firm Id */
            law_firm_id: string;
        };
        /** ReleasedCaseListItem */
        ReleasedCaseListItem: {
            /** Id */
            id: string;
            /** Client Name */
            client_name: string;
            /** Business Name */
            business_name?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Total Demand */
            total_demand?: number | null;
            /** Released At */
            released_at: string;
            /**
             * Status
             * @default released
             */
            status: string;
        };
        /** RemoveTagRequest */
        RemoveTagRequest: {
            /** Report Id */
            report_id: string;
            /** Tag */
            tag: string;
        };
        /**
         * RentEscalation
         * @description Rent escalation terms.
         */
        RentEscalation: {
            /**
             * Type
             * @description fixed, percentage, cpi, market
             * @default fixed
             */
            type: string;
            /**
             * Rate
             * @description Escalation rate (e.g., 3.0 for 3%)
             */
            rate?: number | null;
            /**
             * Frequency
             * @description annual, monthly, biannual
             * @default annual
             */
            frequency: string;
            /** Effective Date */
            effective_date?: string | null;
            /**
             * Cap
             * @description Maximum escalation cap
             */
            cap?: number | null;
        };
        /** ReportCompleteEmailRequest */
        ReportCompleteEmailRequest: {
            /**
             * To Email
             * Format: email
             */
            to_email: string;
            /** Client Name */
            client_name: string;
            /** Claim Value */
            claim_value: number;
            /** Event Type */
            event_type: string;
            /** Causation Passed */
            causation_passed: boolean;
            /** Report Link */
            report_link: string;
        };
        /** ReportGenerateRequest */
        ReportGenerateRequest: {
            /**
             * Client Name
             * @default
             */
            client_name: string | null;
            /**
             * Claimant Name
             * @default
             */
            claimant_name: string | null;
            /**
             * Business Address
             * @default
             */
            business_address: string | null;
            /**
             * Zone
             * @default
             */
            zone: string | null;
            /**
             * Business Type
             * @default
             */
            business_type: string | null;
            /** Financial Data */
            financial_data: {
                [key: string]: unknown;
            };
            /** Law Firm */
            law_firm?: string | null;
            /** Claimant Email */
            claimant_email?: string | null;
            /** Claimant Phone */
            claimant_phone?: string | null;
            /**
             * Tax1065Files
             * @default []
             */
            tax1065Files: unknown[] | null;
            /**
             * Plfiles
             * @default []
             */
            plFiles: unknown[] | null;
            /**
             * Uploadeddocuments
             * @default []
             */
            uploadedDocuments: unknown[] | null;
            /**
             * Tax Data
             * @default []
             */
            tax_data: unknown[] | null;
            /**
             * Reconciliation
             * @default []
             */
            reconciliation: unknown[] | null;
            /**
             * Calculated Years
             * @default []
             */
            calculated_years: unknown[] | null;
            /** Coverage Year */
            coverage_year?: number | null;
            /**
             * Payroll Data
             * @default {}
             */
            payroll_data: {
                [key: string]: unknown;
            } | null;
            /**
             * Employee Payroll Data
             * @default {}
             */
            employee_payroll_data: {
                [key: string]: unknown;
            } | null;
            /**
             * Partner K1 Data
             * @default {}
             */
            partner_k1_data: {
                [key: string]: unknown;
            } | null;
            /** Payroll 2019 */
            payroll_2019?: number | null;
            /** Payroll 2020 */
            payroll_2020?: number | null;
            /** Payroll 2021 */
            payroll_2021?: number | null;
            /** Payroll 2022 */
            payroll_2022?: number | null;
            /** Employee Payroll 2019 */
            employee_payroll_2019?: number | null;
            /** Employee Payroll 2020 */
            employee_payroll_2020?: number | null;
            /** Employee Payroll 2021 */
            employee_payroll_2021?: number | null;
            /** Employee Payroll 2022 */
            employee_payroll_2022?: number | null;
            /** Partner K1 Income 2019 */
            partner_k1_income_2019?: number | null;
            /** Partner K1 Income 2020 */
            partner_k1_income_2020?: number | null;
            /** Partner K1 Income 2021 */
            partner_k1_income_2021?: number | null;
            /** Partner K1 Income 2022 */
            partner_k1_income_2022?: number | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Start Date */
            event_start_date?: string | null;
            /** Event End Date */
            event_end_date?: string | null;
            /**
             * Calculation Mode
             * @default standard_bi
             */
            calculation_mode: string | null;
            /** Draft Id */
            draft_id?: string | null;
            /**
             * Threshold
             * @default 0
             */
            threshold: number | null;
            /**
             * Threshold Type
             * @default dollar
             */
            threshold_type: string | null;
            /**
             * Accountant Fees
             * @default 0
             */
            accountant_fees: number | null;
            /**
             * Continuing Expenses
             * @default 0
             */
            continuing_expenses: number | null;
            /**
             * Extra Expenses
             * @default 0
             */
            extra_expenses: number | null;
            /**
             * Adjustment Notes
             * @default
             */
            adjustment_notes: string | null;
        };
        /** ReportListItem */
        ReportListItem: {
            /** Id */
            id: string;
            /** Client Name */
            client_name?: string | null;
            /** Claimant Name */
            claimant_name?: string | null;
            /** Business Address */
            business_address?: string | null;
            /** Zone */
            zone?: string | null;
            /** Business Type */
            business_type?: string | null;
            /** Status */
            status?: string | null;
            /** Created At */
            created_at?: string | null;
            /** Completed At */
            completed_at?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Coverage Year */
            coverage_year?: number | null;
            /** Pdf Url */
            pdf_url?: string | null;
            /** Result */
            result?: {
                [key: string]: unknown;
            } | null;
            /** Law Firm */
            law_firm?: string | null;
            /** Claimant Email */
            claimant_email?: string | null;
            /** Claimant Phone */
            claimant_phone?: string | null;
        };
        /**
         * ReportMetrics
         * @description Key metrics from a single report
         */
        ReportMetrics: {
            /** Report Id */
            report_id: string;
            /** Client Name */
            client_name: string;
            /** Business Type */
            business_type: string;
            /** Event Type */
            event_type?: string | null;
            /**
             * Benchmark Revenue
             * @default 0
             */
            benchmark_revenue: number;
            /**
             * Actual Revenue
             * @default 0
             */
            actual_revenue: number;
            /**
             * Lost Revenue
             * @default 0
             */
            lost_revenue: number;
            /**
             * Gross Profit Loss
             * @default 0
             */
            gross_profit_loss: number;
            /**
             * Continuing Expenses
             * @default 0
             */
            continuing_expenses: number;
            /**
             * Net Claim Amount
             * @default 0
             */
            net_claim_amount: number;
            /**
             * Revenue Decline Pct
             * @default 0
             */
            revenue_decline_pct: number;
            /**
             * Variable Margin Pct
             * @default 0
             */
            variable_margin_pct: number;
            /**
             * Recovery Rate Pct
             * @default 0
             */
            recovery_rate_pct: number;
            /**
             * Initial Demand
             * @default 0
             */
            initial_demand: number;
            /**
             * Current Offer
             * @default 0
             */
            current_offer: number;
            /** Settlement Amount */
            settlement_amount?: number | null;
            /**
             * Settlement Status
             * @default pending
             */
            settlement_status: string;
            /** Event Start Date */
            event_start_date?: string | null;
            /** Event End Date */
            event_end_date?: string | null;
            /** Created At */
            created_at: string;
        };
        /**
         * ReportPatchRequest
         * @description Partial update request for report fields
         */
        ReportPatchRequest: {
            /** Fema Declaration Number */
            fema_declaration_number?: string | null;
            /** Zone */
            zone?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Start Date */
            event_start_date?: string | null;
            /** Event End Date */
            event_end_date?: string | null;
        };
        /** ReportResponse */
        ReportResponse: {
            /** Id */
            id: string;
            /** Client Name */
            client_name?: string | null;
            /** Claimant Name */
            claimant_name?: string | null;
            /** Business Address */
            business_address?: string | null;
            /**
             * Zone
             * @default
             */
            zone: string | null;
            /** Business Type */
            business_type?: string | null;
            /** Status */
            status?: string | null;
            /** Created At */
            created_at?: string | null;
            /** Completed At */
            completed_at?: string | null;
            /** Pdf Url */
            pdf_url?: string | null;
            /** Pdf S3 Key */
            pdf_s3_key?: string | null;
            /** Result */
            result?: {
                [key: string]: unknown;
            } | null;
            /** Law Firm */
            law_firm?: string | null;
            /** Claimant Email */
            claimant_email?: string | null;
            /** Claimant Phone */
            claimant_phone?: string | null;
            /** Sensitivity Analysis */
            sensitivity_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Monte Carlo Analysis */
            monte_carlo_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Narrative */
            narrative?: {
                [key: string]: unknown;
            } | null;
            /** Narrative Status */
            narrative_status?: string | null;
            /** Financial Data */
            financial_data?: {
                [key: string]: unknown;
            } | null;
            /**
             * Tax1065Files
             * @default []
             */
            tax1065Files: unknown[] | null;
            /**
             * Plfiles
             * @default []
             */
            plFiles: unknown[] | null;
            /**
             * Uploadeddocuments
             * @default []
             */
            uploadedDocuments: unknown[] | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Start Date */
            event_start_date?: string | null;
            /** Event End Date */
            event_end_date?: string | null;
            /** Coverage Year */
            coverage_year?: number | null;
            /** Payroll 2019 */
            payroll_2019?: number | null;
            /** Payroll 2020 */
            payroll_2020?: number | null;
            /** Payroll 2021 */
            payroll_2021?: number | null;
            /** Payroll 2022 */
            payroll_2022?: number | null;
            /** Employee Payroll 2019 */
            employee_payroll_2019?: number | null;
            /** Employee Payroll 2020 */
            employee_payroll_2020?: number | null;
            /** Employee Payroll 2021 */
            employee_payroll_2021?: number | null;
            /** Employee Payroll 2022 */
            employee_payroll_2022?: number | null;
            /** Partner K1 Income 2019 */
            partner_k1_income_2019?: number | null;
            /** Partner K1 Income 2020 */
            partner_k1_income_2020?: number | null;
            /** Partner K1 Income 2021 */
            partner_k1_income_2021?: number | null;
            /** Partner K1 Income 2022 */
            partner_k1_income_2022?: number | null;
            /** Payroll Data */
            payroll_data?: {
                [key: string]: unknown;
            } | null;
            /** Calculated Years */
            calculated_years?: unknown[] | null;
            /**
             * Has Pl Statement
             * @default false
             */
            has_pl_statement: boolean | null;
            /** Parsed Pl Statement */
            parsed_pl_statement?: {
                [key: string]: unknown;
            } | null;
            /** Pl Upload Id */
            pl_upload_id?: string | null;
            /** Pl Parsed At */
            pl_parsed_at?: string | null;
            /** Is Peak Season */
            is_peak_season?: boolean | null;
            /** Contingency Buffer Percent */
            contingency_buffer_percent?: number | null;
            /** Accountant Fees */
            accountant_fees?: number | null;
            /** Continuing Expenses */
            continuing_expenses?: number | null;
            /** Extra Expenses */
            extra_expenses?: number | null;
            /** Calculation Mode */
            calculation_mode?: string | null;
            /**
             * Policy Uploaded
             * @default false
             */
            policy_uploaded: boolean | null;
            /** Policy Data */
            policy_data?: {
                [key: string]: unknown;
            } | null;
            /** Fema Declaration Number */
            fema_declaration_number?: string | null;
            /** Client Email */
            client_email?: string | null;
            /** Entity Type */
            entity_type?: string | null;
        };
        /**
         * ReportShareResponse
         * @description Response model for report share/invite
         */
        ReportShareResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Accountant Id */
            accountant_id?: string | null;
            /** Shared By User Id */
            shared_by_user_id: string;
            /** Shared By Name */
            shared_by_name: string;
            /** Permissions */
            permissions: string[];
            /** Shared At */
            shared_at: string;
            /** Last Accessed */
            last_accessed?: string | null;
            /** Status */
            status: string;
            /** Invite Status */
            invite_status: string;
            /** Invite Email */
            invite_email: string;
            /** Invite Token */
            invite_token?: string | null;
            /** Accountant Name */
            accountant_name?: string | null;
            /** Accountant Firm */
            accountant_firm?: string | null;
        };
        /**
         * ReportTemplate
         * @description Complete report template for an industry
         */
        ReportTemplate: {
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Description */
            description: string;
            /** Icon */
            icon: string;
            /** Business Types */
            business_types: string[];
            defaults: components["schemas"]["ExpenseDefaults"];
            benchmarks: components["schemas"]["IndustryBenchmarks"];
            future_closure_defaults: components["schemas"]["FutureClosureExpenseDefaults"];
            /** Common Expense Categories */
            common_expense_categories: string[];
            /** Tips */
            tips: string[];
            /** Seasonal Adjustments */
            seasonal_adjustments?: {
                [key: string]: unknown;
            } | null;
        };
        /** ReportTemplateCreate */
        ReportTemplateCreate: {
            /** Name */
            name: string;
            /** Description */
            description?: string | null;
            /** Category */
            category: string;
            /** Template Data */
            template_data: {
                [key: string]: unknown;
            };
        };
        /** ReportTemplateResponse */
        ReportTemplateResponse: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string;
            /** Name */
            name: string;
            /** Description */
            description: string | null;
            /** Category */
            category: string;
            /** Template Data */
            template_data: {
                [key: string]: unknown;
            };
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
            /** Usage Count */
            usage_count: number;
        };
        /** ReportTemplateUpdate */
        ReportTemplateUpdate: {
            /** Name */
            name?: string | null;
            /** Description */
            description?: string | null;
            /** Category */
            category?: string | null;
            /** Template Data */
            template_data?: {
                [key: string]: unknown;
            } | null;
        };
        /** ReportsListResponse */
        ReportsListResponse: {
            /** Reports */
            reports: components["schemas"]["ReportListItem"][];
            /** Total */
            total: number;
        };
        /**
         * ReprocessRequest
         * @description Request to reprocess existing files
         */
        ReprocessRequest: {
            /** S3 Keys */
            s3_keys?: string[] | null;
            /** Upload Ids */
            upload_ids?: string[] | null;
            /**
             * Limit
             * @default 10
             */
            limit: number;
            /** File Types */
            file_types?: string[] | null;
            /** Force Method */
            force_method?: string | null;
            /** Status Filter */
            status_filter?: string | null;
            /** Claim Id */
            claim_id?: string | null;
        };
        /**
         * ReprocessResponse
         * @description Response for batch reprocessing
         */
        ReprocessResponse: {
            /** Success */
            success: boolean;
            /** Total Files */
            total_files: number;
            /** Processed */
            processed: number;
            /** Failed */
            failed: number;
            /** Skipped */
            skipped: number;
            /** Results */
            results: components["schemas"]["ReprocessResult"][];
        };
        /**
         * ReprocessResult
         * @description Result of reprocessing a single file
         */
        ReprocessResult: {
            /** Upload Id */
            upload_id: string;
            /** Filename */
            filename: string;
            /** S3 Key */
            s3_key: string;
            /** Old Method */
            old_method: string | null;
            /** New Method */
            new_method: string | null;
            /** Old Transactions */
            old_transactions: number;
            /** New Transactions */
            new_transactions: number;
            /** Status */
            status: string;
            /** Error */
            error?: string | null;
            /**
             * Processing Time Ms
             * @default 0
             */
            processing_time_ms: number;
        };
        /**
         * ReprocessTaxRequest
         * @description Request model for tax document reprocessing
         */
        ReprocessTaxRequest: {
            /** Draft Id */
            draft_id: string;
            /**
             * Force Reprocess
             * @default false
             */
            force_reprocess: boolean;
        };
        /**
         * RequestSummaryResponse
         * @description Response for summary endpoint.
         */
        RequestSummaryResponse: {
            /** Report Id */
            report_id: string;
            /** Total Requests */
            total_requests: number;
            /** Total Items Requested */
            total_items_requested: number;
            /** Items Fulfilled */
            items_fulfilled: number;
            /** Items Pending */
            items_pending: number;
            /** Blocking Items Pending */
            blocking_items_pending: number;
            /** Status Breakdown */
            status_breakdown: {
                [key: string]: unknown;
            };
            /** Has Overdue */
            has_overdue: boolean;
            /** Pending Reminders */
            pending_reminders: number;
        };
        /** RerunRequest */
        RerunRequest: {
            /** Reason */
            reason: string;
            /**
             * Cascade Downstream
             * @default true
             */
            cascade_downstream: boolean;
        };
        /** RerunResponse */
        RerunResponse: {
            /** Report Id */
            report_id: string;
            /** Engine Id */
            engine_id: string;
            /** Task Id */
            task_id?: string | null;
            /** Affected Engines */
            affected_engines: string[];
            /** Invalidated */
            invalidated: string[];
            /** Skipped Already Stale */
            skipped_already_stale?: string[];
            /** Note */
            note?: string | null;
        };
        /**
         * ResolutionMethod
         * @enum {string}
         */
        ResolutionMethod: ResolutionMethod;
        /**
         * ResolveAnomalyRequest
         * @description Request to resolve an anomaly
         */
        ResolveAnomalyRequest: {
            /** Note */
            note: string;
        };
        /**
         * ResolveDisagreementRequest
         * @description Request body for resolving a disagreement
         */
        ResolveDisagreementRequest: {
            /** Resolution */
            resolution: string;
            /** Resolution Notes */
            resolution_notes?: string | null;
            /**
             * Create Issue
             * @default false
             */
            create_issue: boolean;
            /** Issue Type */
            issue_type?: string | null;
            /** Issue Title */
            issue_title?: string | null;
            /** Issue Description */
            issue_description?: string | null;
        };
        /**
         * ResolveItemRequest
         * @description Request to resolve an evidence item
         */
        ResolveItemRequest: {
            /**
             * Document Id
             * @description ID of document that resolves this need
             */
            document_id?: string | null;
            /**
             * Notes
             * @description Resolution notes
             */
            notes?: string | null;
        };
        /**
         * ResolveRequest
         * @description Request to resolve an action item.
         */
        ResolveRequest: {
            /** Resolution Notes */
            resolution_notes?: string | null;
            /** Resolved By Document Id */
            resolved_by_document_id?: string | null;
        };
        /**
         * ReverseRequest
         * @description Request to reverse a readiness decision.
         */
        ReverseRequest: {
            /**
             * Reason
             * @description Reason for reversal
             */
            reason: string;
        };
        /**
         * ReviewItem
         * @description An item that needs human review
         */
        ReviewItem: {
            /**
             * Transaction Date
             * Format: date
             */
            transaction_date: string;
            /** Amount */
            amount: number;
            /** Description */
            description: string;
            /** Source File */
            source_file: string;
            /** Reason */
            reason: string;
            /** Confidence */
            confidence: number;
        };
        /**
         * RiskFlagResponse
         * @description Risk flag in API response.
         */
        RiskFlagResponse: {
            /** Name */
            name: string;
            /** Flag Type */
            flag_type: string;
            /** Severity */
            severity: string;
            /** Description */
            description: string;
            /** Details */
            details: {
                [key: string]: unknown;
            };
            /** Detected At */
            detected_at: string;
        };
        /**
         * RoadmapClientResponse
         * @description Client-safe roadmap response - NO DOLLAR VALUES.
         */
        RoadmapClientResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Version */
            version: number;
            /** Generated At */
            generated_at: string;
            /** Total Actions */
            total_actions: number;
            /** Completed Actions */
            completed_actions: number;
            /** Percent Complete */
            percent_complete: number;
            /** Estimated Days Remaining */
            estimated_days_remaining: number;
            /** Actions */
            actions: {
                [key: string]: unknown;
            }[];
        };
        /**
         * RoadmapFullResponse
         * @description Full roadmap response for staff view.
         */
        RoadmapFullResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Version */
            version: number;
            /** Generated At */
            generated_at: string;
            /** Is Current */
            is_current: boolean;
            /** Current State */
            current_state: {
                [key: string]: unknown;
            };
            /** Target State */
            target_state: {
                [key: string]: unknown;
            };
            /** Progress */
            progress: {
                [key: string]: unknown;
            };
            /** Actions */
            actions: {
                [key: string]: unknown;
            }[];
            /** Has Dependencies */
            has_dependencies: boolean;
            /** Dependency Levels */
            dependency_levels: number;
        };
        /**
         * RoadmapHistoryItem
         * @description Single item in roadmap history.
         */
        RoadmapHistoryItem: {
            /** Id */
            id: string;
            /** Version */
            version: number;
            /** Generated At */
            generated_at: string;
            /** Is Current */
            is_current: boolean;
            /** Total Actions */
            total_actions: number;
            /** Completed Actions */
            completed_actions: number;
            /** Percent Complete */
            percent_complete: number;
        };
        /**
         * RoadmapSummaryResponse
         * @description Summary response for roadmap.
         */
        RoadmapSummaryResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Version */
            version: number;
            /** Generated At */
            generated_at: string;
            /** Is Current */
            is_current: boolean;
            /** Case Strength */
            case_strength: number;
            /** Target Strength */
            target_strength: number;
            /** Ready For Demand */
            ready_for_demand: boolean;
            /** Total Actions */
            total_actions: number;
            /** Completed Actions */
            completed_actions: number;
            /** Percent Complete */
            percent_complete: number;
            /** Top Actions */
            top_actions: components["schemas"]["ActionSummary"][];
        };
        /**
         * SHAPExplainRequest
         * @description Request SHAP explanation for anomalies
         */
        SHAPExplainRequest: {
            /** Anomalies */
            anomalies: {
                [key: string]: unknown;
            }[];
            /** Transactions */
            transactions: {
                [key: string]: unknown;
            }[];
            /** Case Id */
            case_id?: string | null;
            /**
             * Max Explanations
             * @default 50
             */
            max_explanations: number;
        };
        /**
         * SHAPExplainResponse
         * @description Response with SHAP explanations
         */
        SHAPExplainResponse: {
            /** Success */
            success: boolean;
            /** Total Anomalies */
            total_anomalies: number;
            /** Explained Count */
            explained_count: number;
            /** Anomalies */
            anomalies: {
                [key: string]: unknown;
            }[];
            /** Model Trained */
            model_trained: boolean;
            /** Error */
            error?: string | null;
        };
        /**
         * SaveContinuationRatesRequest
         * @description Request to save continuation rates for a case.
         */
        SaveContinuationRatesRequest: {
            rates: components["schemas"]["ContinuationRatesConfig"];
            /** Notes */
            notes?: string | null;
        };
        /**
         * SaveNarrativeRequest
         * @description Request to save narrative to report
         */
        SaveNarrativeRequest: {
            /** Claim Id */
            claim_id: string;
            /** Narrative Sections */
            narrative_sections: {
                [key: string]: string;
            };
            /** Word Count */
            word_count?: number | null;
            /** Estimated Pages */
            estimated_pages?: number | null;
        };
        /** SaveScenarioRequest */
        SaveScenarioRequest: {
            /** Scenario Name */
            scenario_name: string;
            /** Scenario Data */
            scenario_data: {
                [key: string]: unknown;
            };
            /** Notes */
            notes?: string | null;
        };
        /** SavedViewCreate */
        SavedViewCreate: {
            /** Name */
            name: string;
            /** Description */
            description?: string | null;
            /** Filters */
            filters: {
                [key: string]: unknown;
            };
            /** Sort By */
            sort_by?: string | null;
            /** Sort Order */
            sort_order?: string | null;
        };
        /** SavedViewResponse */
        SavedViewResponse: {
            /** Id */
            id: string;
            /** User Id */
            user_id: string;
            /** Name */
            name: string;
            /** Description */
            description: string | null;
            /** Filters */
            filters: {
                [key: string]: unknown;
            };
            /** Sort By */
            sort_by: string | null;
            /** Sort Order */
            sort_order: string | null;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
        };
        /** SavedViewUpdate */
        SavedViewUpdate: {
            /** Name */
            name?: string | null;
            /** Description */
            description?: string | null;
            /** Filters */
            filters?: {
                [key: string]: unknown;
            } | null;
            /** Sort By */
            sort_by?: string | null;
            /** Sort Order */
            sort_order?: string | null;
        };
        /** ScenarioRequest */
        ScenarioRequest: {
            /** Indemnity Period Days */
            indemnity_period_days?: number | null;
            /** Revenue Drop Pct */
            revenue_drop_pct?: number | null;
            /** Expense Reduction Pct */
            expense_reduction_pct?: number | null;
            /** Custom Daily Gp */
            custom_daily_gp?: number | null;
            /** Revenue Multiplier */
            revenue_multiplier?: number | null;
            /** Variable Cost Ratio */
            variable_cost_ratio?: number | null;
            /** Indemnity Default Days */
            indemnity_default_days?: number | null;
            /**
             * Sensitivity Mode
             * @default standard
             */
            sensitivity_mode: string | null;
            /** Custom Sensitivity Bands */
            custom_sensitivity_bands?: {
                [key: string]: number;
            } | null;
            /**
             * Use Merchant Augmented Revenue
             * @default true
             */
            use_merchant_augmented_revenue: boolean | null;
        };
        /**
         * SemanticExtractionRequest
         * @description Request to trigger semantic extraction.
         */
        SemanticExtractionRequest: {
            /** Raw Text */
            raw_text: string;
            /** Filename */
            filename: string;
            /** Doc Type Hint */
            doc_type_hint?: string | null;
            /** Case Id */
            case_id?: string | null;
            /** Report Id */
            report_id?: string | null;
        };
        /**
         * SemanticExtractionResponse
         * @description Response from semantic extraction.
         */
        SemanticExtractionResponse: {
            /** Document Id */
            document_id: string;
            /** Document Type */
            document_type: string;
            /** Classification Confidence */
            classification_confidence: number;
            /** Status */
            status: string;
            /** Overall Confidence */
            overall_confidence: number;
            /** Issues Count */
            issues_count: number;
            /** Issues */
            issues: {
                [key: string]: unknown;
            }[];
            /** Extracted Fields */
            extracted_fields: {
                [key: string]: unknown;
            };
            /** Processing Time Seconds */
            processing_time_seconds: number;
        };
        /**
         * SendEvidenceRequestBody
         * @description Request body for sending evidence request email
         */
        SendEvidenceRequestBody: {
            /**
             * Law Firm Name
             * @description Name of the law firm (overrides default)
             */
            law_firm_name?: string | null;
        };
        /**
         * SensitivityAnalysisRequest
         * @description Request for sensitivity analysis
         * @example {
         *       "base_settlement": 500000,
         *       "continuing_expenses": 100000,
         *       "fixed_expenses": 300000,
         *       "loss_period_months": 12,
         *       "payroll": 500000,
         *       "perturbation_pct": 20,
         *       "recovery_rate": 75,
         *       "revenue": 2000000,
         *       "variable_expenses": 200000
         *     }
         */
        SensitivityAnalysisRequest: {
            /**
             * Base Settlement
             * @description Base settlement/claim amount
             */
            base_settlement: number;
            /**
             * Revenue
             * @description Annual revenue
             * @default 0
             */
            revenue: number;
            /**
             * Payroll
             * @description Annual payroll
             * @default 0
             */
            payroll: number;
            /**
             * Variable Expenses
             * @description Variable expenses
             * @default 0
             */
            variable_expenses: number;
            /**
             * Fixed Expenses
             * @description Fixed expenses
             * @default 0
             */
            fixed_expenses: number;
            /**
             * Continuing Expenses
             * @description Continuing expenses
             * @default 0
             */
            continuing_expenses: number;
            /**
             * Extra Expenses
             * @description Extra expenses
             * @default 0
             */
            extra_expenses: number;
            /**
             * Loss Period Months
             * @description Loss period in months
             * @default 12
             */
            loss_period_months: number;
            /**
             * Recovery Rate
             * @description Expected recovery rate %
             * @default 75
             */
            recovery_rate: number;
            /**
             * Perturbation Pct
             * @description Perturbation percentage
             * @default 20
             */
            perturbation_pct: number;
            /**
             * Include Interactions
             * @description Include interaction analysis
             * @default true
             */
            include_interactions: boolean;
        };
        /** SetAttorneyPasswordRequest */
        SetAttorneyPasswordRequest: {
            /** Password */
            password: string;
        };
        /**
         * SetEstimatedValueRequest
         * @description Request to set the estimated value for a case.
         */
        SetEstimatedValueRequest: {
            /**
             * Estimated Value
             * @description The estimated claim value
             */
            estimated_value: number;
            /**
             * Source
             * @description Source of the value (e.g., 'wizard', 'accountant_review')
             */
            source?: string | null;
            /**
             * Notes
             * @description Optional notes about the value
             */
            notes?: string | null;
        };
        /**
         * SetEstimatedValueResponse
         * @description Response after setting estimated value.
         */
        SetEstimatedValueResponse: {
            /** Success */
            success: boolean;
            /** Case Id */
            case_id: string;
            /** Estimated Value */
            estimated_value: number;
            /** Previous Value */
            previous_value?: number | null;
            /** Source */
            source: string;
        };
        /**
         * SettlementBenchmarkRequest
         * @description Request for settlement benchmarks
         */
        SettlementBenchmarkRequest: {
            /**
             * Event Type
             * @description Event type (fire, flood, hurricane, etc.)
             */
            event_type: string;
            /**
             * Claim Amount
             * @description Claimed amount
             */
            claim_amount: number;
            /**
             * Jurisdiction
             * @description State code
             */
            jurisdiction?: string | null;
        };
        /**
         * SettlementEvent
         * @description A single event in the settlement timeline
         */
        SettlementEvent: {
            /** Id */
            id: string;
            event_type: components["schemas"]["SettlementEventType"];
            /** Description */
            description: string;
            /** Amount */
            amount?: number | null;
            /** Previous Amount */
            previous_amount?: number | null;
            /** Created By */
            created_by: string;
            /** Created At */
            created_at: string;
            /** Metadata */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * SettlementEventType
         * @enum {string}
         */
        SettlementEventType: SettlementEventType;
        /**
         * SettlementResponse
         * @description Full settlement tracking data
         */
        SettlementResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Status */
            status: string;
            /** Initial Demand */
            initial_demand: number;
            /** Current Offer */
            current_offer: number;
            /** Last Counteroffer */
            last_counteroffer?: number | null;
            /** Settlement Amount */
            settlement_amount?: number | null;
            /** Offer To Demand Ratio */
            offer_to_demand_ratio: number;
            /** Recovery Rate */
            recovery_rate?: number | null;
            /** Negotiation Rounds */
            negotiation_rounds: number;
            /** Insurer Name */
            insurer_name?: string | null;
            /** Adjuster Name */
            adjuster_name?: string | null;
            /** Adjuster Email */
            adjuster_email?: string | null;
            /** Adjuster Phone */
            adjuster_phone?: string | null;
            /** Policy Number */
            policy_number?: string | null;
            /** Claim Number */
            claim_number?: string | null;
            /** Timeline */
            timeline: components["schemas"]["SettlementEvent"][];
            /** Demand Date */
            demand_date?: string | null;
            /** First Offer Date */
            first_offer_date?: string | null;
            /** Settlement Date */
            settlement_date?: string | null;
            /** Days To First Offer */
            days_to_first_offer?: number | null;
            /** Days To Settlement */
            days_to_settlement?: number | null;
            /** Notes */
            notes?: string | null;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
        };
        /**
         * SettlementStatus
         * @enum {string}
         */
        SettlementStatus: SettlementStatus;
        /** ShareEmailRequest */
        ShareEmailRequest: {
            /**
             * To Email
             * Format: email
             */
            to_email: string;
            /** Sender Name */
            sender_name: string;
            /** Client Name */
            client_name: string;
            /** Claim Id */
            claim_id: string;
            /** Share Link */
            share_link: string;
            /** Message */
            message?: string | null;
        };
        /**
         * SharedReportListItem
         * @description Lightweight model for listing reports shared with an accountant
         */
        SharedReportListItem: {
            /** Report Id */
            report_id: string;
            /** Client Name */
            client_name: string;
            /** Claimant Name */
            claimant_name: string;
            /** Business Address */
            business_address: string;
            /** Shared By Name */
            shared_by_name: string;
            /** Shared At */
            shared_at: string;
            /** Last Accessed */
            last_accessed?: string | null;
            /** Permissions */
            permissions: string[];
            /** Status */
            status: string;
            /** Event Type */
            event_type?: string | null;
            /** Coverage Year */
            coverage_year?: number | null;
            /** Final Claim Amount */
            final_claim_amount?: number | null;
        };
        /**
         * ShellIndicatorItem
         * @description Shell company indicator
         */
        ShellIndicatorItem: {
            /** Entity */
            entity: string;
            /** Indicator Type */
            indicator_type: string;
            /** Risk Level */
            risk_level: string;
            /** Total Inflow */
            total_inflow: number;
            /** Total Outflow */
            total_outflow: number;
            /** Transaction Count */
            transaction_count: number;
            /** Explanation */
            explanation: string;
            /** Supporting Evidence */
            supporting_evidence: {
                [key: string]: unknown;
            };
        };
        /**
         * SignOffHistoryItem
         * @description A single sign-off history entry.
         */
        SignOffHistoryItem: {
            /** Id */
            id: string;
            /** Case Id */
            case_id: string;
            /** Signed Off By Id */
            signed_off_by_id: string;
            /** Signed Off By Name */
            signed_off_by_name: string;
            /**
             * Signed Off At
             * Format: date-time
             */
            signed_off_at: string;
            /** Notes */
            notes?: string | null;
            /** Action */
            action: string;
            /** Warnings Overridden */
            warnings_overridden?: string[];
        };
        /**
         * SignOffResponse
         * @description Response for sign-off operation.
         */
        SignOffResponse: {
            /** Success */
            success: boolean;
            /** Case Id */
            case_id: string;
            /** Action */
            action: string;
            /** Message */
            message: string;
            /** Signed Off By Id */
            signed_off_by_id?: string | null;
            /** Signed Off By Name */
            signed_off_by_name?: string | null;
            /** Signed Off At */
            signed_off_at?: string | null;
            /** Warnings */
            warnings?: string[];
            /** Blocking Issues */
            blocking_issues?: string[];
        };
        /**
         * SimilarCorrection
         * @description Result from similarity search
         */
        SimilarCorrection: {
            /** Correction Id */
            correction_id: string;
            /** Payee */
            payee: string;
            /** Description */
            description: string;
            /** Corrected Category */
            corrected_category: string;
            /** Similarity Score */
            similarity_score: number;
            /** Times Matched */
            times_matched: number;
        };
        /**
         * SimilarityQueryRequest
         * @description Request for similarity query
         */
        SimilarityQueryRequest: {
            /** Payee */
            payee: string;
            /** Description */
            description: string;
            /**
             * Min Similarity
             * @default 0.85
             */
            min_similarity: number;
        };
        /**
         * SingleAnomalyAnalysisRequest
         * @description Request AI analysis for a single anomaly
         */
        SingleAnomalyAnalysisRequest: {
            /** Anomaly */
            anomaly: {
                [key: string]: unknown;
            };
            /** Business Context */
            business_context?: {
                [key: string]: unknown;
            } | null;
            /** Resolved History */
            resolved_history?: {
                [key: string]: unknown;
            }[] | null;
        };
        /** SingleAnomalyAnalysisResponse */
        SingleAnomalyAnalysisResponse: {
            /** Success */
            success: boolean;
            /** Ai Analysis */
            ai_analysis?: {
                [key: string]: unknown;
            } | null;
            /** Likely False Positive */
            likely_false_positive?: boolean | null;
            /** Recommendation */
            recommendation?: string | null;
            /** Error */
            error?: string | null;
        };
        /**
         * SingleCaseQueueResponse
         * @description Response model for single case queue assignment.
         */
        SingleCaseQueueResponse: {
            /** Case Id */
            case_id: string;
            /** Assigned Queue */
            assigned_queue: string;
            /** Queue Reason */
            queue_reason: string;
            /** Pipeline Stage */
            pipeline_stage: string;
            /**
             * Queue Assigned At
             * Format: date-time
             */
            queue_assigned_at: string;
            /** Expected Ready Date */
            expected_ready_date?: string | null;
            /**
             * Case Strength
             * @default 0
             */
            case_strength: number;
            /**
             * Transactions Need Review
             * @default 0
             */
            transactions_need_review: number;
            /**
             * Documents Missing
             * @default 0
             */
            documents_missing: number;
            /**
             * Completion Percentage
             * @default 0
             */
            completion_percentage: number;
            /**
             * Days Stale
             * @default 0
             */
            days_stale: number;
            /** Signoff Checklist */
            signoff_checklist?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * SingleSHAPExplainRequest
         * @description Request SHAP explanation for a single anomaly
         */
        SingleSHAPExplainRequest: {
            /** Anomaly */
            anomaly: {
                [key: string]: unknown;
            };
            /** Transaction */
            transaction: {
                [key: string]: unknown;
            };
            /** Case Id */
            case_id?: string | null;
        };
        /**
         * SingleSHAPExplainResponse
         * @description Response with SHAP explanation for single anomaly
         */
        SingleSHAPExplainResponse: {
            /** Success */
            success: boolean;
            /** Anomaly */
            anomaly: {
                [key: string]: unknown;
            };
            /** Model Trained */
            model_trained: boolean;
            /** Error */
            error?: string | null;
        };
        /**
         * SingleScenarioRequest
         * @description Request for a single scenario analysis
         * @example {
         *       "base_settlement": 500000,
         *       "selected_modifications": [
         *         "Detailed P&L Analysis",
         *         "Tax Return Reconciliation"
         *       ],
         *       "template_id": "better_documentation"
         *     }
         */
        SingleScenarioRequest: {
            /** Base Settlement */
            base_settlement: number;
            /**
             * Template Id
             * @description Scenario template ID
             */
            template_id: string;
            /**
             * Selected Modifications
             * @description Specific modifications to include
             */
            selected_modifications?: string[] | null;
        };
        /**
         * SmartReviewRequest
         * @description Request for smart review analysis.
         */
        SmartReviewRequest: {
            /** Claim Id */
            claim_id: string;
            /**
             * Include Anomalies
             * @default true
             */
            include_anomalies: boolean;
            /**
             * Include Low Confidence
             * @default true
             */
            include_low_confidence: boolean;
            /**
             * Include Pending Clarifications
             * @default true
             */
            include_pending_clarifications: boolean;
            /**
             * Auto Categorize Threshold
             * @default 0.85
             */
            auto_categorize_threshold: number;
        };
        /**
         * StaffEmailResponse
         * @description Full email response for staff including financial data.
         */
        StaffEmailResponse: {
            client_email: components["schemas"]["EmailResponse"];
            /** Value Unlock */
            value_unlock: number;
            /** Risk Mitigated */
            risk_mitigated: number;
            /** Impact Description */
            impact_description: string;
            /** Priority */
            priority: number;
        };
        /** StartPipelineRequest */
        StartPipelineRequest: {
            /**
             * Trigger Type
             * @default manual
             */
            trigger_type: string;
        };
        /** StartReviewRequest */
        StartReviewRequest: {
            /** Note */
            note?: string | null;
        };
        /**
         * StateUpdateRequest
         * @description Request to manually update case state.
         */
        StateUpdateRequest: {
            /** Target State */
            target_state: string;
            /**
             * Trigger
             * @default manual_update
             */
            trigger: string;
            /** Metadata */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * StatusChange
         * @description Records a status transition in issue history
         */
        StatusChange: {
            from_status?: components["schemas"]["IssueStatus"] | null;
            to_status: components["schemas"]["IssueStatus"];
            /** Changed By */
            changed_by: string;
            /**
             * Changed At
             * Format: date-time
             */
            changed_at?: string;
            /** Reason */
            reason?: string | null;
        };
        /**
         * StepStatus
         * @description Status of a single enrichment step.
         */
        StepStatus: {
            /** Step */
            step: string;
            /**
             * Status
             * @enum {string}
             */
            status: StepStatusStatus;
            /** Detail */
            detail?: string | null;
        };
        /** StreamingUploadResponse */
        StreamingUploadResponse: {
            /** Job Id */
            job_id: string;
            /** Status */
            status: string;
            /** Message */
            message: string;
            /**
             * Files Uploaded
             * @default 0
             */
            files_uploaded: number;
            /**
             * S3 Keys
             * @default []
             */
            s3_keys: string[];
        };
        /**
         * StrengthBreakdownResponse
         * @description Response model for strength breakdown.
         */
        StrengthBreakdownResponse: {
            /** Report Id */
            report_id: string;
            /** Final Score */
            final_score: number;
            /** Confidence Score */
            confidence_score: number;
            /** Evidence Score */
            evidence_score: number;
            /** Vulnerability Penalty */
            vulnerability_penalty: number;
            /** Blocking Penalty */
            blocking_penalty: number;
            /** Confidence Details */
            confidence_details: string;
            /** Evidence Details */
            evidence_details: string;
            /** Vulnerability Details */
            vulnerability_details: string;
            /** Blocking Details */
            blocking_details: string;
            /** Summary */
            summary: string;
        };
        /**
         * SubmittedClientItem
         * @description Whitelisted view of an attorney_clients document.
         *
         *     NOTE: response_model= filters this strictly — the underlying Mongo
         *     document carries additional fields (portal_token, law_firm_id,
         *     submitted_by, etc.) that MUST NOT leak to attorney clients in this
         *     response. Adding a field here is an explicit decision to expose it.
         */
        SubmittedClientItem: {
            /** Id */
            id: string;
            /** Claimant Name */
            claimant_name: string;
            /** Client Email */
            client_email: string;
            /** Business Name */
            business_name?: string | null;
            /** Business Type */
            business_type?: string | null;
            /** Event Type */
            event_type?: string | null;
            /** Event Date */
            event_date?: string | null;
            /** Notes */
            notes?: string | null;
            /** Status */
            status: string;
            /** Case Id */
            case_id?: string | null;
            /** Created At */
            created_at: string;
        };
        /**
         * SubrogationAnalysisResponse
         * @description Complete subrogation analysis result
         */
        SubrogationAnalysisResponse: {
            /** Status */
            status: string;
            /** Report Id */
            report_id: string;
            /** Opportunities */
            opportunities: components["schemas"]["SubrogationOpportunityResponse"][];
            /** Count */
            count: number;
            /** Total Projected Recovery */
            total_projected_recovery: number;
            highest_priority?: components["schemas"]["SubrogationOpportunityResponse"] | null;
            /** Analysis Date */
            analysis_date: string;
            /** State */
            state: string;
            /** Loss Amount */
            loss_amount: number;
        };
        /**
         * SubrogationOpportunityResponse
         * @description Individual subrogation opportunity
         */
        SubrogationOpportunityResponse: {
            /** Trigger Type */
            trigger_type: string;
            /** Category */
            category: string;
            /** Base Probability */
            base_probability: number;
            /** Adjusted Probability */
            adjusted_probability: number;
            /** Probability Percent */
            probability_percent: number;
            /** Projected Recovery */
            projected_recovery: number;
            /** Recovery Range Low */
            recovery_range_low: number;
            /** Recovery Range High */
            recovery_range_high: number;
            /** Evidence Snippet */
            evidence_snippet: string;
            /** Statute Expires */
            statute_expires?: string | null;
            /** Days Until Expiration */
            days_until_expiration?: number | null;
            /** Urgency Level */
            urgency_level: string;
            /** State Factors */
            state_factors: {
                [key: string]: unknown;
            };
            /** Comparative Fault Adjustment */
            comparative_fault_adjustment: number;
            /** Made Whole Required */
            made_whole_required: boolean;
            /** Priority Score */
            priority_score: number;
        };
        /** SuggestFieldsRequest */
        SuggestFieldsRequest: {
            /** Partial Data */
            partial_data: {
                [key: string]: unknown;
            };
        };
        /**
         * SupportedTypesResponse
         * @description Response listing supported document types.
         */
        SupportedTypesResponse: {
            /** Supported Types */
            supported_types: string[];
            /** Version */
            version: string;
        };
        /**
         * SupportingDocumentType
         * @description Types of supporting documents with AI extraction.
         * @enum {string}
         */
        SupportingDocumentType: SupportingDocumentType;
        /**
         * TTSRequest
         * @description Request model for text-to-speech conversion.
         */
        TTSRequest: {
            /** Text */
            text: string;
            /**
             * Voice
             * @default nova
             */
            voice: string;
            /**
             * Model
             * @default tts-1
             */
            model: string;
            /**
             * Speed
             * @default 1
             */
            speed: number;
        };
        /** TeamMemberResponse */
        TeamMemberResponse: {
            /** Id */
            id: string;
            /** Email */
            email: string;
            /** Name */
            name?: string | null;
            /** Role */
            role: string;
            /** Role Display */
            role_display: string;
            /** Role Color */
            role_color: string;
            /** Status */
            status: string;
            /** Created At */
            created_at: string;
            /** Last Active */
            last_active?: string | null;
            /** Last Login */
            last_login?: string | null;
            /** Invited By */
            invited_by?: string | null;
        };
        /** TeamStatsResponse */
        TeamStatsResponse: {
            /** Total Members */
            total_members: number;
            /** Active Members */
            active_members: number;
            /** Pending Invites */
            pending_invites: number;
            /** By Role */
            by_role: {
                [key: string]: unknown;
            };
        };
        /**
         * TextExtractionResponse
         * @description Response for text extraction
         */
        TextExtractionResponse: {
            /** Text */
            text: string;
            /** Source Filename */
            source_filename: string;
            /** File Type */
            file_type: string;
            /** Char Count */
            char_count: number;
            /** Page Count */
            page_count?: number | null;
        };
        /**
         * ThresholdCreateRequest
         * @description Request to create a variance threshold
         */
        ThresholdCreateRequest: {
            /** Threshold Id */
            threshold_id: string;
            /** Name */
            name: string;
            /** Description */
            description: string;
            /** Percentage Threshold */
            percentage_threshold?: number | null;
            /** Absolute Threshold */
            absolute_threshold?: number | null;
            /**
             * Alert Level
             * @default warning
             */
            alert_level: string;
            /**
             * Auto Flag Transactions
             * @default false
             */
            auto_flag_transactions: boolean;
            /** Applies To Sections */
            applies_to_sections?: string[];
        };
        /**
         * ThresholdUpdateRequest
         * @description Request to update a variance threshold
         */
        ThresholdUpdateRequest: {
            /** Name */
            name?: string | null;
            /** Description */
            description?: string | null;
            /** Percentage Threshold */
            percentage_threshold?: number | null;
            /** Absolute Threshold */
            absolute_threshold?: number | null;
            /** Alert Level */
            alert_level?: string | null;
            /** Auto Flag Transactions */
            auto_flag_transactions?: boolean | null;
            /** Applies To Sections */
            applies_to_sections?: string[] | null;
            /** Active */
            active?: boolean | null;
        };
        /**
         * TimeSeriesPoint
         * @description Single point in time series
         */
        TimeSeriesPoint: {
            /** Date */
            date: string;
            /** Value */
            value: number;
            /**
             * Count
             * @default 0
             */
            count: number;
        };
        /**
         * TimelinePredictionRequest
         * @description Request for litigation timeline prediction
         */
        TimelinePredictionRequest: {
            /**
             * Case Data
             * @description Case characteristics for prediction
             */
            case_data: {
                [key: string]: unknown;
            };
            /**
             * Start Date
             * @description Start date (ISO format), defaults to today
             */
            start_date?: string | null;
            /**
             * Include Scenarios
             * @description Include optimistic/pessimistic scenarios
             * @default true
             */
            include_scenarios: boolean;
        };
        /** TokenUsage */
        TokenUsage: {
            /** Input Tokens */
            input_tokens: number;
            /** Output Tokens */
            output_tokens: number;
        };
        /**
         * TokenVerificationResponse
         * @description Access token verification result.
         */
        TokenVerificationResponse: {
            /** Valid */
            valid: boolean;
            /** Package Id */
            package_id: string | null;
            /** Recipient */
            recipient: string | null;
            /** Expires At */
            expires_at: string | null;
            /** Error */
            error: string | null;
        };
        /**
         * TrainModelRequest
         * @description Request to train explainable model
         */
        TrainModelRequest: {
            /** Transactions */
            transactions: components["schemas"]["app__api__v1__explainability__TransactionInput"][];
            /**
             * Contamination
             * @description Expected proportion of anomalies
             * @default 0.1
             */
            contamination: number;
            /**
             * N Estimators
             * @description Number of trees
             * @default 100
             */
            n_estimators: number;
            /** Feature Columns */
            feature_columns?: string[] | null;
        };
        /**
         * TrainModelResponse
         * @description Response from model training
         */
        TrainModelResponse: {
            /** Success */
            success: boolean;
            /** Samples Trained */
            samples_trained: number;
            /** Features Used */
            features_used: number;
            /** Feature Names */
            feature_names: string[];
            /** Anomalies In Training */
            anomalies_in_training: number;
            /** Contamination Rate */
            contamination_rate: number;
            /** Shap Available */
            shap_available: boolean;
            /** Message */
            message: string;
        };
        /**
         * TransactionClarificationItem
         * @description A single transaction needing clarification.
         */
        TransactionClarificationItem: {
            /** Transaction Id */
            transaction_id: string;
            /** Date */
            date: string;
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Current Category */
            current_category?: string | null;
            /** Question */
            question: string;
            /** Options */
            options?: string[] | null;
        };
        /**
         * TransactionFlagUpdate
         * @description Update transaction review status
         */
        TransactionFlagUpdate: {
            /** Checked */
            checked?: boolean | null;
            /** Flagged */
            flagged?: boolean | null;
            /** Flag Reason */
            flag_reason?: string | null;
        };
        /**
         * TransactionRecategorizationItem
         * @description Single transaction recategorization request.
         */
        TransactionRecategorizationItem: {
            /** Transaction Id */
            transaction_id: string;
            /** Date */
            date: string;
            /** Description */
            description: string;
            /** Current Category */
            current_category: string;
            /** New Category */
            new_category: string;
            /** Amount */
            amount: number;
            /** Reason */
            reason?: string | null;
        };
        /**
         * TransactionRecord
         * @description Single transaction for validation
         */
        TransactionRecord: {
            /** Date */
            date?: string | null;
            /** Description */
            description?: string | null;
            /** Amount */
            amount: number;
            /** Category */
            category?: string | null;
            /** Vendor */
            vendor?: string | null;
            /** Account */
            account?: string | null;
        };
        /**
         * TransactionReviewRequest
         * @description Request to review/update transaction
         */
        TransactionReviewRequest: {
            /** Transaction Id */
            transaction_id: string;
            /** Action */
            action: string;
            /** New Category */
            new_category?: string | null;
            /** New Subcategory */
            new_subcategory?: string | null;
            /** Note */
            note?: string | null;
        };
        /** TransferOwnershipRequest */
        TransferOwnershipRequest: {
            /** New Owner Id */
            new_owner_id: string;
            /**
             * New Role For Current
             * @default admin
             */
            new_role_for_current: string;
        };
        /** TransitionResponse */
        TransitionResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /** Engine Id */
            engine_id: string;
            /** From Status */
            from_status: string;
            /** To Status */
            to_status: string;
            /** Transition Id */
            transition_id: string;
        };
        /**
         * TrendStat
         * @description Current value, previous-window value, and signed delta. `delta_pct` is
         *     None when `previous` is 0 — frontend must hide the chip rather than
         *     invent an "infinity" number.
         */
        TrendStat: {
            /** Current */
            current: number;
            /** Previous */
            previous: number;
            /** Delta */
            delta: number;
            /** Delta Pct */
            delta_pct?: number | null;
        };
        /**
         * TriggerEvaluationResponse
         * @description Response model for trigger evaluation.
         */
        TriggerEvaluationResponse: {
            /** Status */
            status: string;
            /** Report Id */
            report_id: string;
            /** Evaluation Id */
            evaluation_id?: string | null;
            /** Case Strength */
            case_strength: number;
            /** Is Ready */
            is_ready: boolean;
            /** Blocking Count */
            blocking_count: number;
            /** Action Items Pending */
            action_items_pending: number;
            /** Message */
            message: string;
        };
        /**
         * UIBranding
         * @description UI-specific branding options
         */
        UIBranding: {
            /**
             * Show Logo In Header
             * @default true
             */
            show_logo_in_header: boolean;
            /**
             * Show Company Name
             * @default true
             */
            show_company_name: boolean;
            /** Custom Favicon */
            custom_favicon?: string | null;
            /** Login Background */
            login_background?: string | null;
            /** Dashboard Welcome Message */
            dashboard_welcome_message?: string | null;
            /**
             * Hide Powered By
             * @default false
             */
            hide_powered_by: boolean;
        };
        /** UnfinalizeRequest */
        UnfinalizeRequest: {
            /**
             * Reason
             * @description Why the sign-off is being reversed.
             */
            reason: string;
        };
        /** UnfinalizeResponse */
        UnfinalizeResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /** New Status */
            new_status: string;
        };
        /**
         * UnifiedAnalysisRequest
         * @description Request body for unified analysis
         */
        UnifiedAnalysisRequest: {
            /**
             * Report Data
             * @description Claim report data
             */
            report_data: {
                [key: string]: unknown;
            };
            /**
             * Financial Data
             * @description Monthly P&L data
             */
            financial_data: {
                [key: string]: unknown;
            };
            /**
             * Claim Context
             * @description Business info, event details
             */
            claim_context: {
                [key: string]: unknown;
            };
            /**
             * Documents
             * @description Optional list of available documents
             */
            documents?: unknown[] | null;
            /**
             * Skip Settlement
             * @description Skip settlement calculation
             * @default false
             */
            skip_settlement: boolean;
            /**
             * Strict Invariant
             * @description Raise error on adjuster > attorney
             * @default false
             */
            strict_invariant: boolean;
            /**
             * Engine Overrides
             * @description Phase 05: per-engine override dict shaped as {engine_id: {field_name: override_value}}. When omitted or null, analysis runs against unmodified engine inputs.
             */
            engine_overrides?: {
                [key: string]: {
                    [key: string]: unknown;
                };
            } | null;
        };
        /**
         * UnifiedAnalysisResponse
         * @description Response model for unified analysis
         */
        UnifiedAnalysisResponse: {
            /** Success */
            success: boolean;
            /** Analysis Id */
            analysis_id: string;
            /** Report Id */
            report_id: string;
            /** Processing Time Ms */
            processing_time_ms: number;
            /** Forensic Validity */
            forensic_validity?: string | null;
            /** Attorney Maximum */
            attorney_maximum?: number | null;
            /** Adjuster Supported */
            adjuster_supported?: number | null;
            /** Fair Settlement */
            fair_settlement?: number | null;
            /**
             * Total Issues Created
             * @default 0
             */
            total_issues_created: number;
            /**
             * Disagreement Count
             * @default 0
             */
            disagreement_count: number;
            /**
             * Adjuster Leq Attorney Valid
             * @default true
             */
            adjuster_leq_attorney_valid: boolean;
            /**
             * Executive Summary
             * @default
             */
            executive_summary: string;
            /** Key Findings */
            key_findings?: unknown[];
            /** Recommended Actions */
            recommended_actions?: unknown[];
            /** Full Result */
            full_result?: {
                [key: string]: unknown;
            } | null;
        };
        /**
         * UnifiedUploadResponse
         * @description Response from the unified upload endpoint
         */
        UnifiedUploadResponse: {
            /** Success */
            success: boolean;
            /** Message */
            message: string;
            /** Canonical Data */
            canonical_data?: {
                [key: string]: unknown;
            } | null;
            /** File Results */
            file_results: components["schemas"]["FileProcessingResult"][];
            /** Review Items */
            review_items: components["schemas"]["ReviewItem"][];
            stats: components["schemas"]["UploadStats"];
        };
        /**
         * UnreadCountResponse
         * @description Unread notification count
         */
        UnreadCountResponse: {
            /** Count */
            count: number;
        };
        /** UnresolvedDispute */
        UnresolvedDispute: {
            /** Dispute Id */
            dispute_id: string;
            /** Issue Tag */
            issue_tag: string;
            /** Affected Engines */
            affected_engines?: string[];
            /** Description */
            description: string;
            requires: components["schemas"]["UnresolvedRequirement"];
        };
        /**
         * UnresolvedRequirement
         * @enum {string}
         */
        UnresolvedRequirement: UnresolvedRequirement;
        /**
         * UpdateActionRequest
         * @description Request to update an action's status.
         */
        UpdateActionRequest: {
            /**
             * Status
             * @description New status: pending, in_progress, completed, blocked, skipped
             */
            status: string;
            /**
             * Notes
             * @description Optional notes
             */
            notes?: string | null;
            /**
             * Completed By Document Id
             * @description Document that completed this action
             */
            completed_by_document_id?: string | null;
        };
        /**
         * UpdateAnnotationRequest
         * @description Request to update an annotation
         */
        UpdateAnnotationRequest: {
            /** Text */
            text: string;
        };
        /**
         * UpdateBrandingRequest
         * @description Request to update branding config
         */
        UpdateBrandingRequest: {
            /** Company Name */
            company_name?: string | null;
            /** Company Tagline */
            company_tagline?: string | null;
            /** Logo Url */
            logo_url?: string | null;
            /** Logo Dark Url */
            logo_dark_url?: string | null;
            /** Favicon Url */
            favicon_url?: string | null;
            colors?: components["schemas"]["ColorScheme"] | null;
            pdf?: components["schemas"]["PDFBranding"] | null;
            ui?: components["schemas"]["UIBranding"] | null;
            /** Contact Email */
            contact_email?: string | null;
            /** Contact Phone */
            contact_phone?: string | null;
            /** Website Url */
            website_url?: string | null;
            /** Address */
            address?: string | null;
        };
        /** UpdateClaimTypeRequest */
        UpdateClaimTypeRequest: {
            /** Claim Type */
            claim_type: string;
        };
        /** UpdateCommentRequest */
        UpdateCommentRequest: {
            /** Comment Text */
            comment_text: string;
            /**
             * Mentions
             * @default []
             */
            mentions: string[] | null;
        };
        /** UpdateRoleRequest */
        UpdateRoleRequest: {
            /** Role */
            role: string;
        };
        /**
         * UpdateSettlementRequest
         * @description Update settlement details
         */
        UpdateSettlementRequest: {
            status?: components["schemas"]["SettlementStatus"] | null;
            /** Current Offer */
            current_offer?: number | null;
            /** Insurer Name */
            insurer_name?: string | null;
            /** Adjuster Name */
            adjuster_name?: string | null;
            /** Adjuster Email */
            adjuster_email?: string | null;
            /** Adjuster Phone */
            adjuster_phone?: string | null;
            /** Policy Number */
            policy_number?: string | null;
            /** Claim Number */
            claim_number?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /** UpdateStatusRequest */
        UpdateStatusRequest: {
            /** Status */
            status: string;
        };
        /**
         * UploadAnalyticsPayload
         * @description Payload for tracking upload analytics.
         */
        UploadAnalyticsPayload: {
            /** Report Id */
            report_id: string;
            /** Event */
            event: string;
            /**
             * Data
             * @default {}
             */
            data: {
                [key: string]: unknown;
            };
            /** Timestamp */
            timestamp: string;
        };
        /**
         * UploadResponse
         * @description Response returned immediately after S3 save
         */
        UploadResponse: {
            /** Success */
            success: boolean;
            /** Message */
            message: string;
            /** File Id */
            file_id: string;
            /** Upload Id */
            upload_id: string;
            /** Status */
            status: string;
        };
        /**
         * UploadStats
         * @description Processing statistics
         */
        UploadStats: {
            /** Total Files */
            total_files: number;
            /** Files Processed */
            files_processed: number;
            /** Files Failed */
            files_failed: number;
            /** Total Transactions */
            total_transactions: number;
            /** Total Periods */
            total_periods: number;
            /** Cache Hits */
            cache_hits: number;
            /** Cache Misses */
            cache_misses: number;
            /** Total Cost Usd */
            total_cost_usd: number;
            /** Total Processing Time Seconds */
            total_processing_time_seconds: number;
            /** Items Needing Review */
            items_needing_review: number;
        };
        /**
         * UploadStatusResponse
         * @description Status check response with full extraction details
         */
        UploadStatusResponse: {
            /** Upload Id */
            upload_id: string;
            /** Status */
            status: string;
            /** Processing Stage */
            processing_stage?: string | null;
            /**
             * Progress Percent
             * @default 0
             */
            progress_percent: number;
            /** Result */
            result?: {
                [key: string]: unknown;
            } | null;
            /** Error Message */
            error_message?: string | null;
            /** Extraction Method */
            extraction_method?: string | null;
            /** Extraction Audit */
            extraction_audit?: {
                [key: string]: unknown;
            } | null;
            /** Parsed Data */
            parsed_data?: {
                [key: string]: unknown;
            } | null;
            /** Total Cost Usd */
            total_cost_usd?: number | null;
            /** Cache Hit */
            cache_hit?: boolean | null;
        };
        /** UpsertOverlayRequest */
        UpsertOverlayRequest: {
            /**
             * Attested Calc Ref
             * @description engine_outputs.run_id this overlay pairs with. The PDF renderer uses this to snapshot the right calc when composing the final document.
             */
            attested_calc_ref: string;
            /** Content Blocks */
            content_blocks?: components["schemas"]["ContentBlockIn"][];
        };
        /** UpstreamEngineSummary */
        UpstreamEngineSummary: {
            /** Engine Id */
            engine_id: string;
            /** Engine Name */
            engine_name: string;
            /** Status */
            status: string;
            /** Last Run At */
            last_run_at?: string | null;
        };
        /**
         * UserDecisionRequest
         * @description User decision on an edge case
         */
        UserDecisionRequest: {
            /** Issue Id */
            issue_id: string;
            /** Issue Type */
            issue_type: string;
            /** Decision */
            decision: string;
            /** Final Value */
            final_value?: number | null;
            /** User Id */
            user_id: string;
            /** Claim Id */
            claim_id: string;
        };
        /**
         * ValidateRequest
         * @description Request for data validation
         */
        ValidateRequest: {
            /** Transactions */
            transactions: components["schemas"]["TransactionRecord"][];
            /** @default extraction */
            layer: components["schemas"]["ValidationLayerEnum"];
            /**
             * Strict Mode
             * @default false
             */
            strict_mode: boolean;
            /** Source File */
            source_file?: string | null;
        };
        /**
         * ValidateResponse
         * @description Response from validation
         */
        ValidateResponse: {
            /** Success */
            success: boolean;
            /** Is Valid */
            is_valid: boolean;
            /** Quality Score */
            quality_score: number;
            /** Quality Grade */
            quality_grade: string;
            /** Total Rows */
            total_rows: number;
            /** Valid Rows */
            valid_rows: number;
            /** Error Count */
            error_count: number;
            /** Warning Count */
            warning_count: number;
            /** Issues */
            issues: {
                [key: string]: unknown;
            }[];
            /** Timestamp */
            timestamp: string;
        };
        /** ValidationError */
        ValidationError: {
            /** Location */
            loc: (string | number)[];
            /** Message */
            msg: string;
            /** Error Type */
            type: string;
        };
        /**
         * ValidationLayerEnum
         * @description Validation layer types
         * @enum {string}
         */
        ValidationLayerEnum: ValidationLayerEnum;
        /**
         * VerifierReport
         * @description One row of `verifier_reports`.
         *
         *     Retention: forever (see a2 §N5).
         */
        VerifierReport: {
            /** Id */
            _id: string;
            /** Report Id */
            report_id: string;
            /** Run Id */
            run_id: string;
            /**
             * Verified At
             * Format: date-time
             */
            verified_at: string;
            /** Verifier Version */
            verifier_version: string;
            /** Checks Passed */
            checks_passed?: components["schemas"]["CheckPassed"][];
            /** Checks Failed */
            checks_failed?: components["schemas"]["CheckFailed"][];
            /** Engagement Score */
            engagement_score?: number | null;
            /** Engagement Notes */
            engagement_notes?: string | null;
            overall_status: components["schemas"]["OverallStatus"];
        };
        /**
         * VersionDetailResponse
         * @description Detailed version response including snapshot data
         */
        VersionDetailResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Version Number */
            version_number: number;
            /** Created By */
            created_by: string;
            /**
             * Created By Type
             * @enum {string}
             */
            created_by_type: VersionDetailResponseCreated_by_type;
            /** Created By Name */
            created_by_name: string;
            /** Created At */
            created_at: string;
            /** Change Summary */
            change_summary: string;
            /** Snapshot Data */
            snapshot_data: {
                [key: string]: unknown;
            };
        };
        /** VersionListResponse */
        VersionListResponse: {
            /** Report Id */
            report_id: string;
            /** Versions */
            versions: components["schemas"]["VersionMetadata"][];
        };
        /** VersionMetadata */
        VersionMetadata: {
            /** Version */
            version: number;
            status: components["schemas"]["OverlayStatus"];
            /** Attested Calc Ref */
            attested_calc_ref: string;
        };
        /**
         * VersionResponse
         * @description Response model for a version
         */
        VersionResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Version Number */
            version_number: number;
            /** Created By */
            created_by: string;
            /**
             * Created By Type
             * @enum {string}
             */
            created_by_type: VersionResponseCreated_by_type;
            /** Created By Name */
            created_by_name: string;
            /** Created At */
            created_at: string;
            /** Change Summary */
            change_summary: string;
        };
        /** WaitlistResponse */
        WaitlistResponse: {
            /** Id */
            id: string;
            /** Message */
            message: string;
        };
        /** WaitlistSignup */
        WaitlistSignup: {
            /** Firstname */
            firstName: string;
            /** Lastname */
            lastName: string;
            /**
             * Email
             * Format: email
             */
            email: string;
            /**
             * Company
             * @default
             */
            company: string;
            /**
             * Role
             * @default
             */
            role: string;
        };
        /** WaiveEngineRequest */
        WaiveEngineRequest: {
            /** Reason */
            reason: string;
            /** Override Warnings */
            override_warnings?: string[];
        };
        /**
         * WarRoomConsensus
         * @description Top-level document stored in the `war_room_consensus` collection.
         */
        WarRoomConsensus: {
            /** Id */
            _id: string;
            /** Report Id */
            report_id: string;
            /** Run Id */
            run_id: string;
            /**
             * Produced At
             * Format: date-time
             */
            produced_at: string;
            /**
             * Produced By
             * @default war_room_consensus_service
             */
            produced_by: string;
            /** Agreed Inputs */
            agreed_inputs?: {
                [key: string]: components["schemas"]["EngineConsensusEntry"];
            };
            /** Unresolved Disputes */
            unresolved_disputes?: components["schemas"]["UnresolvedDispute"][];
            summary?: components["schemas"]["WarRoomConsensusSummary"];
        };
        /** WarRoomConsensusSummary */
        WarRoomConsensusSummary: {
            /**
             * Engines With Full Consensus
             * @default 0
             */
            engines_with_full_consensus: number;
            /**
             * Engines With Dissent
             * @default 0
             */
            engines_with_dissent: number;
            /**
             * Blocking Disputes
             * @default 0
             */
            blocking_disputes: number;
            /** Agent Participation */
            agent_participation?: {
                [key: string]: number;
            };
        };
        /**
         * WarRoomReadResponse
         * @description Response for GET /api/v1/attorney/war-room/{report_id}.
         *
         *     Pinned by frontend `AttorneyWarRoomPage`; renaming ANY field here
         *     breaks the frontend tsc compile via the openapi-typescript
         *     pipeline.
         */
        WarRoomReadResponse: {
            /** Report Id */
            report_id: string;
            /** Attorney Id */
            attorney_id?: string | null;
            deliberation: components["schemas"]["DeliberationView"];
            consensus?: components["schemas"]["WarRoomConsensus"] | null;
            verifier?: components["schemas"]["VerifierReport"] | null;
            /**
             * Query Prompt Context
             * @description Pre-canned context the attorney's LLM query interface prepends to follow-ups.
             */
            query_prompt_context: string;
            /**
             * Max Queries Remaining
             * @description Remaining query budget for (attorney, report, day) tuple.
             */
            max_queries_remaining: number;
            /**
             * Challenges Filed
             * @description Count of attorney_challenge_filed entries in audit_chain for this report.
             */
            challenges_filed: number;
        };
        /**
         * WebhookCreate
         * @description Request to create webhook
         */
        WebhookCreate: {
            /**
             * Url
             * @description Webhook endpoint URL
             */
            url: string;
            /**
             * Events
             * @description Events to subscribe to: claim.created, claim.updated, claim.calculated, settlement.updated
             */
            events: string[];
            /**
             * Secret
             * @description Signing secret (auto-generated if not provided)
             */
            secret?: string | null;
        };
        /**
         * WebhookResponse
         * @description Response with webhook info
         */
        WebhookResponse: {
            /** Id */
            id: string;
            /** Org Id */
            org_id: string;
            /** Url */
            url: string;
            /** Events */
            events: string[];
            /** Is Active */
            is_active: boolean;
            /** Created At */
            created_at: string;
            /** Last Triggered */
            last_triggered: string | null;
            /** Failure Count */
            failure_count: number;
        };
        /**
         * WhatIfAnalysisRequest
         * @description Request for what-if scenario analysis
         * @example {
         *       "base_settlement": 500000,
         *       "template_ids": [
         *         "better_documentation",
         *         "expert_witness"
         *       ]
         *     }
         */
        WhatIfAnalysisRequest: {
            /**
             * Base Settlement
             * @description Base/current settlement value
             */
            base_settlement: number;
            /**
             * Template Ids
             * @description Template IDs to analyze
             */
            template_ids?: string[] | null;
            /**
             * Custom Scenarios
             * @description Custom scenario definitions
             */
            custom_scenarios?: {
                [key: string]: unknown;
            }[] | null;
        };
        /**
         * WontFixRequest
         * @description Request to mark issue as won't fix
         */
        WontFixRequest: {
            /** Reason */
            reason: string;
        };
        /**
         * CancelRequest
         * @description Request to cancel an action item.
         */
        app__api__v1__action_items_api__CancelRequest: {
            /** Reason */
            reason: string;
        };
        /**
         * ExplainRequest
         * @description Request model for explanation
         */
        app__api__v1__ai__ExplainRequest: {
            /** Claim Id */
            claim_id: string;
            /** Question */
            question: string;
            /** Calculation Results */
            calculation_results: {
                [key: string]: unknown;
            };
        };
        /** TransactionInput */
        app__api__v1__anomaly_detection__TransactionInput: {
            /** Description */
            description: string;
            /** Amount */
            amount: number;
            /** Category */
            category?: string | null;
            /** Date */
            date?: string | null;
        };
        /** ChatRequest */
        app__api__v1__assistant__ChatRequest: {
            /** Message */
            message: string;
            /** Claim Id */
            claim_id: string;
            /** Current Step */
            current_step?: number | null;
            /** Session Id */
            session_id?: string | null;
        };
        /**
         * ReadinessResponse
         * @description Response model for readiness status.
         */
        app__api__v1__attorney_ai_api__ReadinessResponse: {
            /** Report Id */
            report_id: string;
            /** Is Ready */
            is_ready: boolean;
            /** Status */
            status: string;
            /** Case Strength */
            case_strength: number;
            /** Ready Threshold */
            ready_threshold: number;
            /** Auto Ready Threshold */
            auto_ready_threshold: number;
            /** Meets Strength Threshold */
            meets_strength_threshold: boolean;
            /** Has Blocking Items */
            has_blocking_items: boolean;
            /** Has Critical Vulnerabilities */
            has_critical_vulnerabilities: boolean;
            /**
             * Reasons Not Ready
             * @default []
             */
            reasons_not_ready: string[];
            /**
             * Reasons Ready
             * @default []
             */
            reasons_ready: string[];
            /** Is Auto Ready Eligible */
            is_auto_ready_eligible: boolean;
            /**
             * Auto Ready Blocked By
             * @default []
             */
            auto_ready_blocked_by: string[];
        };
        /**
         * SignOffRequest
         * @description Request to sign off on a case.
         */
        app__api__v1__case_signoff__SignOffRequest: {
            /**
             * Notes
             * @description Optional notes about sign-off
             */
            notes?: string | null;
            /**
             * Override Warnings
             * @description Override warnings and force sign-off
             * @default false
             */
            override_warnings: boolean;
        };
        /**
         * TransactionInput
         * @description Single transaction for classification
         */
        app__api__v1__classification__TransactionInput: {
            /**
             * Description
             * @description Transaction description from bank statement
             */
            description: string;
            /**
             * Amount
             * @description Transaction amount (positive=credit, negative=debit)
             * @default 0
             */
            amount: number;
            /**
             * Date
             * @description Transaction date
             */
            date?: string | null;
            /**
             * Payee
             * @description Payee/vendor name if separate from description
             */
            payee?: string | null;
        };
        /**
         * CancelRequest
         * @description Request body for cancellation.
         */
        app__api__v1__client_requests_api__CancelRequest: {
            /** Reason */
            reason?: string | null;
        };
        /** CommentResponse */
        app__api__v1__comments__CommentResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Section Id */
            section_id: string;
            /** User Id */
            user_id: string;
            /** User Name */
            user_name: string;
            /** User Email */
            user_email: string;
            /** Comment Text */
            comment_text: string;
            /** Mentions */
            mentions: string[];
            /** Parent Comment Id */
            parent_comment_id: string | null;
            /** Is Resolved */
            is_resolved: boolean;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at: string;
            /**
             * Replies
             * @default []
             */
            replies: components["schemas"]["app__api__v1__comments__CommentResponse"][] | null;
        };
        /** CreateCommentRequest */
        app__api__v1__comments__CreateCommentRequest: {
            /** Report Id */
            report_id: string;
            /** Section Id */
            section_id: string;
            /** Comment Text */
            comment_text: string;
            /**
             * Mentions
             * @default []
             */
            mentions: string[] | null;
            /** Parent Comment Id */
            parent_comment_id?: string | null;
        };
        /**
         * QualityReportResponse
         * @description Response containing quality report
         */
        app__api__v1__data_quality__QualityReportResponse: {
            /** Success */
            success: boolean;
            /** Report Id */
            report_id: string;
            /** Overall Grade */
            overall_grade: string;
            /** Overall Score */
            overall_score: number;
            /** Is Court Ready */
            is_court_ready: boolean;
            /** Executive Summary */
            executive_summary: string;
            /** Validation Summaries */
            validation_summaries: {
                [key: string]: unknown;
            }[];
            /** Recommendations */
            recommendations: string[];
            /** Issues By Severity */
            issues_by_severity: {
                [key: string]: number;
            };
            /** Formatted Report */
            formatted_report?: string | null;
        };
        /**
         * ReclassifyRequest
         * @description Request to reclassify files in a draft
         */
        app__api__v1__document_types_api__ReclassifyRequest: {
            /** File Results */
            file_results?: {
                [key: string]: unknown;
            }[] | null;
        };
        /**
         * ExplainRequest
         * @description Request to explain a single anomaly
         */
        app__api__v1__explainability__ExplainRequest: {
            transaction: components["schemas"]["app__api__v1__explainability__TransactionInput"];
            /** Transaction Id */
            transaction_id?: string | null;
        };
        /**
         * TransactionInput
         * @description Transaction for explainability analysis
         */
        app__api__v1__explainability__TransactionInput: {
            /** Id */
            id?: string | null;
            /** Date */
            date?: string | null;
            /** Description */
            description?: string | null;
            /** Amount */
            amount: number;
            /** Category */
            category?: string | null;
            /** Vendor */
            vendor?: string | null;
        };
        /**
         * BatchUploadResponse
         * @description Response for batch upload
         */
        app__api__v1__extraction__BatchUploadResponse: {
            /** Total Files */
            total_files: number;
            /** Successful */
            successful: number;
            /** Failed */
            failed: number;
            /** Jobs */
            jobs: {
                [key: string]: unknown;
            }[];
        };
        /**
         * QualityReportResponse
         * @description Quality assessment report
         */
        app__api__v1__extraction__QualityReportResponse: {
            /** Overall Score */
            overall_score: number;
            /** Quality Level */
            quality_level: string;
            /** Completeness Score */
            completeness_score: number;
            /** Consistency Score */
            consistency_score: number;
            /** Validity Score */
            validity_score: number;
            /** Field Scores */
            field_scores: {
                [key: string]: unknown;
            }[];
            /** Recommendations */
            recommendations: string[];
            /** Critical Issues */
            critical_issues: string[];
        };
        /**
         * ChatRequest
         * @description Request body for chat endpoint.
         */
        app__api__v1__intelligence_api__ChatRequest: {
            /** Report Id */
            report_id: string;
            /** Message */
            message: string;
            /** Conversation Id */
            conversation_id?: string | null;
            /**
             * Voice Mode
             * @default false
             */
            voice_mode: boolean;
        };
        /**
         * PatternCreateRequest
         * @description Request to create a new pattern
         */
        app__api__v1__pattern_admin__PatternCreateRequest: {
            /**
             * Pattern Id
             * @description Unique pattern identifier
             */
            pattern_id: string;
            /**
             * Event Id
             * @description Event this pattern belongs to
             */
            event_id: string;
            /**
             * Event Type
             * @description Type of event
             * @default business_interruption
             */
            event_type: string;
            /**
             * Match Keywords
             * @description Keywords to match
             */
            match_keywords: string[];
            /**
             * Match Mcc
             * @description MCC codes to match
             */
            match_mcc?: string[];
            /**
             * Amount Range
             * @description [min, max] amount range
             */
            amount_range?: number[] | null;
            /**
             * Generic Category
             * @description Original/generic category
             * @default
             */
            generic_category: string;
            /**
             * Correct Category
             * @description Correct P&L category
             */
            correct_category: string;
            /**
             * Correct Subcategory
             * @description Correct P&L subcategory
             */
            correct_subcategory: string;
            /**
             * Confidence
             * @description Pattern confidence: HIGH, MEDIUM, LOW
             * @default MEDIUM
             */
            confidence: string;
            /**
             * Rationale
             * @description Court-defensible explanation
             */
            rationale: string;
        };
        /**
         * PatternUpdateRequest
         * @description Request to update a pattern
         */
        app__api__v1__pattern_admin__PatternUpdateRequest: {
            /** Match Keywords */
            match_keywords?: string[] | null;
            /** Match Mcc */
            match_mcc?: string[] | null;
            /** Amount Range */
            amount_range?: number[] | null;
            /** Generic Category */
            generic_category?: string | null;
            /** Correct Category */
            correct_category?: string | null;
            /** Correct Subcategory */
            correct_subcategory?: string | null;
            /** Confidence */
            confidence?: string | null;
            /** Rationale */
            rationale?: string | null;
            /** Active */
            active?: boolean | null;
        };
        /**
         * ReadinessResponse
         * @description Full readiness evaluation response.
         */
        app__api__v1__readiness_api__ReadinessResponse: {
            /** Report Id */
            report_id: string;
            /** Status */
            status: string;
            /** Is Ready */
            is_ready: boolean;
            /** Confidence */
            confidence: number;
            /** All Criteria Met */
            all_criteria_met: boolean;
            /** Failed Criteria */
            failed_criteria: string[];
            /** Criteria Results */
            criteria_results: {
                [key: string]: components["schemas"]["CriteriaResultResponse"];
            };
            /** Risk Flag Count */
            risk_flag_count: number;
            /** Blocking Flag Count */
            blocking_flag_count: number;
            /** Review Flag Count */
            review_flag_count: number;
            /** Risk Flags */
            risk_flags: components["schemas"]["RiskFlagResponse"][];
            /** Blocking Flags */
            blocking_flags: components["schemas"]["RiskFlagResponse"][];
            /** Review Flags */
            review_flags: components["schemas"]["RiskFlagResponse"][];
            /** Requires Human Review */
            requires_human_review: boolean;
            /** Reason */
            reason: string;
            /** Decided At */
            decided_at: string;
            /** Reversible */
            reversible: boolean;
            /** Reversal Deadline */
            reversal_deadline: string | null;
        };
        /**
         * SignOffRequest
         * @description Sign off reconciliation for a P&L cell
         */
        app__api__v1__reconciliation__SignOffRequest: {
            /**
             * Notes
             * @description Variance explanation and notes
             */
            notes: string;
            /**
             * Variance Accepted
             * @description Accountant accepts the variance
             */
            variance_accepted: boolean;
        };
        /** CreateSignatureRequest */
        app__api__v1__signatures__CreateSignatureRequest: {
            /** Report Id */
            report_id: string;
            /** Signature Data */
            signature_data: string;
            /** Signature Type */
            signature_type: string;
            /**
             * Signer Title
             * @default Forensic Accountant
             */
            signer_title: string | null;
            /** Signer Credentials */
            signer_credentials?: string | null;
            /** Attestation Text */
            attestation_text?: string | null;
        };
        /** SignatureResponse */
        app__api__v1__signatures__SignatureResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Signer Id */
            signer_id: string;
            /** Signer Name */
            signer_name: string;
            /** Signer Email */
            signer_email: string;
            /** Signer Title */
            signer_title: string;
            /** Signer Credentials */
            signer_credentials: string | null;
            /** Signature Type */
            signature_type: string;
            /** Signed At */
            signed_at: string;
            /** Ip Address */
            ip_address: string | null;
            /** Attestation Text */
            attestation_text: string | null;
            /** Is Valid */
            is_valid: boolean;
        };
        /**
         * BatchUploadResponse
         * @description Response for batch upload
         */
        app__api__v1__upload_savefirst__BatchUploadResponse: {
            /** Success */
            success: boolean;
            /** Total Files */
            total_files: number;
            /** Successful Uploads */
            successful_uploads: number;
            /** Failed Uploads */
            failed_uploads: number;
            /** Uploads */
            uploads: {
                [key: string]: unknown;
            }[];
        };
        /** ReclassifyRequest */
        app__api__v1__upload_savefirst__ReclassifyRequest: {
            /** Draft Id */
            draft_id: string;
            /**
             * Max Tier
             * @default 1
             */
            max_tier: number;
            /**
             * Batch Size
             * @default 100
             */
            batch_size: number;
        };
        /**
         * ConfidenceLevel
         * @description Analysis confidence levels
         * @enum {string}
         */
        app__models__adjuster_models__ConfidenceLevel: App__models__adjuster_models__ConfidenceLevel;
        /**
         * CommentResponse
         * @description Response model for a comment
         */
        app__models__collaboration__CommentResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Author Id */
            author_id: string;
            /**
             * Author Type
             * @enum {string}
             */
            author_type: App__models__collaboration__CommentResponseAuthor_type;
            /** Author Name */
            author_name: string;
            /** Section */
            section: string;
            /** Comment Text */
            comment_text: string;
            /** Created At */
            created_at: string;
            /** Updated At */
            updated_at?: string | null;
            /** Status */
            status: string;
        };
        /**
         * CreateCommentRequest
         * @description Request to create a comment on a report
         */
        app__models__collaboration__CreateCommentRequest: {
            /** Report Id */
            report_id: string;
            /**
             * Section
             * @description Report section identifier (e.g., 'calculation_detail.variable_profit_analysis')
             */
            section: string;
            /** Comment Text */
            comment_text: string;
        };
        /**
         * CreateSignatureRequest
         * @description Request to create an e-signature
         */
        app__models__collaboration__CreateSignatureRequest: {
            /**
             * Signature Data Url
             * @description Base64 data URL of signature image
             */
            signature_data_url: string;
            /** Notes */
            notes?: string | null;
        };
        /**
         * SignatureResponse
         * @description Response model for a signature
         */
        app__models__collaboration__SignatureResponse: {
            /** Id */
            id: string;
            /** Report Id */
            report_id: string;
            /** Accountant Id */
            accountant_id: string;
            /** Accountant Name */
            accountant_name: string;
            /** Signature Data Url */
            signature_data_url: string;
            /** Signed At */
            signed_at: string;
            /** Version Id */
            version_id?: string | null;
            /** Notes */
            notes?: string | null;
        };
        /**
         * ConfidenceLevel
         * @description Document matching confidence tiers
         * @enum {string}
         */
        app__models__issue_models__ConfidenceLevel: App__models__issue_models__ConfidenceLevel;
        /**
         * PatternCreateRequest
         * @description Request to create a new pattern
         */
        app__models__pattern_library__PatternCreateRequest: {
            /** Pattern Id */
            pattern_id: string;
            /** Event Type */
            event_type: string;
            /** Event Id */
            event_id: string;
            /** Match Keywords */
            match_keywords: string[];
            /** Match Mcc */
            match_mcc?: string[];
            /** Amount Range */
            amount_range?: [
                number,
                number
            ] | null;
            /** Generic Category */
            generic_category: string;
            /** Correct Category */
            correct_category: string;
            /** Correct Subcategory */
            correct_subcategory: string;
            /** @default MEDIUM */
            confidence: components["schemas"]["PatternConfidence"];
            /** Rationale */
            rationale: string;
        };
        /**
         * PatternUpdateRequest
         * @description Request to update an existing pattern
         */
        app__models__pattern_library__PatternUpdateRequest: {
            /** Match Keywords */
            match_keywords?: string[] | null;
            /** Match Mcc */
            match_mcc?: string[] | null;
            /** Amount Range */
            amount_range?: [
                number,
                number
            ] | null;
            /** Correct Category */
            correct_category?: string | null;
            /** Correct Subcategory */
            correct_subcategory?: string | null;
            confidence?: components["schemas"]["PatternConfidence"] | null;
            /** Rationale */
            rationale?: string | null;
            /** Active */
            active?: boolean | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    api_root_api__get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_check_api_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_reports_api_v1_reports_get: {
        parameters: {
            query?: {
                limit?: number;
                skip?: number;
                include_orphans?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportsListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_api_v1_reports__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_report_api_v1_reports__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    patch_report_api_v1_reports__report_id__patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportPatchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_reports_api_v1_reports_compare__report_id1___report_id2__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id1: string;
                report_id2: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_report_api_v1_reports_generate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportGenerateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_report_data_api_v1_reports_validate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportGenerateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_report_api_v1_reports__report_id__update_put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DraftSaveRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    recalculate_report_api_v1_reports__report_id__recalculate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RecalculateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    duplicate_claim_api_v1_reports__report_id__duplicate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_case_files_api_v1_reports__report_id__files_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_case_file_api_v1_reports__report_id__files__s3_key__download_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                s3_key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_draft_api_v1_reports_drafts_save_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DraftSaveRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_latest_draft_api_v1_reports_drafts_latest_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DraftResponse"] | null;
                };
            };
        };
    };
    list_drafts_api_v1_reports_drafts_list_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_draft_status_api_v1_reports_drafts__draft_id__status_patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DraftStatusUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_draft_api_v1_reports_drafts__draft_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_draft_api_v1_reports_drafts__draft_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    run_sensitivity_analysis_endpoint_api_v1_reports__report_id__sensitivity_post: {
        parameters: {
            query?: {
                parameter?: string;
                min_pct?: number;
                max_pct?: number;
                step_pct?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    run_monte_carlo_endpoint_api_v1_reports__report_id__monte_carlo_post: {
        parameters: {
            query?: {
                iterations?: number;
                noise_pct?: number;
                seed?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_loss_period_endpoint_api_v1_reports_detect_loss_period_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LossPeriodDetectionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_event_date_endpoint_api_v1_reports_validate_event_date_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EventDateValidationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_organization_api_v1_org_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrgResponse"];
                };
            };
        };
    };
    bulk_health_api_v1_bulk_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_event_types_api_v1_events_event_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    }[];
                };
            };
        };
    };
    get_event_type_details_api_v1_events_event_types__event_type__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    regenerate_sample_pdf_api_v1_download_regenerate_sample_pdf_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_sample_pdf_api_v1_download_sample_pdf_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    download_sample_pdf_api_v1_download_sample_pdf_download_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    download_narrative_pdf_api_v1_download_narrative__filename__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                filename: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_and_download_report_pdf_api_v1_download_report_pdf__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_court_bundle_cache_status_api_v1_download_court_ready_bundle__report_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_cached_bundle_api_v1_download_court_ready_bundle__report_id__cached_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_bundle_cache_api_v1_download_court_ready_bundle__report_id__cache_delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_court_ready_bundle_api_v1_download_court_ready_bundle__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CourtBundleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    preview_court_document_api_v1_download_court_ready_bundle__report_id__preview__document_type__get: {
        parameters: {
            query?: {
                watermark?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
                document_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    extract_pdf_api_v1_ai_extract_pdf_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_extract_pdf_api_v1_ai_extract_pdf_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    suggest_categories_api_v1_ai_suggest_categories_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CategorySuggestion-Input"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_anomalies_api_v1_ai_detect_anomalies_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AnomalyDetection"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    explain_calculation_api_v1_ai_explain_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__ai__ExplainRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    approve_suggestion_api_v1_ai_approve_suggestion_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveSuggestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_audit_trail_api_v1_ai_audit_trail__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_ai_stats_api_v1_ai_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    ai_health_api_v1_ai_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    generate_narrative_pdf_api_v1_narrator_generate_narrative_pdf_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateNarrativeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_narrative_api_v1_narrator_generate_narrative_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateNarrativeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_narrative_for_accountant_api_v1_narrator_generate_narrative_accountant__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_narrative_api_v1_narrator_save_narrative_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SaveNarrativeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    refine_section_api_v1_narrator_refine_section_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RefineSectionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_saved_narrative_api_v1_narrator_narrative__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_narrative_preview_api_v1_narrator_narrative_preview__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    narrator_health_api_v1_narrator_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    parse_1065_api_v1_tax_parse_1065_post: {
        parameters: {
            query?: {
                claim_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_1065_api_v1_tax_parse_1065_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_1065_demo_api_v1_tax_parse_1065_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_1065_demo_api_v1_tax_parse_1065_demo_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reconcile_tax_pl_api_v1_tax_reconcile_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReconcileRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    tax_parser_health_api_v1_tax_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_last_claim_api_v1_predictive_last_claim_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    generate_predictions_api_v1_predictive_predict_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PredictRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_claim_history_api_v1_predictive_history_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_predictions_api_v1_predictive_apply_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApplyPredictionsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    predictive_health_api_v1_predictive_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_last_claim_demo_api_v1_predictive_last_claim_demo_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    generate_predictions_demo_api_v1_predictive_predict_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    create_bundle_api_v1_bundle_create_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateBundleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_bundle_api_v1_bundle_download__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    preview_bundle_api_v1_bundle_preview_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateBundleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_bundle_pricing_api_v1_bundle_pricing_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    bundle_health_api_v1_bundle_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_check_api_v1_financial_docs_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    parse_form_1065_api_v1_financial_docs_parse_1065_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_form_1065_api_v1_financial_docs_parse_1065_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_bank_statement_api_v1_financial_docs_parse_bank_statement_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_bank_statement_api_v1_financial_docs_parse_bank_statement_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_profit_loss_api_v1_financial_docs_parse_profit_loss_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_profit_loss_api_v1_financial_docs_parse_profit_loss_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    three_way_reconciliation_api_v1_financial_docs_three_way_reconciliation_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_three_way_reconciliation_api_v1_financial_docs_three_way_reconciliation_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_form_1065_demo_api_v1_financial_docs_parse_1065_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_form_1065_demo_api_v1_financial_docs_parse_1065_demo_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_bank_statement_demo_api_v1_financial_docs_parse_bank_statement_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_bank_statement_demo_api_v1_financial_docs_parse_bank_statement_demo_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_profit_loss_demo_api_v1_financial_docs_parse_profit_loss_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_profit_loss_demo_api_v1_financial_docs_parse_profit_loss_demo_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    three_way_reconciliation_demo_api_v1_financial_docs_three_way_reconciliation_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_three_way_reconciliation_demo_api_v1_financial_docs_three_way_reconciliation_demo_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_excel_spreadsheet_api_v1_financial_docs_parse_excel_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_excel_spreadsheet_api_v1_financial_docs_parse_excel_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    health_check_api_v1_edge_cases_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    analyze_edge_cases_api_v1_edge_cases_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EdgeCaseAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_negative_revenue_api_v1_edge_cases_detect_negative_revenue_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_zero_payroll_api_v1_edge_cases_detect_zero_payroll_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Body_detect_zero_payroll_api_v1_edge_cases_detect_zero_payroll_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_missing_months_api_v1_edge_cases_detect_missing_months_post: {
        parameters: {
            query: {
                year: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_outliers_api_v1_edge_cases_detect_outliers_post: {
        parameters: {
            query?: {
                field?: string;
                threshold_multiplier?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    log_user_decision_api_v1_edge_cases_log_user_decision_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserDecisionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_edge_cases_demo_api_v1_edge_cases_analyze_demo_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EdgeCaseAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    health_check_api_v1_audit_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_claim_audit_trail_api_v1_audit_claim__claim_id__get: {
        parameters: {
            query?: {
                category?: string | null;
                start_date?: string | null;
                end_date?: string | null;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_audit_summary_api_v1_audit_claim__claim_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_audit_trail_api_v1_audit_claim__claim_id__export_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_field_changes_api_v1_audit_claim__claim_id__field_changes_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_ai_decisions_api_v1_audit_claim__claim_id__ai_decisions_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_calculations_api_v1_audit_claim__claim_id__calculations_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_claim_audit_trail_demo_api_v1_audit_claim__claim_id__demo_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_forensic_excel_api_v1_audit_claim__claim_id__export_excel_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_ai_explanation_pdf_api_v1_audit_claim__claim_id__explain_pdf_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_human_override_log_api_v1_audit_log_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HumanOverrideEntry"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_human_overrides_api_v1_audit_overrides__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_override_summary_api_v1_audit_overrides__case_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_upload_documents_api_v1_documents_bulk_upload_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_bulk_upload_documents_api_v1_documents_bulk_upload_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    process_single_document_api_v1_documents_process_single_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_process_single_document_api_v1_documents_process_single_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_zip_batch_api_v1_documents_upload_zip_post: {
        parameters: {
            query?: {
                /** @description Optional report ID to associate files with */
                report_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_zip_batch_api_v1_documents_upload_zip_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_supported_document_types_api_v1_documents_supported_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_health_assessment_api_v1_claims_health_score__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_health_assessments_summary_api_v1_claims_health_scores_summary_get: {
        parameters: {
            query?: {
                user_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    categorize_single_expense_api_v1_expenses_categorize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExpenseInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    categorize_multiple_expenses_api_v1_expenses_categorize_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchExpenseInput"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_expense_categories_api_v1_expenses_categories_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_classification_suggestion_api_v1_expenses_suggest_classification__category__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                category: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    search_declarations_api_v1_fema_search_get: {
        parameters: {
            query: {
                /** @description Two-letter state code (e.g., NC, FL, TX) */
                state: string;
                /** @description Search incidents from this date (YYYY-MM-DD) */
                start_date?: string | null;
                /** @description Search incidents up to this date (YYYY-MM-DD) */
                end_date?: string | null;
                /** @description Filter by incident type (hurricane, flood, fire, etc.) */
                incident_type?: string | null;
                /** @description Maximum number of results */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_declaration_api_v1_fema_validate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FemaValidationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    suggest_declarations_api_v1_fema_suggest_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FemaSuggestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_recent_declarations_api_v1_fema_recent_get: {
        parameters: {
            query?: {
                /** @description Number of recent declarations to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_comparative_analysis_api_v1_benchmarks_analysis__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_event_benchmarks_api_v1_benchmarks_benchmark__event_type__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_available_industry_benchmarks_api_v1_benchmarks_industry_available_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AvailableIndustry"][];
                };
            };
        };
    };
    get_industry_benchmark_by_naics_api_v1_benchmarks_industry__naics_code__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                naics_code: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_to_industry_benchmark_endpoint_api_v1_benchmarks_industry_compare_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IndustryBenchmarkRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IndustryBenchmarkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_report_to_industry_api_v1_benchmarks_industry_compare_report__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IndustryBenchmarkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    lookup_naics_code_api_v1_benchmarks_industry_naics_lookup__business_type__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                business_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extended_ratios_api_v1_benchmarks_ratios__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    ask_question_api_v1_adjuster_qa_adjuster_qa_ask_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AskQuestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AskQuestionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_conversation_history_api_v1_adjuster_qa_adjuster_qa_history__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConversationHistory"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_conversation_history_api_v1_adjuster_qa_adjuster_qa_history__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_suggested_questions_api_v1_adjuster_qa_adjuster_qa_suggested_questions__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_scenario_api_v1_scenarios_calculate__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ScenarioRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_saved_scenarios_api_v1_scenarios_saved__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_scenario_api_v1_scenarios_save__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SaveScenarioRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_scenario_api_v1_scenarios_saved__report_id___scenario_index__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                scenario_index: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_subrogation_api_v1_subrogation_analyze__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SubrogationAnalysisResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_demand_letter_api_v1_subrogation_generate_letter__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateDemandLetterRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DemandLetterResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    register_accountant_api_v1_collaboration_register_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ForensicAccountantCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantAuthResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    login_accountant_api_v1_collaboration_login_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ForensicAccountantLogin"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantAuthResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accountant_profile_api_v1_collaboration_profile_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ForensicAccountantProfile"];
                };
            };
        };
    };
    list_invites_api_v1_collaboration_invites_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportShareResponse"][];
                };
            };
        };
    };
    invite_accountant_api_v1_collaboration_invites_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InviteAccountantRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportShareResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    accept_invite_api_v1_collaboration_invites_accept_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AcceptInviteRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportShareResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    accept_invite_by_report_api_v1_collaboration_invites_accept_by_report__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_all_my_shares_api_v1_collaboration_shares_my_reports_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportShareResponse"][];
                };
            };
        };
    };
    list_report_shares_api_v1_collaboration_reports__report_id__shares_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportShareResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    revoke_share_api_v1_collaboration_shares__share_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                share_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_pending_invites_api_v1_collaboration_invites_pending_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SharedReportListItem"][];
                };
            };
        };
    };
    list_shared_reports_api_v1_collaboration_reports_shared_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SharedReportListItem"][];
                };
            };
        };
    };
    get_comments_api_v1_collaboration_reports__report_id__comments_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__models__collaboration__CommentResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_comment_api_v1_collaboration_reports__report_id__comments_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__models__collaboration__CreateCommentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__models__collaboration__CommentResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_for_accountant_api_v1_collaboration_reports__report_id__view_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_comparative_analysis_for_accountant_api_v1_collaboration_reports__report_id__comparative_analysis_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_review_insights_for_accountant_api_v1_collaboration_reports__report_id__review_insights_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_all_documents_api_v1_collaboration_reports__report_id__documents_download_all_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_report_document_api_v1_collaboration_reports__report_id__documents__file_type___file_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                file_type: string;
                file_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_versions_api_v1_collaboration_reports__report_id__versions_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VersionResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_version_api_v1_collaboration_reports__report_id__versions_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateVersionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VersionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_version_detail_api_v1_collaboration_reports__report_id__versions__version_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                version_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VersionDetailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_signatures_api_v1_collaboration_reports__report_id__signatures_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__models__collaboration__SignatureResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_signature_api_v1_collaboration_reports__report_id__signatures_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__models__collaboration__CreateSignatureRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__models__collaboration__SignatureResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accountant_dashboard_stats_api_v1_collaboration_accountant_dashboard_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_accountant_clients_api_v1_collaboration_accountant_clients_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_accountant_claims_api_v1_collaboration_accountant_claims_get: {
        parameters: {
            query?: {
                client_filter?: string;
                status_filter?: string;
                search?: string;
                skip?: number;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accountant_all_comments_api_v1_collaboration_accountant_comments_get: {
        parameters: {
            query?: {
                status_filter?: string;
                skip?: number;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_public_share_api_v1_collaboration_reports__report_id__public_share_post: {
        parameters: {
            query?: {
                expires_days?: number;
                watermark_text?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_public_share_api_v1_collaboration_public__share_token__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                share_token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_public_share_pdf_api_v1_collaboration_public__share_token__pdf_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                share_token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_public_shares_api_v1_collaboration_reports__report_id__public_shares_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    revoke_public_share_api_v1_collaboration_public_shares__share_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                share_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    invite_user_to_case_api_v1_collaboration_invite_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollaborationInviteRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CollaborationInviteResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_collaboration_cases_api_v1_collaboration_cases_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CollaborationCaseResponse"][];
                };
            };
        };
    };
    get_case_comments_api_v1_collaboration_cases__case_id__comments_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CollaborationCommentResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_case_comment_api_v1_collaboration_cases__case_id__comments_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollaborationCommentCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CollaborationCommentResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    revoke_collaboration_invite_api_v1_collaboration_invite__invite_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                invite_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_activity_api_v1_collaboration_cases__case_id__activity_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CollaborationActivityResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_or_update_profile_api_v1_accountant_profile_create_post: {
        parameters: {
            query?: never;
            header?: {
                authorization?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AccountantProfileCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantProfileResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_my_profile_api_v1_accountant_profile_me_get: {
        parameters: {
            query?: never;
            header?: {
                authorization?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantProfileResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_my_profile_api_v1_accountant_profile_me_delete: {
        parameters: {
            query?: never;
            header?: {
                authorization?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_profile_status_api_v1_accountant_profile_check_get: {
        parameters: {
            query?: never;
            header?: {
                authorization?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_comment_api_v1_comments__post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__comments__CreateCommentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_comments_api_v1_comments__report_id__get: {
        parameters: {
            query?: {
                section_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__comments__CommentResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_comment_api_v1_comments__comment_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                comment_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCommentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_comment_api_v1_comments__comment_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                comment_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    toggle_comment_resolution_api_v1_comments__comment_id__resolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                comment_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_comment_count_api_v1_comments__report_id__count_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    log_activity_api_v1_activity_log_post: {
        parameters: {
            query?: never;
            header?: {
                "x-forwarded-for"?: string | null;
                "user-agent"?: string | null;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LogActivityRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_activity_api_v1_activity__report_id__get: {
        parameters: {
            query?: {
                action_type?: string | null;
                limit?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ActivityLogResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_report_activity_api_v1_activity__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_my_activity_api_v1_activity_user_me_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ActivityLogResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_activity_summary_api_v1_activity_reports_summary_get: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_activities_api_v1_activity_admin_all_get: {
        parameters: {
            query?: {
                page?: number;
                per_page?: number;
                days?: number;
                user_email?: string | null;
                action_type?: string | null;
                search?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_signature_api_v1_signatures__post: {
        parameters: {
            query?: never;
            header?: {
                "x-forwarded-for"?: string | null;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__signatures__CreateSignatureRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_signature_api_v1_signatures__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__signatures__SignatureResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_signature_image_api_v1_signatures__report_id__image_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    revoke_signature_api_v1_signatures__signature_id__revoke_post: {
        parameters: {
            query?: {
                reason?: string | null;
            };
            header?: never;
            path: {
                signature_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    verify_signature_api_v1_signatures__report_id__verify_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_tags_to_report_api_v1_dashboard_tags_add_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddTagRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    remove_tag_from_report_api_v1_dashboard_tags_remove_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RemoveTagRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_tags_api_v1_dashboard_tags_all_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
        };
    };
    get_saved_views_api_v1_dashboard_views_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SavedViewResponse"][];
                };
            };
        };
    };
    create_saved_view_api_v1_dashboard_views_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SavedViewCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SavedViewResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_saved_view_api_v1_dashboard_views__view_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                view_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SavedViewUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_saved_view_api_v1_dashboard_views__view_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                view_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_templates_api_v1_dashboard_templates_get: {
        parameters: {
            query?: {
                category?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportTemplateResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_report_template_api_v1_dashboard_templates_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportTemplateCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportTemplateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_template_api_v1_dashboard_templates__template_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportTemplateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_report_template_api_v1_dashboard_templates__template_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportTemplateUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_report_template_api_v1_dashboard_templates__template_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_template_categories_api_v1_dashboard_templates_categories_list_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
        };
    };
    extract_from_document_api_v1_ai_automation_extract_from_document_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExtractFromDocumentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    auto_categorize_report_api_v1_ai_automation_auto_categorize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AutoCategorizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    suggest_missing_fields_api_v1_ai_automation_suggest_fields_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SuggestFieldsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_smart_tags_api_v1_ai_automation_generate_tags_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateTagsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    predict_event_duration_api_v1_ai_automation_predict_duration_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PredictDurationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_document_relevance_api_v1_ai_automation_analyze_document_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AnalyzeDocumentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    auto_tag_report_api_v1_ai_automation_auto_tag_report_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AutoTagReportRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_config_api_v1_future_closure_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    update_config_api_v1_future_closure_config_put: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_future_closure_api_v1_future_closure_calculate__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_calculations_api_v1_future_closure_calculations__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_calculation_api_v1_future_closure_calculation__calculation_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                calculation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    project_post_loss_revenue_api_v1_future_closure_project_post_loss__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_projections_history_api_v1_future_closure_projections__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_sensitivity_analysis_api_v1_future_closure_calculate__report_id__sensitivity_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_monte_carlo_api_v1_future_closure_calculate__report_id__monte_carlo_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_edge_cases_api_v1_future_closure_analyze_edge_cases__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_edge_case_explanation_api_v1_future_closure_generate_explanation__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_future_closure_pdf_endpoint_api_v1_future_closure_export__report_id__pdf_get: {
        parameters: {
            query?: {
                calculation_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_future_closure_docx_api_v1_future_closure_export__report_id__docx_get: {
        parameters: {
            query?: {
                calculation_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_config_api_v1_future_closure_case_config__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_case_config_api_v1_future_closure_case_config__report_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_case_config_api_v1_future_closure_case_config__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_report_data_api_v1_future_closure_validate__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_audit_trail_api_v1_future_closure_audit_trail__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_audit_trail_entry_api_v1_future_closure_audit_trail__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_saved_scenarios_api_v1_future_closure_scenarios__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_scenario_api_v1_future_closure_scenarios__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_scenario_api_v1_future_closure_scenarios__report_id___scenario_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                scenario_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_scenarios_api_v1_future_closure_scenarios__report_id__compare_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_pv_discount_api_v1_future_closure_calculate__report_id__pv_discount_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_policy_deductions_api_v1_future_closure_calculate__report_id__policy_deductions_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_bottom_up_api_v1_future_closure_calculate__report_id__bottom_up_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_epi_api_v1_future_closure_calculate__report_id__epi_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_document_messiness_api_v1_cleanup_check_messiness_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_check_document_messiness_api_v1_cleanup_check_messiness_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MessinessCheckResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_cleanup_documents_api_v1_cleanup_upload_post: {
        parameters: {
            query?: {
                /** @description Link to existing case/report (deprecated, use report_id) */
                case_id?: string | null;
                /** @description Job type identifier */
                job_type?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_cleanup_documents_api_v1_cleanup_upload_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CleanupUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_job_by_report_id_api_v1_cleanup_jobs_by_report__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_job_status_api_v1_cleanup_jobs__job_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CleanupJobStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_cleanup_job_api_v1_cleanup_jobs__job_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_job_transactions_api_v1_cleanup_jobs__job_id__transactions_get: {
        parameters: {
            query?: {
                /** @description Filter by review status */
                needs_review?: boolean | null;
                page?: number;
                page_size?: number;
                /** @description Find page containing this transaction */
                transaction_id?: string | null;
            };
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    review_transaction_api_v1_cleanup_jobs__job_id__review_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TransactionReviewRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_review_transactions_api_v1_cleanup_jobs__job_id__bulk_review_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkReviewRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    rerun_auto_approval_api_v1_cleanup_jobs__job_id__re_auto_approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reclassify_transactions_api_v1_cleanup_jobs__job_id__re_classify_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    mark_job_complete_api_v1_cleanup_jobs__job_id__complete_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_job_for_later_api_v1_cleanup_jobs__job_id__save_for_later_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_cleanup_jobs_api_v1_cleanup_jobs_get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status_filter?: string | null;
                /** @description Filter by saved_for_later flag */
                saved_for_later?: boolean | null;
                limit?: number;
                skip?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_delete_cleanup_jobs_api_v1_cleanup_jobs_bulk_delete_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkDeleteRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_stuck_jobs_api_v1_cleanup_jobs_stuck_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    mark_job_as_stuck_api_v1_cleanup_jobs__job_id__mark_stuck_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    retry_stuck_job_api_v1_cleanup_jobs__job_id__retry_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_clean_csv_api_v1_cleanup_jobs__job_id__export_get: {
        parameters: {
            query?: {
                /** @description Export format: csv, json */
                format?: string;
            };
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_wizard_financial_data_api_v1_cleanup_jobs__job_id__wizard_data_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    link_cleanup_to_report_api_v1_cleanup_jobs__job_id__link_report_post: {
        parameters: {
            query: {
                /** @description Report ID to link to */
                report_id: string;
            };
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_sample_job_api_v1_cleanup_test_generate_sample_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateSampleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_ocr_providers_api_v1_cleanup_test_ocr_check_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_categories_api_v1_cleanup_test_categories_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    cleanup_test_data_api_v1_cleanup_test_cleanup_test_data_delete: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_overall_metrics_api_v1_cleanup_monitoring_metrics_get: {
        parameters: {
            query?: {
                /** @description Number of days to analyze */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverallMetrics"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_approval_rate_over_time_api_v1_cleanup_monitoring_approval_rate_get: {
        parameters: {
            query?: {
                days?: number;
                granularity?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TimeSeriesPoint"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_override_rate_by_category_api_v1_cleanup_monitoring_override_rate_get: {
        parameters: {
            query?: {
                days?: number;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CategoryMetric"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accuracy_drift_api_v1_cleanup_monitoring_accuracy_drift_get: {
        parameters: {
            query?: {
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccuracyDriftPoint"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_top_overrides_api_v1_cleanup_monitoring_top_overrides_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    }[];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_category_performance_api_v1_cleanup_monitoring_category_performance_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    }[];
                };
            };
        };
    };
    get_stats_api_v1_cleanup_corrections_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CorrectionStatsResponse"];
                };
            };
        };
    };
    get_vendor_corrections_api_v1_cleanup_corrections_vendor__vendor__get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                vendor: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    find_similar_api_v1_cleanup_corrections_similar_post: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SimilarityQueryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SimilarCorrection"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_boost_api_v1_cleanup_corrections_boost_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BoostQueryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_correction_api_v1_cleanup_corrections_add_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ManualCorrectionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_recent_corrections_api_v1_cleanup_corrections_recent_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_test_corrections_api_v1_cleanup_corrections_clear_test_data_delete: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    detect_anomalies_api_v1_cleanup_anomalies__job_id__detect_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_anomalies_api_v1_cleanup_anomalies__job_id__get: {
        parameters: {
            query?: {
                /** @description Filter by severity */
                severity?: string | null;
                /** @description Filter by type */
                anomaly_type?: string | null;
                /** @description Show only unresolved */
                unresolved_only?: boolean;
            };
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnomalyResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_summary_api_v1_cleanup_anomalies__job_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnomalySummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_api_v1_cleanup_anomalies__anomaly_id__resolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                anomaly_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResolveAnomalyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_anomaly_types_api_v1_cleanup_anomalies_types_list_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnomalyTypeInfo"][];
                };
            };
        };
    };
    list_notifications_api_v1_cleanup_notifications_get: {
        parameters: {
            query?: {
                limit?: number;
                offset?: number;
                unread_only?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NotificationListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_unread_api_v1_cleanup_notifications_unread_count_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UnreadCountResponse"];
                };
            };
        };
    };
    read_notification_api_v1_cleanup_notifications__notification_id__read_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                notification_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    read_all_notifications_api_v1_cleanup_notifications_mark_all_read_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    remove_notification_api_v1_cleanup_notifications__notification_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                notification_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_test_notification_api_v1_cleanup_notifications_test_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    initiate_quickbooks_connect_api_v1_auth_quickbooks_connect_get: {
        parameters: {
            query: {
                /** @description User ID for OAuth state */
                user_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    quickbooks_oauth_callback_api_v1_auth_quickbooks_callback_get: {
        parameters: {
            query?: {
                code?: string;
                state?: string;
                realmId?: string;
                error?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_quickbooks_status_api_v1_auth_quickbooks_status__user_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QuickBooksConnection"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    import_quickbooks_data_api_v1_auth_quickbooks_import__user_id__post: {
        parameters: {
            query?: {
                /** @description Start date for transactions (YYYY-MM-DD) */
                start_date?: string;
                /** @description End date for transactions (YYYY-MM-DD) */
                end_date?: string;
            };
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QuickBooksImportResult"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    disconnect_quickbooks_api_v1_auth_quickbooks_disconnect__user_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_correction_api_v1_cleanup_learnings_record_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CategoryCorrection"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_category_suggestion_api_v1_cleanup_learnings_suggest_get: {
        parameters: {
            query: {
                /** @description User ID */
                user_id: string;
                /** @description Transaction description */
                description: string;
                /** @description Payee name */
                payee?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CategorySuggestion-Output"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_batch_suggestions_api_v1_cleanup_learnings_suggest_batch_get: {
        parameters: {
            query: {
                /** @description User ID */
                user_id: string;
                /** @description Comma-separated transaction descriptions */
                descriptions: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CategorySuggestion-Output"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_learning_stats_api_v1_cleanup_learnings_stats__user_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LearningStats"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reset_user_learnings_api_v1_cleanup_learnings_reset__user_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_templates_api_v1_templates_list_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    }[];
                };
            };
        };
    };
    calculate_estimates_api_v1_templates_calculate_estimates_get: {
        parameters: {
            query: {
                /** @description Template ID */
                template_id: string;
                /** @description Annual revenue estimate */
                annual_revenue: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_future_closure_defaults_api_v1_templates__template_id__future_closure_defaults_get: {
        parameters: {
            query?: {
                /** @description Average monthly revenue for scaling */
                monthly_revenue?: number;
            };
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_template_to_pl_api_v1_templates_apply_post: {
        parameters: {
            query: {
                /** @description Template ID */
                template_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ApplyTemplateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_template_multi_year_api_v1_templates_apply_multi_year_post: {
        parameters: {
            query: {
                /** @description Template ID */
                template_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ApplyMultiYearRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    search_templates_api_v1_templates_search_get: {
        parameters: {
            query: {
                /** @description Search query for templates */
                q: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_template_by_business_type_api_v1_templates_by_business_type__business_type__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                business_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_template_api_v1_templates__template_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportTemplate"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_annotations_api_v1_annotations__report_id__get: {
        parameters: {
            query?: {
                /** @description Filter by section */
                section?: string | null;
                /** @description Filter by type */
                annotation_type?: string | null;
                /** @description Filter by resolved status */
                resolved?: boolean | null;
                /** @description Get replies to specific annotation */
                parent_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnnotationResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_annotation_api_v1_annotations__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateAnnotationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnnotationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_annotation_summary_api_v1_annotations__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnnotationSummary"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_annotation_replies_api_v1_annotations__report_id___annotation_id__replies_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                annotation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnnotationResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_annotation_api_v1_annotations__report_id___annotation_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                annotation_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateAnnotationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AnnotationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_annotation_api_v1_annotations__report_id___annotation_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                annotation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_annotation_api_v1_annotations__report_id___annotation_id__resolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                annotation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    unresolve_annotation_api_v1_annotations__report_id___annotation_id__unresolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                annotation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_pdf_job_api_v1_pdf_generate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PDFJobCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PDFJobResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pdf_job_api_v1_pdf_jobs__job_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PDFJobResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_pdf_job_api_v1_pdf_jobs__job_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_pdf_jobs_api_v1_pdf_jobs_get: {
        parameters: {
            query?: {
                /** @description Filter by report ID */
                report_id?: string | null;
                /** @description Filter by status */
                status?: string | null;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PDFJobListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_pdf_api_v1_pdf_download__job_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_stats_api_v1_cache_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    clear_cache_api_v1_cache_clear_post: {
        parameters: {
            query?: {
                namespace?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_warmup_api_v1_cache_warmup_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_stats_api_v1_errors_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_circuit_breakers_api_v1_errors_circuit_breakers_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    reset_circuit_breaker_api_v1_errors_circuit_breakers__name__reset_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    report_frontend_error_api_v1_errors_report_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    compare_reports_api_v1_comparison_compare_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ComparisonRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ComparisonResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_comparison_api_v1_comparison_compare__comparison_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                comparison_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_comparison_api_v1_comparison_compare__comparison_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                comparison_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_user_claims_summary_api_v1_comparison_user__user_id__summary_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_recent_comparisons_api_v1_comparison_recent_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_settlements_api_v1_settlements__get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status?: string | null;
                /** @description Filter by user */
                user_id?: string | null;
                limit?: number;
                skip?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_settlement_api_v1_settlements__post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateSettlementRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SettlementResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_settlement_api_v1_settlements__settlement_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                settlement_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SettlementResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_settlement_api_v1_settlements__settlement_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                settlement_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateSettlementRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_settlement_api_v1_settlements__settlement_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                settlement_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_settlement_by_report_api_v1_settlements_report__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SettlementResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_event_api_v1_settlements__settlement_id__events_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                settlement_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddEventRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_settlement_stats_api_v1_settlements_stats_summary_get: {
        parameters: {
            query?: {
                /** @description Filter by user */
                user_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_brandings_api_v1_branding__get: {
        parameters: {
            query?: {
                limit?: number;
                skip?: number;
                active_only?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_branding_api_v1_branding__post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateBrandingRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BrandingResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_branding_api_v1_branding__org_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BrandingResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_branding_api_v1_branding__org_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateBrandingRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_branding_api_v1_branding__org_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_branding_css_api_v1_branding__org_id__css_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_branding_tailwind_api_v1_branding__org_id__tailwind_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pdf_branding_api_v1_branding__org_id__pdf_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    preview_branding_api_v1_branding__org_id__preview_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BrandingConfig"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_preset_themes_api_v1_branding_themes_presets_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    apply_preset_theme_api_v1_branding__org_id__apply_theme__theme_name__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                org_id: string;
                theme_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_api_keys_api_v1_external_keys_get: {
        parameters: {
            query: {
                org_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIKeyResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_api_key_api_v1_external_keys_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["APIKeyCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["APIKeyWithSecret"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    revoke_api_key_api_v1_external_keys__key_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                key_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_webhooks_api_v1_external_webhooks_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookResponse"][];
                };
            };
        };
    };
    create_webhook_api_v1_external_webhooks_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WebhookCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_webhook_api_v1_external_webhooks__webhook_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                webhook_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    test_webhook_api_v1_external_webhooks__webhook_id__test_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                webhook_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_claims_api_v1_external_claims_get: {
        parameters: {
            query?: {
                status?: string | null;
                limit?: number;
                skip?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_claim_api_v1_external_claims_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClaimCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_claim_api_v1_external_claims__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_claim_api_v1_external_claims__claim_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_api_usage_api_v1_external_usage_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_openapi_schema_api_v1_external_openapi_json_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_analytics_summary_api_v1_analytics_summary_get: {
        parameters: {
            query?: {
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_analytics_csv_api_v1_analytics_export_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_data_health_metrics_api_v1_analytics_data_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_email_engagement_analytics_api_v1_analytics_email_engagement_get: {
        parameters: {
            query?: {
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_ab_test_results_api_v1_analytics_ab_test_results_get: {
        parameters: {
            query?: {
                email_type?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_ab_test_winner_api_v1_analytics_ab_test_apply_winner_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApplyWinnerRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_ab_test_winner_api_v1_analytics_ab_test_clear_winner_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClearWinnerRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_locked_winners_api_v1_analytics_ab_test_locked_winners_get: {
        parameters: {
            query?: {
                email_type?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_email_retry_stats_api_v1_analytics_email_retry_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_email_retry_history_api_v1_analytics_email_retry_history_get: {
        parameters: {
            query?: {
                report_id?: string | null;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_email_retry_api_v1_analytics_email_retry__job_id__cancel_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_retry_processing_api_v1_analytics_email_retry_process_pending_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    send_test_email_api_v1_notifications_test_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EmailTestRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_claim_status_email_api_v1_notifications_claim_status_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClaimStatusEmailRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_share_email_api_v1_notifications_share_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ShareEmailRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_report_complete_email_api_v1_notifications_report_complete_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReportCompleteEmailRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_email_preferences_api_v1_notifications_preferences_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    update_email_preferences_api_v1_notifications_preferences_put: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_claims_csv_api_v1_export_csv_get: {
        parameters: {
            query?: {
                status?: string | null;
                event_type?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_claims_excel_api_v1_export_excel_get: {
        parameters: {
            query?: {
                status?: string | null;
                event_type?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_single_report_excel_api_v1_export_report__report_id__excel_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_team_members_api_v1_team_members_get: {
        parameters: {
            query?: {
                search?: string | null;
                role_filter?: string | null;
                status_filter?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TeamMemberResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_team_stats_api_v1_team_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TeamStatsResponse"];
                };
            };
        };
    };
    invite_member_api_v1_team_invite_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InviteMemberRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_member_directly_api_v1_team_add_direct_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DirectAddMemberRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_member_role_api_v1_team_members__member_id__role_put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                member_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateRoleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    remove_member_api_v1_team_members__member_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                member_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_member_status_api_v1_team_members__member_id__status_put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                member_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateStatusRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    transfer_ownership_api_v1_team_transfer_ownership_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TransferOwnershipRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resend_invite_api_v1_team_invites__invite_id__resend_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                invite_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_available_roles_api_v1_team_roles_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_my_permissions_api_v1_team_my_permissions_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    classify_single_transaction_api_v1_classify_transaction_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClassifySingleRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClassificationResult"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    classify_batch_transactions_api_v1_classify_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClassifyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BatchClassificationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    learn_from_correction_api_v1_classify_learn_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LearnCorrectionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_classification_statistics_api_v1_classify_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_available_models_api_v1_classify_models_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_valid_categories_api_v1_classify_categories_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    provide_payee_info_api_v1_classify_provide_payee_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PayeeInfoRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    provide_payee_info_batch_api_v1_classify_provide_payee_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PayeeInfoBatchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_claim_documents_api_v1_upload_claim_documents_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_claim_documents_api_v1_upload_claim_documents_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UnifiedUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_supported_formats_api_v1_upload_supported_formats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    unified_upload_api_v1_upload_savefirst_unified_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_unified_upload_api_v1_upload_savefirst_unified_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    unified_batch_upload_api_v1_upload_savefirst_unified_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_unified_batch_upload_api_v1_upload_savefirst_unified_batch_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__upload_savefirst__BatchUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_batch_status_api_v1_upload_savefirst_unified_batch_status_get: {
        parameters: {
            query: {
                upload_ids: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_upload_status_api_v1_upload_savefirst_unified__upload_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                upload_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UploadStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_upload_result_api_v1_upload_savefirst_unified__upload_id__result_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                upload_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_upload_evidence_api_v1_upload_savefirst_unified__upload_id__evidence_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                upload_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_evidence_api_v1_upload_savefirst_claims__claim_id__evidence_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reprocess_files_api_v1_upload_savefirst_reprocess_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReprocessRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReprocessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reprocess_failed_files_api_v1_upload_savefirst_reprocess_failed_post: {
        parameters: {
            query?: {
                claim_id?: string | null;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string[] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReprocessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reprocess_evidence_analysis_api_v1_upload_savefirst_reprocess_evidence_post: {
        parameters: {
            query: {
                claim_id: string;
                force?: boolean;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reprocess_zero_transaction_files_api_v1_upload_savefirst_reprocess_zero_transactions_post: {
        parameters: {
            query?: {
                claim_id?: string | null;
                draft_id?: string | null;
                limit?: number;
                dry_run?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    count_zero_transaction_files_api_v1_upload_savefirst_reprocess_zero_transactions_count_get: {
        parameters: {
            query?: {
                claim_id?: string | null;
                draft_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    count_failed_files_api_v1_upload_savefirst_reprocess_failed_count_get: {
        parameters: {
            query?: {
                claim_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_available_files_api_v1_upload_savefirst_reprocess_available_get: {
        parameters: {
            query?: {
                file_type?: string | null;
                limit?: number;
                status?: string | null;
                claim_id?: string | null;
                draft_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_extraction_api_v1_upload_savefirst_reprocess_compare__upload_id__post: {
        parameters: {
            query?: {
                force_method?: string | null;
            };
            header?: never;
            path: {
                upload_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    recalculate_aggregates_api_v1_upload_savefirst_recalculate_aggregates_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RecalculateAggregatesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    batch_recalculate_aggregates_api_v1_upload_savefirst_recalculate_aggregates_batch_post: {
        parameters: {
            query?: {
                dry_run?: boolean;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reclassify_uncategorized_transactions_api_v1_upload_savefirst_reclassify_uncategorized_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__upload_savefirst__ReclassifyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    diagnose_data_issues_api_v1_upload_savefirst_diagnostics__draft_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    fix_data_issues_api_v1_upload_savefirst_fix_issues__draft_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["FixIssuesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reprocess_tax_documents_api_v1_upload_savefirst_reprocess_tax_documents_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReprocessTaxRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    rebuild_variance_explanations_api_v1_upload_savefirst_rebuild_variance_explanations__claim_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reconcile_revenue_sources_api_v1_upload_savefirst_reconcile_revenue_sources__claim_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    sync_draft_to_claims_api_v1_upload_savefirst_sync_draft_to_claims__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    scan_s3_missing_api_v1_upload_savefirst_scan_s3_missing__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    restore_draft_api_v1_upload_savefirst_restore_draft__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dedup_tax_files_api_v1_upload_savefirst_dedup_tax_files__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dedup_uploads_api_v1_upload_savefirst_dedup_uploads__claim_id__post: {
        parameters: {
            query?: {
                dry_run?: boolean;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reanalyze_anomalies_api_v1_upload_savefirst_reanalyze_anomalies__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_cost_analytics_api_v1_upload_savefirst_analytics_extraction_costs_get: {
        parameters: {
            query?: {
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_by_case_api_v1_upload_savefirst_analytics_extraction_by_case_get: {
        parameters: {
            query?: {
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_sync_status_api_v1_upload_savefirst_sync_status__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reaggregate_financial_data_api_v1_upload_savefirst_reaggregate__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_draft_k1_api_v1_upload_savefirst_debug_draft_k1__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_k1_extraction_api_v1_upload_savefirst_debug_k1_extraction__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_anomalies_api_v1_anomalies_detect_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DetectAnomaliesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DetectAnomaliesResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_anomaly_types_api_v1_anomalies_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    detect_canonical_anomalies_api_v1_anomalies_detect_canonical_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CanonicalAnomalyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CanonicalAnomalyResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_ai_analysis_status_api_v1_anomalies_ai_analysis__job_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_single_anomaly_api_v1_anomalies_analyze_single_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SingleAnomalyAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SingleAnomalyAnalysisResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    forensic_analyze_anomaly_api_v1_anomalies_forensic_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ForensicAnomalyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ForensicAnomalyResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    batch_forensic_analyze_api_v1_anomalies_batch_forensic_analyze__draft_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchForensicRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_anomaly_resolution_api_v1_anomalies_save_anomaly_resolution__draft_id__post: {
        parameters: {
            query: {
                anomaly_id: string;
            };
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_consensus_anomalies_api_v1_anomalies_consensus__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EnsembleAnomalyResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_consensus_anomalies_api_v1_anomalies_consensus__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EnsembleAnomalyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EnsembleAnomalyResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    explain_anomalies_with_shap_api_v1_anomalies_explain_shap_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SHAPExplainRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SHAPExplainResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    explain_single_anomaly_shap_api_v1_anomalies_explain_single_shap_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SingleSHAPExplainRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SingleSHAPExplainResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_stored_explanation_api_v1_anomalies_explain__case_id___anomaly_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
                anomaly_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_explanations_api_v1_anomalies_explanations__case_id__get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_shap_status_api_v1_anomalies_shap_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_feature_importance_api_v1_anomalies_feature_importance_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    detect_anomalies_canonical_cached_api_v1_anomalies_canonical_with_cache_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CanonicalAnomalyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    invalidate_cache_api_v1_anomalies_cache__cache_hash__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                cache_hash: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    start_streaming_upload_api_v1_upload_stream_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_start_streaming_upload_api_v1_upload_stream_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StreamingUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    stream_job_progress_api_v1_upload_stream__job_id__progress_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_job_status_api_v1_upload_stream__job_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_job_result_api_v1_upload_stream__job_id__result_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dedup_uploads_api_v1_upload_dedup__claim_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    adopt_orphan_uploads_api_v1_upload_adopt_orphans__claim_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_bi_categories_api_v1_bi_categories_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BICategoryResponse"][];
                };
            };
        };
    };
    get_variable_categories_api_v1_bi_categories_variable_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BICategoryResponse"][];
                };
            };
        };
    };
    get_fixed_categories_api_v1_bi_categories_fixed_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BICategoryResponse"][];
                };
            };
        };
    };
    map_categories_api_v1_bi_map_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BIMappingRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BIMappingResult"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    map_single_category_api_v1_bi_map__category__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                category: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BIMappingResult"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_for_carrier_api_v1_bi_export__report_id__get: {
        parameters: {
            query?: {
                /** @description Export format: xlsx, csv, or json */
                format?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_summary_api_v1_bi_export__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_law_firms_api_v1_law_firms_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    create_law_firm_api_v1_law_firms_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LawFirmCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_import_clients_api_v1_law_firms__law_firm_id__bulk_import_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkImportRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_law_firm_clients_api_v1_law_firms__law_firm_id__clients_get: {
        parameters: {
            query?: {
                skip?: number;
                limit?: number;
            };
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_law_firm_api_v1_law_firms__law_firm_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_law_firm_api_v1_law_firms__law_firm_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LawFirmUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_law_firm_api_v1_law_firms__law_firm_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    search_law_firms_api_v1_law_firms_search__query__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                query: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_report_api_v1_forensic_analyze__report_id__post: {
        parameters: {
            query?: {
                force_refresh?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ForensicAnalysisResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_analysis_cache_api_v1_forensic_cache__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_fraud_graph_results_api_v1_forensic_fraud_graph__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FraudGraphResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_fraud_graph_endpoint_api_v1_forensic_fraud_graph__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FraudGraphRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FraudGraphResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_report_fraud_graph_api_v1_forensic_fraud_graph_report__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FraudGraphResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    run_forensic_orchestrator_api_v1_forensic__report_id__analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["OrchestratorAnalyzeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrchestratorAnalyzeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_forensic_orchestrator_results_api_v1_forensic__report_id__results_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrchestratorAnalyzeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_case_api_v1_attorney_analyze__report_id__post: {
        parameters: {
            query?: {
                force_refresh?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyAnalysisResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_analysis_cache_api_v1_attorney_cache__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    log_error_api_v1_errors_log_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ErrorLogCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_errors_api_v1_errors_list_get: {
        parameters: {
            query?: {
                /** @description Filter by HTTP status code */
                status_filter?: number | null;
                /** @description Filter by resolved status */
                resolved?: boolean | null;
                /** @description Number of days to look back */
                days?: number;
                /** @description Max results to return */
                limit?: number;
                /** @description Pagination offset */
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    error_summary_api_v1_errors_summary_get: {
        parameters: {
            query?: {
                /** @description Number of days to analyze */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_error_api_v1_errors__error_id__resolve_put: {
        parameters: {
            query?: {
                notes?: string | null;
            };
            header?: never;
            path: {
                error_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_fair_settlement_api_v1_mediation_calculate__report_id__post: {
        parameters: {
            query?: {
                force_refresh?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FairSettlementResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_fair_settlement_cache_api_v1_mediation_cache__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_gap_bridge_analysis_api_v1_mediation_gap_bridge__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    submit_outcome_api_v1_outcomes_submit_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OutcomeSubmission"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutcomeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_outcome_for_report_api_v1_outcomes_report__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutcomeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_outcome_api_v1_outcomes_report__report_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OutcomeSubmission"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutcomeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_outcome_api_v1_outcomes_report__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_outcomes_api_v1_outcomes_list_get: {
        parameters: {
            query?: {
                limit?: number;
                offset?: number;
                settlement_type?: string | null;
                industry_type?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutcomeResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_outcome_stats_api_v1_outcomes_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OutcomeStats"];
                };
            };
        };
    };
    get_closed_reports_api_v1_outcomes_closed_reports_get: {
        parameters: {
            query?: {
                limit?: number;
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_document_request_api_v1_notifications_send_document_request__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DocumentRequestPayload"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_status_update_api_v1_notifications_send_status_update__report_id__post: {
        parameters: {
            query: {
                recipient_email: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_reminder_api_v1_notifications_send_reminder__report_id__post: {
        parameters: {
            query: {
                recipient_email: string;
                /** @description Bypass rate limiting */
                force?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_email_history_api_v1_notifications_email_history__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_stale_claims_api_v1_notifications_check_stale_claims_post: {
        parameters: {
            query?: {
                /** @description Days without activity */
                days_threshold?: number;
                /** @description If true, don't send emails */
                dry_run?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkReminderResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_upload_portal_info_api_v1_notifications_upload_portal__report_id__get: {
        parameters: {
            query: {
                /** @description Magic-link token bound to this report */
                token: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_document_public_api_v1_notifications_upload_document__report_id__post: {
        parameters: {
            query: {
                /** @description Magic-link token bound to this report */
                token: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_document_public_api_v1_notifications_upload_document__report_id__post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    track_upload_analytics_api_v1_notifications_track_upload_analytics_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UploadAnalyticsPayload"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_upload_analytics_stats_api_v1_notifications_upload_analytics_stats_get: {
        parameters: {
            query?: {
                /** @description Number of days to analyze */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_unified_request_email_api_v1_notifications_send_unified_request__report_id__post: {
        parameters: {
            query: {
                recipient_email: string;
                /** @description Include missing documents section */
                include_docs?: boolean;
                /** @description Include transaction clarifications */
                include_clarifications?: boolean;
                /** @description Bypass rate limiting */
                force?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_unified_status_api_v1_notifications_check_unified_status__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    track_email_open_api_v1_notifications_track_open__tracking_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                tracking_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    track_email_click_api_v1_notifications_track_click__tracking_id___action__get: {
        parameters: {
            query: {
                redirect_url: string;
            };
            header?: never;
            path: {
                tracking_id: string;
                action: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    track_conversion_api_v1_notifications_track_conversion_post: {
        parameters: {
            query: {
                tracking_id: string;
                action: string;
                details?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_email_performance_analytics_api_v1_notifications_analytics_email_performance_get: {
        parameters: {
            query?: {
                /** @description Number of days to analyze */
                days?: number;
                /** @description Filter by email type */
                email_type?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    handle_inbound_email_api_v1_inbound_webhook_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_inbound_email_address_api_v1_inbound_email_address__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_received_emails_api_v1_inbound_received__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_email_attachments_api_v1_inbound_attachments__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_clarification_request_api_v1_clarifications_create_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateClarificationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_clarification_email_api_v1_clarifications_send__request_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                request_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_clarifications_api_v1_clarifications_pending_get: {
        parameters: {
            query?: {
                /** @description Filter by report ID */
                report_id?: string | null;
                /** @description Filter by status */
                status?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_review_queue_api_v1_clarifications_review_queue_get: {
        parameters: {
            query?: {
                /** @description Max items to return */
                limit?: number;
                /** @description View mode: 'grouped' or 'flat' */
                view?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_ai_suggestions_api_v1_clarifications_pending_ai_suggestions_get: {
        parameters: {
            query?: {
                /** @description Max items to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    submit_manual_response_api_v1_clarifications_responses_manual_post: {
        parameters: {
            query: {
                /** @description Clarification request ID */
                request_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ManualClarificationResponse"][];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    review_ai_parsed_response_api_v1_clarifications_responses__response_id__review_post: {
        parameters: {
            query: {
                /** @description Approve AI parsing? */
                approved: boolean;
                /** @description If not approved, provide correct category */
                corrected_category?: string | null;
                /** @description Apply approved category to wizard draft data */
                apply_to_draft?: boolean;
            };
            header?: never;
            path: {
                response_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_clarification_stats_api_v1_clarifications_stats_get: {
        parameters: {
            query?: {
                /** @description Number of days to analyze */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cleanup_orphaned_clarifications_api_v1_clarifications_cleanup_orphaned_post: {
        parameters: {
            query?: {
                /** @description If true, only report what would be deleted */
                dry_run?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_approve_clarifications_api_v1_clarifications_responses_bulk_approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkApprovalRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    flag_transaction_for_clarification_api_v1_clarifications_flag_transaction_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Body_flag_transaction_for_clarification_api_v1_clarifications_flag_transaction_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_client_clarification_portal_api_v1_clarifications_client__token__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    submit_client_clarifications_api_v1_clarifications_client__token__submit_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClientBatchSubmission"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_client_submission_status_api_v1_clarifications_client__token__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_scheduler_status_api_v1_clarifications_scheduler_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    trigger_daily_sweep_api_v1_clarifications_scheduler_trigger_sweep_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    trigger_reminder_sweep_api_v1_clarifications_scheduler_trigger_reminder_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_scheduler_logs_api_v1_clarifications_scheduler_logs_get: {
        parameters: {
            query?: {
                /** @description Max logs to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    chat_with_assistant_api_v1_assistant_chat_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__assistant__ChatRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_proactive_suggestions_api_v1_assistant_suggestions_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProactiveSuggestionsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_chat_history_api_v1_assistant_history__claim_id__get: {
        parameters: {
            query?: {
                session_id?: string | null;
                limit?: number;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_chat_history_api_v1_assistant_history__claim_id__delete: {
        parameters: {
            query?: {
                session_id?: string | null;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_chat_sessions_api_v1_assistant_sessions__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    text_to_speech_api_v1_assistant_voice_speak_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TTSRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    text_to_speech_raw_api_v1_assistant_voice_speak_raw_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TTSRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    speech_to_text_api_v1_assistant_voice_transcribe_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_speech_to_text_api_v1_assistant_voice_transcribe_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    voice_chat_api_v1_assistant_voice_chat_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_voice_chat_api_v1_assistant_voice_chat_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_voice_config_api_v1_assistant_voice_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    preview_recategorization_api_v1_assistant_actions_preview_recategorize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkRecategorizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_recategorization_api_v1_assistant_actions_apply_recategorize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BulkRecategorizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    flag_transactions_for_client_api_v1_assistant_actions_flag_for_client_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FlagForClientRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_client_questions_api_v1_assistant_actions_pending_questions__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_client_responses_api_v1_assistant_actions_parse_client_responses_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ParseClientResponsesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_all_pending_responses_api_v1_assistant_actions_parse_all_pending_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    apply_parsed_category_api_v1_assistant_actions_apply_parsed_category_post: {
        parameters: {
            query: {
                claim_id: string;
                transaction_id: string;
                category: string;
                specialist_confirmed?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_client_responses_api_v1_assistant_actions_pending_client_responses__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_batch_questions_api_v1_assistant_actions_generate_batch_questions_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQuestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_batch_questions_api_v1_assistant_actions_send_batch_questions_post: {
        parameters: {
            query: {
                claim_id: string;
                email?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    smart_review_api_v1_assistant_actions_smart_review_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SmartReviewRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_smart_review_actions_api_v1_assistant_actions_apply_smart_review_actions_post: {
        parameters: {
            query: {
                claim_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_unified_portal_data_api_v1_portal__token__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_portal_status_api_v1_portal__token__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_chart_image_api_v1_chart_upload_upload_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_chart_image_api_v1_chart_upload_upload_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_chart_images_api_v1_chart_upload_list__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_chart_image_api_v1_chart_upload__chart_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                chart_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_beat_schedule_api_v1_beat_test_schedule_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_stale_draft_reminder_api_v1_beat_test_stale_draft_reminder_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_weekly_attorney_summary_api_v1_beat_test_weekly_attorney_summary_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_low_confidence_digest_api_v1_beat_test_low_confidence_digest_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_reprocess_failed_uploads_api_v1_beat_test_reprocess_failed_uploads_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_orphan_cleanup_api_v1_beat_test_orphan_cleanup_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    test_run_all_tasks_api_v1_beat_test_run_all_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    attorney_login_api_v1_attorney_login_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AttorneyLogin"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyAuthResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_attorney_dashboard_api_v1_attorney_dashboard_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyDashboardResponse"];
                };
            };
        };
    };
    get_dashboard_alerts_api_v1_attorney_dashboard_alerts_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DashboardAlertsResponse"];
                };
            };
        };
    };
    get_attorney_clients_api_v1_attorney_clients_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyClientsResponse"];
                };
            };
        };
    };
    submit_new_client_api_v1_attorney_clients_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewClientRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NewClientResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_detail_api_v1_attorney_case__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CaseDetailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_context_api_v1_attorney_case__case_id__context_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_claim_type_api_v1_attorney_case__case_id__claim_type_patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateClaimTypeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_case_pdf_api_v1_attorney_case__case_id__download_pdf_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_case_docx_api_v1_attorney_case__case_id__download_docx_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_policy_document_api_v1_attorney_case__case_id__policy_document_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    set_attorney_password_api_v1_attorney_admin_law_firms__law_firm_id__set_password_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                law_firm_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetAttorneyPasswordRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    release_case_to_attorney_api_v1_attorney_admin_cases__case_id__release_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReleaseToAttorneyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_release_status_api_v1_attorney_admin_cases__case_id__release_status_get: {
        parameters: {
            query?: {
                task_id?: string | null;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    request_password_reset_api_v1_attorney_forgot_password_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasswordResetRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reset_password_api_v1_attorney_reset_password_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasswordResetConfirm"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_data_api_v1_data_quality_validate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ValidateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ValidateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_with_expectations_api_v1_data_quality_expectations_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GXValidateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GXValidateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    profile_data_api_v1_data_quality_profile_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProfileRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProfileResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cross_validate_documents_api_v1_data_quality_cross_validate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CrossValidateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CrossValidateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_report_api_v1_data_quality_report_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QualityReportRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__data_quality__QualityReportResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    data_quality_health_api_v1_data_quality_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    train_explainable_model_api_v1_explainability_train_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TrainModelRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TrainModelResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    explain_anomaly_api_v1_explainability_explain_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__explainability__ExplainRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExplainResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    explain_batch_api_v1_explainability_explain_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExplainBatchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExplainBatchResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_feature_importance_api_v1_explainability_feature_importance_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureImportanceResponse"];
                };
            };
        };
    };
    explainability_health_api_v1_explainability_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    upload_and_extract_api_v1_extraction_upload_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_and_extract_api_v1_extraction_upload_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExtractionResultResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_status_api_v1_extraction_status__job_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExtractionStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_results_api_v1_extraction_results__job_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                job_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExtractionResultResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_stats_api_v1_extraction_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrchestratorStatsResponse"];
                };
            };
        };
    };
    get_recent_cache_entries_api_v1_extraction_cache_recent_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    clear_cache_api_v1_extraction_cache_clear_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    invalidate_cache_entry_api_v1_extraction_cache__fingerprint__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                fingerprint: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    extraction_health_api_v1_extraction_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    batch_upload_api_v1_extraction_upload_batch_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_batch_upload_api_v1_extraction_upload_batch_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__extraction__BatchUploadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upload_with_postprocessing_api_v1_extraction_upload_with_postprocessing_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_upload_with_postprocessing_api_v1_extraction_upload_with_postprocessing_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExtractionResultResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_quality_api_v1_extraction_analyze_quality_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__extraction__QualityReportResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    normalize_records_api_v1_extraction_normalize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NormalizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NormalizationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    detect_duplicates_api_v1_extraction_detect_duplicates_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DuplicateDetectionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DuplicateReportResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    infer_schema_api_v1_extraction_infer_schema_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_infer_schema_api_v1_extraction_infer_schema_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_supported_formats_api_v1_extraction_supported_formats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_vendor_summary_api_v1_vendor_intelligence_summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_known_vendors_api_v1_vendor_intelligence_known_vendors_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    extract_vendor_api_v1_vendor_intelligence_extract_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_category_breakdown_api_v1_vendor_intelligence_category_breakdown_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_discovered_vendors_api_v1_vendor_intelligence_discovered_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    approve_discovered_vendor_api_v1_vendor_intelligence_discovered_approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reject_discovered_vendor_api_v1_vendor_intelligence_discovered_reject_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_learned_vendors_api_v1_vendor_intelligence_learned_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_vendor_intelligence_stats_api_v1_vendor_intelligence_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_classification_tier_stats_api_v1_vendor_intelligence_classification_tiers_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_classification_history_api_v1_vendor_intelligence_classification_history_get: {
        parameters: {
            query?: {
                months?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_negotiation_api_v1_game_theory_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GameTheoryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    quick_analyze_api_v1_game_theory_quick_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QuickAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_from_report_api_v1_game_theory_report__report_id__get: {
        parameters: {
            query?: {
                /** @description Negotiation approach */
                negotiation_style?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_negotiation_styles_api_v1_game_theory_styles_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    calculate_zopa_api_v1_game_theory_zopa_calculator_get: {
        parameters: {
            query: {
                /** @description Claimant's minimum acceptable (reservation price) */
                claimant_min: number;
                /** @description Insurer's maximum willingness to pay */
                insurer_max: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_nash_point_api_v1_game_theory_nash_point_get: {
        parameters: {
            query: {
                /** @description Claimant's BATNA value */
                claimant_batna: number;
                /** @description Insurer's reservation price (max willing to pay) */
                insurer_reservation: number;
                /** @description Claimant's reservation price (min willing to accept) */
                claimant_reservation: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_available_cases_api_v1_settlement_intelligence_cases_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    run_sensitivity_analysis_api_v1_settlement_intelligence_sensitivity_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SensitivityAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    quick_sensitivity_analysis_api_v1_settlement_intelligence_sensitivity_quick_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QuickSensitivityRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_tornado_chart_format_api_v1_settlement_intelligence_sensitivity_tornado_format_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    compare_to_historical_api_v1_settlement_intelligence_historical_compare_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HistoricalComparisonRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_available_industries_api_v1_settlement_intelligence_historical_industries_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_event_types_api_v1_settlement_intelligence_historical_event_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    list_whatif_templates_api_v1_settlement_intelligence_whatif_templates_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    run_whatif_scenarios_api_v1_settlement_intelligence_whatif_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WhatIfAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_single_scenario_api_v1_settlement_intelligence_whatif_single_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SingleScenarioRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_custom_scenario_api_v1_settlement_intelligence_whatif_custom_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomScenarioRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_roi_guide_api_v1_settlement_intelligence_whatif_roi_guide_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_all_modifications_api_v1_settlement_intelligence_whatif_modifications_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    build_custom_strategy_api_v1_settlement_intelligence_whatif_build_strategy_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BuildStrategyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_settlement_data_api_v1_settlement_intelligence_case__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_litigation_economics_api_v1_settlement_intelligence_litigation_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LitigationAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_litigation_guide_api_v1_settlement_intelligence_litigation_guide_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    analyze_bad_faith_api_v1_attorney_tools_bad_faith_analyze_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BadFaithAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_state_deadlines_api_v1_attorney_tools_bad_faith_deadlines__state__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                state: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_supported_states_api_v1_attorney_tools_bad_faith_states_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_upcoming_deadlines_api_v1_attorney_tools_bad_faith_upcoming_deadlines_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Body_get_upcoming_deadlines_api_v1_attorney_tools_bad_faith_upcoming_deadlines_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    search_case_law_api_v1_attorney_tools_case_law_search_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CaseLawSearchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_settlement_benchmarks_api_v1_attorney_tools_case_law_benchmarks_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SettlementBenchmarkRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    initialize_case_law_db_api_v1_attorney_tools_case_law_initialize_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_event_types_api_v1_attorney_tools_case_law_event_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_jurisdictions_api_v1_attorney_tools_case_law_jurisdictions_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    generate_demand_letter_api_v1_attorney_tools_demand_letter_generate_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DemandLetterRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_demand_letter_pdf_api_v1_attorney_tools_demand_letter_export_pdf_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DemandLetterRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_demand_letter_docx_api_v1_attorney_tools_demand_letter_export_docx_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DemandLetterRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_letter_types_api_v1_attorney_tools_demand_letter_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_state_statutes_api_v1_attorney_tools_demand_letter_state_statutes__state__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                state: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    predict_litigation_timeline_api_v1_attorney_tools_litigation_predict_timeline_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TimelinePredictionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_litigation_costs_api_v1_attorney_tools_litigation_cost_breakdown_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CostBreakdownRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    assess_case_complexity_api_v1_attorney_tools_litigation_complexity_assessment_get: {
        parameters: {
            query: {
                /** @description Claim amount in dollars */
                claim_amount: number;
                /** @description Is coverage disputed? */
                coverage_disputed?: boolean;
                /** @description Multiple parties involved? */
                multiple_parties?: boolean;
                /** @description Number of expert witnesses */
                experts_needed?: number;
                /** @description Bad faith alleged? */
                bad_faith_claim?: boolean;
                /** @description Approximate document pages */
                document_pages?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_litigation_phases_api_v1_attorney_tools_litigation_phases_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    extract_policy_dna_api_v1_attorney_tools_policy_dna_extract_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PolicyDNARequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    retrieve_policy_dna_api_v1_attorney_tools_policy_dna_retrieve_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PolicyDNARetrieveRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_exclusion_types_api_v1_attorney_tools_policy_dna_exclusion_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_coverage_types_api_v1_attorney_tools_policy_dna_coverage_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_key_definitions_api_v1_attorney_tools_policy_dna_key_definitions_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_pl_grid_api_v1_reconciliation_pl_grid__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_cell_transactions_api_v1_reconciliation_cell_transactions__report_id__get: {
        parameters: {
            query: {
                /** @description Year (e.g., 2022) */
                year: number;
                /** @description Month (1-12) */
                month: number;
                /** @description P&L section (e.g., 'INCOME') */
                section: string;
                /** @description P&L line item (e.g., 'Sales') */
                line_item: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CellTransactionsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reclassify_transaction_api_v1_reconciliation_transactions__report_id___transaction_id__reclassify_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                transaction_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReclassificationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_reclassification_history_api_v1_reconciliation_history__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    sign_off_cell_api_v1_reconciliation_cells__report_id___cell_id__sign_off_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                cell_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__reconciliation__SignOffRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_transaction_flags_api_v1_reconciliation_transactions__report_id___transaction_id__patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                transaction_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TransactionFlagUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_reconciliation_workpaper_api_v1_reconciliation_export__report_id__get: {
        parameters: {
            query?: {
                /** @description Filter to a single calendar year (inclusive). Rows whose date doesn't parse drop out under any year filter. */
                year?: number | null;
                /** @description Filter to a single calendar month (1–12). Combines with year. */
                month?: number | null;
                /** @description Filter to one P&L line item (e.g. 'Gross Sales'). Matches the transaction's computed pl_line_item exactly. */
                line_item?: string | null;
                /** @description Filter to a single source group (bank_statements|credit_card|tax_returns|pl_statements|quickbooks). */
                source?: string | null;
                /** @description xlsx (default) preserves the 6-sheet workbook scoped to the filters; csv streams a single transaction-detail sheet. */
                format?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_multi_source_reconciliation_api_v1_reconciliation_multi_source__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_multi_source_reconciliation_api_v1_reconciliation_multi_source__report_id__export_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_bates_exhibit_package_api_v1_reconciliation_export_exhibit_package__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["BatesExhibitRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    bulk_update_transaction_flags_api_v1_reconciliation_transactions__report_id__bulk_flag_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Body_bulk_update_transaction_flags_api_v1_reconciliation_transactions__report_id__bulk_flag_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_reconciliation_stats_api_v1_reconciliation_stats__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_audit_trail_api_v1_reconciliation_audit_trail__report_id__get: {
        parameters: {
            query?: {
                /** @description Export format: json or csv */
                export_format?: string;
                /** @description Include sign-off records */
                include_signoffs?: boolean;
                /** @description Include flag changes */
                include_flags?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_source_pdf_url_api_v1_reconciliation_source_pdf__report_id__get: {
        parameters: {
            query: {
                /** @description Source document filename */
                filename: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    stream_source_pdf_api_v1_reconciliation_source_pdf_stream__report_id__get: {
        parameters: {
            query: {
                /** @description Source document filename */
                filename: string;
                /** @description Optional JWT token for iframe auth */
                token?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_source_pdf_text_api_v1_reconciliation_source_pdf_text__report_id__get: {
        parameters: {
            query: {
                /** @description Source document filename */
                filename: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_source_pdf_url_direct_api_v1_reconciliation_source_pdf_url_get: {
        parameters: {
            query: {
                /** @description S3 key of the document */
                s3_key: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_source_file_for_period_api_v1_reconciliation_source_file__report_id__get: {
        parameters: {
            query: {
                /** @description Year of the period */
                year: number;
                /** @description Month of the period (1-12) */
                month: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    batch_reclassify_transactions_api_v1_reconciliation_transactions__report_id__batch_reclassify_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchReclassificationRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    start_batch_processing_api_v1_batch_process_start_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchProcessRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_batch_status_api_v1_batch_process_status__batch_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                batch_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_s3_documents_api_v1_batch_process_list_s3_documents_get: {
        parameters: {
            query?: {
                prefix?: string;
                max_keys?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_viewers_api_v1_ws_report__report_id__viewers_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_supported_types_api_v1_semantic_extraction_supported_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SupportedTypesResponse"];
                };
            };
        };
    };
    extract_document_api_v1_semantic_extraction_extract_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SemanticExtractionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SemanticExtractionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_result_api_v1_semantic_extraction_results__document_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                document_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_extraction_result_api_v1_semantic_extraction_results__document_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                document_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extractions_by_report_api_v1_semantic_extraction_results_by_report__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extractions_by_case_api_v1_semantic_extraction_results_by_case__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extraction_stats_api_v1_semantic_extraction_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_timeline_api_v1_bi_timeline_cases__case_id__timeline_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_timeline_api_v1_bi_timeline_cases__case_id__timeline_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateTimelineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_milestone_api_v1_bi_timeline_cases__case_id__timeline_milestones_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RecordMilestoneRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_predictions_api_v1_bi_timeline_cases__case_id__timeline_predict_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_deadlines_api_v1_bi_timeline_cases__case_id__timeline_deadlines_get: {
        parameters: {
            query?: {
                /** @description Days to look ahead */
                days?: number;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_state_rules_api_v1_bi_timeline_state_rules_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_state_rule_details_api_v1_bi_timeline_state_rules__state_code__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                state_code: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_carrier_profile_api_v1_bi_timeline_carriers__carrier_name__profile_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                carrier_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_carriers_api_v1_bi_timeline_carriers_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_milestone_types_api_v1_bi_timeline_milestone_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_claim_phases_api_v1_bi_timeline_claim_phases_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    check_deadline_notifications_api_v1_bi_timeline_notifications_check_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    send_deadline_notifications_api_v1_bi_timeline_notifications_send_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_notification_history_api_v1_bi_timeline_cases__case_id__notifications_history_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_case_for_learning_api_v1_bi_timeline_carriers_learn_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CaseResolutionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_learned_carrier_profile_api_v1_bi_timeline_carriers__carrier_name__learned_profile_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                carrier_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_learned_profiles_api_v1_bi_timeline_carriers_learned_profiles_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_learning_stats_api_v1_bi_timeline_carriers_learning_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_digest_preferences_api_v1_bi_timeline_digest_preferences__attorney_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                attorney_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_digest_preferences_api_v1_bi_timeline_digest_preferences__attorney_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                attorney_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DigestPreferencesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    preview_digest_api_v1_bi_timeline_digest_preview__attorney_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                attorney_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_digest_to_attorney_api_v1_bi_timeline_digest_send__attorney_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                attorney_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_all_digests_api_v1_bi_timeline_digest_send_all_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_digest_stats_api_v1_bi_timeline_digest_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    analyze_report_api_v1_adjuster_analyze__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["AdjusterAnalyzeRequest"] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_analysis_api_v1_adjuster_analysis__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_analysis_api_v1_adjuster_analysis__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_analysis_summary_api_v1_adjuster_analysis__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdjusterAnalyzeSummary"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_adjuster_attorney_api_v1_adjuster_compare__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdjusterComparisonResult"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    analyze_with_issues_api_v1_adjuster_analyze_with_issues__report_id__post: {
        parameters: {
            query?: {
                /** @description Force re-run even if analysis exists */
                force_refresh?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    adjuster_health_api_v1_adjuster_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_check_api_v1_issues_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_all_pending_issues_api_v1_issues_pending_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_pending_matches_api_v1_issues_matches_pending_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MatchListResponse"];
                };
            };
        };
    };
    confirm_match_api_v1_issues_matches__match_id__confirm_post: {
        parameters: {
            query: {
                /** @description User confirming/rejecting the match */
                user_id: string;
            };
            header?: never;
            path: {
                match_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmMatchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_all_issues_api_v1_issues_list_get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status?: string | null;
                /** @description Filter by priority */
                priority?: string | null;
                /** @description Filter by issue type */
                issue_type?: string | null;
                /** @description Max issues to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_global_issue_stats_api_v1_issues_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_issue_api_v1_issues_detail__issue_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                issue_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    preview_request_api_v1_issues_requests__report_id__preview_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_request_api_v1_issues_requests__report_id__send_post: {
        parameters: {
            query: {
                /** @description User sending the request */
                user_id: string;
                /** @description Client email address */
                client_email: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    handle_document_upload_api_v1_issues_on_document_upload_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DocumentUploadNotification"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_issue_api_v1_issues_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateIssueRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_issues_api_v1_issues__report_id__get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status?: string[] | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IssueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_pending_issues_api_v1_issues__report_id__pending_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_issue_stats_api_v1_issues__report_id__stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    approve_issue_api_v1_issues__issue_id__approve_post: {
        parameters: {
            query: {
                /** @description User approving the issue */
                user_id: string;
            };
            header?: never;
            path: {
                issue_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveIssueRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dismiss_issue_api_v1_issues__issue_id__dismiss_post: {
        parameters: {
            query: {
                /** @description User dismissing the issue */
                user_id: string;
            };
            header?: never;
            path: {
                issue_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DismissIssueRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    mark_wont_fix_api_v1_issues__issue_id__wont_fix_post: {
        parameters: {
            query: {
                /** @description User marking issue as won't fix */
                user_id: string;
            };
            header?: never;
            path: {
                issue_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WontFixRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_disagreement_api_v1_issues_disagreements_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateDisagreementRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_pending_disagreements_api_v1_issues_disagreements_pending_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_disagreements_for_report_api_v1_issues__report_id__disagreements_get: {
        parameters: {
            query?: {
                /** @description Include resolved disagreements */
                include_resolved?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_disagreement_api_v1_issues_disagreements__disagreement_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                disagreement_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_disagreement_api_v1_issues_disagreements__disagreement_id__resolve_post: {
        parameters: {
            query: {
                /** @description User resolving the disagreement */
                user_id: string;
            };
            header?: never;
            path: {
                disagreement_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResolveDisagreementRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_batch_requests_api_v1_issues_admin_trigger_batch_requests_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    trigger_stale_detection_api_v1_issues_admin_trigger_stale_detection_post: {
        parameters: {
            query?: {
                /** @description Days threshold for stale detection */
                days_threshold?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_stale_reminders_api_v1_issues_admin_trigger_stale_reminders_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    run_unified_analysis_api_v1_analysis_unified__report_id__post: {
        parameters: {
            query?: {
                /** @description Include full result in response */
                include_full_result?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UnifiedAnalysisRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UnifiedAnalysisResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_unified_analysis_status_api_v1_analysis_unified__report_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    unified_analysis_health_api_v1_analysis_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    query_case_data_api_v1_query_case_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CaseQueryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CaseQueryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_summary_api_v1_query_case__case_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_issues_api_v1_query_case__case_id__issues_get: {
        parameters: {
            query?: {
                /** @description Filter by status (comma-separated) */
                status?: string | null;
                /** @description Filter by priority (comma-separated) */
                priority?: string | null;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_timeline_api_v1_query_case__case_id__timeline_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_queryable_collections_api_v1_query_case_collections_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_available_benchmarks_api_v1_query_benchmarks_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AvailableBenchmarkResponse"][];
                };
            };
        };
    };
    get_benchmark_info_api_v1_query_benchmark__benchmark_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                benchmark_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    execute_benchmark_api_v1_query_benchmark__benchmark_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                benchmark_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["BenchmarkQueryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BenchmarkQueryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    query_service_health_api_v1_query_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_check_api_v1_ai_assistant_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    match_documents_api_v1_ai_assistant_match_documents_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DocumentMatchRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DocumentMatchResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    draft_email_api_v1_ai_assistant_draft_email_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EmailDraftRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EmailDraftResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_priority_scores_api_v1_ai_assistant_priority_scores_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PriorityScoreRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PriorityScoreResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    batch_match_documents_api_v1_ai_assistant_batch_match__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_summary_api_v1_orchestrator_cases__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_state_api_v1_orchestrator_cases__report_id__state_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_case_state_api_v1_orchestrator_cases__report_id__state_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["StateUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_document_uploaded_api_v1_orchestrator_cases__report_id__events_document_uploaded_post: {
        parameters: {
            query: {
                document_id: string;
                filename: string;
                file_type?: string;
                transaction_count?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_analysis_completed_api_v1_orchestrator_cases__report_id__events_analysis_completed_post: {
        parameters: {
            query: {
                analysis_type: string;
                success?: boolean;
                duration_seconds?: number;
                findings_count?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_issue_created_api_v1_orchestrator_cases__report_id__events_issue_created_post: {
        parameters: {
            query: {
                issue_id: string;
                issue_type: string;
                priority?: string;
                auto_created?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_issue_resolved_api_v1_orchestrator_cases__report_id__events_issue_resolved_post: {
        parameters: {
            query: {
                issue_id: string;
                resolution_type?: string;
                resolved_by?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_config_api_v1_orchestrator_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    update_config_api_v1_orchestrator_config_put: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfigUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_states_api_v1_orchestrator_states_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    assess_readiness_api_v1_orchestrator_cases__report_id__readiness_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    assess_readiness_full_api_v1_orchestrator_cases__report_id__readiness_full_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    configure_readiness_api_v1_orchestrator_cases__report_id__readiness_configure_post: {
        parameters: {
            query?: {
                classification_threshold?: number;
                min_transactions?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_dispatch_queue_api_v1_orchestrator_dispatch_queue_get: {
        parameters: {
            query?: {
                report_id?: string | null;
                status?: string | null;
                include_completed?: boolean;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_dispatch_summary_api_v1_orchestrator_dispatch_queue_summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                dispatch_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    approve_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                dispatch_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DispatchApprovalRequest"] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_dispatch_api_v1_orchestrator_dispatch_queue__dispatch_id__cancel_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                dispatch_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    manual_dispatch_api_v1_orchestrator_cases__report_id__dispatch_post: {
        parameters: {
            query: {
                action: string;
                priority?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pipeline_stats_api_v1_orchestrator_pipeline_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_cases_list_api_v1_orchestrator_cases_get: {
        parameters: {
            query?: {
                state?: string | null;
                include_complete?: boolean;
                limit?: number;
                offset?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    admin_trigger_analysis_api_v1_orchestrator_admin_trigger_analysis__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    chat_api_v1_intelligence_chat_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__intelligence_api__ChatRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatResponseModel"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_conversation_api_v1_intelligence_conversations__conversation_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                conversation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_tools_api_v1_intelligence_tools_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_check_api_v1_intelligence_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_evidence_checklist_api_v1_evidence_checklist__report_id__get: {
        parameters: {
            query?: {
                /** @description Include resolved/obtained items */
                include_resolved?: boolean;
                /** @description Response format: json, pdf, docx */
                format?: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_checklist_pdf_api_v1_evidence_checklist__report_id__pdf_get: {
        parameters: {
            query?: {
                /** @description Include resolved items */
                include_resolved?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_checklist_docx_api_v1_evidence_checklist__report_id__docx_get: {
        parameters: {
            query?: {
                /** @description Include resolved items */
                include_resolved?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_checklist_summary_api_v1_evidence_checklist__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_evidence_item_api_v1_evidence_checklist__report_id__item__item_id__resolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                item_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ResolveItemRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_critical_items_api_v1_evidence_checklist__report_id__critical_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_items_by_source_api_v1_evidence_checklist__report_id__by_source_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_portal_upload_slots_api_v1_evidence_portal__report_id__upload_slots_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    validate_upload_type_api_v1_evidence_portal__report_id__validate_upload_post: {
        parameters: {
            query: {
                /** @description Evidence item being uploaded to */
                evidence_item_id: string;
                /** @description Detected document type from parser */
                detected_type: string;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    send_evidence_request_to_client_api_v1_evidence__report_id__send_request_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SendEvidenceRequestBody"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_evidence_email_analytics_api_v1_evidence__report_id__email_analytics_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    extract_text_from_file_api_v1_documents_extract_text_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_extract_text_from_file_api_v1_documents_extract_text_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TextExtractionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_action_items_api_v1_action_items__report_id__get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status?: string | null;
                /** @description Filter by action type */
                action_type?: string | null;
                /** @description Filter by blocking status */
                is_blocking?: boolean | null;
                limit?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ActionItemListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_blocking_items_api_v1_action_items__report_id__blocking_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ActionItemListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_action_item_summary_api_v1_action_items__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ActionItemSummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resolve_action_item_api_v1_action_items__item_id__resolve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResolveRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_action_item_api_v1_action_items__item_id__cancel_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__action_items_api__CancelRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    escalate_action_item_api_v1_action_items__item_id__escalate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_pending_items_api_v1_action_items_pending_all_get: {
        parameters: {
            query?: {
                limit?: number;
                /** @description Filter by urgency */
                urgency?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_requests_for_report_api_v1_client_requests__report_id__get: {
        parameters: {
            query?: {
                /** @description Filter by status */
                status?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_requests_api_v1_client_requests__report_id__pending_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_request_summary_api_v1_client_requests__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RequestSummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    mark_request_fulfilled_api_v1_client_requests__request_id__mark_fulfilled_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                request_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ManualFulfillmentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    resend_request_email_api_v1_client_requests__request_id__resend_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                request_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    cancel_request_api_v1_client_requests__request_id__cancel_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                request_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["app__api__v1__client_requests_api__CancelRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_due_reminders_api_v1_client_requests_admin_due_reminders_get: {
        parameters: {
            query?: {
                /** @description Max items to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_reminder_processing_api_v1_client_requests_admin_process_reminders_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_expired_requests_api_v1_client_requests_admin_expired_get: {
        parameters: {
            query?: {
                /** @description Max items to return */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_expired_processing_api_v1_client_requests_admin_process_expired_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_upload_portal_info_api_v1_client_requests_portal__token__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_evaluation_api_v1_attorney_ai__report_id__evaluation_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EvaluationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_evaluation_history_api_v1_attorney_ai__report_id__evaluation_history_get: {
        parameters: {
            query?: {
                limit?: number;
                offset?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EvaluationHistoryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_evaluation_api_v1_attorney_ai__report_id__evaluate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TriggerEvaluationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_strength_breakdown_api_v1_attorney_ai__report_id__strength_breakdown_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StrengthBreakdownResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_readiness_status_api_v1_attorney_ai__report_id__readiness_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__attorney_ai_api__ReadinessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_improvement_potential_api_v1_attorney_ai__report_id__improvement_potential_get: {
        parameters: {
            query?: {
                resolve_blocking?: number;
                resolve_high_vulns?: number;
                additional_evidence?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ImprovementPotentialResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_attorney_ai_config_api_v1_attorney_ai_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_dashboard_stats_api_v1_attorney_ai_dashboard_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DashboardStatsResponse"];
                };
            };
        };
    };
    get_roadmap_summary_api_v1_roadmap__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RoadmapSummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_roadmap_full_api_v1_roadmap__report_id__full_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RoadmapFullResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_roadmap_client_view_api_v1_roadmap__report_id__client_view_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RoadmapClientResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_roadmap_api_v1_roadmap__report_id__generate_post: {
        parameters: {
            query?: {
                /** @description Force regeneration even if current roadmap exists */
                force_refresh?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_action_status_api_v1_roadmap__report_id__action__action_id__patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                action_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateActionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_roadmap_history_api_v1_roadmap__report_id__history_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RoadmapHistoryItem"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    match_document_to_action_api_v1_roadmap__report_id__action__action_id__match_document_post: {
        parameters: {
            query: {
                document_id: string;
                document_filename: string;
            };
            header?: never;
            path: {
                report_id: string;
                action_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pending_actions_api_v1_roadmap__report_id__pending_actions_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_client_email_api_v1_roadmap__report_id__action__action_id__generate_email_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                action_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateEmailRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EmailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_staff_email_view_api_v1_roadmap__report_id__action__action_id__generate_email_staff_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                action_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateEmailRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StaffEmailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_strength_breakdown_api_v1_roadmap__report_id__strength_breakdown_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_dependency_graph_api_v1_roadmap__report_id__dependency_graph_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_next_actions_api_v1_roadmap__report_id__next_actions_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_readiness_config_api_v1_readiness_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReadinessConfigResponse"];
                };
            };
        };
    };
    get_readiness_status_api_v1_readiness__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReadinessSummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_readiness_full_api_v1_readiness__report_id__full_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__readiness_api__ReadinessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    evaluate_readiness_api_v1_readiness__report_id__evaluate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["app__api__v1__readiness_api__ReadinessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    execute_readiness_api_v1_readiness__report_id__execute_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExecuteRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reverse_readiness_api_v1_readiness__report_id__reverse_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReverseRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_readiness_history_api_v1_readiness__report_id__history_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HistoryItemResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_risk_flags_api_v1_readiness__report_id__risk_flags_get: {
        parameters: {
            query?: {
                /** @description Filter by severity: blocking, review, info */
                severity?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RiskFlagResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_criteria_breakdown_api_v1_readiness__report_id__criteria_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    health_check_api_v1_packages_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_package_api_v1_packages__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PackageDetailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_package_summary_api_v1_packages__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PackageSummaryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_package_status_api_v1_packages__report_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_package_api_v1_packages__report_id__generate_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GeneratePackageRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    deliver_package_api_v1_packages__report_id__deliver_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DeliverPackageRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeliveryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    verify_access_token_api_v1_packages_token__token__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TokenVerificationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_package_by_token_api_v1_packages_access__token__package_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PackageDetailResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_package_download_api_v1_packages_access__token__download_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_package_history_api_v1_packages_history_all_get: {
        parameters: {
            query?: {
                limit?: number;
                status?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_delivery_history_api_v1_packages__report_id__deliveries_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_defense_matrix_api_v1_packages__report_id__defense_matrix_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_queue_stats_api_v1_queue_stats_get: {
        parameters: {
            query?: {
                /** @description Filter stats by user role */
                user_role?: string | null;
                /** @description Use fast query (requires pre-assigned queues) */
                fast?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueStatsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_data_specialist_queue_api_v1_queue_data_specialist_get: {
        parameters: {
            query?: {
                /** @description Page number */
                page?: number;
                /** @description Cases per page */
                page_size?: number;
                /** @description Sort stale cases first */
                include_stale?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accountant_queue_api_v1_queue_accountant_get: {
        parameters: {
            query?: {
                /** @description Page number */
                page?: number;
                /** @description Cases per page */
                page_size?: number;
                /** @description Sort stale cases first */
                include_stale?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_attorney_queue_api_v1_queue_attorney_get: {
        parameters: {
            query?: {
                /** @description Page number */
                page?: number;
                /** @description Cases per page */
                page_size?: number;
                /** @description Sort stale cases first */
                include_stale?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_all_cases_with_queues_api_v1_queue_all_get: {
        parameters: {
            query?: {
                /** @description Filter by queue type */
                queue_filter?: string | null;
                /** @description Sort stale cases first */
                include_stale?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_queue_assignment_api_v1_queue_case__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SingleCaseQueueResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    refresh_queue_assignments_api_v1_queue_refresh_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueueUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BatchQueueUpdateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_stale_cases_api_v1_queue_stale_get: {
        parameters: {
            query?: {
                /** @description Days threshold for staleness */
                threshold_days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pipeline_summary_api_v1_queue_pipeline_summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    batch_update_all_queue_assignments_api_v1_queue_batch_update_post: {
        parameters: {
            query?: {
                /** @description Max cases to update per call */
                limit?: number;
                /** @description Force refresh all cases, not just those without queue */
                force_refresh?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    ensure_queue_indexes_api_v1_queue_ensure_indexes_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_accountant_stats_api_v1_queue_accountant_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantStatsResponse"];
                };
            };
        };
    };
    get_nowline_stats_api_v1_queue_nowline_stats_get: {
        parameters: {
            query?: {
                /** @description User role: data_specialist, accountant, or attorney */
                role?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NowLineStatsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_accountant_dashboard_overview_api_v1_queue_accountant_dashboard_overview_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DashboardOverviewResponse"];
                };
            };
        };
    };
    get_available_cases_for_accountant_api_v1_queue_accountant_available_get: {
        parameters: {
            query?: {
                /** @description Page number */
                page?: number;
                /** @description Cases per page */
                page_size?: number;
                /** @description Filter to only cases that are ready for review */
                ready_only?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantQueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_my_claimed_cases_api_v1_queue_accountant_my_cases_get: {
        parameters: {
            query?: {
                /** @description Page number */
                page?: number;
                /** @description Cases per page */
                page_size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccountantQueueListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    claim_case_api_v1_queue_accountant_claim__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ClaimCaseRequest"] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimActionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    release_case_api_v1_queue_accountant_release__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ReleaseCaseRequest"] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimActionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reassign_case_api_v1_queue_accountant_reassign__case_id__post: {
        parameters: {
            query: {
                /** @description Admin performing the reassignment */
                admin_id: string;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReassignCaseRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimActionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_priorities_api_v1_queue_case__case_id__priorities_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_readiness_api_v1_queue_case__case_id__readiness_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CaseReadinessResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    set_case_estimated_value_api_v1_queue_case__case_id__estimated_value_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetEstimatedValueRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetEstimatedValueResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_feature_flags_api_v1_feature_flags__get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: boolean;
                    };
                };
            };
        };
    };
    get_feature_flags_detailed_api_v1_feature_flags_detailed_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: {
                            [key: string]: unknown;
                        };
                    };
                };
            };
        };
    };
    get_feature_flag_api_v1_feature_flags__flag_name__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                flag_name: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    feature_flags_health_api_v1_feature_flags_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_document_types_api_v1_document_pipeline_document_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DocumentTypesResponse"];
                };
            };
        };
    };
    classify_document_api_v1_document_pipeline_classify_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_classify_document_api_v1_document_pipeline_classify_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClassificationResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    parse_pl_document_api_v1_document_pipeline_parse_pl_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["Body_parse_pl_document_api_v1_document_pipeline_parse_pl_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PLParseResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pl_status_api_v1_document_pipeline_pl_status__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pl_expenses_api_v1_document_pipeline_pl_expenses__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_expense_corrections_api_v1_document_pipeline_pl_expenses__case_id__corrections_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExpenseCorrectionsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reclassify_draft_files_api_v1_document_pipeline_reclassify_draft_files__draft_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["app__api__v1__document_types_api__ReclassifyRequest"] | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    sign_off_case_api_v1_case_signoff__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["app__api__v1__case_signoff__SignOffRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SignOffResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    undo_sign_off_api_v1_case_signoff__case_id__undo_post: {
        parameters: {
            query?: {
                /** @description Reason for undoing sign-off */
                reason?: string | null;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SignOffResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_sign_off_history_api_v1_case_signoff__case_id__history_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SignOffHistoryItem"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_sign_off_status_api_v1_case_signoff__case_id__status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    finalize_attestation_api_v1_external_accountant_review__report_id__finalize_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinalizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FinalizeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    unfinalize_attestation_api_v1_external_accountant_review__report_id__unfinalize_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UnfinalizeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UnfinalizeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_list_engine_reviews_api_v1_external_accountant_review__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngineReviewListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_get_engine_review_detail_api_v1_external_accountant_review__report_id___engine_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                /** @description One of the 12 canonical engines */
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngineReviewStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_start_review_api_v1_external_accountant_review__report_id___engine_id__start_review_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["StartReviewRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_approve_engine_api_v1_external_accountant_review__report_id___engine_id__approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_dispute_engine_api_v1_external_accountant_review__report_id___engine_id__dispute_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DisputeEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    witness_waive_engine_api_v1_external_accountant_review__report_id___engine_id__waive_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WaiveEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_home_feed_api_v1_external_accountant_home_feed_get: {
        parameters: {
            query?: {
                /** @description Max items per bucket */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_production_export_api_v1_admin_production_export__report_id__get: {
        parameters: {
            query?: {
                /** @description `calculation_only` strips strategy/mixed events; `full` exports everything. */
                scope?: string;
            };
            header?: never;
            path: {
                /** @description Report (claim) UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_overlay_api_v1_attorney_overlay__report_id__get: {
        parameters: {
            query?: {
                /** @description Specific version to fetch; latest if omitted. */
                version?: number | null;
            };
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyOverlay"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    upsert_overlay_api_v1_attorney_overlay__report_id__post: {
        parameters: {
            query?: {
                /** @description If true, lock the overlay version after this upsert. Subsequent edits will require a new version (auto-bumped on re-attestation). */
                finalize?: boolean;
            };
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpsertOverlayRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AttorneyOverlay"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_overlay_versions_api_v1_attorney_overlay__report_id__versions_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VersionListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_attorney_war_room_api_v1_attorney_war_room__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WarRoomReadResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    file_challenge_api_v1_attorney_challenge__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ChallengeRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChallengeResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    query_war_room_api_v1_attorney_war_room__report_id__query_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QueryRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["QueryResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_consensus_api_v1_war_room_consensus__report_id__get: {
        parameters: {
            query?: {
                /** @description Specific run_id; omit for latest. */
                run_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_verifier_api_v1_war_room_verifier__report_id__get: {
        parameters: {
            query?: {
                run_id?: string | null;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    rerun_engine_api_v1_engine_review__report_id___engine_id__rerun_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RerunRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RerunResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_for_in_house_review_api_v1_engine_review_view__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_engine_review_view_typed_api_v1_engine_review_view_typed__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngineReviewDetail"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_engine_reviews_api_v1_engine_review__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngineReviewListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_engine_review_detail_api_v1_engine_review__report_id___engine_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Claim / report UUID */
                report_id: string;
                /** @description One of the 12 canonical engines */
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngineReviewStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    start_review_api_v1_engine_review__report_id___engine_id__start_review_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["StartReviewRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    approve_engine_api_v1_engine_review__report_id___engine_id__approve_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ApproveEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dispute_engine_api_v1_engine_review__report_id___engine_id__dispute_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DisputeEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    waive_engine_api_v1_engine_review__report_id___engine_id__waive_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WaiveEngineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TransitionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_override_api_v1_engine_review__report_id___engine_id__override_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OverrideCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverrideCreateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    inactivate_override_api_v1_engine_review__report_id___engine_id__override__override_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
                override_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OverrideInactivateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverrideInactivateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_overrides_api_v1_engine_review__report_id___engine_id__overrides_get: {
        parameters: {
            query?: {
                include_inactive?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverrideListItem"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    extract_document_api_v1_supporting_documents_extract_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExtractionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExtractionResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_supporting_documents_api_v1_supporting_documents_case__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DocumentSummary"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_extracted_document_api_v1_supporting_documents_document__document_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                document_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    verify_extraction_api_v1_supporting_documents_document__document_id__verify_put: {
        parameters: {
            query: {
                /** @description Name of person verifying */
                verified_by: string;
            };
            header?: never;
            path: {
                document_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                } | null;
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    extract_all_supporting_documents_api_v1_supporting_documents_case__case_id__extract_all_post: {
        parameters: {
            query?: {
                /** @description Re-extract even if already done */
                force_reextract?: boolean;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_continuation_rates_api_v1_continuation_rates__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ContinuationRatesResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_continuation_rates_api_v1_continuation_rates__report_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SaveContinuationRatesRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reset_continuation_rates_api_v1_continuation_rates__report_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_default_rates_api_v1_continuation_rates_defaults_all_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_rate_presets_api_v1_continuation_rates_presets_list_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_available_industries_api_v1_pl_benchmark_industries_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IndustryInfo"][];
                };
            };
        };
    };
    compare_report_pl_to_benchmark_api_v1_pl_benchmark_compare__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PLBenchmarkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    compare_pl_data_to_benchmark_api_v1_pl_benchmark_compare_data_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Body_compare_pl_data_to_benchmark_api_v1_pl_benchmark_compare_data_post"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PLBenchmarkResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_cached_benchmark_api_v1_pl_benchmark_cached__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_industry_benchmarks_api_v1_pl_benchmark_industry__industry_key__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                industry_key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_top_priorities_api_v1_dashboard_top_priorities_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_data_quality_api_v1_dashboard_data_quality_get: {
        parameters: {
            query?: {
                draft_id?: string | null;
                report_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_alerts_api_v1_dashboard_alerts_get: {
        parameters: {
            query?: {
                limit?: number;
                severity?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    dismiss_alert_api_v1_dashboard_alerts__alert_id__dismiss_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                alert_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    mark_alert_read_api_v1_dashboard_alerts__alert_id__read_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                alert_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_forensic_insights_api_v1_dashboard_forensic_insights__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_insurance_questions_api_v1_dashboard_insurance_questions__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_next_actions_api_v1_dashboard_next_actions__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_anomaly_review_api_v1_dashboard_anomaly_review__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    save_accountant_anomaly_action_api_v1_dashboard_anomaly_review__report_id__accountant_action_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    complete_next_action_api_v1_dashboard_next_actions__action_id__complete_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                action_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_classification_cache_stats_api_v1_dashboard_cache_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_accountant_dashboard_payload_api_v1_dashboard_accountant_payload__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_details_api_v1_dashboard_case_details__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_dashboard_trends_api_v1_dashboard_trends_get: {
        parameters: {
            query?: {
                /** @description Window in days for previous-period comparison */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DashboardTrendsResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_aggregated_pipeline_status_api_v1_pipeline_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PipelineStatusResponse"];
                };
            };
        };
    };
    get_claim_pipeline_status_api_v1_pipeline_status__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PipelineStatusResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    start_pipeline_api_v1_pipeline__report_id__start_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["StartPipelineRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pipeline_run_status_api_v1_pipeline__report_id__run_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    retry_stage_api_v1_pipeline__report_id__retry__stage__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                stage: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_document_requirements_api_v1_reports__report_id__document_requirements_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_readiness_status_api_v1_reports__report_id__readiness_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_case_type_api_v1_reports__report_id__case_type_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CaseTypeUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_custom_requirements_api_v1_reports__report_id__custom_requirements_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomRequirementsRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_requirement_templates_api_v1_document_templates_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_case_types_api_v1_case_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_document_types_api_v1_document_types_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
        };
    };
    get_requirements_for_case_type_api_v1_requirements_matrix__case_type__get: {
        parameters: {
            query?: {
                entity_type?: string | null;
                has_pl?: boolean;
                has_bank?: boolean;
                /** @description first_party or third_party - determines if insurance policy required */
                claim_source?: string | null;
            };
            header?: never;
            path: {
                case_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_pattern_templates_api_v1_patterns_templates_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    list_patterns_api_v1_patterns__event_id__get: {
        parameters: {
            query?: {
                /** @description Only return active patterns */
                active_only?: boolean;
                /** @description Filter by confidence: HIGH, MEDIUM, LOW */
                confidence?: string | null;
            };
            header?: never;
            path: {
                event_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pattern_api_v1_patterns__event_id__pattern__pattern_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_suggestions_for_report_api_v1_patterns__event_id__suggestions__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_suggestions_for_transaction_api_v1_patterns__event_id__suggestions__report_id__transaction__transaction_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
                report_id: string;
                transaction_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    accept_suggestion_api_v1_patterns__pattern_id__accept_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AcceptSuggestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reject_suggestion_api_v1_patterns__pattern_id__reject_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RejectSuggestionRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_pattern_api_v1_patterns_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__models__pattern_library__PatternCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_pattern_api_v1_patterns__pattern_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__models__pattern_library__PatternUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    deactivate_pattern_api_v1_patterns__pattern_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_event_stats_api_v1_patterns__event_id__stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pattern_stats_api_v1_patterns__event_id__stats__pattern_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    seed_event_patterns_api_v1_patterns_seed__event_id__post: {
        parameters: {
            query?: {
                /** @description Event type template: hurricane, fire, pandemic, civil_authority */
                template?: string | null;
            };
            header?: never;
            path: {
                event_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_thresholds_api_v1_alerts_thresholds_get: {
        parameters: {
            query?: {
                /** @description Only return active thresholds */
                active_only?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_threshold_api_v1_alerts_thresholds_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThresholdCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_threshold_api_v1_alerts_thresholds__threshold_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                threshold_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ThresholdUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    seed_default_thresholds_api_v1_alerts_thresholds_seed_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_report_alerts_api_v1_alerts_report__report_id__get: {
        parameters: {
            query?: {
                /** @description Include acknowledged alerts */
                include_acknowledged?: boolean;
            };
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_report_alert_summary_api_v1_alerts_report__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    acknowledge_alert_api_v1_alerts__alert_id__acknowledge_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                alert_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_report_cells_api_v1_alerts_report__report_id__check_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CellCheckRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    test_transaction_patterns_api_v1_pattern_admin_test_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PatternTestRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PatternTestResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_all_patterns_api_v1_pattern_admin_patterns_get: {
        parameters: {
            query?: {
                /** @description Filter by event ID */
                event_id?: string | null;
                /** @description Include inactive patterns */
                include_inactive?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_pattern_api_v1_pattern_admin_patterns_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__pattern_admin__PatternCreateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_pattern_api_v1_pattern_admin_patterns__pattern_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__pattern_admin__PatternUpdateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_pattern_api_v1_pattern_admin_patterns__pattern_id__delete: {
        parameters: {
            query?: {
                /** @description Permanently delete instead of deactivate */
                hard_delete?: boolean;
            };
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pattern_candidates_api_v1_pattern_admin_candidates_get: {
        parameters: {
            query?: {
                /** @description Filter by event ID */
                event_id?: string | null;
                /** @description Filter by status */
                status?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    promote_candidate_api_v1_pattern_admin_candidates__candidate_id__promote_post: {
        parameters: {
            query: {
                /** @description ID for the new pattern */
                pattern_id: string;
                /** @description Initial confidence level */
                confidence?: string;
            };
            header?: never;
            path: {
                candidate_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    reject_candidate_api_v1_pattern_admin_candidates__candidate_id__reject_post: {
        parameters: {
            query?: {
                /** @description Reason for rejection */
                reason?: string;
            };
            header?: never;
            path: {
                candidate_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    ai_suggest_reclassification_api_v1_pattern_admin_ai_suggest_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AIReclassifyRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AIReclassifyResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    import_patterns_api_v1_pattern_admin_patterns_import_post: {
        parameters: {
            query: {
                /** @description Event ID to import patterns into */
                event_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["app__api__v1__pattern_admin__PatternCreateRequest"][];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_patterns_api_v1_pattern_admin_patterns_export_get: {
        parameters: {
            query?: {
                /** @description Filter by event ID */
                event_id?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_confidence_decay_api_v1_pattern_admin_maintenance_apply_decay_post: {
        parameters: {
            query: {
                /** @description Event ID to apply decay to */
                event_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    consolidate_vendor_aliases_api_v1_pattern_admin_maintenance_consolidate_aliases_post: {
        parameters: {
            query: {
                /** @description Event ID to consolidate */
                event_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    find_similar_vendors_api_v1_pattern_admin_vendors_similar_get: {
        parameters: {
            query: {
                /** @description Vendor name to check */
                vendor: string;
                /** @description Event ID */
                event_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    add_vendor_alias_to_pattern_api_v1_pattern_admin_patterns__pattern_id__aliases_post: {
        parameters: {
            query: {
                /** @description Vendor alias to add */
                alias: string;
            };
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pattern_statistics_api_v1_pattern_admin_patterns__pattern_id__stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pattern_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pattern_library_health_api_v1_pattern_admin_event__event_id__health_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                event_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_templates_api_v1_event_templates__get: {
        parameters: {
            query?: {
                include_inactive?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventTemplateResponse"][];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_template_api_v1_event_templates__post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EventTemplateCreate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventTemplateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_template_api_v1_event_templates__template_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventTemplateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_template_api_v1_event_templates__template_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EventTemplateUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EventTemplateResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_template_api_v1_event_templates__template_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    apply_template_to_draft_api_v1_event_templates__template_id__apply__draft_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                template_id: string;
                draft_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    health_shallow_api_v1_health_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    health_deep_api_v1_health_deep_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    get_recent_ai_activity_api_v1_ai_activity_recent_all_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header: {
                authorization: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_ai_activity_api_v1_ai_activity__report_id__get: {
        parameters: {
            query?: {
                agent_name?: string | null;
                limit?: number;
                offset?: number;
            };
            header: {
                authorization: string;
            };
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_ai_summary_api_v1_ai_activity__report_id__summary_get: {
        parameters: {
            query?: never;
            header: {
                authorization: string;
            };
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_memory_stats_api_v1_memory_stats_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MemoryStatsResponse"];
                };
            };
        };
    };
    search_memories_api_v1_memory_search_get: {
        parameters: {
            query: {
                /** @description Search query */
                query: string;
                /** @description Filter by agent name */
                agent_name?: string | null;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_memory_api_v1_memory__memory_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                memory_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    backfill_memories_api_v1_memory_backfill_post: {
        parameters: {
            query?: {
                /** @description Max activity log entries to process */
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BackfillResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_audit_chain_api_v1_audit_chain__report_id__chain_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    verify_audit_chain_api_v1_audit_chain__report_id__verify_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    calculate_mitigation_credit_api_v1_mitigation_calculate__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MitigationCalculateRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_mitigation_credit_api_v1_mitigation__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    enrich_report_api_v1_calculations_enrich__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EnrichmentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EnrichmentResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_expert_report_api_v1_reports__case_id__expert_report_get: {
        parameters: {
            query?: {
                /** @description Override auto-detected event type */
                event_type?: string | null;
                /** @description Output format (docx or pdf) */
                format?: string;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    generate_demand_letter_template_api_v1_reports__case_id__demand_letter__letter_type__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
                letter_type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    download_attorney_package_docx_api_v1_packages__package_id__docx_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                package_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_deliberation_api_v1_deliberation__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_issues_api_v1_deliberation__report_id__issues_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_timeline_api_v1_deliberation__report_id__timeline_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_summary_api_v1_deliberation__report_id__summary_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_resolution_paths_api_v1_deliberation__report_id__resolution_paths_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    post_human_input_api_v1_deliberation__report_id__input_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HumanInputRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_war_room_analysis_api_v1_deliberation__report_id__trigger_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_trigger_status_api_v1_deliberation__report_id__trigger_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_data_availability_api_v1_deliberation__report_id__debug_data_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_challenge_round_api_v1_deliberation__report_id__challenge_round_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    trigger_challenge_round_api_v1_deliberation__report_id__challenge_round_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_challenge_round_status_api_v1_deliberation__report_id__challenge_round_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_vulnerabilities_api_v1_deliberation__report_id__vulnerabilities_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    create_claim_api_v1_claims_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateClaimResponse"];
                };
            };
        };
    };
    get_claim_api_v1_claims__claim_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_claim_api_v1_claims__claim_id__put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    update_claim_status_api_v1_claims__claim_id__status_put: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClaimStatusUpdate"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_canonical_data_api_v1_claims__claim_id__canonical_data_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CanonicalDataResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_claim_files_api_v1_claims__claim_id__files_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ClaimFilesResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    invalidate_cache_api_v1_claims__claim_id__invalidate_cache_post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    audit_transaction_buckets_api_v1_claims__claim_id__audit_buckets_get: {
        parameters: {
            query?: {
                year?: number | null;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    migrate_claimsync_to_claimgenius_api_v1_admin_migrate_claimsync_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    normalize_claim_ids_api_v1_admin_normalize_claim_ids_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    check_db_config_api_v1_admin_db_config_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    search_uploaded_files_api_v1_admin_search_files_get: {
        parameters: {
            query?: {
                s3_pattern?: string;
                filename_pattern?: string;
                limit?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    find_case_everywhere_api_v1_admin_find_case__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_case_claim_fields_api_v1_admin_case_claim_fields__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_file_detail_api_v1_admin_file_detail__file_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                file_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    sample_transactions_api_v1_admin_sample_transactions__claim_id__get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    fix_case_owner_api_v1_admin_fix_case_owner__case_id__post: {
        parameters: {
            query?: {
                accountant_id?: string;
                user_id?: string;
            };
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    invalidate_canonical_cache_api_v1_admin_invalidate_canonical_cache__case_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    invalidate_all_canonical_caches_api_v1_admin_invalidate_all_canonical_caches_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    nuclear_reset_api_v1_admin_nuclear_reset_post: {
        parameters: {
            query?: {
                confirm?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    check_claimsync_db_api_v1_admin_check_claimsync_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    debug_canonical_rebuild_api_v1_admin_debug_canonical__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_draft_fields_api_v1_admin_debug_draft_fields__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_cleanup_transactions_api_v1_admin_debug_cleanup_txns__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    debug_bucket_distribution_api_v1_admin_debug_buckets__case_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                case_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    merge_databases_api_v1_admin_merge_databases_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    export_wb1_api_v1_workbook_wb1__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    export_wb2_api_v1_workbook_wb2__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    recalculate_financial_data_api_v1_claims__claim_id__financial_data_patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinancialEditRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FinancialEditResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_agent_summaries_api_v1_deliberation__report_id__agent_summaries_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AgentSummariesResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_attorney_payload_api_v1_dashboard_attorney_payload__user_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_pipeline_status_api_v1_case_pipeline__claim_id__pipeline_status_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                claim_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_overrides_api_v1_reconciliation_override__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverrideListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_override_api_v1_reconciliation_override__report_id__patch: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OverrideRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OverrideWriteResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    list_adjustments_api_v1_adjustments_payroll__report_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PayrollAdjustmentListResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    record_adjustment_api_v1_adjustments_payroll__report_id__post: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PayrollAdjustmentRequest"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PayrollAdjustmentWriteResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    delete_adjustment_api_v1_adjustments_payroll__report_id___adjustment_id__delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                adjustment_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_latest_engine_output_api_v1_internal_engine_outputs__report_id___engine_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_engine_outputs_for_run_api_v1_internal_engine_outputs__report_id__run__run_id__get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                report_id: string;
                run_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_engine_output_history_api_v1_internal_engine_outputs__report_id___engine_id__history_get: {
        parameters: {
            query?: {
                limit?: number;
            };
            header?: never;
            path: {
                report_id: string;
                engine_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
    get_waitlist_api_waitlist_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown;
                };
            };
        };
    };
    join_waitlist_api_waitlist_post: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WaitlistSignup"];
            };
        };
        responses: {
            /** @description Successful Response */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WaitlistResponse"];
                };
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HTTPValidationError"];
                };
            };
        };
    };
}
export enum BlockType {
    narrative_section = "narrative_section",
    exhibit_selection = "exhibit_selection",
    strategy_note = "strategy_note",
    cover_letter_paragraph = "cover_letter_paragraph",
    annotation = "annotation"
}
export enum BlockVisibility {
    final_pdf = "final_pdf",
    internal_only = "internal_only"
}
export enum CheckSeverity {
    info = "info",
    warning = "warning",
    blocker = "blocker"
}
export enum CollaborationInviteRequestRole {
    viewer = "viewer",
    commenter = "commenter",
    editor = "editor"
}
export enum DeadlineAlertItemUrgency {
    critical = "critical",
    warning = "warning",
    info = "info"
}
export enum EdgeCaseType {
    revenue_spike = "revenue_spike",
    cash_basis_lag = "cash_basis_lag",
    payroll_mode = "payroll_mode",
    nonprofit_rules = "nonprofit_rules",
    data_gaps = "data_gaps",
    multiplier = "multiplier",
    unusual_expense = "unusual_expense"
}
export enum EnrichmentRequestSource {
    bi = "bi",
    future_closure = "future_closure"
}
export enum ExtractionConfidence {
    high = "high",
    medium = "medium",
    low = "low",
    manual = "manual"
}
export enum InputSource {
    unanimous = "unanimous",
    majority = "majority",
    forensic_default = "forensic_default"
}
export enum InviteAccountantRequestPermissions {
    view = "view",
    comment = "comment",
    edit = "edit",
    sign = "sign"
}
export enum IssueStatus {
    DETECTED = "DETECTED",
    PENDING_REVIEW = "PENDING_REVIEW",
    APPROVED = "APPROVED",
    REQUESTED = "REQUESTED",
    RESOLVED = "RESOLVED",
    DISMISSED = "DISMISSED",
    STALE = "STALE",
    WONT_FIX = "WONT_FIX"
}
export enum IssueType {
    MISSING_DOCUMENT = "MISSING_DOCUMENT",
    UNEXPLAINED_ITEM = "UNEXPLAINED_ITEM",
    CAUSATION_CONCERN = "CAUSATION_CONCERN",
    WEAK_EVIDENCE = "WEAK_EVIDENCE",
    DATA_CONFLICT = "DATA_CONFLICT"
}
export enum JobStatus {
    pending = "pending",
    uploading = "uploading",
    ocr_processing = "ocr_processing",
    extracting = "extracting",
    classifying = "classifying",
    pending_review = "pending_review",
    completed = "completed",
    failed = "failed"
}
export enum MatchStatus {
    PENDING = "PENDING",
    CONFIRMED = "CONFIRMED",
    REJECTED = "REJECTED",
    AUTO_MATCHED = "AUTO_MATCHED"
}
export enum OverallStatus {
    passed = "passed",
    warnings = "warnings",
    blocked = "blocked"
}
export enum OverlayStatus {
    draft = "draft",
    finalized = "finalized"
}
export enum OverrideOrigin {
    manual = "manual",
    from_ai_suggestion = "from_ai_suggestion"
}
export enum PatternConfidence {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW"
}
export enum Priority {
    CRITICAL = "CRITICAL",
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW"
}
export enum ResolutionMethod {
    majority_override = "majority_override",
    confidence_weight = "confidence_weight",
    escalation_needed = "escalation_needed"
}
export enum SettlementEventType {
    demand_submitted = "demand_submitted",
    offer_received = "offer_received",
    counteroffer_sent = "counteroffer_sent",
    documentation_requested = "documentation_requested",
    documentation_submitted = "documentation_submitted",
    negotiation_call = "negotiation_call",
    status_update = "status_update",
    settlement_reached = "settlement_reached",
    payment_received = "payment_received",
    note_added = "note_added",
    denied = "denied",
    escalated = "escalated"
}
export enum SettlementStatus {
    pending = "pending",
    demand_sent = "demand_sent",
    under_review = "under_review",
    negotiating = "negotiating",
    offer_received = "offer_received",
    counteroffer_sent = "counteroffer_sent",
    accepted = "accepted",
    settled = "settled",
    denied = "denied",
    withdrawn = "withdrawn",
    litigation = "litigation"
}
export enum StepStatusStatus {
    success = "success",
    skipped = "skipped",
    error = "error"
}
export enum SupportingDocumentType {
    lease_agreement = "lease_agreement",
    insurance_policy = "insurance_policy",
    loan_document = "loan_document",
    contract = "contract",
    vendor_agreement = "vendor_agreement"
}
export enum UnresolvedRequirement {
    human_input = "human_input",
    more_data = "more_data",
    policy_decision = "policy_decision"
}
export enum ValidationLayerEnum {
    extraction = "extraction",
    classification = "classification",
    analysis = "analysis"
}
export enum VersionDetailResponseCreated_by_type {
    user = "user",
    accountant = "accountant"
}
export enum VersionResponseCreated_by_type {
    user = "user",
    accountant = "accountant"
}
export enum App__models__adjuster_models__ConfidenceLevel {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW"
}
export enum App__models__collaboration__CommentResponseAuthor_type {
    accountant = "accountant",
    user = "user"
}
export enum App__models__issue_models__ConfidenceLevel {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW"
}
